// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./webfonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./webfonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes iconPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes notificationAction {
  0% {
    opacity: 0.4;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1.2);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0);
  }
}
/*!
 * Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
.blastream-icon {
  font-family: var(--blastream-icon-style-family, "Font Awesome 6 Free");
  font-weight: var(--blastream-icon-style, 900);
}

.blastream-icon-solid,
.blastream-icon-regular,
.blastream-icon-brands,
.fas,
.far,
.fab,
.blastream-icon-sharp-solid,
.blastream-icon-classic,
.blastream-icon {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--blastream-icon-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
}

.fas,
.blastream-icon-classic,
.blastream-icon-solid,
.far,
.blastream-icon-regular {
  font-family: "Font Awesome 6 Free";
}

.fab,
.blastream-icon-brands {
  font-family: "Font Awesome 6 Brands";
}

.blastream-icon-1x {
  font-size: 1em;
}

.blastream-icon-2x {
  font-size: 2em;
}

.blastream-icon-3x {
  font-size: 3em;
}

.blastream-icon-4x {
  font-size: 4em;
}

.blastream-icon-5x {
  font-size: 5em;
}

.blastream-icon-6x {
  font-size: 6em;
}

.blastream-icon-7x {
  font-size: 7em;
}

.blastream-icon-8x {
  font-size: 8em;
}

.blastream-icon-9x {
  font-size: 9em;
}

.blastream-icon-10x {
  font-size: 10em;
}

.blastream-icon-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.blastream-icon-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.blastream-icon-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.blastream-icon-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.blastream-icon-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.blastream-icon-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.blastream-icon-fw {
  text-align: center;
  width: 1.25em;
}

.blastream-icon-ul {
  list-style-type: none;
  margin-left: var(--blastream-icon-li-margin, 2.5em);
  padding-left: 0;
}
.blastream-icon-ul > li {
  position: relative;
}

.blastream-icon-li {
  left: calc(-1 * var(--blastream-icon-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--blastream-icon-li-width, 2em);
  line-height: inherit;
}

.blastream-icon-border {
  border-color: var(--blastream-icon-border-color, #eee);
  border-radius: var(--blastream-icon-border-radius, 0.1em);
  border-style: var(--blastream-icon-border-style, solid);
  border-width: var(--blastream-icon-border-width, 0.08em);
  padding: var(--blastream-icon-border-padding, 0.2em 0.25em 0.15em);
}

.blastream-icon-pull-left {
  float: left;
  margin-right: var(--blastream-icon-pull-margin, 0.3em);
}

.blastream-icon-pull-right {
  float: right;
  margin-left: var(--blastream-icon-pull-margin, 0.3em);
}

.blastream-icon-beat {
  animation-name: blastream-icon-beat;
  animation-delay: var(--blastream-icon-animation-delay, 0s);
  animation-direction: var(--blastream-icon-animation-direction, normal);
  animation-duration: var(--blastream-icon-animation-duration, 1s);
  animation-iteration-count: var(--blastream-icon-animation-iteration-count, infinite);
  animation-timing-function: var(--blastream-icon-animation-timing, ease-in-out);
}

.blastream-icon-bounce {
  animation-name: blastream-icon-bounce;
  animation-delay: var(--blastream-icon-animation-delay, 0s);
  animation-direction: var(--blastream-icon-animation-direction, normal);
  animation-duration: var(--blastream-icon-animation-duration, 1s);
  animation-iteration-count: var(--blastream-icon-animation-iteration-count, infinite);
  animation-timing-function: var(--blastream-icon-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.blastream-icon-fade {
  animation-name: blastream-icon-fade;
  animation-delay: var(--blastream-icon-animation-delay, 0s);
  animation-direction: var(--blastream-icon-animation-direction, normal);
  animation-duration: var(--blastream-icon-animation-duration, 1s);
  animation-iteration-count: var(--blastream-icon-animation-iteration-count, infinite);
  animation-timing-function: var(--blastream-icon-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.blastream-icon-beat-fade {
  animation-name: blastream-icon-beat-fade;
  animation-delay: var(--blastream-icon-animation-delay, 0s);
  animation-direction: var(--blastream-icon-animation-direction, normal);
  animation-duration: var(--blastream-icon-animation-duration, 1s);
  animation-iteration-count: var(--blastream-icon-animation-iteration-count, infinite);
  animation-timing-function: var(--blastream-icon-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.blastream-icon-flip {
  animation-name: blastream-icon-flip;
  animation-delay: var(--blastream-icon-animation-delay, 0s);
  animation-direction: var(--blastream-icon-animation-direction, normal);
  animation-duration: var(--blastream-icon-animation-duration, 1s);
  animation-iteration-count: var(--blastream-icon-animation-iteration-count, infinite);
  animation-timing-function: var(--blastream-icon-animation-timing, ease-in-out);
}

.blastream-icon-shake {
  animation-name: blastream-icon-shake;
  animation-delay: var(--blastream-icon-animation-delay, 0s);
  animation-direction: var(--blastream-icon-animation-direction, normal);
  animation-duration: var(--blastream-icon-animation-duration, 1s);
  animation-iteration-count: var(--blastream-icon-animation-iteration-count, infinite);
  animation-timing-function: var(--blastream-icon-animation-timing, linear);
}

.blastream-icon-spin {
  animation-name: blastream-icon-spin;
  animation-delay: var(--blastream-icon-animation-delay, 0s);
  animation-direction: var(--blastream-icon-animation-direction, normal);
  animation-duration: var(--blastream-icon-animation-duration, 2s);
  animation-iteration-count: var(--blastream-icon-animation-iteration-count, infinite);
  animation-timing-function: var(--blastream-icon-animation-timing, linear);
}

.blastream-icon-spin-reverse {
  --blastream-icon-animation-direction: reverse;
}

.blastream-icon-pulse,
.blastream-icon-spin-pulse {
  animation-name: blastream-icon-spin;
  animation-direction: var(--blastream-icon-animation-direction, normal);
  animation-duration: var(--blastream-icon-animation-duration, 1s);
  animation-iteration-count: var(--blastream-icon-animation-iteration-count, infinite);
  animation-timing-function: var(--blastream-icon-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .blastream-icon-beat,
  .blastream-icon-bounce,
  .blastream-icon-fade,
  .blastream-icon-beat-fade,
  .blastream-icon-flip,
  .blastream-icon-pulse,
  .blastream-icon-shake,
  .blastream-icon-spin,
  .blastream-icon-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes blastream-icon-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--blastream-icon-beat-scale, 1.25));
  }
}
@keyframes blastream-icon-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--blastream-icon-bounce-start-scale-x, 1.1), var(--blastream-icon-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--blastream-icon-bounce-jump-scale-x, 0.9), var(--blastream-icon-bounce-jump-scale-y, 1.1)) translateY(var(--blastream-icon-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--blastream-icon-bounce-land-scale-x, 1.05), var(--blastream-icon-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--blastream-icon-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes blastream-icon-fade {
  50% {
    opacity: var(--blastream-icon-fade-opacity, 0.4);
  }
}
@keyframes blastream-icon-beat-fade {
  0%, 100% {
    opacity: var(--blastream-icon-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--blastream-icon-beat-fade-scale, 1.125));
  }
}
@keyframes blastream-icon-flip {
  50% {
    transform: rotate3d(var(--blastream-icon-flip-x, 0), var(--blastream-icon-flip-y, 1), var(--blastream-icon-flip-z, 0), var(--blastream-icon-flip-angle, -180deg));
  }
}
@keyframes blastream-icon-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes blastream-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.blastream-icon-rotate-90 {
  transform: rotate(90deg);
}

.blastream-icon-rotate-180 {
  transform: rotate(180deg);
}

.blastream-icon-rotate-270 {
  transform: rotate(270deg);
}

.blastream-icon-flip-horizontal {
  transform: scale(-1, 1);
}

.blastream-icon-flip-vertical {
  transform: scale(1, -1);
}

.blastream-icon-flip-both,
.blastream-icon-flip-horizontal.blastream-icon-flip-vertical {
  transform: scale(-1, -1);
}

.blastream-icon-rotate-by {
  transform: rotate(var(--blastream-icon-rotate-angle, 0));
}

.blastream-icon-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.blastream-icon-stack-1x,
.blastream-icon-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: var(--blastream-icon-stack-z-index, auto);
}

.blastream-icon-stack-1x {
  line-height: inherit;
}

.blastream-icon-stack-2x {
  font-size: 2em;
}

.blastream-icon-inverse {
  color: var(--blastream-icon-inverse, #fff);
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.blastream-icon-0::before {
  content: "\\30 ";
}

.blastream-icon-1::before {
  content: "\\31 ";
}

.blastream-icon-2::before {
  content: "\\32 ";
}

.blastream-icon-3::before {
  content: "\\33 ";
}

.blastream-icon-4::before {
  content: "\\34 ";
}

.blastream-icon-5::before {
  content: "\\35 ";
}

.blastream-icon-6::before {
  content: "\\36 ";
}

.blastream-icon-7::before {
  content: "\\37 ";
}

.blastream-icon-8::before {
  content: "\\38 ";
}

.blastream-icon-9::before {
  content: "\\39 ";
}

.blastream-icon-fill-drip::before {
  content: "\\f576";
}

.blastream-icon-arrows-to-circle::before {
  content: "\\e4bd";
}

.blastream-icon-circle-chevron-right::before {
  content: "\\f138";
}

.blastream-icon-chevron-circle-right::before {
  content: "\\f138";
}

.blastream-icon-at::before {
  content: "\\@";
}

.blastream-icon-trash-can::before {
  content: "\\f2ed";
}

.blastream-icon-trash-alt::before {
  content: "\\f2ed";
}

.blastream-icon-text-height::before {
  content: "\\f034";
}

.blastream-icon-user-xmark::before {
  content: "\\f235";
}

.blastream-icon-user-times::before {
  content: "\\f235";
}

.blastream-icon-stethoscope::before {
  content: "\\f0f1";
}

.blastream-icon-message::before {
  content: "\\f27a";
}

.blastream-icon-comment-alt::before {
  content: "\\f27a";
}

.blastream-icon-info::before {
  content: "\\f129";
}

.blastream-icon-down-left-and-up-right-to-center::before {
  content: "\\f422";
}

.blastream-icon-compress-alt::before {
  content: "\\f422";
}

.blastream-icon-explosion::before {
  content: "\\e4e9";
}

.blastream-icon-file-lines::before {
  content: "\\f15c";
}

.blastream-icon-file-alt::before {
  content: "\\f15c";
}

.blastream-icon-file-text::before {
  content: "\\f15c";
}

.blastream-icon-wave-square::before {
  content: "\\f83e";
}

.blastream-icon-ring::before {
  content: "\\f70b";
}

.blastream-icon-building-un::before {
  content: "\\e4d9";
}

.blastream-icon-dice-three::before {
  content: "\\f527";
}

.blastream-icon-calendar-days::before {
  content: "\\f073";
}

.blastream-icon-calendar-alt::before {
  content: "\\f073";
}

.blastream-icon-anchor-circle-check::before {
  content: "\\e4aa";
}

.blastream-icon-building-circle-arrow-right::before {
  content: "\\e4d1";
}

.blastream-icon-volleyball::before {
  content: "\\f45f";
}

.blastream-icon-volleyball-ball::before {
  content: "\\f45f";
}

.blastream-icon-arrows-up-to-line::before {
  content: "\\e4c2";
}

.blastream-icon-sort-down::before {
  content: "\\f0dd";
}

.blastream-icon-sort-desc::before {
  content: "\\f0dd";
}

.blastream-icon-circle-minus::before {
  content: "\\f056";
}

.blastream-icon-minus-circle::before {
  content: "\\f056";
}

.blastream-icon-door-open::before {
  content: "\\f52b";
}

.blastream-icon-right-from-bracket::before {
  content: "\\f2f5";
}

.blastream-icon-sign-out-alt::before {
  content: "\\f2f5";
}

.blastream-icon-atom::before {
  content: "\\f5d2";
}

.blastream-icon-soap::before {
  content: "\\e06e";
}

.blastream-icon-icons::before {
  content: "\\f86d";
}

.blastream-icon-heart-music-camera-bolt::before {
  content: "\\f86d";
}

.blastream-icon-microphone-lines-slash::before {
  content: "\\f539";
}

.blastream-icon-microphone-alt-slash::before {
  content: "\\f539";
}

.blastream-icon-bridge-circle-check::before {
  content: "\\e4c9";
}

.blastream-icon-pump-medical::before {
  content: "\\e06a";
}

.blastream-icon-fingerprint::before {
  content: "\\f577";
}

.blastream-icon-hand-point-right::before {
  content: "\\f0a4";
}

.blastream-icon-magnifying-glass-location::before {
  content: "\\f689";
}

.blastream-icon-search-location::before {
  content: "\\f689";
}

.blastream-icon-forward-step::before {
  content: "\\f051";
}

.blastream-icon-step-forward::before {
  content: "\\f051";
}

.blastream-icon-face-smile-beam::before {
  content: "\\f5b8";
}

.blastream-icon-smile-beam::before {
  content: "\\f5b8";
}

.blastream-icon-flag-checkered::before {
  content: "\\f11e";
}

.blastream-icon-football::before {
  content: "\\f44e";
}

.blastream-icon-football-ball::before {
  content: "\\f44e";
}

.blastream-icon-school-circle-exclamation::before {
  content: "\\e56c";
}

.blastream-icon-crop::before {
  content: "\\f125";
}

.blastream-icon-angles-down::before {
  content: "\\f103";
}

.blastream-icon-angle-double-down::before {
  content: "\\f103";
}

.blastream-icon-users-rectangle::before {
  content: "\\e594";
}

.blastream-icon-people-roof::before {
  content: "\\e537";
}

.blastream-icon-people-line::before {
  content: "\\e534";
}

.blastream-icon-beer-mug-empty::before {
  content: "\\f0fc";
}

.blastream-icon-beer::before {
  content: "\\f0fc";
}

.blastream-icon-diagram-predecessor::before {
  content: "\\e477";
}

.blastream-icon-arrow-up-long::before {
  content: "\\f176";
}

.blastream-icon-long-arrow-up::before {
  content: "\\f176";
}

.blastream-icon-fire-flame-simple::before {
  content: "\\f46a";
}

.blastream-icon-burn::before {
  content: "\\f46a";
}

.blastream-icon-person::before {
  content: "\\f183";
}

.blastream-icon-male::before {
  content: "\\f183";
}

.blastream-icon-laptop::before {
  content: "\\f109";
}

.blastream-icon-file-csv::before {
  content: "\\f6dd";
}

.blastream-icon-menorah::before {
  content: "\\f676";
}

.blastream-icon-truck-plane::before {
  content: "\\e58f";
}

.blastream-icon-record-vinyl::before {
  content: "\\f8d9";
}

.blastream-icon-face-grin-stars::before {
  content: "\\f587";
}

.blastream-icon-grin-stars::before {
  content: "\\f587";
}

.blastream-icon-bong::before {
  content: "\\f55c";
}

.blastream-icon-spaghetti-monster-flying::before {
  content: "\\f67b";
}

.blastream-icon-pastafarianism::before {
  content: "\\f67b";
}

.blastream-icon-arrow-down-up-across-line::before {
  content: "\\e4af";
}

.blastream-icon-spoon::before {
  content: "\\f2e5";
}

.blastream-icon-utensil-spoon::before {
  content: "\\f2e5";
}

.blastream-icon-jar-wheat::before {
  content: "\\e517";
}

.blastream-icon-envelopes-bulk::before {
  content: "\\f674";
}

.blastream-icon-mail-bulk::before {
  content: "\\f674";
}

.blastream-icon-file-circle-exclamation::before {
  content: "\\e4eb";
}

.blastream-icon-circle-h::before {
  content: "\\f47e";
}

.blastream-icon-hospital-symbol::before {
  content: "\\f47e";
}

.blastream-icon-pager::before {
  content: "\\f815";
}

.blastream-icon-address-book::before {
  content: "\\f2b9";
}

.blastream-icon-contact-book::before {
  content: "\\f2b9";
}

.blastream-icon-strikethrough::before {
  content: "\\f0cc";
}

.blastream-icon-k::before {
  content: "K";
}

.blastream-icon-landmark-flag::before {
  content: "\\e51c";
}

.blastream-icon-pencil::before {
  content: "\\f303";
}

.blastream-icon-pencil-alt::before {
  content: "\\f303";
}

.blastream-icon-backward::before {
  content: "\\f04a";
}

.blastream-icon-caret-right::before {
  content: "\\f0da";
}

.blastream-icon-comments::before {
  content: "\\f086";
}

.blastream-icon-paste::before {
  content: "\\f0ea";
}

.blastream-icon-file-clipboard::before {
  content: "\\f0ea";
}

.blastream-icon-code-pull-request::before {
  content: "\\e13c";
}

.blastream-icon-clipboard-list::before {
  content: "\\f46d";
}

.blastream-icon-truck-ramp-box::before {
  content: "\\f4de";
}

.blastream-icon-truck-loading::before {
  content: "\\f4de";
}

.blastream-icon-user-check::before {
  content: "\\f4fc";
}

.blastream-icon-vial-virus::before {
  content: "\\e597";
}

.blastream-icon-sheet-plastic::before {
  content: "\\e571";
}

.blastream-icon-blog::before {
  content: "\\f781";
}

.blastream-icon-user-ninja::before {
  content: "\\f504";
}

.blastream-icon-person-arrow-up-from-line::before {
  content: "\\e539";
}

.blastream-icon-scroll-torah::before {
  content: "\\f6a0";
}

.blastream-icon-torah::before {
  content: "\\f6a0";
}

.blastream-icon-broom-ball::before {
  content: "\\f458";
}

.blastream-icon-quidditch::before {
  content: "\\f458";
}

.blastream-icon-quidditch-broom-ball::before {
  content: "\\f458";
}

.blastream-icon-toggle-off::before {
  content: "\\f204";
}

.blastream-icon-box-archive::before {
  content: "\\f187";
}

.blastream-icon-archive::before {
  content: "\\f187";
}

.blastream-icon-person-drowning::before {
  content: "\\e545";
}

.blastream-icon-arrow-down-9-1::before {
  content: "\\f886";
}

.blastream-icon-sort-numeric-desc::before {
  content: "\\f886";
}

.blastream-icon-sort-numeric-down-alt::before {
  content: "\\f886";
}

.blastream-icon-face-grin-tongue-squint::before {
  content: "\\f58a";
}

.blastream-icon-grin-tongue-squint::before {
  content: "\\f58a";
}

.blastream-icon-spray-can::before {
  content: "\\f5bd";
}

.blastream-icon-truck-monster::before {
  content: "\\f63b";
}

.blastream-icon-w::before {
  content: "W";
}

.blastream-icon-earth-africa::before {
  content: "\\f57c";
}

.blastream-icon-globe-africa::before {
  content: "\\f57c";
}

.blastream-icon-rainbow::before {
  content: "\\f75b";
}

.blastream-icon-circle-notch::before {
  content: "\\f1ce";
}

.blastream-icon-tablet-screen-button::before {
  content: "\\f3fa";
}

.blastream-icon-tablet-alt::before {
  content: "\\f3fa";
}

.blastream-icon-paw::before {
  content: "\\f1b0";
}

.blastream-icon-cloud::before {
  content: "\\f0c2";
}

.blastream-icon-trowel-bricks::before {
  content: "\\e58a";
}

.blastream-icon-face-flushed::before {
  content: "\\f579";
}

.blastream-icon-flushed::before {
  content: "\\f579";
}

.blastream-icon-hospital-user::before {
  content: "\\f80d";
}

.blastream-icon-tent-arrow-left-right::before {
  content: "\\e57f";
}

.blastream-icon-gavel::before {
  content: "\\f0e3";
}

.blastream-icon-legal::before {
  content: "\\f0e3";
}

.blastream-icon-binoculars::before {
  content: "\\f1e5";
}

.blastream-icon-microphone-slash::before {
  content: "\\f131";
}

.blastream-icon-box-tissue::before {
  content: "\\e05b";
}

.blastream-icon-motorcycle::before {
  content: "\\f21c";
}

.blastream-icon-bell-concierge::before {
  content: "\\f562";
}

.blastream-icon-concierge-bell::before {
  content: "\\f562";
}

.blastream-icon-pen-ruler::before {
  content: "\\f5ae";
}

.blastream-icon-pencil-ruler::before {
  content: "\\f5ae";
}

.blastream-icon-people-arrows::before {
  content: "\\e068";
}

.blastream-icon-people-arrows-left-right::before {
  content: "\\e068";
}

.blastream-icon-mars-and-venus-burst::before {
  content: "\\e523";
}

.blastream-icon-square-caret-right::before {
  content: "\\f152";
}

.blastream-icon-caret-square-right::before {
  content: "\\f152";
}

.blastream-icon-scissors::before {
  content: "\\f0c4";
}

.blastream-icon-cut::before {
  content: "\\f0c4";
}

.blastream-icon-sun-plant-wilt::before {
  content: "\\e57a";
}

.blastream-icon-toilets-portable::before {
  content: "\\e584";
}

.blastream-icon-hockey-puck::before {
  content: "\\f453";
}

.blastream-icon-table::before {
  content: "\\f0ce";
}

.blastream-icon-magnifying-glass-arrow-right::before {
  content: "\\e521";
}

.blastream-icon-tachograph-digital::before {
  content: "\\f566";
}

.blastream-icon-digital-tachograph::before {
  content: "\\f566";
}

.blastream-icon-users-slash::before {
  content: "\\e073";
}

.blastream-icon-clover::before {
  content: "\\e139";
}

.blastream-icon-reply::before {
  content: "\\f3e5";
}

.blastream-icon-mail-reply::before {
  content: "\\f3e5";
}

.blastream-icon-star-and-crescent::before {
  content: "\\f699";
}

.blastream-icon-house-fire::before {
  content: "\\e50c";
}

.blastream-icon-square-minus::before {
  content: "\\f146";
}

.blastream-icon-minus-square::before {
  content: "\\f146";
}

.blastream-icon-helicopter::before {
  content: "\\f533";
}

.blastream-icon-compass::before {
  content: "\\f14e";
}

.blastream-icon-square-caret-down::before {
  content: "\\f150";
}

.blastream-icon-caret-square-down::before {
  content: "\\f150";
}

.blastream-icon-file-circle-question::before {
  content: "\\e4ef";
}

.blastream-icon-laptop-code::before {
  content: "\\f5fc";
}

.blastream-icon-swatchbook::before {
  content: "\\f5c3";
}

.blastream-icon-prescription-bottle::before {
  content: "\\f485";
}

.blastream-icon-bars::before {
  content: "\\f0c9";
}

.blastream-icon-navicon::before {
  content: "\\f0c9";
}

.blastream-icon-people-group::before {
  content: "\\e533";
}

.blastream-icon-hourglass-end::before {
  content: "\\f253";
}

.blastream-icon-hourglass-3::before {
  content: "\\f253";
}

.blastream-icon-heart-crack::before {
  content: "\\f7a9";
}

.blastream-icon-heart-broken::before {
  content: "\\f7a9";
}

.blastream-icon-square-up-right::before {
  content: "\\f360";
}

.blastream-icon-external-link-square-alt::before {
  content: "\\f360";
}

.blastream-icon-face-kiss-beam::before {
  content: "\\f597";
}

.blastream-icon-kiss-beam::before {
  content: "\\f597";
}

.blastream-icon-film::before {
  content: "\\f008";
}

.blastream-icon-ruler-horizontal::before {
  content: "\\f547";
}

.blastream-icon-people-robbery::before {
  content: "\\e536";
}

.blastream-icon-lightbulb::before {
  content: "\\f0eb";
}

.blastream-icon-caret-left::before {
  content: "\\f0d9";
}

.blastream-icon-circle-exclamation::before {
  content: "\\f06a";
}

.blastream-icon-exclamation-circle::before {
  content: "\\f06a";
}

.blastream-icon-school-circle-xmark::before {
  content: "\\e56d";
}

.blastream-icon-arrow-right-from-bracket::before {
  content: "\\f08b";
}

.blastream-icon-sign-out::before {
  content: "\\f08b";
}

.blastream-icon-circle-chevron-down::before {
  content: "\\f13a";
}

.blastream-icon-chevron-circle-down::before {
  content: "\\f13a";
}

.blastream-icon-unlock-keyhole::before {
  content: "\\f13e";
}

.blastream-icon-unlock-alt::before {
  content: "\\f13e";
}

.blastream-icon-cloud-showers-heavy::before {
  content: "\\f740";
}

.blastream-icon-headphones-simple::before {
  content: "\\f58f";
}

.blastream-icon-headphones-alt::before {
  content: "\\f58f";
}

.blastream-icon-sitemap::before {
  content: "\\f0e8";
}

.blastream-icon-circle-dollar-to-slot::before {
  content: "\\f4b9";
}

.blastream-icon-donate::before {
  content: "\\f4b9";
}

.blastream-icon-memory::before {
  content: "\\f538";
}

.blastream-icon-road-spikes::before {
  content: "\\e568";
}

.blastream-icon-fire-burner::before {
  content: "\\e4f1";
}

.blastream-icon-flag::before {
  content: "\\f024";
}

.blastream-icon-hanukiah::before {
  content: "\\f6e6";
}

.blastream-icon-feather::before {
  content: "\\f52d";
}

.blastream-icon-volume-low::before {
  content: "\\f027";
}

.blastream-icon-volume-down::before {
  content: "\\f027";
}

.blastream-icon-comment-slash::before {
  content: "\\f4b3";
}

.blastream-icon-cloud-sun-rain::before {
  content: "\\f743";
}

.blastream-icon-compress::before {
  content: "\\f066";
}

.blastream-icon-wheat-awn::before {
  content: "\\e2cd";
}

.blastream-icon-wheat-alt::before {
  content: "\\e2cd";
}

.blastream-icon-ankh::before {
  content: "\\f644";
}

.blastream-icon-hands-holding-child::before {
  content: "\\e4fa";
}

.blastream-icon-asterisk::before {
  content: "\\*";
}

.blastream-icon-square-check::before {
  content: "\\f14a";
}

.blastream-icon-check-square::before {
  content: "\\f14a";
}

.blastream-icon-peseta-sign::before {
  content: "\\e221";
}

.blastream-icon-heading::before {
  content: "\\f1dc";
}

.blastream-icon-header::before {
  content: "\\f1dc";
}

.blastream-icon-ghost::before {
  content: "\\f6e2";
}

.blastream-icon-list::before {
  content: "\\f03a";
}

.blastream-icon-list-squares::before {
  content: "\\f03a";
}

.blastream-icon-square-phone-flip::before {
  content: "\\f87b";
}

.blastream-icon-phone-square-alt::before {
  content: "\\f87b";
}

.blastream-icon-cart-plus::before {
  content: "\\f217";
}

.blastream-icon-gamepad::before {
  content: "\\f11b";
}

.blastream-icon-circle-dot::before {
  content: "\\f192";
}

.blastream-icon-dot-circle::before {
  content: "\\f192";
}

.blastream-icon-face-dizzy::before {
  content: "\\f567";
}

.blastream-icon-dizzy::before {
  content: "\\f567";
}

.blastream-icon-egg::before {
  content: "\\f7fb";
}

.blastream-icon-house-medical-circle-xmark::before {
  content: "\\e513";
}

.blastream-icon-campground::before {
  content: "\\f6bb";
}

.blastream-icon-folder-plus::before {
  content: "\\f65e";
}

.blastream-icon-futbol::before {
  content: "\\f1e3";
}

.blastream-icon-futbol-ball::before {
  content: "\\f1e3";
}

.blastream-icon-soccer-ball::before {
  content: "\\f1e3";
}

.blastream-icon-paintbrush::before {
  content: "\\f1fc";
}

.blastream-icon-paint-brush::before {
  content: "\\f1fc";
}

.blastream-icon-lock::before {
  content: "\\f023";
}

.blastream-icon-gas-pump::before {
  content: "\\f52f";
}

.blastream-icon-hot-tub-person::before {
  content: "\\f593";
}

.blastream-icon-hot-tub::before {
  content: "\\f593";
}

.blastream-icon-map-location::before {
  content: "\\f59f";
}

.blastream-icon-map-marked::before {
  content: "\\f59f";
}

.blastream-icon-house-flood-water::before {
  content: "\\e50e";
}

.blastream-icon-tree::before {
  content: "\\f1bb";
}

.blastream-icon-bridge-lock::before {
  content: "\\e4cc";
}

.blastream-icon-sack-dollar::before {
  content: "\\f81d";
}

.blastream-icon-pen-to-square::before {
  content: "\\f044";
}

.blastream-icon-edit::before {
  content: "\\f044";
}

.blastream-icon-car-side::before {
  content: "\\f5e4";
}

.blastream-icon-share-nodes::before {
  content: "\\f1e0";
}

.blastream-icon-share-alt::before {
  content: "\\f1e0";
}

.blastream-icon-heart-circle-minus::before {
  content: "\\e4ff";
}

.blastream-icon-hourglass-half::before {
  content: "\\f252";
}

.blastream-icon-hourglass-2::before {
  content: "\\f252";
}

.blastream-icon-microscope::before {
  content: "\\f610";
}

.blastream-icon-sink::before {
  content: "\\e06d";
}

.blastream-icon-bag-shopping::before {
  content: "\\f290";
}

.blastream-icon-shopping-bag::before {
  content: "\\f290";
}

.blastream-icon-arrow-down-z-a::before {
  content: "\\f881";
}

.blastream-icon-sort-alpha-desc::before {
  content: "\\f881";
}

.blastream-icon-sort-alpha-down-alt::before {
  content: "\\f881";
}

.blastream-icon-mitten::before {
  content: "\\f7b5";
}

.blastream-icon-person-rays::before {
  content: "\\e54d";
}

.blastream-icon-users::before {
  content: "\\f0c0";
}

.blastream-icon-eye-slash::before {
  content: "\\f070";
}

.blastream-icon-flask-vial::before {
  content: "\\e4f3";
}

.blastream-icon-hand::before {
  content: "\\f256";
}

.blastream-icon-hand-paper::before {
  content: "\\f256";
}

.blastream-icon-om::before {
  content: "\\f679";
}

.blastream-icon-worm::before {
  content: "\\e599";
}

.blastream-icon-house-circle-xmark::before {
  content: "\\e50b";
}

.blastream-icon-plug::before {
  content: "\\f1e6";
}

.blastream-icon-chevron-up::before {
  content: "\\f077";
}

.blastream-icon-hand-spock::before {
  content: "\\f259";
}

.blastream-icon-stopwatch::before {
  content: "\\f2f2";
}

.blastream-icon-face-kiss::before {
  content: "\\f596";
}

.blastream-icon-kiss::before {
  content: "\\f596";
}

.blastream-icon-bridge-circle-xmark::before {
  content: "\\e4cb";
}

.blastream-icon-face-grin-tongue::before {
  content: "\\f589";
}

.blastream-icon-grin-tongue::before {
  content: "\\f589";
}

.blastream-icon-chess-bishop::before {
  content: "\\f43a";
}

.blastream-icon-face-grin-wink::before {
  content: "\\f58c";
}

.blastream-icon-grin-wink::before {
  content: "\\f58c";
}

.blastream-icon-ear-deaf::before {
  content: "\\f2a4";
}

.blastream-icon-deaf::before {
  content: "\\f2a4";
}

.blastream-icon-deafness::before {
  content: "\\f2a4";
}

.blastream-icon-hard-of-hearing::before {
  content: "\\f2a4";
}

.blastream-icon-road-circle-check::before {
  content: "\\e564";
}

.blastream-icon-dice-five::before {
  content: "\\f523";
}

.blastream-icon-square-rss::before {
  content: "\\f143";
}

.blastream-icon-rss-square::before {
  content: "\\f143";
}

.blastream-icon-land-mine-on::before {
  content: "\\e51b";
}

.blastream-icon-i-cursor::before {
  content: "\\f246";
}

.blastream-icon-stamp::before {
  content: "\\f5bf";
}

.blastream-icon-stairs::before {
  content: "\\e289";
}

.blastream-icon-i::before {
  content: "I";
}

.blastream-icon-hryvnia-sign::before {
  content: "\\f6f2";
}

.blastream-icon-hryvnia::before {
  content: "\\f6f2";
}

.blastream-icon-pills::before {
  content: "\\f484";
}

.blastream-icon-face-grin-wide::before {
  content: "\\f581";
}

.blastream-icon-grin-alt::before {
  content: "\\f581";
}

.blastream-icon-tooth::before {
  content: "\\f5c9";
}

.blastream-icon-v::before {
  content: "V";
}

.blastream-icon-bangladeshi-taka-sign::before {
  content: "\\e2e6";
}

.blastream-icon-bicycle::before {
  content: "\\f206";
}

.blastream-icon-staff-snake::before {
  content: "\\e579";
}

.blastream-icon-rod-asclepius::before {
  content: "\\e579";
}

.blastream-icon-rod-snake::before {
  content: "\\e579";
}

.blastream-icon-staff-aesculapius::before {
  content: "\\e579";
}

.blastream-icon-head-side-cough-slash::before {
  content: "\\e062";
}

.blastream-icon-truck-medical::before {
  content: "\\f0f9";
}

.blastream-icon-ambulance::before {
  content: "\\f0f9";
}

.blastream-icon-wheat-awn-circle-exclamation::before {
  content: "\\e598";
}

.blastream-icon-snowman::before {
  content: "\\f7d0";
}

.blastream-icon-mortar-pestle::before {
  content: "\\f5a7";
}

.blastream-icon-road-barrier::before {
  content: "\\e562";
}

.blastream-icon-school::before {
  content: "\\f549";
}

.blastream-icon-igloo::before {
  content: "\\f7ae";
}

.blastream-icon-joint::before {
  content: "\\f595";
}

.blastream-icon-angle-right::before {
  content: "\\f105";
}

.blastream-icon-horse::before {
  content: "\\f6f0";
}

.blastream-icon-q::before {
  content: "Q";
}

.blastream-icon-g::before {
  content: "G";
}

.blastream-icon-notes-medical::before {
  content: "\\f481";
}

.blastream-icon-temperature-half::before {
  content: "\\f2c9";
}

.blastream-icon-temperature-2::before {
  content: "\\f2c9";
}

.blastream-icon-thermometer-2::before {
  content: "\\f2c9";
}

.blastream-icon-thermometer-half::before {
  content: "\\f2c9";
}

.blastream-icon-dong-sign::before {
  content: "\\e169";
}

.blastream-icon-capsules::before {
  content: "\\f46b";
}

.blastream-icon-poo-storm::before {
  content: "\\f75a";
}

.blastream-icon-poo-bolt::before {
  content: "\\f75a";
}

.blastream-icon-face-frown-open::before {
  content: "\\f57a";
}

.blastream-icon-frown-open::before {
  content: "\\f57a";
}

.blastream-icon-hand-point-up::before {
  content: "\\f0a6";
}

.blastream-icon-money-bill::before {
  content: "\\f0d6";
}

.blastream-icon-bookmark::before {
  content: "\\f02e";
}

.blastream-icon-align-justify::before {
  content: "\\f039";
}

.blastream-icon-umbrella-beach::before {
  content: "\\f5ca";
}

.blastream-icon-helmet-un::before {
  content: "\\e503";
}

.blastream-icon-bullseye::before {
  content: "\\f140";
}

.blastream-icon-bacon::before {
  content: "\\f7e5";
}

.blastream-icon-hand-point-down::before {
  content: "\\f0a7";
}

.blastream-icon-arrow-up-from-bracket::before {
  content: "\\e09a";
}

.blastream-icon-folder::before {
  content: "\\f07b";
}

.blastream-icon-folder-blank::before {
  content: "\\f07b";
}

.blastream-icon-file-waveform::before {
  content: "\\f478";
}

.blastream-icon-file-medical-alt::before {
  content: "\\f478";
}

.blastream-icon-radiation::before {
  content: "\\f7b9";
}

.blastream-icon-chart-simple::before {
  content: "\\e473";
}

.blastream-icon-mars-stroke::before {
  content: "\\f229";
}

.blastream-icon-vial::before {
  content: "\\f492";
}

.blastream-icon-gauge::before {
  content: "\\f624";
}

.blastream-icon-dashboard::before {
  content: "\\f624";
}

.blastream-icon-gauge-med::before {
  content: "\\f624";
}

.blastream-icon-tachometer-alt-average::before {
  content: "\\f624";
}

.blastream-icon-wand-magic-sparkles::before {
  content: "\\e2ca";
}

.blastream-icon-magic-wand-sparkles::before {
  content: "\\e2ca";
}

.blastream-icon-e::before {
  content: "E";
}

.blastream-icon-pen-clip::before {
  content: "\\f305";
}

.blastream-icon-pen-alt::before {
  content: "\\f305";
}

.blastream-icon-bridge-circle-exclamation::before {
  content: "\\e4ca";
}

.blastream-icon-user::before {
  content: "\\f007";
}

.blastream-icon-school-circle-check::before {
  content: "\\e56b";
}

.blastream-icon-dumpster::before {
  content: "\\f793";
}

.blastream-icon-van-shuttle::before {
  content: "\\f5b6";
}

.blastream-icon-shuttle-van::before {
  content: "\\f5b6";
}

.blastream-icon-building-user::before {
  content: "\\e4da";
}

.blastream-icon-square-caret-left::before {
  content: "\\f191";
}

.blastream-icon-caret-square-left::before {
  content: "\\f191";
}

.blastream-icon-highlighter::before {
  content: "\\f591";
}

.blastream-icon-key::before {
  content: "\\f084";
}

.blastream-icon-bullhorn::before {
  content: "\\f0a1";
}

.blastream-icon-globe::before {
  content: "\\f0ac";
}

.blastream-icon-synagogue::before {
  content: "\\f69b";
}

.blastream-icon-person-half-dress::before {
  content: "\\e548";
}

.blastream-icon-road-bridge::before {
  content: "\\e563";
}

.blastream-icon-location-arrow::before {
  content: "\\f124";
}

.blastream-icon-c::before {
  content: "C";
}

.blastream-icon-tablet-button::before {
  content: "\\f10a";
}

.blastream-icon-building-lock::before {
  content: "\\e4d6";
}

.blastream-icon-pizza-slice::before {
  content: "\\f818";
}

.blastream-icon-money-bill-wave::before {
  content: "\\f53a";
}

.blastream-icon-chart-area::before {
  content: "\\f1fe";
}

.blastream-icon-area-chart::before {
  content: "\\f1fe";
}

.blastream-icon-house-flag::before {
  content: "\\e50d";
}

.blastream-icon-person-circle-minus::before {
  content: "\\e540";
}

.blastream-icon-ban::before {
  content: "\\f05e";
}

.blastream-icon-cancel::before {
  content: "\\f05e";
}

.blastream-icon-camera-rotate::before {
  content: "\\e0d8";
}

.blastream-icon-spray-can-sparkles::before {
  content: "\\f5d0";
}

.blastream-icon-air-freshener::before {
  content: "\\f5d0";
}

.blastream-icon-star::before {
  content: "\\f005";
}

.blastream-icon-repeat::before {
  content: "\\f363";
}

.blastream-icon-cross::before {
  content: "\\f654";
}

.blastream-icon-box::before {
  content: "\\f466";
}

.blastream-icon-venus-mars::before {
  content: "\\f228";
}

.blastream-icon-arrow-pointer::before {
  content: "\\f245";
}

.blastream-icon-mouse-pointer::before {
  content: "\\f245";
}

.blastream-icon-maximize::before {
  content: "\\f31e";
}

.blastream-icon-expand-arrows-alt::before {
  content: "\\f31e";
}

.blastream-icon-charging-station::before {
  content: "\\f5e7";
}

.blastream-icon-shapes::before {
  content: "\\f61f";
}

.blastream-icon-triangle-circle-square::before {
  content: "\\f61f";
}

.blastream-icon-shuffle::before {
  content: "\\f074";
}

.blastream-icon-random::before {
  content: "\\f074";
}

.blastream-icon-person-running::before {
  content: "\\f70c";
}

.blastream-icon-running::before {
  content: "\\f70c";
}

.blastream-icon-mobile-retro::before {
  content: "\\e527";
}

.blastream-icon-grip-lines-vertical::before {
  content: "\\f7a5";
}

.blastream-icon-spider::before {
  content: "\\f717";
}

.blastream-icon-hands-bound::before {
  content: "\\e4f9";
}

.blastream-icon-file-invoice-dollar::before {
  content: "\\f571";
}

.blastream-icon-plane-circle-exclamation::before {
  content: "\\e556";
}

.blastream-icon-x-ray::before {
  content: "\\f497";
}

.blastream-icon-spell-check::before {
  content: "\\f891";
}

.blastream-icon-slash::before {
  content: "\\f715";
}

.blastream-icon-computer-mouse::before {
  content: "\\f8cc";
}

.blastream-icon-mouse::before {
  content: "\\f8cc";
}

.blastream-icon-arrow-right-to-bracket::before {
  content: "\\f090";
}

.blastream-icon-sign-in::before {
  content: "\\f090";
}

.blastream-icon-shop-slash::before {
  content: "\\e070";
}

.blastream-icon-store-alt-slash::before {
  content: "\\e070";
}

.blastream-icon-server::before {
  content: "\\f233";
}

.blastream-icon-virus-covid-slash::before {
  content: "\\e4a9";
}

.blastream-icon-shop-lock::before {
  content: "\\e4a5";
}

.blastream-icon-hourglass-start::before {
  content: "\\f251";
}

.blastream-icon-hourglass-1::before {
  content: "\\f251";
}

.blastream-icon-blender-phone::before {
  content: "\\f6b6";
}

.blastream-icon-building-wheat::before {
  content: "\\e4db";
}

.blastream-icon-person-breastfeeding::before {
  content: "\\e53a";
}

.blastream-icon-right-to-bracket::before {
  content: "\\f2f6";
}

.blastream-icon-sign-in-alt::before {
  content: "\\f2f6";
}

.blastream-icon-venus::before {
  content: "\\f221";
}

.blastream-icon-passport::before {
  content: "\\f5ab";
}

.blastream-icon-thumbtack-slash::before {
  content: "\\e68f";
}

.blastream-icon-thumb-tack-slash::before {
  content: "\\e68f";
}

.blastream-icon-heart-pulse::before {
  content: "\\f21e";
}

.blastream-icon-heartbeat::before {
  content: "\\f21e";
}

.blastream-icon-people-carry-box::before {
  content: "\\f4ce";
}

.blastream-icon-people-carry::before {
  content: "\\f4ce";
}

.blastream-icon-temperature-high::before {
  content: "\\f769";
}

.blastream-icon-microchip::before {
  content: "\\f2db";
}

.blastream-icon-crown::before {
  content: "\\f521";
}

.blastream-icon-weight-hanging::before {
  content: "\\f5cd";
}

.blastream-icon-xmarks-lines::before {
  content: "\\e59a";
}

.blastream-icon-file-prescription::before {
  content: "\\f572";
}

.blastream-icon-weight-scale::before {
  content: "\\f496";
}

.blastream-icon-weight::before {
  content: "\\f496";
}

.blastream-icon-user-group::before {
  content: "\\f500";
}

.blastream-icon-user-friends::before {
  content: "\\f500";
}

.blastream-icon-arrow-up-a-z::before {
  content: "\\f15e";
}

.blastream-icon-sort-alpha-up::before {
  content: "\\f15e";
}

.blastream-icon-chess-knight::before {
  content: "\\f441";
}

.blastream-icon-face-laugh-squint::before {
  content: "\\f59b";
}

.blastream-icon-laugh-squint::before {
  content: "\\f59b";
}

.blastream-icon-wheelchair::before {
  content: "\\f193";
}

.blastream-icon-circle-arrow-up::before {
  content: "\\f0aa";
}

.blastream-icon-arrow-circle-up::before {
  content: "\\f0aa";
}

.blastream-icon-toggle-on::before {
  content: "\\f205";
}

.blastream-icon-person-walking::before {
  content: "\\f554";
}

.blastream-icon-walking::before {
  content: "\\f554";
}

.blastream-icon-l::before {
  content: "L";
}

.blastream-icon-fire::before {
  content: "\\f06d";
}

.blastream-icon-bed-pulse::before {
  content: "\\f487";
}

.blastream-icon-procedures::before {
  content: "\\f487";
}

.blastream-icon-shuttle-space::before {
  content: "\\f197";
}

.blastream-icon-space-shuttle::before {
  content: "\\f197";
}

.blastream-icon-face-laugh::before {
  content: "\\f599";
}

.blastream-icon-laugh::before {
  content: "\\f599";
}

.blastream-icon-folder-open::before {
  content: "\\f07c";
}

.blastream-icon-heart-circle-plus::before {
  content: "\\e500";
}

.blastream-icon-code-fork::before {
  content: "\\e13b";
}

.blastream-icon-city::before {
  content: "\\f64f";
}

.blastream-icon-microphone-lines::before {
  content: "\\f3c9";
}

.blastream-icon-microphone-alt::before {
  content: "\\f3c9";
}

.blastream-icon-pepper-hot::before {
  content: "\\f816";
}

.blastream-icon-unlock::before {
  content: "\\f09c";
}

.blastream-icon-colon-sign::before {
  content: "\\e140";
}

.blastream-icon-headset::before {
  content: "\\f590";
}

.blastream-icon-store-slash::before {
  content: "\\e071";
}

.blastream-icon-road-circle-xmark::before {
  content: "\\e566";
}

.blastream-icon-user-minus::before {
  content: "\\f503";
}

.blastream-icon-mars-stroke-up::before {
  content: "\\f22a";
}

.blastream-icon-mars-stroke-v::before {
  content: "\\f22a";
}

.blastream-icon-champagne-glasses::before {
  content: "\\f79f";
}

.blastream-icon-glass-cheers::before {
  content: "\\f79f";
}

.blastream-icon-clipboard::before {
  content: "\\f328";
}

.blastream-icon-house-circle-exclamation::before {
  content: "\\e50a";
}

.blastream-icon-file-arrow-up::before {
  content: "\\f574";
}

.blastream-icon-file-upload::before {
  content: "\\f574";
}

.blastream-icon-wifi::before {
  content: "\\f1eb";
}

.blastream-icon-wifi-3::before {
  content: "\\f1eb";
}

.blastream-icon-wifi-strong::before {
  content: "\\f1eb";
}

.blastream-icon-bath::before {
  content: "\\f2cd";
}

.blastream-icon-bathtub::before {
  content: "\\f2cd";
}

.blastream-icon-underline::before {
  content: "\\f0cd";
}

.blastream-icon-user-pen::before {
  content: "\\f4ff";
}

.blastream-icon-user-edit::before {
  content: "\\f4ff";
}

.blastream-icon-signature::before {
  content: "\\f5b7";
}

.blastream-icon-stroopwafel::before {
  content: "\\f551";
}

.blastream-icon-bold::before {
  content: "\\f032";
}

.blastream-icon-anchor-lock::before {
  content: "\\e4ad";
}

.blastream-icon-building-ngo::before {
  content: "\\e4d7";
}

.blastream-icon-manat-sign::before {
  content: "\\e1d5";
}

.blastream-icon-not-equal::before {
  content: "\\f53e";
}

.blastream-icon-border-top-left::before {
  content: "\\f853";
}

.blastream-icon-border-style::before {
  content: "\\f853";
}

.blastream-icon-map-location-dot::before {
  content: "\\f5a0";
}

.blastream-icon-map-marked-alt::before {
  content: "\\f5a0";
}

.blastream-icon-jedi::before {
  content: "\\f669";
}

.blastream-icon-square-poll-vertical::before {
  content: "\\f681";
}

.blastream-icon-poll::before {
  content: "\\f681";
}

.blastream-icon-mug-hot::before {
  content: "\\f7b6";
}

.blastream-icon-car-battery::before {
  content: "\\f5df";
}

.blastream-icon-battery-car::before {
  content: "\\f5df";
}

.blastream-icon-gift::before {
  content: "\\f06b";
}

.blastream-icon-dice-two::before {
  content: "\\f528";
}

.blastream-icon-chess-queen::before {
  content: "\\f445";
}

.blastream-icon-glasses::before {
  content: "\\f530";
}

.blastream-icon-chess-board::before {
  content: "\\f43c";
}

.blastream-icon-building-circle-check::before {
  content: "\\e4d2";
}

.blastream-icon-person-chalkboard::before {
  content: "\\e53d";
}

.blastream-icon-mars-stroke-right::before {
  content: "\\f22b";
}

.blastream-icon-mars-stroke-h::before {
  content: "\\f22b";
}

.blastream-icon-hand-back-fist::before {
  content: "\\f255";
}

.blastream-icon-hand-rock::before {
  content: "\\f255";
}

.blastream-icon-square-caret-up::before {
  content: "\\f151";
}

.blastream-icon-caret-square-up::before {
  content: "\\f151";
}

.blastream-icon-cloud-showers-water::before {
  content: "\\e4e4";
}

.blastream-icon-chart-bar::before {
  content: "\\f080";
}

.blastream-icon-bar-chart::before {
  content: "\\f080";
}

.blastream-icon-hands-bubbles::before {
  content: "\\e05e";
}

.blastream-icon-hands-wash::before {
  content: "\\e05e";
}

.blastream-icon-less-than-equal::before {
  content: "\\f537";
}

.blastream-icon-train::before {
  content: "\\f238";
}

.blastream-icon-eye-low-vision::before {
  content: "\\f2a8";
}

.blastream-icon-low-vision::before {
  content: "\\f2a8";
}

.blastream-icon-crow::before {
  content: "\\f520";
}

.blastream-icon-sailboat::before {
  content: "\\e445";
}

.blastream-icon-window-restore::before {
  content: "\\f2d2";
}

.blastream-icon-square-plus::before {
  content: "\\f0fe";
}

.blastream-icon-plus-square::before {
  content: "\\f0fe";
}

.blastream-icon-torii-gate::before {
  content: "\\f6a1";
}

.blastream-icon-frog::before {
  content: "\\f52e";
}

.blastream-icon-bucket::before {
  content: "\\e4cf";
}

.blastream-icon-image::before {
  content: "\\f03e";
}

.blastream-icon-microphone::before {
  content: "\\f130";
}

.blastream-icon-cow::before {
  content: "\\f6c8";
}

.blastream-icon-caret-up::before {
  content: "\\f0d8";
}

.blastream-icon-screwdriver::before {
  content: "\\f54a";
}

.blastream-icon-folder-closed::before {
  content: "\\e185";
}

.blastream-icon-house-tsunami::before {
  content: "\\e515";
}

.blastream-icon-square-nfi::before {
  content: "\\e576";
}

.blastream-icon-arrow-up-from-ground-water::before {
  content: "\\e4b5";
}

.blastream-icon-martini-glass::before {
  content: "\\f57b";
}

.blastream-icon-glass-martini-alt::before {
  content: "\\f57b";
}

.blastream-icon-rotate-left::before {
  content: "\\f2ea";
}

.blastream-icon-rotate-back::before {
  content: "\\f2ea";
}

.blastream-icon-rotate-backward::before {
  content: "\\f2ea";
}

.blastream-icon-undo-alt::before {
  content: "\\f2ea";
}

.blastream-icon-table-columns::before {
  content: "\\f0db";
}

.blastream-icon-columns::before {
  content: "\\f0db";
}

.blastream-icon-lemon::before {
  content: "\\f094";
}

.blastream-icon-head-side-mask::before {
  content: "\\e063";
}

.blastream-icon-handshake::before {
  content: "\\f2b5";
}

.blastream-icon-gem::before {
  content: "\\f3a5";
}

.blastream-icon-dolly::before {
  content: "\\f472";
}

.blastream-icon-dolly-box::before {
  content: "\\f472";
}

.blastream-icon-smoking::before {
  content: "\\f48d";
}

.blastream-icon-minimize::before {
  content: "\\f78c";
}

.blastream-icon-compress-arrows-alt::before {
  content: "\\f78c";
}

.blastream-icon-monument::before {
  content: "\\f5a6";
}

.blastream-icon-snowplow::before {
  content: "\\f7d2";
}

.blastream-icon-angles-right::before {
  content: "\\f101";
}

.blastream-icon-angle-double-right::before {
  content: "\\f101";
}

.blastream-icon-cannabis::before {
  content: "\\f55f";
}

.blastream-icon-circle-play::before {
  content: "\\f144";
}

.blastream-icon-play-circle::before {
  content: "\\f144";
}

.blastream-icon-tablets::before {
  content: "\\f490";
}

.blastream-icon-ethernet::before {
  content: "\\f796";
}

.blastream-icon-euro-sign::before {
  content: "\\f153";
}

.blastream-icon-eur::before {
  content: "\\f153";
}

.blastream-icon-euro::before {
  content: "\\f153";
}

.blastream-icon-chair::before {
  content: "\\f6c0";
}

.blastream-icon-circle-check::before {
  content: "\\f058";
}

.blastream-icon-check-circle::before {
  content: "\\f058";
}

.blastream-icon-circle-stop::before {
  content: "\\f28d";
}

.blastream-icon-stop-circle::before {
  content: "\\f28d";
}

.blastream-icon-compass-drafting::before {
  content: "\\f568";
}

.blastream-icon-drafting-compass::before {
  content: "\\f568";
}

.blastream-icon-plate-wheat::before {
  content: "\\e55a";
}

.blastream-icon-icicles::before {
  content: "\\f7ad";
}

.blastream-icon-person-shelter::before {
  content: "\\e54f";
}

.blastream-icon-neuter::before {
  content: "\\f22c";
}

.blastream-icon-id-badge::before {
  content: "\\f2c1";
}

.blastream-icon-marker::before {
  content: "\\f5a1";
}

.blastream-icon-face-laugh-beam::before {
  content: "\\f59a";
}

.blastream-icon-laugh-beam::before {
  content: "\\f59a";
}

.blastream-icon-helicopter-symbol::before {
  content: "\\e502";
}

.blastream-icon-universal-access::before {
  content: "\\f29a";
}

.blastream-icon-circle-chevron-up::before {
  content: "\\f139";
}

.blastream-icon-chevron-circle-up::before {
  content: "\\f139";
}

.blastream-icon-lari-sign::before {
  content: "\\e1c8";
}

.blastream-icon-volcano::before {
  content: "\\f770";
}

.blastream-icon-person-walking-dashed-line-arrow-right::before {
  content: "\\e553";
}

.blastream-icon-sterling-sign::before {
  content: "\\f154";
}

.blastream-icon-gbp::before {
  content: "\\f154";
}

.blastream-icon-pound-sign::before {
  content: "\\f154";
}

.blastream-icon-viruses::before {
  content: "\\e076";
}

.blastream-icon-square-person-confined::before {
  content: "\\e577";
}

.blastream-icon-user-tie::before {
  content: "\\f508";
}

.blastream-icon-arrow-down-long::before {
  content: "\\f175";
}

.blastream-icon-long-arrow-down::before {
  content: "\\f175";
}

.blastream-icon-tent-arrow-down-to-line::before {
  content: "\\e57e";
}

.blastream-icon-certificate::before {
  content: "\\f0a3";
}

.blastream-icon-reply-all::before {
  content: "\\f122";
}

.blastream-icon-mail-reply-all::before {
  content: "\\f122";
}

.blastream-icon-suitcase::before {
  content: "\\f0f2";
}

.blastream-icon-person-skating::before {
  content: "\\f7c5";
}

.blastream-icon-skating::before {
  content: "\\f7c5";
}

.blastream-icon-filter-circle-dollar::before {
  content: "\\f662";
}

.blastream-icon-funnel-dollar::before {
  content: "\\f662";
}

.blastream-icon-camera-retro::before {
  content: "\\f083";
}

.blastream-icon-circle-arrow-down::before {
  content: "\\f0ab";
}

.blastream-icon-arrow-circle-down::before {
  content: "\\f0ab";
}

.blastream-icon-file-import::before {
  content: "\\f56f";
}

.blastream-icon-arrow-right-to-file::before {
  content: "\\f56f";
}

.blastream-icon-square-arrow-up-right::before {
  content: "\\f14c";
}

.blastream-icon-external-link-square::before {
  content: "\\f14c";
}

.blastream-icon-box-open::before {
  content: "\\f49e";
}

.blastream-icon-scroll::before {
  content: "\\f70e";
}

.blastream-icon-spa::before {
  content: "\\f5bb";
}

.blastream-icon-location-pin-lock::before {
  content: "\\e51f";
}

.blastream-icon-pause::before {
  content: "\\f04c";
}

.blastream-icon-hill-avalanche::before {
  content: "\\e507";
}

.blastream-icon-temperature-empty::before {
  content: "\\f2cb";
}

.blastream-icon-temperature-0::before {
  content: "\\f2cb";
}

.blastream-icon-thermometer-0::before {
  content: "\\f2cb";
}

.blastream-icon-thermometer-empty::before {
  content: "\\f2cb";
}

.blastream-icon-bomb::before {
  content: "\\f1e2";
}

.blastream-icon-registered::before {
  content: "\\f25d";
}

.blastream-icon-address-card::before {
  content: "\\f2bb";
}

.blastream-icon-contact-card::before {
  content: "\\f2bb";
}

.blastream-icon-vcard::before {
  content: "\\f2bb";
}

.blastream-icon-scale-unbalanced-flip::before {
  content: "\\f516";
}

.blastream-icon-balance-scale-right::before {
  content: "\\f516";
}

.blastream-icon-subscript::before {
  content: "\\f12c";
}

.blastream-icon-diamond-turn-right::before {
  content: "\\f5eb";
}

.blastream-icon-directions::before {
  content: "\\f5eb";
}

.blastream-icon-burst::before {
  content: "\\e4dc";
}

.blastream-icon-house-laptop::before {
  content: "\\e066";
}

.blastream-icon-laptop-house::before {
  content: "\\e066";
}

.blastream-icon-face-tired::before {
  content: "\\f5c8";
}

.blastream-icon-tired::before {
  content: "\\f5c8";
}

.blastream-icon-money-bills::before {
  content: "\\e1f3";
}

.blastream-icon-smog::before {
  content: "\\f75f";
}

.blastream-icon-crutch::before {
  content: "\\f7f7";
}

.blastream-icon-cloud-arrow-up::before {
  content: "\\f0ee";
}

.blastream-icon-cloud-upload::before {
  content: "\\f0ee";
}

.blastream-icon-cloud-upload-alt::before {
  content: "\\f0ee";
}

.blastream-icon-palette::before {
  content: "\\f53f";
}

.blastream-icon-arrows-turn-right::before {
  content: "\\e4c0";
}

.blastream-icon-vest::before {
  content: "\\e085";
}

.blastream-icon-ferry::before {
  content: "\\e4ea";
}

.blastream-icon-arrows-down-to-people::before {
  content: "\\e4b9";
}

.blastream-icon-seedling::before {
  content: "\\f4d8";
}

.blastream-icon-sprout::before {
  content: "\\f4d8";
}

.blastream-icon-left-right::before {
  content: "\\f337";
}

.blastream-icon-arrows-alt-h::before {
  content: "\\f337";
}

.blastream-icon-boxes-packing::before {
  content: "\\e4c7";
}

.blastream-icon-circle-arrow-left::before {
  content: "\\f0a8";
}

.blastream-icon-arrow-circle-left::before {
  content: "\\f0a8";
}

.blastream-icon-group-arrows-rotate::before {
  content: "\\e4f6";
}

.blastream-icon-bowl-food::before {
  content: "\\e4c6";
}

.blastream-icon-candy-cane::before {
  content: "\\f786";
}

.blastream-icon-arrow-down-wide-short::before {
  content: "\\f160";
}

.blastream-icon-sort-amount-asc::before {
  content: "\\f160";
}

.blastream-icon-sort-amount-down::before {
  content: "\\f160";
}

.blastream-icon-cloud-bolt::before {
  content: "\\f76c";
}

.blastream-icon-thunderstorm::before {
  content: "\\f76c";
}

.blastream-icon-text-slash::before {
  content: "\\f87d";
}

.blastream-icon-remove-format::before {
  content: "\\f87d";
}

.blastream-icon-face-smile-wink::before {
  content: "\\f4da";
}

.blastream-icon-smile-wink::before {
  content: "\\f4da";
}

.blastream-icon-file-word::before {
  content: "\\f1c2";
}

.blastream-icon-file-powerpoint::before {
  content: "\\f1c4";
}

.blastream-icon-arrows-left-right::before {
  content: "\\f07e";
}

.blastream-icon-arrows-h::before {
  content: "\\f07e";
}

.blastream-icon-house-lock::before {
  content: "\\e510";
}

.blastream-icon-cloud-arrow-down::before {
  content: "\\f0ed";
}

.blastream-icon-cloud-download::before {
  content: "\\f0ed";
}

.blastream-icon-cloud-download-alt::before {
  content: "\\f0ed";
}

.blastream-icon-children::before {
  content: "\\e4e1";
}

.blastream-icon-chalkboard::before {
  content: "\\f51b";
}

.blastream-icon-blackboard::before {
  content: "\\f51b";
}

.blastream-icon-user-large-slash::before {
  content: "\\f4fa";
}

.blastream-icon-user-alt-slash::before {
  content: "\\f4fa";
}

.blastream-icon-envelope-open::before {
  content: "\\f2b6";
}

.blastream-icon-handshake-simple-slash::before {
  content: "\\e05f";
}

.blastream-icon-handshake-alt-slash::before {
  content: "\\e05f";
}

.blastream-icon-mattress-pillow::before {
  content: "\\e525";
}

.blastream-icon-guarani-sign::before {
  content: "\\e19a";
}

.blastream-icon-arrows-rotate::before {
  content: "\\f021";
}

.blastream-icon-refresh::before {
  content: "\\f021";
}

.blastream-icon-sync::before {
  content: "\\f021";
}

.blastream-icon-fire-extinguisher::before {
  content: "\\f134";
}

.blastream-icon-cruzeiro-sign::before {
  content: "\\e152";
}

.blastream-icon-greater-than-equal::before {
  content: "\\f532";
}

.blastream-icon-shield-halved::before {
  content: "\\f3ed";
}

.blastream-icon-shield-alt::before {
  content: "\\f3ed";
}

.blastream-icon-book-atlas::before {
  content: "\\f558";
}

.blastream-icon-atlas::before {
  content: "\\f558";
}

.blastream-icon-virus::before {
  content: "\\e074";
}

.blastream-icon-envelope-circle-check::before {
  content: "\\e4e8";
}

.blastream-icon-layer-group::before {
  content: "\\f5fd";
}

.blastream-icon-arrows-to-dot::before {
  content: "\\e4be";
}

.blastream-icon-archway::before {
  content: "\\f557";
}

.blastream-icon-heart-circle-check::before {
  content: "\\e4fd";
}

.blastream-icon-house-chimney-crack::before {
  content: "\\f6f1";
}

.blastream-icon-house-damage::before {
  content: "\\f6f1";
}

.blastream-icon-file-zipper::before {
  content: "\\f1c6";
}

.blastream-icon-file-archive::before {
  content: "\\f1c6";
}

.blastream-icon-square::before {
  content: "\\f0c8";
}

.blastream-icon-martini-glass-empty::before {
  content: "\\f000";
}

.blastream-icon-glass-martini::before {
  content: "\\f000";
}

.blastream-icon-couch::before {
  content: "\\f4b8";
}

.blastream-icon-cedi-sign::before {
  content: "\\e0df";
}

.blastream-icon-italic::before {
  content: "\\f033";
}

.blastream-icon-table-cells-column-lock::before {
  content: "\\e678";
}

.blastream-icon-church::before {
  content: "\\f51d";
}

.blastream-icon-comments-dollar::before {
  content: "\\f653";
}

.blastream-icon-democrat::before {
  content: "\\f747";
}

.blastream-icon-z::before {
  content: "Z";
}

.blastream-icon-person-skiing::before {
  content: "\\f7c9";
}

.blastream-icon-skiing::before {
  content: "\\f7c9";
}

.blastream-icon-road-lock::before {
  content: "\\e567";
}

.blastream-icon-a::before {
  content: "A";
}

.blastream-icon-temperature-arrow-down::before {
  content: "\\e03f";
}

.blastream-icon-temperature-down::before {
  content: "\\e03f";
}

.blastream-icon-feather-pointed::before {
  content: "\\f56b";
}

.blastream-icon-feather-alt::before {
  content: "\\f56b";
}

.blastream-icon-p::before {
  content: "P";
}

.blastream-icon-snowflake::before {
  content: "\\f2dc";
}

.blastream-icon-newspaper::before {
  content: "\\f1ea";
}

.blastream-icon-rectangle-ad::before {
  content: "\\f641";
}

.blastream-icon-ad::before {
  content: "\\f641";
}

.blastream-icon-circle-arrow-right::before {
  content: "\\f0a9";
}

.blastream-icon-arrow-circle-right::before {
  content: "\\f0a9";
}

.blastream-icon-filter-circle-xmark::before {
  content: "\\e17b";
}

.blastream-icon-locust::before {
  content: "\\e520";
}

.blastream-icon-sort::before {
  content: "\\f0dc";
}

.blastream-icon-unsorted::before {
  content: "\\f0dc";
}

.blastream-icon-list-ol::before {
  content: "\\f0cb";
}

.blastream-icon-list-1-2::before {
  content: "\\f0cb";
}

.blastream-icon-list-numeric::before {
  content: "\\f0cb";
}

.blastream-icon-person-dress-burst::before {
  content: "\\e544";
}

.blastream-icon-money-check-dollar::before {
  content: "\\f53d";
}

.blastream-icon-money-check-alt::before {
  content: "\\f53d";
}

.blastream-icon-vector-square::before {
  content: "\\f5cb";
}

.blastream-icon-bread-slice::before {
  content: "\\f7ec";
}

.blastream-icon-language::before {
  content: "\\f1ab";
}

.blastream-icon-face-kiss-wink-heart::before {
  content: "\\f598";
}

.blastream-icon-kiss-wink-heart::before {
  content: "\\f598";
}

.blastream-icon-filter::before {
  content: "\\f0b0";
}

.blastream-icon-question::before {
  content: "\\?";
}

.blastream-icon-file-signature::before {
  content: "\\f573";
}

.blastream-icon-up-down-left-right::before {
  content: "\\f0b2";
}

.blastream-icon-arrows-alt::before {
  content: "\\f0b2";
}

.blastream-icon-house-chimney-user::before {
  content: "\\e065";
}

.blastream-icon-hand-holding-heart::before {
  content: "\\f4be";
}

.blastream-icon-puzzle-piece::before {
  content: "\\f12e";
}

.blastream-icon-money-check::before {
  content: "\\f53c";
}

.blastream-icon-star-half-stroke::before {
  content: "\\f5c0";
}

.blastream-icon-star-half-alt::before {
  content: "\\f5c0";
}

.blastream-icon-code::before {
  content: "\\f121";
}

.blastream-icon-whiskey-glass::before {
  content: "\\f7a0";
}

.blastream-icon-glass-whiskey::before {
  content: "\\f7a0";
}

.blastream-icon-building-circle-exclamation::before {
  content: "\\e4d3";
}

.blastream-icon-magnifying-glass-chart::before {
  content: "\\e522";
}

.blastream-icon-arrow-up-right-from-square::before {
  content: "\\f08e";
}

.blastream-icon-external-link::before {
  content: "\\f08e";
}

.blastream-icon-cubes-stacked::before {
  content: "\\e4e6";
}

.blastream-icon-won-sign::before {
  content: "\\f159";
}

.blastream-icon-krw::before {
  content: "\\f159";
}

.blastream-icon-won::before {
  content: "\\f159";
}

.blastream-icon-virus-covid::before {
  content: "\\e4a8";
}

.blastream-icon-austral-sign::before {
  content: "\\e0a9";
}

.blastream-icon-f::before {
  content: "F";
}

.blastream-icon-leaf::before {
  content: "\\f06c";
}

.blastream-icon-road::before {
  content: "\\f018";
}

.blastream-icon-taxi::before {
  content: "\\f1ba";
}

.blastream-icon-cab::before {
  content: "\\f1ba";
}

.blastream-icon-person-circle-plus::before {
  content: "\\e541";
}

.blastream-icon-chart-pie::before {
  content: "\\f200";
}

.blastream-icon-pie-chart::before {
  content: "\\f200";
}

.blastream-icon-bolt-lightning::before {
  content: "\\e0b7";
}

.blastream-icon-sack-xmark::before {
  content: "\\e56a";
}

.blastream-icon-file-excel::before {
  content: "\\f1c3";
}

.blastream-icon-file-contract::before {
  content: "\\f56c";
}

.blastream-icon-fish-fins::before {
  content: "\\e4f2";
}

.blastream-icon-building-flag::before {
  content: "\\e4d5";
}

.blastream-icon-face-grin-beam::before {
  content: "\\f582";
}

.blastream-icon-grin-beam::before {
  content: "\\f582";
}

.blastream-icon-object-ungroup::before {
  content: "\\f248";
}

.blastream-icon-poop::before {
  content: "\\f619";
}

.blastream-icon-location-pin::before {
  content: "\\f041";
}

.blastream-icon-map-marker::before {
  content: "\\f041";
}

.blastream-icon-kaaba::before {
  content: "\\f66b";
}

.blastream-icon-toilet-paper::before {
  content: "\\f71e";
}

.blastream-icon-helmet-safety::before {
  content: "\\f807";
}

.blastream-icon-hard-hat::before {
  content: "\\f807";
}

.blastream-icon-hat-hard::before {
  content: "\\f807";
}

.blastream-icon-eject::before {
  content: "\\f052";
}

.blastream-icon-circle-right::before {
  content: "\\f35a";
}

.blastream-icon-arrow-alt-circle-right::before {
  content: "\\f35a";
}

.blastream-icon-plane-circle-check::before {
  content: "\\e555";
}

.blastream-icon-face-rolling-eyes::before {
  content: "\\f5a5";
}

.blastream-icon-meh-rolling-eyes::before {
  content: "\\f5a5";
}

.blastream-icon-object-group::before {
  content: "\\f247";
}

.blastream-icon-chart-line::before {
  content: "\\f201";
}

.blastream-icon-line-chart::before {
  content: "\\f201";
}

.blastream-icon-mask-ventilator::before {
  content: "\\e524";
}

.blastream-icon-arrow-right::before {
  content: "\\f061";
}

.blastream-icon-signs-post::before {
  content: "\\f277";
}

.blastream-icon-map-signs::before {
  content: "\\f277";
}

.blastream-icon-cash-register::before {
  content: "\\f788";
}

.blastream-icon-person-circle-question::before {
  content: "\\e542";
}

.blastream-icon-h::before {
  content: "H";
}

.blastream-icon-tarp::before {
  content: "\\e57b";
}

.blastream-icon-screwdriver-wrench::before {
  content: "\\f7d9";
}

.blastream-icon-tools::before {
  content: "\\f7d9";
}

.blastream-icon-arrows-to-eye::before {
  content: "\\e4bf";
}

.blastream-icon-plug-circle-bolt::before {
  content: "\\e55b";
}

.blastream-icon-heart::before {
  content: "\\f004";
}

.blastream-icon-mars-and-venus::before {
  content: "\\f224";
}

.blastream-icon-house-user::before {
  content: "\\e1b0";
}

.blastream-icon-home-user::before {
  content: "\\e1b0";
}

.blastream-icon-dumpster-fire::before {
  content: "\\f794";
}

.blastream-icon-house-crack::before {
  content: "\\e3b1";
}

.blastream-icon-martini-glass-citrus::before {
  content: "\\f561";
}

.blastream-icon-cocktail::before {
  content: "\\f561";
}

.blastream-icon-face-surprise::before {
  content: "\\f5c2";
}

.blastream-icon-surprise::before {
  content: "\\f5c2";
}

.blastream-icon-bottle-water::before {
  content: "\\e4c5";
}

.blastream-icon-circle-pause::before {
  content: "\\f28b";
}

.blastream-icon-pause-circle::before {
  content: "\\f28b";
}

.blastream-icon-toilet-paper-slash::before {
  content: "\\e072";
}

.blastream-icon-apple-whole::before {
  content: "\\f5d1";
}

.blastream-icon-apple-alt::before {
  content: "\\f5d1";
}

.blastream-icon-kitchen-set::before {
  content: "\\e51a";
}

.blastream-icon-r::before {
  content: "R";
}

.blastream-icon-temperature-quarter::before {
  content: "\\f2ca";
}

.blastream-icon-temperature-1::before {
  content: "\\f2ca";
}

.blastream-icon-thermometer-1::before {
  content: "\\f2ca";
}

.blastream-icon-thermometer-quarter::before {
  content: "\\f2ca";
}

.blastream-icon-cube::before {
  content: "\\f1b2";
}

.blastream-icon-bitcoin-sign::before {
  content: "\\e0b4";
}

.blastream-icon-shield-dog::before {
  content: "\\e573";
}

.blastream-icon-solar-panel::before {
  content: "\\f5ba";
}

.blastream-icon-lock-open::before {
  content: "\\f3c1";
}

.blastream-icon-elevator::before {
  content: "\\e16d";
}

.blastream-icon-money-bill-transfer::before {
  content: "\\e528";
}

.blastream-icon-money-bill-trend-up::before {
  content: "\\e529";
}

.blastream-icon-house-flood-water-circle-arrow-right::before {
  content: "\\e50f";
}

.blastream-icon-square-poll-horizontal::before {
  content: "\\f682";
}

.blastream-icon-poll-h::before {
  content: "\\f682";
}

.blastream-icon-circle::before {
  content: "\\f111";
}

.blastream-icon-backward-fast::before {
  content: "\\f049";
}

.blastream-icon-fast-backward::before {
  content: "\\f049";
}

.blastream-icon-recycle::before {
  content: "\\f1b8";
}

.blastream-icon-user-astronaut::before {
  content: "\\f4fb";
}

.blastream-icon-plane-slash::before {
  content: "\\e069";
}

.blastream-icon-trademark::before {
  content: "\\f25c";
}

.blastream-icon-basketball::before {
  content: "\\f434";
}

.blastream-icon-basketball-ball::before {
  content: "\\f434";
}

.blastream-icon-satellite-dish::before {
  content: "\\f7c0";
}

.blastream-icon-circle-up::before {
  content: "\\f35b";
}

.blastream-icon-arrow-alt-circle-up::before {
  content: "\\f35b";
}

.blastream-icon-mobile-screen-button::before {
  content: "\\f3cd";
}

.blastream-icon-mobile-alt::before {
  content: "\\f3cd";
}

.blastream-icon-volume-high::before {
  content: "\\f028";
}

.blastream-icon-volume-up::before {
  content: "\\f028";
}

.blastream-icon-users-rays::before {
  content: "\\e593";
}

.blastream-icon-wallet::before {
  content: "\\f555";
}

.blastream-icon-clipboard-check::before {
  content: "\\f46c";
}

.blastream-icon-file-audio::before {
  content: "\\f1c7";
}

.blastream-icon-burger::before {
  content: "\\f805";
}

.blastream-icon-hamburger::before {
  content: "\\f805";
}

.blastream-icon-wrench::before {
  content: "\\f0ad";
}

.blastream-icon-bugs::before {
  content: "\\e4d0";
}

.blastream-icon-rupee-sign::before {
  content: "\\f156";
}

.blastream-icon-rupee::before {
  content: "\\f156";
}

.blastream-icon-file-image::before {
  content: "\\f1c5";
}

.blastream-icon-circle-question::before {
  content: "\\f059";
}

.blastream-icon-question-circle::before {
  content: "\\f059";
}

.blastream-icon-plane-departure::before {
  content: "\\f5b0";
}

.blastream-icon-handshake-slash::before {
  content: "\\e060";
}

.blastream-icon-book-bookmark::before {
  content: "\\e0bb";
}

.blastream-icon-code-branch::before {
  content: "\\f126";
}

.blastream-icon-hat-cowboy::before {
  content: "\\f8c0";
}

.blastream-icon-bridge::before {
  content: "\\e4c8";
}

.blastream-icon-phone-flip::before {
  content: "\\f879";
}

.blastream-icon-phone-alt::before {
  content: "\\f879";
}

.blastream-icon-truck-front::before {
  content: "\\e2b7";
}

.blastream-icon-cat::before {
  content: "\\f6be";
}

.blastream-icon-anchor-circle-exclamation::before {
  content: "\\e4ab";
}

.blastream-icon-truck-field::before {
  content: "\\e58d";
}

.blastream-icon-route::before {
  content: "\\f4d7";
}

.blastream-icon-clipboard-question::before {
  content: "\\e4e3";
}

.blastream-icon-panorama::before {
  content: "\\e209";
}

.blastream-icon-comment-medical::before {
  content: "\\f7f5";
}

.blastream-icon-teeth-open::before {
  content: "\\f62f";
}

.blastream-icon-file-circle-minus::before {
  content: "\\e4ed";
}

.blastream-icon-tags::before {
  content: "\\f02c";
}

.blastream-icon-wine-glass::before {
  content: "\\f4e3";
}

.blastream-icon-forward-fast::before {
  content: "\\f050";
}

.blastream-icon-fast-forward::before {
  content: "\\f050";
}

.blastream-icon-face-meh-blank::before {
  content: "\\f5a4";
}

.blastream-icon-meh-blank::before {
  content: "\\f5a4";
}

.blastream-icon-square-parking::before {
  content: "\\f540";
}

.blastream-icon-parking::before {
  content: "\\f540";
}

.blastream-icon-house-signal::before {
  content: "\\e012";
}

.blastream-icon-bars-progress::before {
  content: "\\f828";
}

.blastream-icon-tasks-alt::before {
  content: "\\f828";
}

.blastream-icon-faucet-drip::before {
  content: "\\e006";
}

.blastream-icon-cart-flatbed::before {
  content: "\\f474";
}

.blastream-icon-dolly-flatbed::before {
  content: "\\f474";
}

.blastream-icon-ban-smoking::before {
  content: "\\f54d";
}

.blastream-icon-smoking-ban::before {
  content: "\\f54d";
}

.blastream-icon-terminal::before {
  content: "\\f120";
}

.blastream-icon-mobile-button::before {
  content: "\\f10b";
}

.blastream-icon-house-medical-flag::before {
  content: "\\e514";
}

.blastream-icon-basket-shopping::before {
  content: "\\f291";
}

.blastream-icon-shopping-basket::before {
  content: "\\f291";
}

.blastream-icon-tape::before {
  content: "\\f4db";
}

.blastream-icon-bus-simple::before {
  content: "\\f55e";
}

.blastream-icon-bus-alt::before {
  content: "\\f55e";
}

.blastream-icon-eye::before {
  content: "\\f06e";
}

.blastream-icon-face-sad-cry::before {
  content: "\\f5b3";
}

.blastream-icon-sad-cry::before {
  content: "\\f5b3";
}

.blastream-icon-audio-description::before {
  content: "\\f29e";
}

.blastream-icon-person-military-to-person::before {
  content: "\\e54c";
}

.blastream-icon-file-shield::before {
  content: "\\e4f0";
}

.blastream-icon-user-slash::before {
  content: "\\f506";
}

.blastream-icon-pen::before {
  content: "\\f304";
}

.blastream-icon-tower-observation::before {
  content: "\\e586";
}

.blastream-icon-file-code::before {
  content: "\\f1c9";
}

.blastream-icon-signal::before {
  content: "\\f012";
}

.blastream-icon-signal-5::before {
  content: "\\f012";
}

.blastream-icon-signal-perfect::before {
  content: "\\f012";
}

.blastream-icon-bus::before {
  content: "\\f207";
}

.blastream-icon-heart-circle-xmark::before {
  content: "\\e501";
}

.blastream-icon-house-chimney::before {
  content: "\\e3af";
}

.blastream-icon-home-lg::before {
  content: "\\e3af";
}

.blastream-icon-window-maximize::before {
  content: "\\f2d0";
}

.blastream-icon-face-frown::before {
  content: "\\f119";
}

.blastream-icon-frown::before {
  content: "\\f119";
}

.blastream-icon-prescription::before {
  content: "\\f5b1";
}

.blastream-icon-shop::before {
  content: "\\f54f";
}

.blastream-icon-store-alt::before {
  content: "\\f54f";
}

.blastream-icon-floppy-disk::before {
  content: "\\f0c7";
}

.blastream-icon-save::before {
  content: "\\f0c7";
}

.blastream-icon-vihara::before {
  content: "\\f6a7";
}

.blastream-icon-scale-unbalanced::before {
  content: "\\f515";
}

.blastream-icon-balance-scale-left::before {
  content: "\\f515";
}

.blastream-icon-sort-up::before {
  content: "\\f0de";
}

.blastream-icon-sort-asc::before {
  content: "\\f0de";
}

.blastream-icon-comment-dots::before {
  content: "\\f4ad";
}

.blastream-icon-commenting::before {
  content: "\\f4ad";
}

.blastream-icon-plant-wilt::before {
  content: "\\e5aa";
}

.blastream-icon-diamond::before {
  content: "\\f219";
}

.blastream-icon-face-grin-squint::before {
  content: "\\f585";
}

.blastream-icon-grin-squint::before {
  content: "\\f585";
}

.blastream-icon-hand-holding-dollar::before {
  content: "\\f4c0";
}

.blastream-icon-hand-holding-usd::before {
  content: "\\f4c0";
}

.blastream-icon-bacterium::before {
  content: "\\e05a";
}

.blastream-icon-hand-pointer::before {
  content: "\\f25a";
}

.blastream-icon-drum-steelpan::before {
  content: "\\f56a";
}

.blastream-icon-hand-scissors::before {
  content: "\\f257";
}

.blastream-icon-hands-praying::before {
  content: "\\f684";
}

.blastream-icon-praying-hands::before {
  content: "\\f684";
}

.blastream-icon-arrow-rotate-right::before {
  content: "\\f01e";
}

.blastream-icon-arrow-right-rotate::before {
  content: "\\f01e";
}

.blastream-icon-arrow-rotate-forward::before {
  content: "\\f01e";
}

.blastream-icon-redo::before {
  content: "\\f01e";
}

.blastream-icon-biohazard::before {
  content: "\\f780";
}

.blastream-icon-location-crosshairs::before {
  content: "\\f601";
}

.blastream-icon-location::before {
  content: "\\f601";
}

.blastream-icon-mars-double::before {
  content: "\\f227";
}

.blastream-icon-child-dress::before {
  content: "\\e59c";
}

.blastream-icon-users-between-lines::before {
  content: "\\e591";
}

.blastream-icon-lungs-virus::before {
  content: "\\e067";
}

.blastream-icon-face-grin-tears::before {
  content: "\\f588";
}

.blastream-icon-grin-tears::before {
  content: "\\f588";
}

.blastream-icon-phone::before {
  content: "\\f095";
}

.blastream-icon-calendar-xmark::before {
  content: "\\f273";
}

.blastream-icon-calendar-times::before {
  content: "\\f273";
}

.blastream-icon-child-reaching::before {
  content: "\\e59d";
}

.blastream-icon-head-side-virus::before {
  content: "\\e064";
}

.blastream-icon-user-gear::before {
  content: "\\f4fe";
}

.blastream-icon-user-cog::before {
  content: "\\f4fe";
}

.blastream-icon-arrow-up-1-9::before {
  content: "\\f163";
}

.blastream-icon-sort-numeric-up::before {
  content: "\\f163";
}

.blastream-icon-door-closed::before {
  content: "\\f52a";
}

.blastream-icon-shield-virus::before {
  content: "\\e06c";
}

.blastream-icon-dice-six::before {
  content: "\\f526";
}

.blastream-icon-mosquito-net::before {
  content: "\\e52c";
}

.blastream-icon-bridge-water::before {
  content: "\\e4ce";
}

.blastream-icon-person-booth::before {
  content: "\\f756";
}

.blastream-icon-text-width::before {
  content: "\\f035";
}

.blastream-icon-hat-wizard::before {
  content: "\\f6e8";
}

.blastream-icon-pen-fancy::before {
  content: "\\f5ac";
}

.blastream-icon-person-digging::before {
  content: "\\f85e";
}

.blastream-icon-digging::before {
  content: "\\f85e";
}

.blastream-icon-trash::before {
  content: "\\f1f8";
}

.blastream-icon-gauge-simple::before {
  content: "\\f629";
}

.blastream-icon-gauge-simple-med::before {
  content: "\\f629";
}

.blastream-icon-tachometer-average::before {
  content: "\\f629";
}

.blastream-icon-book-medical::before {
  content: "\\f7e6";
}

.blastream-icon-poo::before {
  content: "\\f2fe";
}

.blastream-icon-quote-right::before {
  content: "\\f10e";
}

.blastream-icon-quote-right-alt::before {
  content: "\\f10e";
}

.blastream-icon-shirt::before {
  content: "\\f553";
}

.blastream-icon-t-shirt::before {
  content: "\\f553";
}

.blastream-icon-tshirt::before {
  content: "\\f553";
}

.blastream-icon-cubes::before {
  content: "\\f1b3";
}

.blastream-icon-divide::before {
  content: "\\f529";
}

.blastream-icon-tenge-sign::before {
  content: "\\f7d7";
}

.blastream-icon-tenge::before {
  content: "\\f7d7";
}

.blastream-icon-headphones::before {
  content: "\\f025";
}

.blastream-icon-hands-holding::before {
  content: "\\f4c2";
}

.blastream-icon-hands-clapping::before {
  content: "\\e1a8";
}

.blastream-icon-republican::before {
  content: "\\f75e";
}

.blastream-icon-arrow-left::before {
  content: "\\f060";
}

.blastream-icon-person-circle-xmark::before {
  content: "\\e543";
}

.blastream-icon-ruler::before {
  content: "\\f545";
}

.blastream-icon-align-left::before {
  content: "\\f036";
}

.blastream-icon-dice-d6::before {
  content: "\\f6d1";
}

.blastream-icon-restroom::before {
  content: "\\f7bd";
}

.blastream-icon-j::before {
  content: "J";
}

.blastream-icon-users-viewfinder::before {
  content: "\\e595";
}

.blastream-icon-file-video::before {
  content: "\\f1c8";
}

.blastream-icon-up-right-from-square::before {
  content: "\\f35d";
}

.blastream-icon-external-link-alt::before {
  content: "\\f35d";
}

.blastream-icon-table-cells::before {
  content: "\\f00a";
}

.blastream-icon-th::before {
  content: "\\f00a";
}

.blastream-icon-file-pdf::before {
  content: "\\f1c1";
}

.blastream-icon-book-bible::before {
  content: "\\f647";
}

.blastream-icon-bible::before {
  content: "\\f647";
}

.blastream-icon-o::before {
  content: "O";
}

.blastream-icon-suitcase-medical::before {
  content: "\\f0fa";
}

.blastream-icon-medkit::before {
  content: "\\f0fa";
}

.blastream-icon-user-secret::before {
  content: "\\f21b";
}

.blastream-icon-otter::before {
  content: "\\f700";
}

.blastream-icon-person-dress::before {
  content: "\\f182";
}

.blastream-icon-female::before {
  content: "\\f182";
}

.blastream-icon-comment-dollar::before {
  content: "\\f651";
}

.blastream-icon-business-time::before {
  content: "\\f64a";
}

.blastream-icon-briefcase-clock::before {
  content: "\\f64a";
}

.blastream-icon-table-cells-large::before {
  content: "\\f009";
}

.blastream-icon-th-large::before {
  content: "\\f009";
}

.blastream-icon-book-tanakh::before {
  content: "\\f827";
}

.blastream-icon-tanakh::before {
  content: "\\f827";
}

.blastream-icon-phone-volume::before {
  content: "\\f2a0";
}

.blastream-icon-volume-control-phone::before {
  content: "\\f2a0";
}

.blastream-icon-hat-cowboy-side::before {
  content: "\\f8c1";
}

.blastream-icon-clipboard-user::before {
  content: "\\f7f3";
}

.blastream-icon-child::before {
  content: "\\f1ae";
}

.blastream-icon-lira-sign::before {
  content: "\\f195";
}

.blastream-icon-satellite::before {
  content: "\\f7bf";
}

.blastream-icon-plane-lock::before {
  content: "\\e558";
}

.blastream-icon-tag::before {
  content: "\\f02b";
}

.blastream-icon-comment::before {
  content: "\\f075";
}

.blastream-icon-cake-candles::before {
  content: "\\f1fd";
}

.blastream-icon-birthday-cake::before {
  content: "\\f1fd";
}

.blastream-icon-cake::before {
  content: "\\f1fd";
}

.blastream-icon-envelope::before {
  content: "\\f0e0";
}

.blastream-icon-angles-up::before {
  content: "\\f102";
}

.blastream-icon-angle-double-up::before {
  content: "\\f102";
}

.blastream-icon-paperclip::before {
  content: "\\f0c6";
}

.blastream-icon-arrow-right-to-city::before {
  content: "\\e4b3";
}

.blastream-icon-ribbon::before {
  content: "\\f4d6";
}

.blastream-icon-lungs::before {
  content: "\\f604";
}

.blastream-icon-arrow-up-9-1::before {
  content: "\\f887";
}

.blastream-icon-sort-numeric-up-alt::before {
  content: "\\f887";
}

.blastream-icon-litecoin-sign::before {
  content: "\\e1d3";
}

.blastream-icon-border-none::before {
  content: "\\f850";
}

.blastream-icon-circle-nodes::before {
  content: "\\e4e2";
}

.blastream-icon-parachute-box::before {
  content: "\\f4cd";
}

.blastream-icon-indent::before {
  content: "\\f03c";
}

.blastream-icon-truck-field-un::before {
  content: "\\e58e";
}

.blastream-icon-hourglass::before {
  content: "\\f254";
}

.blastream-icon-hourglass-empty::before {
  content: "\\f254";
}

.blastream-icon-mountain::before {
  content: "\\f6fc";
}

.blastream-icon-user-doctor::before {
  content: "\\f0f0";
}

.blastream-icon-user-md::before {
  content: "\\f0f0";
}

.blastream-icon-circle-info::before {
  content: "\\f05a";
}

.blastream-icon-info-circle::before {
  content: "\\f05a";
}

.blastream-icon-cloud-meatball::before {
  content: "\\f73b";
}

.blastream-icon-camera::before {
  content: "\\f030";
}

.blastream-icon-camera-alt::before {
  content: "\\f030";
}

.blastream-icon-square-virus::before {
  content: "\\e578";
}

.blastream-icon-meteor::before {
  content: "\\f753";
}

.blastream-icon-car-on::before {
  content: "\\e4dd";
}

.blastream-icon-sleigh::before {
  content: "\\f7cc";
}

.blastream-icon-arrow-down-1-9::before {
  content: "\\f162";
}

.blastream-icon-sort-numeric-asc::before {
  content: "\\f162";
}

.blastream-icon-sort-numeric-down::before {
  content: "\\f162";
}

.blastream-icon-hand-holding-droplet::before {
  content: "\\f4c1";
}

.blastream-icon-hand-holding-water::before {
  content: "\\f4c1";
}

.blastream-icon-water::before {
  content: "\\f773";
}

.blastream-icon-calendar-check::before {
  content: "\\f274";
}

.blastream-icon-braille::before {
  content: "\\f2a1";
}

.blastream-icon-prescription-bottle-medical::before {
  content: "\\f486";
}

.blastream-icon-prescription-bottle-alt::before {
  content: "\\f486";
}

.blastream-icon-landmark::before {
  content: "\\f66f";
}

.blastream-icon-truck::before {
  content: "\\f0d1";
}

.blastream-icon-crosshairs::before {
  content: "\\f05b";
}

.blastream-icon-person-cane::before {
  content: "\\e53c";
}

.blastream-icon-tent::before {
  content: "\\e57d";
}

.blastream-icon-vest-patches::before {
  content: "\\e086";
}

.blastream-icon-check-double::before {
  content: "\\f560";
}

.blastream-icon-arrow-down-a-z::before {
  content: "\\f15d";
}

.blastream-icon-sort-alpha-asc::before {
  content: "\\f15d";
}

.blastream-icon-sort-alpha-down::before {
  content: "\\f15d";
}

.blastream-icon-money-bill-wheat::before {
  content: "\\e52a";
}

.blastream-icon-cookie::before {
  content: "\\f563";
}

.blastream-icon-arrow-rotate-left::before {
  content: "\\f0e2";
}

.blastream-icon-arrow-left-rotate::before {
  content: "\\f0e2";
}

.blastream-icon-arrow-rotate-back::before {
  content: "\\f0e2";
}

.blastream-icon-arrow-rotate-backward::before {
  content: "\\f0e2";
}

.blastream-icon-undo::before {
  content: "\\f0e2";
}

.blastream-icon-hard-drive::before {
  content: "\\f0a0";
}

.blastream-icon-hdd::before {
  content: "\\f0a0";
}

.blastream-icon-face-grin-squint-tears::before {
  content: "\\f586";
}

.blastream-icon-grin-squint-tears::before {
  content: "\\f586";
}

.blastream-icon-dumbbell::before {
  content: "\\f44b";
}

.blastream-icon-rectangle-list::before {
  content: "\\f022";
}

.blastream-icon-list-alt::before {
  content: "\\f022";
}

.blastream-icon-tarp-droplet::before {
  content: "\\e57c";
}

.blastream-icon-house-medical-circle-check::before {
  content: "\\e511";
}

.blastream-icon-person-skiing-nordic::before {
  content: "\\f7ca";
}

.blastream-icon-skiing-nordic::before {
  content: "\\f7ca";
}

.blastream-icon-calendar-plus::before {
  content: "\\f271";
}

.blastream-icon-plane-arrival::before {
  content: "\\f5af";
}

.blastream-icon-circle-left::before {
  content: "\\f359";
}

.blastream-icon-arrow-alt-circle-left::before {
  content: "\\f359";
}

.blastream-icon-train-subway::before {
  content: "\\f239";
}

.blastream-icon-subway::before {
  content: "\\f239";
}

.blastream-icon-chart-gantt::before {
  content: "\\e0e4";
}

.blastream-icon-indian-rupee-sign::before {
  content: "\\e1bc";
}

.blastream-icon-indian-rupee::before {
  content: "\\e1bc";
}

.blastream-icon-inr::before {
  content: "\\e1bc";
}

.blastream-icon-crop-simple::before {
  content: "\\f565";
}

.blastream-icon-crop-alt::before {
  content: "\\f565";
}

.blastream-icon-money-bill-1::before {
  content: "\\f3d1";
}

.blastream-icon-money-bill-alt::before {
  content: "\\f3d1";
}

.blastream-icon-left-long::before {
  content: "\\f30a";
}

.blastream-icon-long-arrow-alt-left::before {
  content: "\\f30a";
}

.blastream-icon-dna::before {
  content: "\\f471";
}

.blastream-icon-virus-slash::before {
  content: "\\e075";
}

.blastream-icon-minus::before {
  content: "\\f068";
}

.blastream-icon-subtract::before {
  content: "\\f068";
}

.blastream-icon-chess::before {
  content: "\\f439";
}

.blastream-icon-arrow-left-long::before {
  content: "\\f177";
}

.blastream-icon-long-arrow-left::before {
  content: "\\f177";
}

.blastream-icon-plug-circle-check::before {
  content: "\\e55c";
}

.blastream-icon-street-view::before {
  content: "\\f21d";
}

.blastream-icon-franc-sign::before {
  content: "\\e18f";
}

.blastream-icon-volume-off::before {
  content: "\\f026";
}

.blastream-icon-hands-asl-interpreting::before {
  content: "\\f2a3";
}

.blastream-icon-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.blastream-icon-asl-interpreting::before {
  content: "\\f2a3";
}

.blastream-icon-hands-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.blastream-icon-gear::before {
  content: "\\f013";
}

.blastream-icon-cog::before {
  content: "\\f013";
}

.blastream-icon-droplet-slash::before {
  content: "\\f5c7";
}

.blastream-icon-tint-slash::before {
  content: "\\f5c7";
}

.blastream-icon-mosque::before {
  content: "\\f678";
}

.blastream-icon-mosquito::before {
  content: "\\e52b";
}

.blastream-icon-star-of-david::before {
  content: "\\f69a";
}

.blastream-icon-person-military-rifle::before {
  content: "\\e54b";
}

.blastream-icon-cart-shopping::before {
  content: "\\f07a";
}

.blastream-icon-shopping-cart::before {
  content: "\\f07a";
}

.blastream-icon-vials::before {
  content: "\\f493";
}

.blastream-icon-plug-circle-plus::before {
  content: "\\e55f";
}

.blastream-icon-place-of-worship::before {
  content: "\\f67f";
}

.blastream-icon-grip-vertical::before {
  content: "\\f58e";
}

.blastream-icon-arrow-turn-up::before {
  content: "\\f148";
}

.blastream-icon-level-up::before {
  content: "\\f148";
}

.blastream-icon-u::before {
  content: "U";
}

.blastream-icon-square-root-variable::before {
  content: "\\f698";
}

.blastream-icon-square-root-alt::before {
  content: "\\f698";
}

.blastream-icon-clock::before {
  content: "\\f017";
}

.blastream-icon-clock-four::before {
  content: "\\f017";
}

.blastream-icon-backward-step::before {
  content: "\\f048";
}

.blastream-icon-step-backward::before {
  content: "\\f048";
}

.blastream-icon-pallet::before {
  content: "\\f482";
}

.blastream-icon-faucet::before {
  content: "\\e005";
}

.blastream-icon-baseball-bat-ball::before {
  content: "\\f432";
}

.blastream-icon-s::before {
  content: "S";
}

.blastream-icon-timeline::before {
  content: "\\e29c";
}

.blastream-icon-keyboard::before {
  content: "\\f11c";
}

.blastream-icon-caret-down::before {
  content: "\\f0d7";
}

.blastream-icon-house-chimney-medical::before {
  content: "\\f7f2";
}

.blastream-icon-clinic-medical::before {
  content: "\\f7f2";
}

.blastream-icon-temperature-three-quarters::before {
  content: "\\f2c8";
}

.blastream-icon-temperature-3::before {
  content: "\\f2c8";
}

.blastream-icon-thermometer-3::before {
  content: "\\f2c8";
}

.blastream-icon-thermometer-three-quarters::before {
  content: "\\f2c8";
}

.blastream-icon-mobile-screen::before {
  content: "\\f3cf";
}

.blastream-icon-mobile-android-alt::before {
  content: "\\f3cf";
}

.blastream-icon-plane-up::before {
  content: "\\e22d";
}

.blastream-icon-piggy-bank::before {
  content: "\\f4d3";
}

.blastream-icon-battery-half::before {
  content: "\\f242";
}

.blastream-icon-battery-3::before {
  content: "\\f242";
}

.blastream-icon-mountain-city::before {
  content: "\\e52e";
}

.blastream-icon-coins::before {
  content: "\\f51e";
}

.blastream-icon-khanda::before {
  content: "\\f66d";
}

.blastream-icon-sliders::before {
  content: "\\f1de";
}

.blastream-icon-sliders-h::before {
  content: "\\f1de";
}

.blastream-icon-folder-tree::before {
  content: "\\f802";
}

.blastream-icon-network-wired::before {
  content: "\\f6ff";
}

.blastream-icon-map-pin::before {
  content: "\\f276";
}

.blastream-icon-hamsa::before {
  content: "\\f665";
}

.blastream-icon-cent-sign::before {
  content: "\\e3f5";
}

.blastream-icon-flask::before {
  content: "\\f0c3";
}

.blastream-icon-person-pregnant::before {
  content: "\\e31e";
}

.blastream-icon-wand-sparkles::before {
  content: "\\f72b";
}

.blastream-icon-ellipsis-vertical::before {
  content: "\\f142";
}

.blastream-icon-ellipsis-v::before {
  content: "\\f142";
}

.blastream-icon-ticket::before {
  content: "\\f145";
}

.blastream-icon-power-off::before {
  content: "\\f011";
}

.blastream-icon-right-long::before {
  content: "\\f30b";
}

.blastream-icon-long-arrow-alt-right::before {
  content: "\\f30b";
}

.blastream-icon-flag-usa::before {
  content: "\\f74d";
}

.blastream-icon-laptop-file::before {
  content: "\\e51d";
}

.blastream-icon-tty::before {
  content: "\\f1e4";
}

.blastream-icon-teletype::before {
  content: "\\f1e4";
}

.blastream-icon-diagram-next::before {
  content: "\\e476";
}

.blastream-icon-person-rifle::before {
  content: "\\e54e";
}

.blastream-icon-house-medical-circle-exclamation::before {
  content: "\\e512";
}

.blastream-icon-closed-captioning::before {
  content: "\\f20a";
}

.blastream-icon-person-hiking::before {
  content: "\\f6ec";
}

.blastream-icon-hiking::before {
  content: "\\f6ec";
}

.blastream-icon-venus-double::before {
  content: "\\f226";
}

.blastream-icon-images::before {
  content: "\\f302";
}

.blastream-icon-calculator::before {
  content: "\\f1ec";
}

.blastream-icon-people-pulling::before {
  content: "\\e535";
}

.blastream-icon-n::before {
  content: "N";
}

.blastream-icon-cable-car::before {
  content: "\\f7da";
}

.blastream-icon-tram::before {
  content: "\\f7da";
}

.blastream-icon-cloud-rain::before {
  content: "\\f73d";
}

.blastream-icon-building-circle-xmark::before {
  content: "\\e4d4";
}

.blastream-icon-ship::before {
  content: "\\f21a";
}

.blastream-icon-arrows-down-to-line::before {
  content: "\\e4b8";
}

.blastream-icon-download::before {
  content: "\\f019";
}

.blastream-icon-face-grin::before {
  content: "\\f580";
}

.blastream-icon-grin::before {
  content: "\\f580";
}

.blastream-icon-delete-left::before {
  content: "\\f55a";
}

.blastream-icon-backspace::before {
  content: "\\f55a";
}

.blastream-icon-eye-dropper::before {
  content: "\\f1fb";
}

.blastream-icon-eye-dropper-empty::before {
  content: "\\f1fb";
}

.blastream-icon-eyedropper::before {
  content: "\\f1fb";
}

.blastream-icon-file-circle-check::before {
  content: "\\e5a0";
}

.blastream-icon-forward::before {
  content: "\\f04e";
}

.blastream-icon-mobile::before {
  content: "\\f3ce";
}

.blastream-icon-mobile-android::before {
  content: "\\f3ce";
}

.blastream-icon-mobile-phone::before {
  content: "\\f3ce";
}

.blastream-icon-face-meh::before {
  content: "\\f11a";
}

.blastream-icon-meh::before {
  content: "\\f11a";
}

.blastream-icon-align-center::before {
  content: "\\f037";
}

.blastream-icon-book-skull::before {
  content: "\\f6b7";
}

.blastream-icon-book-dead::before {
  content: "\\f6b7";
}

.blastream-icon-id-card::before {
  content: "\\f2c2";
}

.blastream-icon-drivers-license::before {
  content: "\\f2c2";
}

.blastream-icon-outdent::before {
  content: "\\f03b";
}

.blastream-icon-dedent::before {
  content: "\\f03b";
}

.blastream-icon-heart-circle-exclamation::before {
  content: "\\e4fe";
}

.blastream-icon-house::before {
  content: "\\f015";
}

.blastream-icon-home::before {
  content: "\\f015";
}

.blastream-icon-home-alt::before {
  content: "\\f015";
}

.blastream-icon-home-lg-alt::before {
  content: "\\f015";
}

.blastream-icon-calendar-week::before {
  content: "\\f784";
}

.blastream-icon-laptop-medical::before {
  content: "\\f812";
}

.blastream-icon-b::before {
  content: "B";
}

.blastream-icon-file-medical::before {
  content: "\\f477";
}

.blastream-icon-dice-one::before {
  content: "\\f525";
}

.blastream-icon-kiwi-bird::before {
  content: "\\f535";
}

.blastream-icon-arrow-right-arrow-left::before {
  content: "\\f0ec";
}

.blastream-icon-exchange::before {
  content: "\\f0ec";
}

.blastream-icon-rotate-right::before {
  content: "\\f2f9";
}

.blastream-icon-redo-alt::before {
  content: "\\f2f9";
}

.blastream-icon-rotate-forward::before {
  content: "\\f2f9";
}

.blastream-icon-utensils::before {
  content: "\\f2e7";
}

.blastream-icon-cutlery::before {
  content: "\\f2e7";
}

.blastream-icon-arrow-up-wide-short::before {
  content: "\\f161";
}

.blastream-icon-sort-amount-up::before {
  content: "\\f161";
}

.blastream-icon-mill-sign::before {
  content: "\\e1ed";
}

.blastream-icon-bowl-rice::before {
  content: "\\e2eb";
}

.blastream-icon-skull::before {
  content: "\\f54c";
}

.blastream-icon-tower-broadcast::before {
  content: "\\f519";
}

.blastream-icon-broadcast-tower::before {
  content: "\\f519";
}

.blastream-icon-truck-pickup::before {
  content: "\\f63c";
}

.blastream-icon-up-long::before {
  content: "\\f30c";
}

.blastream-icon-long-arrow-alt-up::before {
  content: "\\f30c";
}

.blastream-icon-stop::before {
  content: "\\f04d";
}

.blastream-icon-code-merge::before {
  content: "\\f387";
}

.blastream-icon-upload::before {
  content: "\\f093";
}

.blastream-icon-hurricane::before {
  content: "\\f751";
}

.blastream-icon-mound::before {
  content: "\\e52d";
}

.blastream-icon-toilet-portable::before {
  content: "\\e583";
}

.blastream-icon-compact-disc::before {
  content: "\\f51f";
}

.blastream-icon-file-arrow-down::before {
  content: "\\f56d";
}

.blastream-icon-file-download::before {
  content: "\\f56d";
}

.blastream-icon-caravan::before {
  content: "\\f8ff";
}

.blastream-icon-shield-cat::before {
  content: "\\e572";
}

.blastream-icon-bolt::before {
  content: "\\f0e7";
}

.blastream-icon-zap::before {
  content: "\\f0e7";
}

.blastream-icon-glass-water::before {
  content: "\\e4f4";
}

.blastream-icon-oil-well::before {
  content: "\\e532";
}

.blastream-icon-vault::before {
  content: "\\e2c5";
}

.blastream-icon-mars::before {
  content: "\\f222";
}

.blastream-icon-toilet::before {
  content: "\\f7d8";
}

.blastream-icon-plane-circle-xmark::before {
  content: "\\e557";
}

.blastream-icon-yen-sign::before {
  content: "\\f157";
}

.blastream-icon-cny::before {
  content: "\\f157";
}

.blastream-icon-jpy::before {
  content: "\\f157";
}

.blastream-icon-rmb::before {
  content: "\\f157";
}

.blastream-icon-yen::before {
  content: "\\f157";
}

.blastream-icon-ruble-sign::before {
  content: "\\f158";
}

.blastream-icon-rouble::before {
  content: "\\f158";
}

.blastream-icon-rub::before {
  content: "\\f158";
}

.blastream-icon-ruble::before {
  content: "\\f158";
}

.blastream-icon-sun::before {
  content: "\\f185";
}

.blastream-icon-guitar::before {
  content: "\\f7a6";
}

.blastream-icon-face-laugh-wink::before {
  content: "\\f59c";
}

.blastream-icon-laugh-wink::before {
  content: "\\f59c";
}

.blastream-icon-horse-head::before {
  content: "\\f7ab";
}

.blastream-icon-bore-hole::before {
  content: "\\e4c3";
}

.blastream-icon-industry::before {
  content: "\\f275";
}

.blastream-icon-circle-down::before {
  content: "\\f358";
}

.blastream-icon-arrow-alt-circle-down::before {
  content: "\\f358";
}

.blastream-icon-arrows-turn-to-dots::before {
  content: "\\e4c1";
}

.blastream-icon-florin-sign::before {
  content: "\\e184";
}

.blastream-icon-arrow-down-short-wide::before {
  content: "\\f884";
}

.blastream-icon-sort-amount-desc::before {
  content: "\\f884";
}

.blastream-icon-sort-amount-down-alt::before {
  content: "\\f884";
}

.blastream-icon-less-than::before {
  content: "\\<";
}

.blastream-icon-angle-down::before {
  content: "\\f107";
}

.blastream-icon-car-tunnel::before {
  content: "\\e4de";
}

.blastream-icon-head-side-cough::before {
  content: "\\e061";
}

.blastream-icon-grip-lines::before {
  content: "\\f7a4";
}

.blastream-icon-thumbs-down::before {
  content: "\\f165";
}

.blastream-icon-user-lock::before {
  content: "\\f502";
}

.blastream-icon-arrow-right-long::before {
  content: "\\f178";
}

.blastream-icon-long-arrow-right::before {
  content: "\\f178";
}

.blastream-icon-anchor-circle-xmark::before {
  content: "\\e4ac";
}

.blastream-icon-ellipsis::before {
  content: "\\f141";
}

.blastream-icon-ellipsis-h::before {
  content: "\\f141";
}

.blastream-icon-chess-pawn::before {
  content: "\\f443";
}

.blastream-icon-kit-medical::before {
  content: "\\f479";
}

.blastream-icon-first-aid::before {
  content: "\\f479";
}

.blastream-icon-person-through-window::before {
  content: "\\e5a9";
}

.blastream-icon-toolbox::before {
  content: "\\f552";
}

.blastream-icon-hands-holding-circle::before {
  content: "\\e4fb";
}

.blastream-icon-bug::before {
  content: "\\f188";
}

.blastream-icon-credit-card::before {
  content: "\\f09d";
}

.blastream-icon-credit-card-alt::before {
  content: "\\f09d";
}

.blastream-icon-car::before {
  content: "\\f1b9";
}

.blastream-icon-automobile::before {
  content: "\\f1b9";
}

.blastream-icon-hand-holding-hand::before {
  content: "\\e4f7";
}

.blastream-icon-book-open-reader::before {
  content: "\\f5da";
}

.blastream-icon-book-reader::before {
  content: "\\f5da";
}

.blastream-icon-mountain-sun::before {
  content: "\\e52f";
}

.blastream-icon-arrows-left-right-to-line::before {
  content: "\\e4ba";
}

.blastream-icon-dice-d20::before {
  content: "\\f6cf";
}

.blastream-icon-truck-droplet::before {
  content: "\\e58c";
}

.blastream-icon-file-circle-xmark::before {
  content: "\\e5a1";
}

.blastream-icon-temperature-arrow-up::before {
  content: "\\e040";
}

.blastream-icon-temperature-up::before {
  content: "\\e040";
}

.blastream-icon-medal::before {
  content: "\\f5a2";
}

.blastream-icon-bed::before {
  content: "\\f236";
}

.blastream-icon-square-h::before {
  content: "\\f0fd";
}

.blastream-icon-h-square::before {
  content: "\\f0fd";
}

.blastream-icon-podcast::before {
  content: "\\f2ce";
}

.blastream-icon-temperature-full::before {
  content: "\\f2c7";
}

.blastream-icon-temperature-4::before {
  content: "\\f2c7";
}

.blastream-icon-thermometer-4::before {
  content: "\\f2c7";
}

.blastream-icon-thermometer-full::before {
  content: "\\f2c7";
}

.blastream-icon-bell::before {
  content: "\\f0f3";
}

.blastream-icon-superscript::before {
  content: "\\f12b";
}

.blastream-icon-plug-circle-xmark::before {
  content: "\\e560";
}

.blastream-icon-star-of-life::before {
  content: "\\f621";
}

.blastream-icon-phone-slash::before {
  content: "\\f3dd";
}

.blastream-icon-paint-roller::before {
  content: "\\f5aa";
}

.blastream-icon-handshake-angle::before {
  content: "\\f4c4";
}

.blastream-icon-hands-helping::before {
  content: "\\f4c4";
}

.blastream-icon-location-dot::before {
  content: "\\f3c5";
}

.blastream-icon-map-marker-alt::before {
  content: "\\f3c5";
}

.blastream-icon-file::before {
  content: "\\f15b";
}

.blastream-icon-greater-than::before {
  content: "\\>";
}

.blastream-icon-person-swimming::before {
  content: "\\f5c4";
}

.blastream-icon-swimmer::before {
  content: "\\f5c4";
}

.blastream-icon-arrow-down::before {
  content: "\\f063";
}

.blastream-icon-droplet::before {
  content: "\\f043";
}

.blastream-icon-tint::before {
  content: "\\f043";
}

.blastream-icon-eraser::before {
  content: "\\f12d";
}

.blastream-icon-earth-americas::before {
  content: "\\f57d";
}

.blastream-icon-earth::before {
  content: "\\f57d";
}

.blastream-icon-earth-america::before {
  content: "\\f57d";
}

.blastream-icon-globe-americas::before {
  content: "\\f57d";
}

.blastream-icon-person-burst::before {
  content: "\\e53b";
}

.blastream-icon-dove::before {
  content: "\\f4ba";
}

.blastream-icon-battery-empty::before {
  content: "\\f244";
}

.blastream-icon-battery-0::before {
  content: "\\f244";
}

.blastream-icon-socks::before {
  content: "\\f696";
}

.blastream-icon-inbox::before {
  content: "\\f01c";
}

.blastream-icon-section::before {
  content: "\\e447";
}

.blastream-icon-gauge-high::before {
  content: "\\f625";
}

.blastream-icon-tachometer-alt::before {
  content: "\\f625";
}

.blastream-icon-tachometer-alt-fast::before {
  content: "\\f625";
}

.blastream-icon-envelope-open-text::before {
  content: "\\f658";
}

.blastream-icon-hospital::before {
  content: "\\f0f8";
}

.blastream-icon-hospital-alt::before {
  content: "\\f0f8";
}

.blastream-icon-hospital-wide::before {
  content: "\\f0f8";
}

.blastream-icon-wine-bottle::before {
  content: "\\f72f";
}

.blastream-icon-chess-rook::before {
  content: "\\f447";
}

.blastream-icon-bars-staggered::before {
  content: "\\f550";
}

.blastream-icon-reorder::before {
  content: "\\f550";
}

.blastream-icon-stream::before {
  content: "\\f550";
}

.blastream-icon-dharmachakra::before {
  content: "\\f655";
}

.blastream-icon-hotdog::before {
  content: "\\f80f";
}

.blastream-icon-person-walking-with-cane::before {
  content: "\\f29d";
}

.blastream-icon-blind::before {
  content: "\\f29d";
}

.blastream-icon-drum::before {
  content: "\\f569";
}

.blastream-icon-ice-cream::before {
  content: "\\f810";
}

.blastream-icon-heart-circle-bolt::before {
  content: "\\e4fc";
}

.blastream-icon-fax::before {
  content: "\\f1ac";
}

.blastream-icon-paragraph::before {
  content: "\\f1dd";
}

.blastream-icon-check-to-slot::before {
  content: "\\f772";
}

.blastream-icon-vote-yea::before {
  content: "\\f772";
}

.blastream-icon-star-half::before {
  content: "\\f089";
}

.blastream-icon-boxes-stacked::before {
  content: "\\f468";
}

.blastream-icon-boxes::before {
  content: "\\f468";
}

.blastream-icon-boxes-alt::before {
  content: "\\f468";
}

.blastream-icon-link::before {
  content: "\\f0c1";
}

.blastream-icon-chain::before {
  content: "\\f0c1";
}

.blastream-icon-ear-listen::before {
  content: "\\f2a2";
}

.blastream-icon-assistive-listening-systems::before {
  content: "\\f2a2";
}

.blastream-icon-tree-city::before {
  content: "\\e587";
}

.blastream-icon-play::before {
  content: "\\f04b";
}

.blastream-icon-font::before {
  content: "\\f031";
}

.blastream-icon-table-cells-row-lock::before {
  content: "\\e67a";
}

.blastream-icon-rupiah-sign::before {
  content: "\\e23d";
}

.blastream-icon-magnifying-glass::before {
  content: "\\f002";
}

.blastream-icon-search::before {
  content: "\\f002";
}

.blastream-icon-table-tennis-paddle-ball::before {
  content: "\\f45d";
}

.blastream-icon-ping-pong-paddle-ball::before {
  content: "\\f45d";
}

.blastream-icon-table-tennis::before {
  content: "\\f45d";
}

.blastream-icon-person-dots-from-line::before {
  content: "\\f470";
}

.blastream-icon-diagnoses::before {
  content: "\\f470";
}

.blastream-icon-trash-can-arrow-up::before {
  content: "\\f82a";
}

.blastream-icon-trash-restore-alt::before {
  content: "\\f82a";
}

.blastream-icon-naira-sign::before {
  content: "\\e1f6";
}

.blastream-icon-cart-arrow-down::before {
  content: "\\f218";
}

.blastream-icon-walkie-talkie::before {
  content: "\\f8ef";
}

.blastream-icon-file-pen::before {
  content: "\\f31c";
}

.blastream-icon-file-edit::before {
  content: "\\f31c";
}

.blastream-icon-receipt::before {
  content: "\\f543";
}

.blastream-icon-square-pen::before {
  content: "\\f14b";
}

.blastream-icon-pen-square::before {
  content: "\\f14b";
}

.blastream-icon-pencil-square::before {
  content: "\\f14b";
}

.blastream-icon-suitcase-rolling::before {
  content: "\\f5c1";
}

.blastream-icon-person-circle-exclamation::before {
  content: "\\e53f";
}

.blastream-icon-chevron-down::before {
  content: "\\f078";
}

.blastream-icon-battery-full::before {
  content: "\\f240";
}

.blastream-icon-battery::before {
  content: "\\f240";
}

.blastream-icon-battery-5::before {
  content: "\\f240";
}

.blastream-icon-skull-crossbones::before {
  content: "\\f714";
}

.blastream-icon-code-compare::before {
  content: "\\e13a";
}

.blastream-icon-list-ul::before {
  content: "\\f0ca";
}

.blastream-icon-list-dots::before {
  content: "\\f0ca";
}

.blastream-icon-school-lock::before {
  content: "\\e56f";
}

.blastream-icon-tower-cell::before {
  content: "\\e585";
}

.blastream-icon-down-long::before {
  content: "\\f309";
}

.blastream-icon-long-arrow-alt-down::before {
  content: "\\f309";
}

.blastream-icon-ranking-star::before {
  content: "\\e561";
}

.blastream-icon-chess-king::before {
  content: "\\f43f";
}

.blastream-icon-person-harassing::before {
  content: "\\e549";
}

.blastream-icon-brazilian-real-sign::before {
  content: "\\e46c";
}

.blastream-icon-landmark-dome::before {
  content: "\\f752";
}

.blastream-icon-landmark-alt::before {
  content: "\\f752";
}

.blastream-icon-arrow-up::before {
  content: "\\f062";
}

.blastream-icon-tv::before {
  content: "\\f26c";
}

.blastream-icon-television::before {
  content: "\\f26c";
}

.blastream-icon-tv-alt::before {
  content: "\\f26c";
}

.blastream-icon-shrimp::before {
  content: "\\e448";
}

.blastream-icon-list-check::before {
  content: "\\f0ae";
}

.blastream-icon-tasks::before {
  content: "\\f0ae";
}

.blastream-icon-jug-detergent::before {
  content: "\\e519";
}

.blastream-icon-circle-user::before {
  content: "\\f2bd";
}

.blastream-icon-user-circle::before {
  content: "\\f2bd";
}

.blastream-icon-user-shield::before {
  content: "\\f505";
}

.blastream-icon-wind::before {
  content: "\\f72e";
}

.blastream-icon-car-burst::before {
  content: "\\f5e1";
}

.blastream-icon-car-crash::before {
  content: "\\f5e1";
}

.blastream-icon-y::before {
  content: "Y";
}

.blastream-icon-person-snowboarding::before {
  content: "\\f7ce";
}

.blastream-icon-snowboarding::before {
  content: "\\f7ce";
}

.blastream-icon-truck-fast::before {
  content: "\\f48b";
}

.blastream-icon-shipping-fast::before {
  content: "\\f48b";
}

.blastream-icon-fish::before {
  content: "\\f578";
}

.blastream-icon-user-graduate::before {
  content: "\\f501";
}

.blastream-icon-circle-half-stroke::before {
  content: "\\f042";
}

.blastream-icon-adjust::before {
  content: "\\f042";
}

.blastream-icon-clapperboard::before {
  content: "\\e131";
}

.blastream-icon-circle-radiation::before {
  content: "\\f7ba";
}

.blastream-icon-radiation-alt::before {
  content: "\\f7ba";
}

.blastream-icon-baseball::before {
  content: "\\f433";
}

.blastream-icon-baseball-ball::before {
  content: "\\f433";
}

.blastream-icon-jet-fighter-up::before {
  content: "\\e518";
}

.blastream-icon-diagram-project::before {
  content: "\\f542";
}

.blastream-icon-project-diagram::before {
  content: "\\f542";
}

.blastream-icon-copy::before {
  content: "\\f0c5";
}

.blastream-icon-volume-xmark::before {
  content: "\\f6a9";
}

.blastream-icon-volume-mute::before {
  content: "\\f6a9";
}

.blastream-icon-volume-times::before {
  content: "\\f6a9";
}

.blastream-icon-hand-sparkles::before {
  content: "\\e05d";
}

.blastream-icon-grip::before {
  content: "\\f58d";
}

.blastream-icon-grip-horizontal::before {
  content: "\\f58d";
}

.blastream-icon-share-from-square::before {
  content: "\\f14d";
}

.blastream-icon-share-square::before {
  content: "\\f14d";
}

.blastream-icon-child-combatant::before {
  content: "\\e4e0";
}

.blastream-icon-child-rifle::before {
  content: "\\e4e0";
}

.blastream-icon-gun::before {
  content: "\\e19b";
}

.blastream-icon-square-phone::before {
  content: "\\f098";
}

.blastream-icon-phone-square::before {
  content: "\\f098";
}

.blastream-icon-plus::before {
  content: "\\+";
}

.blastream-icon-add::before {
  content: "\\+";
}

.blastream-icon-expand::before {
  content: "\\f065";
}

.blastream-icon-computer::before {
  content: "\\e4e5";
}

.blastream-icon-xmark::before {
  content: "\\f00d";
}

.blastream-icon-close::before {
  content: "\\f00d";
}

.blastream-icon-multiply::before {
  content: "\\f00d";
}

.blastream-icon-remove::before {
  content: "\\f00d";
}

.blastream-icon-times::before {
  content: "\\f00d";
}

.blastream-icon-arrows-up-down-left-right::before {
  content: "\\f047";
}

.blastream-icon-arrows::before {
  content: "\\f047";
}

.blastream-icon-chalkboard-user::before {
  content: "\\f51c";
}

.blastream-icon-chalkboard-teacher::before {
  content: "\\f51c";
}

.blastream-icon-peso-sign::before {
  content: "\\e222";
}

.blastream-icon-building-shield::before {
  content: "\\e4d8";
}

.blastream-icon-baby::before {
  content: "\\f77c";
}

.blastream-icon-users-line::before {
  content: "\\e592";
}

.blastream-icon-quote-left::before {
  content: "\\f10d";
}

.blastream-icon-quote-left-alt::before {
  content: "\\f10d";
}

.blastream-icon-tractor::before {
  content: "\\f722";
}

.blastream-icon-trash-arrow-up::before {
  content: "\\f829";
}

.blastream-icon-trash-restore::before {
  content: "\\f829";
}

.blastream-icon-arrow-down-up-lock::before {
  content: "\\e4b0";
}

.blastream-icon-lines-leaning::before {
  content: "\\e51e";
}

.blastream-icon-ruler-combined::before {
  content: "\\f546";
}

.blastream-icon-copyright::before {
  content: "\\f1f9";
}

.blastream-icon-equals::before {
  content: "\\=";
}

.blastream-icon-blender::before {
  content: "\\f517";
}

.blastream-icon-teeth::before {
  content: "\\f62e";
}

.blastream-icon-shekel-sign::before {
  content: "\\f20b";
}

.blastream-icon-ils::before {
  content: "\\f20b";
}

.blastream-icon-shekel::before {
  content: "\\f20b";
}

.blastream-icon-sheqel::before {
  content: "\\f20b";
}

.blastream-icon-sheqel-sign::before {
  content: "\\f20b";
}

.blastream-icon-map::before {
  content: "\\f279";
}

.blastream-icon-rocket::before {
  content: "\\f135";
}

.blastream-icon-photo-film::before {
  content: "\\f87c";
}

.blastream-icon-photo-video::before {
  content: "\\f87c";
}

.blastream-icon-folder-minus::before {
  content: "\\f65d";
}

.blastream-icon-store::before {
  content: "\\f54e";
}

.blastream-icon-arrow-trend-up::before {
  content: "\\e098";
}

.blastream-icon-plug-circle-minus::before {
  content: "\\e55e";
}

.blastream-icon-sign-hanging::before {
  content: "\\f4d9";
}

.blastream-icon-sign::before {
  content: "\\f4d9";
}

.blastream-icon-bezier-curve::before {
  content: "\\f55b";
}

.blastream-icon-bell-slash::before {
  content: "\\f1f6";
}

.blastream-icon-tablet::before {
  content: "\\f3fb";
}

.blastream-icon-tablet-android::before {
  content: "\\f3fb";
}

.blastream-icon-school-flag::before {
  content: "\\e56e";
}

.blastream-icon-fill::before {
  content: "\\f575";
}

.blastream-icon-angle-up::before {
  content: "\\f106";
}

.blastream-icon-drumstick-bite::before {
  content: "\\f6d7";
}

.blastream-icon-holly-berry::before {
  content: "\\f7aa";
}

.blastream-icon-chevron-left::before {
  content: "\\f053";
}

.blastream-icon-bacteria::before {
  content: "\\e059";
}

.blastream-icon-hand-lizard::before {
  content: "\\f258";
}

.blastream-icon-notdef::before {
  content: "\\e1fe";
}

.blastream-icon-disease::before {
  content: "\\f7fa";
}

.blastream-icon-briefcase-medical::before {
  content: "\\f469";
}

.blastream-icon-genderless::before {
  content: "\\f22d";
}

.blastream-icon-chevron-right::before {
  content: "\\f054";
}

.blastream-icon-retweet::before {
  content: "\\f079";
}

.blastream-icon-car-rear::before {
  content: "\\f5de";
}

.blastream-icon-car-alt::before {
  content: "\\f5de";
}

.blastream-icon-pump-soap::before {
  content: "\\e06b";
}

.blastream-icon-video-slash::before {
  content: "\\f4e2";
}

.blastream-icon-battery-quarter::before {
  content: "\\f243";
}

.blastream-icon-battery-2::before {
  content: "\\f243";
}

.blastream-icon-radio::before {
  content: "\\f8d7";
}

.blastream-icon-baby-carriage::before {
  content: "\\f77d";
}

.blastream-icon-carriage-baby::before {
  content: "\\f77d";
}

.blastream-icon-traffic-light::before {
  content: "\\f637";
}

.blastream-icon-thermometer::before {
  content: "\\f491";
}

.blastream-icon-vr-cardboard::before {
  content: "\\f729";
}

.blastream-icon-hand-middle-finger::before {
  content: "\\f806";
}

.blastream-icon-percent::before {
  content: "\\%";
}

.blastream-icon-percentage::before {
  content: "\\%";
}

.blastream-icon-truck-moving::before {
  content: "\\f4df";
}

.blastream-icon-glass-water-droplet::before {
  content: "\\e4f5";
}

.blastream-icon-display::before {
  content: "\\e163";
}

.blastream-icon-face-smile::before {
  content: "\\f118";
}

.blastream-icon-smile::before {
  content: "\\f118";
}

.blastream-icon-thumbtack::before {
  content: "\\f08d";
}

.blastream-icon-thumb-tack::before {
  content: "\\f08d";
}

.blastream-icon-trophy::before {
  content: "\\f091";
}

.blastream-icon-person-praying::before {
  content: "\\f683";
}

.blastream-icon-pray::before {
  content: "\\f683";
}

.blastream-icon-hammer::before {
  content: "\\f6e3";
}

.blastream-icon-hand-peace::before {
  content: "\\f25b";
}

.blastream-icon-rotate::before {
  content: "\\f2f1";
}

.blastream-icon-sync-alt::before {
  content: "\\f2f1";
}

.blastream-icon-spinner::before {
  content: "\\f110";
}

.blastream-icon-robot::before {
  content: "\\f544";
}

.blastream-icon-peace::before {
  content: "\\f67c";
}

.blastream-icon-gears::before {
  content: "\\f085";
}

.blastream-icon-cogs::before {
  content: "\\f085";
}

.blastream-icon-warehouse::before {
  content: "\\f494";
}

.blastream-icon-arrow-up-right-dots::before {
  content: "\\e4b7";
}

.blastream-icon-splotch::before {
  content: "\\f5bc";
}

.blastream-icon-face-grin-hearts::before {
  content: "\\f584";
}

.blastream-icon-grin-hearts::before {
  content: "\\f584";
}

.blastream-icon-dice-four::before {
  content: "\\f524";
}

.blastream-icon-sim-card::before {
  content: "\\f7c4";
}

.blastream-icon-transgender::before {
  content: "\\f225";
}

.blastream-icon-transgender-alt::before {
  content: "\\f225";
}

.blastream-icon-mercury::before {
  content: "\\f223";
}

.blastream-icon-arrow-turn-down::before {
  content: "\\f149";
}

.blastream-icon-level-down::before {
  content: "\\f149";
}

.blastream-icon-person-falling-burst::before {
  content: "\\e547";
}

.blastream-icon-award::before {
  content: "\\f559";
}

.blastream-icon-ticket-simple::before {
  content: "\\f3ff";
}

.blastream-icon-ticket-alt::before {
  content: "\\f3ff";
}

.blastream-icon-building::before {
  content: "\\f1ad";
}

.blastream-icon-angles-left::before {
  content: "\\f100";
}

.blastream-icon-angle-double-left::before {
  content: "\\f100";
}

.blastream-icon-qrcode::before {
  content: "\\f029";
}

.blastream-icon-clock-rotate-left::before {
  content: "\\f1da";
}

.blastream-icon-history::before {
  content: "\\f1da";
}

.blastream-icon-face-grin-beam-sweat::before {
  content: "\\f583";
}

.blastream-icon-grin-beam-sweat::before {
  content: "\\f583";
}

.blastream-icon-file-export::before {
  content: "\\f56e";
}

.blastream-icon-arrow-right-from-file::before {
  content: "\\f56e";
}

.blastream-icon-shield::before {
  content: "\\f132";
}

.blastream-icon-shield-blank::before {
  content: "\\f132";
}

.blastream-icon-arrow-up-short-wide::before {
  content: "\\f885";
}

.blastream-icon-sort-amount-up-alt::before {
  content: "\\f885";
}

.blastream-icon-house-medical::before {
  content: "\\e3b2";
}

.blastream-icon-golf-ball-tee::before {
  content: "\\f450";
}

.blastream-icon-golf-ball::before {
  content: "\\f450";
}

.blastream-icon-circle-chevron-left::before {
  content: "\\f137";
}

.blastream-icon-chevron-circle-left::before {
  content: "\\f137";
}

.blastream-icon-house-chimney-window::before {
  content: "\\e00d";
}

.blastream-icon-pen-nib::before {
  content: "\\f5ad";
}

.blastream-icon-tent-arrow-turn-left::before {
  content: "\\e580";
}

.blastream-icon-tents::before {
  content: "\\e582";
}

.blastream-icon-wand-magic::before {
  content: "\\f0d0";
}

.blastream-icon-magic::before {
  content: "\\f0d0";
}

.blastream-icon-dog::before {
  content: "\\f6d3";
}

.blastream-icon-carrot::before {
  content: "\\f787";
}

.blastream-icon-moon::before {
  content: "\\f186";
}

.blastream-icon-wine-glass-empty::before {
  content: "\\f5ce";
}

.blastream-icon-wine-glass-alt::before {
  content: "\\f5ce";
}

.blastream-icon-cheese::before {
  content: "\\f7ef";
}

.blastream-icon-yin-yang::before {
  content: "\\f6ad";
}

.blastream-icon-music::before {
  content: "\\f001";
}

.blastream-icon-code-commit::before {
  content: "\\f386";
}

.blastream-icon-temperature-low::before {
  content: "\\f76b";
}

.blastream-icon-person-biking::before {
  content: "\\f84a";
}

.blastream-icon-biking::before {
  content: "\\f84a";
}

.blastream-icon-broom::before {
  content: "\\f51a";
}

.blastream-icon-shield-heart::before {
  content: "\\e574";
}

.blastream-icon-gopuram::before {
  content: "\\f664";
}

.blastream-icon-earth-oceania::before {
  content: "\\e47b";
}

.blastream-icon-globe-oceania::before {
  content: "\\e47b";
}

.blastream-icon-square-xmark::before {
  content: "\\f2d3";
}

.blastream-icon-times-square::before {
  content: "\\f2d3";
}

.blastream-icon-xmark-square::before {
  content: "\\f2d3";
}

.blastream-icon-hashtag::before {
  content: "\\#";
}

.blastream-icon-up-right-and-down-left-from-center::before {
  content: "\\f424";
}

.blastream-icon-expand-alt::before {
  content: "\\f424";
}

.blastream-icon-oil-can::before {
  content: "\\f613";
}

.blastream-icon-t::before {
  content: "T";
}

.blastream-icon-hippo::before {
  content: "\\f6ed";
}

.blastream-icon-chart-column::before {
  content: "\\e0e3";
}

.blastream-icon-infinity::before {
  content: "\\f534";
}

.blastream-icon-vial-circle-check::before {
  content: "\\e596";
}

.blastream-icon-person-arrow-down-to-line::before {
  content: "\\e538";
}

.blastream-icon-voicemail::before {
  content: "\\f897";
}

.blastream-icon-fan::before {
  content: "\\f863";
}

.blastream-icon-person-walking-luggage::before {
  content: "\\e554";
}

.blastream-icon-up-down::before {
  content: "\\f338";
}

.blastream-icon-arrows-alt-v::before {
  content: "\\f338";
}

.blastream-icon-cloud-moon-rain::before {
  content: "\\f73c";
}

.blastream-icon-calendar::before {
  content: "\\f133";
}

.blastream-icon-trailer::before {
  content: "\\e041";
}

.blastream-icon-bahai::before {
  content: "\\f666";
}

.blastream-icon-haykal::before {
  content: "\\f666";
}

.blastream-icon-sd-card::before {
  content: "\\f7c2";
}

.blastream-icon-dragon::before {
  content: "\\f6d5";
}

.blastream-icon-shoe-prints::before {
  content: "\\f54b";
}

.blastream-icon-circle-plus::before {
  content: "\\f055";
}

.blastream-icon-plus-circle::before {
  content: "\\f055";
}

.blastream-icon-face-grin-tongue-wink::before {
  content: "\\f58b";
}

.blastream-icon-grin-tongue-wink::before {
  content: "\\f58b";
}

.blastream-icon-hand-holding::before {
  content: "\\f4bd";
}

.blastream-icon-plug-circle-exclamation::before {
  content: "\\e55d";
}

.blastream-icon-link-slash::before {
  content: "\\f127";
}

.blastream-icon-chain-broken::before {
  content: "\\f127";
}

.blastream-icon-chain-slash::before {
  content: "\\f127";
}

.blastream-icon-unlink::before {
  content: "\\f127";
}

.blastream-icon-clone::before {
  content: "\\f24d";
}

.blastream-icon-person-walking-arrow-loop-left::before {
  content: "\\e551";
}

.blastream-icon-arrow-up-z-a::before {
  content: "\\f882";
}

.blastream-icon-sort-alpha-up-alt::before {
  content: "\\f882";
}

.blastream-icon-fire-flame-curved::before {
  content: "\\f7e4";
}

.blastream-icon-fire-alt::before {
  content: "\\f7e4";
}

.blastream-icon-tornado::before {
  content: "\\f76f";
}

.blastream-icon-file-circle-plus::before {
  content: "\\e494";
}

.blastream-icon-book-quran::before {
  content: "\\f687";
}

.blastream-icon-quran::before {
  content: "\\f687";
}

.blastream-icon-anchor::before {
  content: "\\f13d";
}

.blastream-icon-border-all::before {
  content: "\\f84c";
}

.blastream-icon-face-angry::before {
  content: "\\f556";
}

.blastream-icon-angry::before {
  content: "\\f556";
}

.blastream-icon-cookie-bite::before {
  content: "\\f564";
}

.blastream-icon-arrow-trend-down::before {
  content: "\\e097";
}

.blastream-icon-rss::before {
  content: "\\f09e";
}

.blastream-icon-feed::before {
  content: "\\f09e";
}

.blastream-icon-draw-polygon::before {
  content: "\\f5ee";
}

.blastream-icon-scale-balanced::before {
  content: "\\f24e";
}

.blastream-icon-balance-scale::before {
  content: "\\f24e";
}

.blastream-icon-gauge-simple-high::before {
  content: "\\f62a";
}

.blastream-icon-tachometer::before {
  content: "\\f62a";
}

.blastream-icon-tachometer-fast::before {
  content: "\\f62a";
}

.blastream-icon-shower::before {
  content: "\\f2cc";
}

.blastream-icon-desktop::before {
  content: "\\f390";
}

.blastream-icon-desktop-alt::before {
  content: "\\f390";
}

.blastream-icon-m::before {
  content: "M";
}

.blastream-icon-table-list::before {
  content: "\\f00b";
}

.blastream-icon-th-list::before {
  content: "\\f00b";
}

.blastream-icon-comment-sms::before {
  content: "\\f7cd";
}

.blastream-icon-sms::before {
  content: "\\f7cd";
}

.blastream-icon-book::before {
  content: "\\f02d";
}

.blastream-icon-user-plus::before {
  content: "\\f234";
}

.blastream-icon-check::before {
  content: "\\f00c";
}

.blastream-icon-battery-three-quarters::before {
  content: "\\f241";
}

.blastream-icon-battery-4::before {
  content: "\\f241";
}

.blastream-icon-house-circle-check::before {
  content: "\\e509";
}

.blastream-icon-angle-left::before {
  content: "\\f104";
}

.blastream-icon-diagram-successor::before {
  content: "\\e47a";
}

.blastream-icon-truck-arrow-right::before {
  content: "\\e58b";
}

.blastream-icon-arrows-split-up-and-left::before {
  content: "\\e4bc";
}

.blastream-icon-hand-fist::before {
  content: "\\f6de";
}

.blastream-icon-fist-raised::before {
  content: "\\f6de";
}

.blastream-icon-cloud-moon::before {
  content: "\\f6c3";
}

.blastream-icon-briefcase::before {
  content: "\\f0b1";
}

.blastream-icon-person-falling::before {
  content: "\\e546";
}

.blastream-icon-image-portrait::before {
  content: "\\f3e0";
}

.blastream-icon-portrait::before {
  content: "\\f3e0";
}

.blastream-icon-user-tag::before {
  content: "\\f507";
}

.blastream-icon-rug::before {
  content: "\\e569";
}

.blastream-icon-earth-europe::before {
  content: "\\f7a2";
}

.blastream-icon-globe-europe::before {
  content: "\\f7a2";
}

.blastream-icon-cart-flatbed-suitcase::before {
  content: "\\f59d";
}

.blastream-icon-luggage-cart::before {
  content: "\\f59d";
}

.blastream-icon-rectangle-xmark::before {
  content: "\\f410";
}

.blastream-icon-rectangle-times::before {
  content: "\\f410";
}

.blastream-icon-times-rectangle::before {
  content: "\\f410";
}

.blastream-icon-window-close::before {
  content: "\\f410";
}

.blastream-icon-baht-sign::before {
  content: "\\e0ac";
}

.blastream-icon-book-open::before {
  content: "\\f518";
}

.blastream-icon-book-journal-whills::before {
  content: "\\f66a";
}

.blastream-icon-journal-whills::before {
  content: "\\f66a";
}

.blastream-icon-handcuffs::before {
  content: "\\e4f8";
}

.blastream-icon-triangle-exclamation::before {
  content: "\\f071";
}

.blastream-icon-exclamation-triangle::before {
  content: "\\f071";
}

.blastream-icon-warning::before {
  content: "\\f071";
}

.blastream-icon-database::before {
  content: "\\f1c0";
}

.blastream-icon-share::before {
  content: "\\f064";
}

.blastream-icon-mail-forward::before {
  content: "\\f064";
}

.blastream-icon-bottle-droplet::before {
  content: "\\e4c4";
}

.blastream-icon-mask-face::before {
  content: "\\e1d7";
}

.blastream-icon-hill-rockslide::before {
  content: "\\e508";
}

.blastream-icon-right-left::before {
  content: "\\f362";
}

.blastream-icon-exchange-alt::before {
  content: "\\f362";
}

.blastream-icon-paper-plane::before {
  content: "\\f1d8";
}

.blastream-icon-road-circle-exclamation::before {
  content: "\\e565";
}

.blastream-icon-dungeon::before {
  content: "\\f6d9";
}

.blastream-icon-align-right::before {
  content: "\\f038";
}

.blastream-icon-money-bill-1-wave::before {
  content: "\\f53b";
}

.blastream-icon-money-bill-wave-alt::before {
  content: "\\f53b";
}

.blastream-icon-life-ring::before {
  content: "\\f1cd";
}

.blastream-icon-hands::before {
  content: "\\f2a7";
}

.blastream-icon-sign-language::before {
  content: "\\f2a7";
}

.blastream-icon-signing::before {
  content: "\\f2a7";
}

.blastream-icon-calendar-day::before {
  content: "\\f783";
}

.blastream-icon-water-ladder::before {
  content: "\\f5c5";
}

.blastream-icon-ladder-water::before {
  content: "\\f5c5";
}

.blastream-icon-swimming-pool::before {
  content: "\\f5c5";
}

.blastream-icon-arrows-up-down::before {
  content: "\\f07d";
}

.blastream-icon-arrows-v::before {
  content: "\\f07d";
}

.blastream-icon-face-grimace::before {
  content: "\\f57f";
}

.blastream-icon-grimace::before {
  content: "\\f57f";
}

.blastream-icon-wheelchair-move::before {
  content: "\\e2ce";
}

.blastream-icon-wheelchair-alt::before {
  content: "\\e2ce";
}

.blastream-icon-turn-down::before {
  content: "\\f3be";
}

.blastream-icon-level-down-alt::before {
  content: "\\f3be";
}

.blastream-icon-person-walking-arrow-right::before {
  content: "\\e552";
}

.blastream-icon-square-envelope::before {
  content: "\\f199";
}

.blastream-icon-envelope-square::before {
  content: "\\f199";
}

.blastream-icon-dice::before {
  content: "\\f522";
}

.blastream-icon-bowling-ball::before {
  content: "\\f436";
}

.blastream-icon-brain::before {
  content: "\\f5dc";
}

.blastream-icon-bandage::before {
  content: "\\f462";
}

.blastream-icon-band-aid::before {
  content: "\\f462";
}

.blastream-icon-calendar-minus::before {
  content: "\\f272";
}

.blastream-icon-circle-xmark::before {
  content: "\\f057";
}

.blastream-icon-times-circle::before {
  content: "\\f057";
}

.blastream-icon-xmark-circle::before {
  content: "\\f057";
}

.blastream-icon-gifts::before {
  content: "\\f79c";
}

.blastream-icon-hotel::before {
  content: "\\f594";
}

.blastream-icon-earth-asia::before {
  content: "\\f57e";
}

.blastream-icon-globe-asia::before {
  content: "\\f57e";
}

.blastream-icon-id-card-clip::before {
  content: "\\f47f";
}

.blastream-icon-id-card-alt::before {
  content: "\\f47f";
}

.blastream-icon-magnifying-glass-plus::before {
  content: "\\f00e";
}

.blastream-icon-search-plus::before {
  content: "\\f00e";
}

.blastream-icon-thumbs-up::before {
  content: "\\f164";
}

.blastream-icon-user-clock::before {
  content: "\\f4fd";
}

.blastream-icon-hand-dots::before {
  content: "\\f461";
}

.blastream-icon-allergies::before {
  content: "\\f461";
}

.blastream-icon-file-invoice::before {
  content: "\\f570";
}

.blastream-icon-window-minimize::before {
  content: "\\f2d1";
}

.blastream-icon-mug-saucer::before {
  content: "\\f0f4";
}

.blastream-icon-coffee::before {
  content: "\\f0f4";
}

.blastream-icon-brush::before {
  content: "\\f55d";
}

.blastream-icon-mask::before {
  content: "\\f6fa";
}

.blastream-icon-magnifying-glass-minus::before {
  content: "\\f010";
}

.blastream-icon-search-minus::before {
  content: "\\f010";
}

.blastream-icon-ruler-vertical::before {
  content: "\\f548";
}

.blastream-icon-user-large::before {
  content: "\\f406";
}

.blastream-icon-user-alt::before {
  content: "\\f406";
}

.blastream-icon-train-tram::before {
  content: "\\e5b4";
}

.blastream-icon-user-nurse::before {
  content: "\\f82f";
}

.blastream-icon-syringe::before {
  content: "\\f48e";
}

.blastream-icon-cloud-sun::before {
  content: "\\f6c4";
}

.blastream-icon-stopwatch-20::before {
  content: "\\e06f";
}

.blastream-icon-square-full::before {
  content: "\\f45c";
}

.blastream-icon-magnet::before {
  content: "\\f076";
}

.blastream-icon-jar::before {
  content: "\\e516";
}

.blastream-icon-note-sticky::before {
  content: "\\f249";
}

.blastream-icon-sticky-note::before {
  content: "\\f249";
}

.blastream-icon-bug-slash::before {
  content: "\\e490";
}

.blastream-icon-arrow-up-from-water-pump::before {
  content: "\\e4b6";
}

.blastream-icon-bone::before {
  content: "\\f5d7";
}

.blastream-icon-table-cells-row-unlock::before {
  content: "\\e691";
}

.blastream-icon-user-injured::before {
  content: "\\f728";
}

.blastream-icon-face-sad-tear::before {
  content: "\\f5b4";
}

.blastream-icon-sad-tear::before {
  content: "\\f5b4";
}

.blastream-icon-plane::before {
  content: "\\f072";
}

.blastream-icon-tent-arrows-down::before {
  content: "\\e581";
}

.blastream-icon-exclamation::before {
  content: "\\!";
}

.blastream-icon-arrows-spin::before {
  content: "\\e4bb";
}

.blastream-icon-print::before {
  content: "\\f02f";
}

.blastream-icon-turkish-lira-sign::before {
  content: "\\e2bb";
}

.blastream-icon-try::before {
  content: "\\e2bb";
}

.blastream-icon-turkish-lira::before {
  content: "\\e2bb";
}

.blastream-icon-dollar-sign::before {
  content: "\\\$";
}

.blastream-icon-dollar::before {
  content: "\\\$";
}

.blastream-icon-usd::before {
  content: "\\\$";
}

.blastream-icon-x::before {
  content: "X";
}

.blastream-icon-magnifying-glass-dollar::before {
  content: "\\f688";
}

.blastream-icon-search-dollar::before {
  content: "\\f688";
}

.blastream-icon-users-gear::before {
  content: "\\f509";
}

.blastream-icon-users-cog::before {
  content: "\\f509";
}

.blastream-icon-person-military-pointing::before {
  content: "\\e54a";
}

.blastream-icon-building-columns::before {
  content: "\\f19c";
}

.blastream-icon-bank::before {
  content: "\\f19c";
}

.blastream-icon-institution::before {
  content: "\\f19c";
}

.blastream-icon-museum::before {
  content: "\\f19c";
}

.blastream-icon-university::before {
  content: "\\f19c";
}

.blastream-icon-umbrella::before {
  content: "\\f0e9";
}

.blastream-icon-trowel::before {
  content: "\\e589";
}

.blastream-icon-d::before {
  content: "D";
}

.blastream-icon-stapler::before {
  content: "\\e5af";
}

.blastream-icon-masks-theater::before {
  content: "\\f630";
}

.blastream-icon-theater-masks::before {
  content: "\\f630";
}

.blastream-icon-kip-sign::before {
  content: "\\e1c4";
}

.blastream-icon-hand-point-left::before {
  content: "\\f0a5";
}

.blastream-icon-handshake-simple::before {
  content: "\\f4c6";
}

.blastream-icon-handshake-alt::before {
  content: "\\f4c6";
}

.blastream-icon-jet-fighter::before {
  content: "\\f0fb";
}

.blastream-icon-fighter-jet::before {
  content: "\\f0fb";
}

.blastream-icon-square-share-nodes::before {
  content: "\\f1e1";
}

.blastream-icon-share-alt-square::before {
  content: "\\f1e1";
}

.blastream-icon-barcode::before {
  content: "\\f02a";
}

.blastream-icon-plus-minus::before {
  content: "\\e43c";
}

.blastream-icon-video::before {
  content: "\\f03d";
}

.blastream-icon-video-camera::before {
  content: "\\f03d";
}

.blastream-icon-graduation-cap::before {
  content: "\\f19d";
}

.blastream-icon-mortar-board::before {
  content: "\\f19d";
}

.blastream-icon-hand-holding-medical::before {
  content: "\\e05c";
}

.blastream-icon-person-circle-check::before {
  content: "\\e53e";
}

.blastream-icon-turn-up::before {
  content: "\\f3bf";
}

.blastream-icon-level-up-alt::before {
  content: "\\f3bf";
}

.sr-only,
.blastream-icon-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.blastream-icon-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/*!
 * Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
:root, :host {
  --blastream-icon-style-family-classic: "Font Awesome 6 Free";
  --blastream-icon-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
}

@font-face {
  font-family: "Font Awesome 6 Free";
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
.fas,
.blastream-icon-solid {
  font-weight: 900;
}

/*!
 * Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
:root, :host {
  --blastream-icon-style-family-classic: "Font Awesome 6 Free";
  --blastream-icon-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
}

@font-face {
  font-family: "Font Awesome 6 Free";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
.far,
.blastream-icon-regular {
  font-weight: 400;
}

.blastream-player-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  pointer-events: none;
}
.blastream-player-controls-show, .blastream-player-controls-hover {
  z-index: inherit;
}
.blastream-player-controls-show.blastream-player-controls-container-bottom .blastream-player-controls-bottom::before, .blastream-player-controls-hover.blastream-player-controls-container-bottom .blastream-player-controls-bottom::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.1) 75%, rgba(0, 0, 0, 0) 100%);
  height: 0;
  opacity: 0;
  z-index: 0;
  transition: opacity 0.2s ease, height 0.1s ease;
}
.blastream-player-controls-show.blastream-player-controls-container-top .blastream-player-controls-top::before, .blastream-player-controls-hover.blastream-player-controls-container-top .blastream-player-controls-top::before {
  content: "";
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.1) 75%, rgba(0, 0, 0, 0) 100%);
  height: 0;
  opacity: 0;
  z-index: 0;
  transition: opacity 0.2s ease;
}
.blastream-player-controls-show.blastream-player-controls-container-bottom-top .blastream-player-controls-bottom::before, .blastream-player-controls-hover.blastream-player-controls-container-bottom-top .blastream-player-controls-bottom::before {
  content: "";
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.1) 75%, rgba(0, 0, 0, 0) 100%);
  height: 0;
  opacity: 0;
  z-index: 0;
  transition: opacity 0.2s ease, height 0.1s ease;
}
.blastream-player-controls-show.blastream-player-controls-container-bottom-top .blastream-player-controls-top::before, .blastream-player-controls-hover.blastream-player-controls-container-bottom-top .blastream-player-controls-top::before {
  content: "";
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.1) 75%, rgba(0, 0, 0, 0) 100%);
  height: 0;
  opacity: 0;
  z-index: 0;
  transition: opacity 0.2s ease;
}
.blastream-player-controls-show.blastream-player-controls-container-full::before, .blastream-player-controls-hover.blastream-player-controls-container-full::before {
  content: "";
  pointer-events: none;
  position: absolute;
  transition: opacity 200ms ease-in-out;
  background: linear-gradient(180deg, rgba(13, 13, 13, 0.6) 0, rgba(13, 13, 13, 0.2) 20%, rgba(13, 13, 13, 0.2) 80%, rgba(13, 13, 13, 0.6) 100%);
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  opacity: 0;
}
.blastream-player-controls-middle, .blastream-player-controls-bottom, .blastream-player-controls-top {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  opacity: 0;
  transition: opacity 0.3s ease var(--player-control-hide-time, 0s);
  color: var(--player-color-control-icon, var(--player-color-primary, #ffffff));
  width: 100%;
}
.blastream-player-controls-middle-left, .blastream-player-controls-middle-center, .blastream-player-controls-middle-right, .blastream-player-controls-bottom-left, .blastream-player-controls-bottom-center, .blastream-player-controls-bottom-right, .blastream-player-controls-top-left, .blastream-player-controls-top-center, .blastream-player-controls-top-right {
  display: flex;
  align-items: center;
  pointer-events: auto;
}
.blastream-player-controls-middle-center, .blastream-player-controls-bottom-center, .blastream-player-controls-top-center {
  flex-grow: 1;
}
.blastream-player-controls-top {
  bottom: initial;
  top: 0;
}
.blastream-player-controls-middle {
  justify-content: center;
  align-items: center;
  align-content: center;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
  width: fit-content;
  height: fit-content;
  flex-direction: row;
  pointer-events: auto;
  margin: 0 auto;
}
.blastream-player-controls-top-sticky, .blastream-player-controls-bottom-sticky {
  opacity: 1;
}

.blastream-player-controls-show.blastream-player-controls-container-full::before,
.blastream-player:hover .blastream-player-controls.blastream-player-controls-container-full::before {
  opacity: 1;
}
.blastream-player-controls-show.blastream-player-controls-container-bottom .blastream-player-controls-bottom::before,
.blastream-player:hover .blastream-player-controls.blastream-player-controls-container-bottom .blastream-player-controls-bottom::before {
  height: 200%;
  min-height: 50px;
  opacity: 1;
}
.blastream-player-controls-show.blastream-player-controls-container-top .blastream-player-controls-top::before,
.blastream-player:hover .blastream-player-controls.blastream-player-controls-container-top .blastream-player-controls-top::before {
  height: 200%;
  min-height: 50px;
  opacity: 1;
}
.blastream-player-controls-show.blastream-player-controls-container-bottom-top .blastream-player-controls-bottom::before,
.blastream-player:hover .blastream-player-controls.blastream-player-controls-container-bottom-top .blastream-player-controls-bottom::before {
  height: 200%;
  min-height: 50px;
  opacity: 1;
}
.blastream-player-controls-show.blastream-player-controls-container-bottom-top .blastream-player-controls-top::before,
.blastream-player:hover .blastream-player-controls.blastream-player-controls-container-bottom-top .blastream-player-controls-top::before {
  height: 200%;
  min-height: 50px;
  opacity: 1;
}

.blastream-player-controls-hide {
  height: 0px;
}

.blastream-player-controls-show .blastream-player-controls-zone,
.blastream-player:hover .blastream-player-controls .blastream-player-controls-zone {
  opacity: 1;
}

.blastream-player-control {
  background: none;
  border: none;
  color: var(--player-color-control-icon, var(--player-color-primary, #ffffff));
  font-size: 20px;
  padding: 0 5px;
  display: flex;
  transition: color 0.3s ease;
  position: relative;
  /*button {
    &:hover {
      filter: brightness(0.8);
    }
  }*/
}

.blastream-player-controls-middle .blastream-player-control {
  font-size: 55px;
  padding: 5px 25px;
}

.blastream-player-size-xs .blastream-player-controls-middle .blastream-player-control,
.blastream-player-size-xxs .blastream-player-controls-middle .blastream-player-control {
  font-size: 30px;
  padding: 5px;
}

.blastream-player-control-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-align: inherit;
  outline: none;
  cursor: pointer;
  width: 30px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  opacity: 0.9;
}
.blastream-player-control-button:focus-visible {
  border: 1px solid var(--player-color-primary, #ffffff);
}
.blastream-player-control-button:focus {
  outline: none;
}
.blastream-player-control-button:hover {
  opacity: 1;
}
.blastream-player-control-button .blastream-player-control-button-back {
  display: none;
}
.blastream-player-control-button .blastream-player-control-button-title {
  display: none;
}
.blastream-player-control-button-show-text {
  width: fit-content;
}
.blastream-player-control-button-show-text .blastream-player-control-button-title {
  display: block;
  width: fit-content;
}
.blastream-player-control-button-show-text .blastream-player-control-button-title .blastream-player-control-icon {
  display: none;
}
.blastream-player-control-button .blastream-player-control-button-icon {
  display: flex;
  justify-content: center;
}
.blastream-player-control-button-fullscreen .blastream-player-control-button-icon {
  transition: transform 250ms cubic-bezier(0.4, 0, 1, 1);
  transform-origin: center;
}
.blastream-player-control-button-fullscreen:hover .blastream-player-control-button-icon {
  animation: iconPulse 400ms;
}

.blastream-player-control-live-dvr-indicator {
  cursor: pointer;
}

.blastream-player-control-button-sub-menu {
  z-index: 14;
}
.blastream-player-control-button-sub-menu .blastream-player-control-button-icon {
  transition: transform 150ms cubic-bezier(0.4, 0, 1, 1);
  transform-origin: center;
}

.blastream-player-control-sub-menu .blastream-player-control {
  font-size: 12px;
  position: initial;
}
.blastream-player-control-sub-menu .blastream-player-control:hover {
  background: rgba(255, 255, 255, 0.08);
}
.blastream-player-control-sub-menu .blastream-player-control .blastream-tooltip-container {
  width: 100%;
}
.blastream-player-control-sub-menu .blastream-player-control .blastream-player-control-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: -webkit-fill-available;
  width: -moz-available;
  height: 20px;
  line-height: 20px;
}
.blastream-player-control-sub-menu .blastream-player-control .blastream-player-control-button .blastream-player-control-button-title {
  margin-left: 10px;
  display: initial;
  text-align: right;
  padding: 4px 0;
  flex-grow: 1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.blastream-player-control-sub-menu .blastream-player-control .blastream-player-control-button .blastream-player-control-button-title .blastream-player-control-icon {
  padding-left: 12px;
}
.blastream-player-control-sub-menu .blastream-player-control .blastream-player-control-menu {
  background: transparent;
  position: absolute;
  bottom: 0;
  padding: 0px;
  transform: translate(100%, 0);
  transition: none;
  /*transition:
    transform 250ms ease-in-out,
    height 250ms ease-in-out;
  */
}
.blastream-player-control-sub-menu .blastream-player-control .blastream-player-control-menu-open {
  transform: translate(0, 0);
  height: initial;
  padding: 6px;
  width: 100%;
  text-align: left;
  position: relative;
}
.blastream-player-control-sub-menu .blastream-player-control .blastream-player-control-menu-back {
  display: initial;
}
.blastream-player-control-sub-menu .blastream-player-control .blastream-player-control-menu .blastream-player-control-button-title {
  font-size: 12px;
}

.blastream-player-control-menu-list-sub-menu .blastream-player-control-menu-item-submenu:hover {
  background: none;
}
.blastream-player-control-menu-list-sub-menu-open .blastream-player-control-button {
  display: none !important;
}
.blastream-player-control-menu-list-sub-menu-open .blastream-player-control .blastream-tooltip-container {
  width: initial;
}
.blastream-player-control-menu-list-sub-menu-open .blastream-player-control.blastream-player-control-menu-open {
  padding: 0;
}
.blastream-player-control-menu-list-sub-menu-open .blastream-player-control.blastream-player-control-menu-open:hover {
  background: none;
}

.blastream-player-control-menu {
  position: absolute;
  background: rgba(43, 42, 42, 0.589);
  border-radius: 6px;
  font-size: 12px;
  bottom: 100%;
  right: 0;
  opacity: 0;
  width: max-content;
  white-space: nowrap;
  height: fit-content;
  transition: opacity 250ms ease-in-out, transform 250ms ease-in-out 100ms, height 250ms ease-in-out;
  transform: translateY(200%);
  overflow: hidden;
  padding: 6px;
  color: var(--player-color-text, var(--player-color-primary, #ffffff));
  z-index: 3;
}
.blastream-player-control-menu-title {
  font-weight: bold;
  margin-bottom: 6px;
  text-align: left;
}
.blastream-player-control-menu-back {
  display: none;
}
.blastream-player-control-menu-item {
  border-top: 1px solid rgba(255, 255, 255, 0.288);
  padding: 2px;
  text-align: right;
  cursor: pointer;
}
.blastream-player-control-menu-item .tooltip {
  display: none;
}
.blastream-player-control-menu-item:first-child {
  border: none;
}
.blastream-player-control-menu-item:hover {
  background: rgba(255, 255, 255, 0.08);
}
.blastream-player-control-menu-item-selected {
  background: rgba(255, 255, 255, 0.2);
  font-weight: bold;
}

.blastream-player-control-menu-open {
  outline: none;
}
.blastream-player-control-menu-open .blastream-player-control-menu {
  outline: none;
  opacity: 1;
  transform: translateY(0);
  max-height: calc(var(--player-height) - 80px);
  overflow: hidden;
  overflow-y: auto;
}
.blastream-player-control-menu-open .blastream-player-control-menu.blastream-player-control-sub-menu-menu {
  overflow: hidden;
}
.blastream-player-control-menu-open .blastream-player-control-menu::-webkit-scrollbar {
  width: 8px;
}
.blastream-player-control-menu-open .blastream-player-control-menu::-webkit-scrollbar-track {
  background-color: #000000;
  border-radius: 8px;
}
.blastream-player-control-menu-open .blastream-player-control-menu::-webkit-scrollbar-thumb {
  background-color: #272727;
  border-radius: 8px;
}
.blastream-player-control-menu-open .blastream-player-control-menu::-webkit-scrollbar-thumb {
  border: 2px solid #000000;
}
.blastream-player-control-menu-open .blastream-tooltip {
  display: none;
}
.blastream-player-control-menu-open .blastream-player-control-menu-list-sub-menu-open .blastream-player-control-menu-open .blastream-player-control-menu {
  outline: none;
  opacity: 1;
  transform: translateY(0);
  position: relative;
  transition: transform 250ms ease-in-out, height 250ms ease-in-out;
  padding: 0 6px;
}

.blastream-player-controls-top .blastream-player-control-menu {
  transform: translateY(100%);
  bottom: 0;
}

.blastream-player-controls-bottom-left .blastream-player-control-menu,
.blastream-player-controls-top-left .blastream-player-control-menu {
  left: 0;
  right: initial;
}

.blastream-player-controls-bottom-left .blastream-player-control-sub-menu .blastream-player-control .blastream-player-control-menu,
.blastream-player-controls-top-left .blastream-player-control-sub-menu .blastream-player-control .blastream-player-control-menu {
  transform: translate(-100%, 0);
}
.blastream-player-controls-bottom-left .blastream-player-control-sub-menu .blastream-player-control-menu-open .blastream-player-control-menu,
.blastream-player-controls-top-left .blastream-player-control-sub-menu .blastream-player-control-menu-open .blastream-player-control-menu {
  transform: translate(0, 0);
}

.blastream-player-device-mobile .blastream-player-control-menu {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: none;
  margin: 0;
  padding: 0;
  pointer-events: none;
  border-radius: 0;
  z-index: 51;
  max-height: 100%;
}
.blastream-player-device-mobile .blastream-player-control-menu::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: rgba(40, 40, 40, 0.5607843137);
  opacity: 0;
  transition: opacity 300ms ease 300ms;
}
.blastream-player-device-mobile .blastream-player-control-menu-inner {
  font-size: 16px;
  background: #000000;
  margin: 6px;
  text-align: center;
  padding: 6px;
  border-radius: 12px;
  pointer-events: auto;
  max-height: calc(80vh - 24px);
  overflow-y: auto;
}
.blastream-player-device-mobile .blastream-player-control-menu-item {
  padding: 6px 12px;
  text-align: left;
}
.blastream-player-device-mobile .blastream-player-control-menu-list-sub-menu .blastream-player-control-menu-item-submenu {
  padding: 0;
  background: none;
}
.blastream-player-device-mobile .blastream-player-control-menu-list-sub-menu .blastream-player-control-menu-item-submenu .blastream-player-control-menu-open {
  padding: 0px;
}
.blastream-player-device-mobile .blastream-player-control-menu-list-sub-menu .blastream-player-control-menu-item-submenu .blastream-player-control-menu::before {
  display: none;
}
.blastream-player-device-mobile .blastream-player-control-menu-list-sub-menu .blastream-player-control-menu-item-submenu .blastream-player-control-menu-inner {
  padding: 0px;
  margin: 0;
}
.blastream-player-device-mobile .blastream-player-control-menu-list-sub-menu .blastream-player-control:hover {
  background: none;
}
.blastream-player-device-mobile .blastream-player-control-menu-list-sub-menu .blastream-player-control-button {
  height: 33px;
  line-height: 33px;
  padding-left: 6px;
}
.blastream-player-device-mobile .blastream-player-control-menu-open .blastream-player-control-menu::before {
  opacity: 1;
}

.blastream-player-control-volume {
  display: flex;
  align-items: center;
}
.blastream-player-control-volume-container {
  position: relative;
  display: inline-block;
}
.blastream-player-control-volume-thumb {
  position: absolute;
  top: 50%;
  left: calc(var(--value) * 1%);
  width: 16px;
  height: 16px;
  transform: translate(-50%, -50%);
  background-color: var(--player-color-progress-bar, var(--player-color-primary, #0075ff));
  border-radius: 50%;
  z-index: 3;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease, width 0.3s ease, height 0.3s ease;
}
.blastream-player-control-volume-slider {
  padding: 0px;
  margin: 0px;
  position: relative;
  height: 8px;
  width: 0px;
  opacity: 0;
  border-radius: 4px;
  cursor: pointer;
  background-color: #ddd;
  background: linear-gradient(to right, var(--player-color-primary, #0075ff) calc(var(--value) * 1%), #ddd calc(var(--value) * 1%));
  transition: margin 0.2s cubic-bezier(0.4, 0, 1, 1), width 0.2s cubic-bezier(0.4, 0, 1, 1);
}
.blastream-player-control-volume .blastream-player-control-volume-slider-portrait.blastream-player-control-volume-slider-container {
  position: absolute;
  left: 50%;
  margin-top: 0px;
  transform: translateX(-50%);
  width: 100%;
  display: flex;
  justify-content: center;
}
.blastream-player-control-volume .blastream-player-control-volume-slider-portrait .blastream-player-control-volume-slider {
  width: 8px;
  height: 0px;
  opacity: 0;
  background: linear-gradient(to top, var(--player-color-primary, #0075ff) calc(var(--value) * 1%), #ddd calc(var(--value) * 1%));
  transition: margin 0.2s cubic-bezier(0.4, 0, 1, 1), height 0.2s cubic-bezier(0.4, 0, 1, 1);
}
.blastream-player-control-volume .blastream-player-control-volume-slider-portrait .blastream-player-control-volume-slider .blastream-player-control-volume-thumb {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 50%);
  bottom: calc(var(--value) * 1%);
  top: initial;
}
.blastream-player-control-volume:hover .blastream-player-control-volume-slider {
  margin-right: 10px;
  opacity: 1;
  width: 60px;
}
.blastream-player-control-volume:hover .blastream-player-control-volume-slider-portrait {
  bottom: 100%;
}
.blastream-player-control-volume:hover .blastream-player-control-volume-slider-portrait .blastream-player-control-volume-slider {
  margin-right: 0px;
  margin-top: -15px;
  opacity: 1;
  width: 8px;
  height: 60px;
}
.blastream-player-control-volume-muted {
  color: var(--player-color-primary, #0075ff);
}
.blastream-player-control-volume-muted:hover {
  color: var(--player-color-primary, #0075ff);
}
.blastream-player-control-volume-muted .blastream-player-control-volume-range {
  background: #ddd;
}

.blastream-player-controls-bottom-right .blastream-player-control-volume,
.blastream-player-controls-top-right .blastream-player-control-volume {
  flex-direction: row-reverse;
}

.blastream-player-control-quality {
  display: flex;
}

.blastream-player-progressbar {
  position: relative;
  display: inline-block;
  width: calc(100% - 20px);
  margin: 5px 10px;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
  pointer-events: auto;
  z-index: 2;
  cursor: pointer;
}
.blastream-player-progressbar-container {
  position: relative;
  width: 100%;
  height: 5px;
  background-color: rgba(149, 149, 149, 0.8901960784);
  border-radius: 4px;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
}
.blastream-player-progressbar-container:focus {
  box-shadow: 0 0 3px 2px rgba(21, 156, 228, 0.4);
}
.blastream-player-progressbar-loaded {
  position: absolute;
  height: 100%;
  height: 5px;
  top: 0;
  left: 0;
  background-color: #ddd;
  border-radius: 4px;
  z-index: 1;
  transition: width 150ms;
}
.blastream-player-progressbar-progress {
  position: relative;
  height: 100%;
  background-color: var(--player-color-progress-bar, var(--player-color-primary, #0075ff));
  border-radius: 4px;
  z-index: 3;
  transition: width 150ms;
}
.blastream-player-progressbar-thumb {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translate(100%, -50%);
  width: 16px;
  height: 16px;
  background-color: var(--player-color-progress-bar, var(--player-color-primary, #0075ff));
  border-radius: 50%;
  z-index: 3;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease, width 0.3s ease, height 0.3s ease;
  opacity: 0;
}
.blastream-player-progressbar-hover-bar {
  position: absolute;
  height: 100%;
  height: 5px;
  top: 0;
  left: 0;
  background-color: #afafaf;
  border-radius: 4px;
  z-index: 2;
  transition: opacity 0.3s ease, width 0.3s ease, height 0.3s ease;
}
.blastream-player-progressbar:hover .blastream-player-progressbar-thumb, .blastream-player-progressbar:active .blastream-player-progressbar-thumb {
  opacity: 1;
}
.blastream-player-progressbar:not(:hover) .blastream-player-progressbar-thumb {
  width: 0;
  height: 0;
  opacity: 0;
}
.blastream-player-progressbar-hover-time {
  position: absolute;
  bottom: 12px;
  font-size: 12px;
  transform: translateX(-50%);
  padding: 0;
  pointer-events: none;
  background: rgba(43, 42, 42, 0.589);
  padding: 2px 4px;
  border-radius: 4px;
  color: var(--player-color-primary, #ffffff);
  border: 1px solid rgba(255, 255, 255, 0.4588235294);
}
.blastream-player-progressbar-before-bottom-controls {
  position: absolute;
  left: 0;
  top: -10px;
}
.blastream-player-progressbar-after-bottom-controls {
  padding: 10px 0;
  flex-basis: 100%;
}
.blastream-player-progressbar-after-bottom-controls .blastream-player-progressbar-hover-time {
  bottom: 17px;
}
.blastream-player-progressbar-bottom {
  position: absolute;
  left: 0;
  bottom: 0px;
  padding: 5px 0 0;
  margin: 0;
  width: 100%;
}
.blastream-player-progressbar-bottom .blastream-player-progressbar-progress {
  border-radius: 0;
}
.blastream-player-progressbar-bottom .blastream-player-progressbar-loaded {
  border-radius: 0;
}
.blastream-player-progressbar-bottom .blastream-player-container {
  border-radius: 0;
}

.blastream-player-control-time-info {
  font-size: 17px;
  display: flex;
  cursor: initial;
  align-items: center;
  line-height: 17px;
  /*&:hover {
    color: \$secondary-color;
  }*/
}
.blastream-player-control-time-info-sep {
  font-size: 15px;
  padding: 0 2px;
}

.blastream-player-control-pip .blastream-player-control-button-icon {
  transform: scaleY(-1);
}

.blastream-player-control-big-button {
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  height: 20vh;
  width: 20vh;
  color: var(--player-color-control-icon, var(--player-color-primary, #ffffff));
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 20;
  text-align: center;
}
.blastream-player-control-big-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: var(--player-color-control-icon, var(--player-color-primary, #ffffff));
  opacity: 0.2;
}
.blastream-player-control-big-button .tooltip-container,
.blastream-player-control-big-button button {
  width: 100%;
  height: 100%;
}
.blastream-player-control-big-button .tooltip {
  display: none;
}
.blastream-player-control-big-button .blastream-player-control-button {
  font-size: 35px;
  text-shadow: 2px 0px 3px rgba(0, 0, 0, 0.7);
  line-height: initial;
}
.blastream-player-control-big-button .blastream-player-control-button .blastream-player-control-button-title {
  display: block;
  font-size: 18px;
  text-shadow: 2px 0px 3px rgba(0, 0, 0, 0.7);
}
.blastream-player-control-big-button .blastream-player-control-button .blastream-player-control-button-title .blastream-player-control-icon {
  display: none;
}
.blastream-player-control-big-button-topRight, .blastream-player-control-big-button-topLeft {
  left: 20px;
  top: 20px;
  transform: none;
  flex-direction: row;
  width: auto;
  height: auto;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.4509803922);
  padding: 10px;
}
.blastream-player-control-big-button-topRight .blastream-player-control-button, .blastream-player-control-big-button-topLeft .blastream-player-control-button {
  display: flex;
  align-items: center;
  font-size: 20px;
}
.blastream-player-control-big-button-topRight .blastream-player-control-button .blastream-player-control-button-title, .blastream-player-control-big-button-topLeft .blastream-player-control-button .blastream-player-control-button-title {
  padding-left: 15px;
}
.blastream-player-control-big-button-topRight {
  left: initial;
  right: 20px;
}
.blastream-player-control-big-button-mute {
  transition: opacity 0.3s ease var(--player-control-hide-time, 0s);
}
.blastream-player-control-big-button-mute .blastream-player-control-button-title {
  transition: width 1s ease;
  overflow: hidden;
}
.blastream-player-control-big-button-mute-shrinked .blastream-player-control-button-title {
  width: 0px;
  line-height: 0px;
  padding-left: 0px !important;
}
.blastream-player-control-big-button-mute-hided {
  opacity: 0;
}

.blastream-player-notification-loading {
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  height: 10vh;
  width: 10vh;
  color: var(--player-color-primary, #ffffff);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 17;
  text-align: center;
  font-size: 20px;
  font-size: 3vw;
  text-shadow: 2px 0px 3px rgba(0, 0, 0, 0.7);
}

.blastream-player-notification-error {
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  max-width: 80vw;
  max-height: 80vw;
  color: var(--player-color-tooltip-background-text, var(--player-color-primary, #ffffff));
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  z-index: 17;
  text-align: center;
  font-size: 3vw;
  text-shadow: 2px 0px 3px rgba(0, 0, 0, 0.7);
}
.blastream-player-notification-error::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  border-radius: 12px;
  background: var(--player-color-tooltip-background, #000000);
  opacity: 0.9;
}
.blastream-player-notification-error-message {
  padding: 20px;
  font-size: 16px;
}

.player-on-error .blastream-player-control-big-button {
  display: none;
}

.blastream-player-notification-action {
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  color: var(--player-color-control-icon, var(--player-color-primary, #ffffff));
  display: flex;
  font-size: 35px;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  z-index: 10;
  text-align: center;
  animation: notificationAction 800ms ease-in-out 1 forwards;
  pointer-events: none;
  transform-origin: center;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.blastream-player-notification-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  border-radius: 50%;
  background: var(--player-color-tooltip-background, #000000);
  opacity: 0.3;
}

.blastream-tooltip-container {
  position: relative;
  display: flex;
  outline: none;
}

.blastream-tooltip {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7019607843);
  color: #e3e3e3;
  text-align: center;
  padding: 5px;
  border-radius: 4px;
  z-index: 1;
  white-space: nowrap;
  margin: 5px 0;
  font-size: 12px;
  font-weight: 400;
  opacity: 0;
  transition: opacity 150ms ease;
  pointer-events: none;
  outline: none;
  left: 50%;
}
.blastream-tooltip-center {
  left: 50%;
  transform: translateY(0px) translateX(-50%);
}
.blastream-tooltip-left {
  left: inherit;
  right: 0em;
  transform: translateY(0px) translateX(0%);
}
.blastream-tooltip-right {
  left: 0em;
  transform: translateY(0px) translateX(0%);
}
.blastream-tooltip-top {
  bottom: 100%;
}
.blastream-tooltip-bottom {
  top: 100%;
  bottom: initial;
}
.blastream-tooltip-fadeIn {
  opacity: 1;
}
.blastream-tooltip-fadeOut {
  opacity: 0;
}

.blastream-player-control-cta a {
  color: var(--player-color-cta-background-text, var(--player-color-text, var(--player-color-primary, #ffffff)));
  background: var(--player-color-cta-background, var(--player-color-primary, #0075ff));
  text-decoration: none;
  padding: 5px;
  border-radius: 6px;
  transition: filter 0.3s ease;
}
.blastream-player-control-cta a:hover {
  color: var(--player-color-cta-background-text, var(--player-color-text, var(--player-color-primary, #ffffff)));
  filter: brightness(0.9);
}

.blastream-player-control-title {
  color: var(--player-color-title, var(--player-color-primary, #ffffff));
}

.blastream-player-control-logo {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 200px;
  padding: 10px;
  pointer-events: none;
}
.blastream-player-control-logo img {
  width: 100%;
  /*max-width: 200px;
  min-width: 70px;*/
  height: auto;
  display: block;
  margin: 0 auto;
}

.blastream-player-poster {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 16;
  top: 0;
  left: 0;
  background-color: transparent;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}

/*
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Verdana, sans-serif;
}
*/
.blastream-player {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-user-select: none;
          user-select: none;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu;
}
.blastream-player-inner {
  display: flex;
  align-content: center;
  align-items: center;
  height: 100%;
  overflow: hidden;
}
.blastream-player video {
  width: 100%;
  display: block;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  /*background: \$primary-color; 
  that doesn't work when video height is inferior to the container height
  */
}
.blastream-player-background {
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.blastream-player-background video {
  height: 100%;
}
.blastream-player-fit-cover {
  object-fit: cover;
}
.blastream-player-fit-cover video {
  object-fit: cover;
  height: 100%;
}
.blastream-player-fit-contain {
  object-fit: contain;
}
.blastream-player-inactivity {
  cursor: none;
}
.blastream-player-inactivity .blastream-player-controls {
  transition: opacity 0.2s ease;
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/utils/_animation.scss","webpack://./src/assets/styles/main.scss","webpack://./src/assets/styles/fontawesome/fontawesome.scss","webpack://./src/assets/styles/fontawesome/_core.scss","webpack://./src/assets/styles/fontawesome/_sizing.scss","webpack://./src/assets/styles/fontawesome/_mixins.scss","webpack://./src/assets/styles/fontawesome/_fixed-width.scss","webpack://./src/assets/styles/fontawesome/_variables.scss","webpack://./src/assets/styles/fontawesome/_list.scss","webpack://./src/assets/styles/fontawesome/_bordered-pulled.scss","webpack://./src/assets/styles/fontawesome/_animated.scss","webpack://./src/assets/styles/fontawesome/_rotated-flipped.scss","webpack://./src/assets/styles/fontawesome/_stacked.scss","webpack://./src/assets/styles/fontawesome/_icons.scss","webpack://./src/assets/styles/fontawesome/_screen-reader.scss","webpack://./src/assets/styles/fontawesome/solid.scss","webpack://./src/assets/styles/fontawesome/regular.scss","webpack://./src/assets/styles/utils/_mixins.scss","webpack://./src/assets/styles/components/controls.scss","webpack://./src/assets/styles/utils/_variables.scss","webpack://./src/assets/styles/components/submenu.scss","webpack://./src/assets/styles/components/volume.scss","webpack://./src/assets/styles/components/quality.scss","webpack://./src/assets/styles/components/progressbar.scss","webpack://./src/assets/styles/components/timeInfo.scss","webpack://./src/assets/styles/components/pip.scss","webpack://./src/assets/styles/components/bigbutton.scss","webpack://./src/assets/styles/components/loading.scss","webpack://./src/assets/styles/components/error.scss","webpack://./src/assets/styles/components/notification.scss","webpack://./src/assets/styles/components/tooltip.scss","webpack://./src/assets/styles/components/cta.scss","webpack://./src/assets/styles/components/title.scss","webpack://./src/assets/styles/components/logo.scss","webpack://./src/assets/styles/components/poster.scss"],"names":[],"mappings":"AAAA;EACE;IACE,mBAAA;ECCF;EDCA;IACE,qBAAA;ECCF;EDCA;IACE,mBAAA;ECCF;AACF;ADEA;EACE;IACE,YAAA;IACA,yCAAA;ECAF;EDEA;IACE,YAAA;IACA,2CAAA;ECAF;EDEA;IACE,UAAA;IACA,yCAAA;ECAF;AACF;ACxBA;;;;EAAA;ACGA;EACE,sEAAA;EACA,6CAAA;AF4BF;;AEzBA;;;;;;;;;EASE,kCAAA;EACA,mCAAA;EACA,oDAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;AF4BF;;AEzBA;;;;;EAKE,kCAAA;AF4BF;;AEzBA;;EAEE,oCAAA;AF4BF;;AG3DE;EACE,cAAA;AH8DJ;;AG/DE;EACE,cAAA;AHkEJ;;AGnEE;EACE,cAAA;AHsEJ;;AGvEE;EACE,cAAA;AH0EJ;;AG3EE;EACE,cAAA;AH8EJ;;AG/EE;EACE,cAAA;AHkFJ;;AGnFE;EACE,cAAA;AHsFJ;;AGvFE;EACE,cAAA;AH0FJ;;AG3FE;EACE,cAAA;AH8FJ;;AG/FE;EACE,eAAA;AHkGJ;;AG5FE;ECIA,kBAAA;EACA,kBAAA;EACA,uBAAA;AJ4FF;;AGlGE;ECIA,iBAAA;EACA,2BAAA;EACA,uBAAA;AJkGF;;AGxGE;ECIA,kBAAA;EACA,2BAAA;EACA,8BAAA;AJwGF;;AG9GE;ECIA,iBAAA;EACA,mBAAA;EACA,wBAAA;AJ8GF;;AGpHE;ECIA,gBAAA;EACA,2BAAA;EACA,wBAAA;AJoHF;;AG1HE;ECIA,cAAA;EACA,sBAAA;EACA,yBAAA;AJ0HF;;AKzIA;EACE,kBAAA;EACA,aCIY;ANwId;;AO9IA;EACE,qBAAA;EACA,mDAAA;EACA,eAAA;APiJF;AO/IE;EAAO,kBAAA;APkJT;;AO/IA;EACE,oDAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,oBAAA;APkJF;;AQ/JA;EACE,sDAAA;EACA,yDAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;ARkKF;;AQ/JA;EACE,WAAA;EACA,sDAAA;ARkKF;;AQ/JA;EACE,YAAA;EACA,qDAAA;ARkKF;;ASjLA;EACE,mCAAA;EACA,0DAAA;EACA,sEAAA;EACA,gEAAA;EACA,oFAAA;EACA,8EAAA;AToLF;;ASjLA;EACE,qCAAA;EACA,0DAAA;EACA,sEAAA;EACA,gEAAA;EACA,oFAAA;EACA,oGAAA;AToLF;;ASjLA;EACE,mCAAA;EACA,0DAAA;EACA,sEAAA;EACA,gEAAA;EACA,oFAAA;EACA,+FAAA;AToLF;;ASjLA;EACE,wCAAA;EACA,0DAAA;EACA,sEAAA;EACA,gEAAA;EACA,oFAAA;EACA,+FAAA;AToLF;;ASjLA;EACE,mCAAA;EACA,0DAAA;EACA,sEAAA;EACA,gEAAA;EACA,oFAAA;EACA,8EAAA;AToLF;;ASjLA;EACE,oCAAA;EACA,0DAAA;EACA,sEAAA;EACA,gEAAA;EACA,oFAAA;EACA,yEAAA;AToLF;;ASjLA;EACE,mCAAA;EACA,0DAAA;EACA,sEAAA;EACA,gEAAA;EACA,oFAAA;EACA,yEAAA;AToLF;;ASjLA;EACE,6CAAA;AToLF;;ASjLA;;EAEE,mCAAA;EACA,sEAAA;EACA,gEAAA;EACA,oFAAA;EACA,2EAAA;AToLF;;AS9KA;EACE;;;;;;;;;IASE,qBAAA;IACA,uBAAA;IACA,4BAAA;IACA,oBAAA;IACA,uBAAA;ETiLF;AACF;AS9KA;EACE;IAAU,mBAAA;ETiLV;EShLA;IAAM,wDAAA;ETmLN;AACF;ASjLA;EACE;IAAO,oCAAA;EToLP;ESnLA;IAAO,gIAAA;ETsLP;ESrLA;IAAO,wKAAA;ETwLP;ESvLA;IAAO,gIAAA;ET0LP;ESzLA;IAAO,iFAAA;ET4LP;ES3LA;IAAO,oCAAA;ET8LP;ES7LA;IAAO,oCAAA;ETgMP;AACF;AS9LA;EACE;IAAM,gDAAA;ETiMN;AACF;AS/LA;EACE;IACE,qDAAA;IACA,mBAAA;ETiMF;ES/LA;IACE,UAAA;IACA,8DAAA;ETiMF;AACF;AS9LA;EACE;IACE,iKAAA;ETgMF;AACF;AS7LA;EACE;IAAK,yBAAA;ETgML;ES/LA;IAAK,wBAAA;ETkML;ESjMA;IAAU,yBAAA;EToMV;ESnMA;IAAW,wBAAA;ETsMX;ESrMA;IAAM,yBAAA;ETwMN;ESvMA;IAAM,wBAAA;ET0MN;ESzMA;IAAM,yBAAA;ET4MN;ES3MA;IAAM,wBAAA;ET8MN;ES7MA;IAAY,uBAAA;ETgNZ;AACF;AS9MA;EACE;IAAK,uBAAA;ETiNL;EShNA;IAAO,yBAAA;ETmNP;AACF;AUvWA;EACE,wBAAA;AVyWF;;AUtWA;EACE,yBAAA;AVyWF;;AUtWA;EACE,yBAAA;AVyWF;;AUtWA;EACE,uBAAA;AVyWF;;AUtWA;EACE,uBAAA;AVyWF;;AUtWA;;EAEE,wBAAA;AVyWF;;AUtWA;EACE,wDAAA;AVyWF;;AWnYA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBLmCwB;EKlCxB,YLmCe;ANmWjB;;AWnYA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kDAAA;AXsYF;;AWnYA;EACE,oBAAA;AXsYF;;AWnYA;EACE,cAAA;AXsYF;;AWnYA;EACE,0CAAA;AXsYF;;AYjaA;gEAAA;AAIE;EAAsC,eAAA;AZmaxC;;AYnaE;EAAsC,eAAA;AZuaxC;;AYvaE;EAAsC,eAAA;AZ2axC;;AY3aE;EAAsC,eAAA;AZ+axC;;AY/aE;EAAsC,eAAA;AZmbxC;;AYnbE;EAAsC,eAAA;AZubxC;;AYvbE;EAAsC,eAAA;AZ2bxC;;AY3bE;EAAsC,eAAA;AZ+bxC;;AY/bE;EAAsC,eAAA;AZmcxC;;AYncE;EAAsC,eAAA;AZucxC;;AYvcE;EAAsC,gBAAA;AZ2cxC;;AY3cE;EAAsC,gBAAA;AZ+cxC;;AY/cE;EAAsC,gBAAA;AZmdxC;;AYndE;EAAsC,gBAAA;AZudxC;;AYvdE;EAAsC,aAAA;AZ2dxC;;AY3dE;EAAsC,gBAAA;AZ+dxC;;AY/dE;EAAsC,gBAAA;AZmexC;;AYneE;EAAsC,gBAAA;AZuexC;;AYveE;EAAsC,gBAAA;AZ2exC;;AY3eE;EAAsC,gBAAA;AZ+exC;;AY/eE;EAAsC,gBAAA;AZmfxC;;AYnfE;EAAsC,gBAAA;AZufxC;;AYvfE;EAAsC,gBAAA;AZ2fxC;;AY3fE;EAAsC,gBAAA;AZ+fxC;;AY/fE;EAAsC,gBAAA;AZmgBxC;;AYngBE;EAAsC,gBAAA;AZugBxC;;AYvgBE;EAAsC,gBAAA;AZ2gBxC;;AY3gBE;EAAsC,gBAAA;AZ+gBxC;;AY/gBE;EAAsC,gBAAA;AZmhBxC;;AYnhBE;EAAsC,gBAAA;AZuhBxC;;AYvhBE;EAAsC,gBAAA;AZ2hBxC;;AY3hBE;EAAsC,gBAAA;AZ+hBxC;;AY/hBE;EAAsC,gBAAA;AZmiBxC;;AYniBE;EAAsC,gBAAA;AZuiBxC;;AYviBE;EAAsC,gBAAA;AZ2iBxC;;AY3iBE;EAAsC,gBAAA;AZ+iBxC;;AY/iBE;EAAsC,gBAAA;AZmjBxC;;AYnjBE;EAAsC,gBAAA;AZujBxC;;AYvjBE;EAAsC,gBAAA;AZ2jBxC;;AY3jBE;EAAsC,gBAAA;AZ+jBxC;;AY/jBE;EAAsC,gBAAA;AZmkBxC;;AYnkBE;EAAsC,gBAAA;AZukBxC;;AYvkBE;EAAsC,gBAAA;AZ2kBxC;;AY3kBE;EAAsC,gBAAA;AZ+kBxC;;AY/kBE;EAAsC,gBAAA;AZmlBxC;;AYnlBE;EAAsC,gBAAA;AZulBxC;;AYvlBE;EAAsC,gBAAA;AZ2lBxC;;AY3lBE;EAAsC,gBAAA;AZ+lBxC;;AY/lBE;EAAsC,gBAAA;AZmmBxC;;AYnmBE;EAAsC,gBAAA;AZumBxC;;AYvmBE;EAAsC,gBAAA;AZ2mBxC;;AY3mBE;EAAsC,gBAAA;AZ+mBxC;;AY/mBE;EAAsC,gBAAA;AZmnBxC;;AYnnBE;EAAsC,gBAAA;AZunBxC;;AYvnBE;EAAsC,gBAAA;AZ2nBxC;;AY3nBE;EAAsC,gBAAA;AZ+nBxC;;AY/nBE;EAAsC,gBAAA;AZmoBxC;;AYnoBE;EAAsC,gBAAA;AZuoBxC;;AYvoBE;EAAsC,gBAAA;AZ2oBxC;;AY3oBE;EAAsC,gBAAA;AZ+oBxC;;AY/oBE;EAAsC,gBAAA;AZmpBxC;;AYnpBE;EAAsC,gBAAA;AZupBxC;;AYvpBE;EAAsC,gBAAA;AZ2pBxC;;AY3pBE;EAAsC,gBAAA;AZ+pBxC;;AY/pBE;EAAsC,gBAAA;AZmqBxC;;AYnqBE;EAAsC,gBAAA;AZuqBxC;;AYvqBE;EAAsC,gBAAA;AZ2qBxC;;AY3qBE;EAAsC,gBAAA;AZ+qBxC;;AY/qBE;EAAsC,gBAAA;AZmrBxC;;AYnrBE;EAAsC,gBAAA;AZurBxC;;AYvrBE;EAAsC,gBAAA;AZ2rBxC;;AY3rBE;EAAsC,gBAAA;AZ+rBxC;;AY/rBE;EAAsC,gBAAA;AZmsBxC;;AYnsBE;EAAsC,gBAAA;AZusBxC;;AYvsBE;EAAsC,gBAAA;AZ2sBxC;;AY3sBE;EAAsC,gBAAA;AZ+sBxC;;AY/sBE;EAAsC,gBAAA;AZmtBxC;;AYntBE;EAAsC,gBAAA;AZutBxC;;AYvtBE;EAAsC,gBAAA;AZ2tBxC;;AY3tBE;EAAsC,gBAAA;AZ+tBxC;;AY/tBE;EAAsC,gBAAA;AZmuBxC;;AYnuBE;EAAsC,gBAAA;AZuuBxC;;AYvuBE;EAAsC,gBAAA;AZ2uBxC;;AY3uBE;EAAsC,gBAAA;AZ+uBxC;;AY/uBE;EAAsC,gBAAA;AZmvBxC;;AYnvBE;EAAsC,gBAAA;AZuvBxC;;AYvvBE;EAAsC,gBAAA;AZ2vBxC;;AY3vBE;EAAsC,gBAAA;AZ+vBxC;;AY/vBE;EAAsC,gBAAA;AZmwBxC;;AYnwBE;EAAsC,gBAAA;AZuwBxC;;AYvwBE;EAAsC,gBAAA;AZ2wBxC;;AY3wBE;EAAsC,gBAAA;AZ+wBxC;;AY/wBE;EAAsC,gBAAA;AZmxBxC;;AYnxBE;EAAsC,gBAAA;AZuxBxC;;AYvxBE;EAAsC,gBAAA;AZ2xBxC;;AY3xBE;EAAsC,gBAAA;AZ+xBxC;;AY/xBE;EAAsC,gBAAA;AZmyBxC;;AYnyBE;EAAsC,gBAAA;AZuyBxC;;AYvyBE;EAAsC,gBAAA;AZ2yBxC;;AY3yBE;EAAsC,gBAAA;AZ+yBxC;;AY/yBE;EAAsC,gBAAA;AZmzBxC;;AYnzBE;EAAsC,gBAAA;AZuzBxC;;AYvzBE;EAAsC,gBAAA;AZ2zBxC;;AY3zBE;EAAsC,gBAAA;AZ+zBxC;;AY/zBE;EAAsC,gBAAA;AZm0BxC;;AYn0BE;EAAsC,gBAAA;AZu0BxC;;AYv0BE;EAAsC,YAAA;AZ20BxC;;AY30BE;EAAsC,gBAAA;AZ+0BxC;;AY/0BE;EAAsC,gBAAA;AZm1BxC;;AYn1BE;EAAsC,gBAAA;AZu1BxC;;AYv1BE;EAAsC,gBAAA;AZ21BxC;;AY31BE;EAAsC,gBAAA;AZ+1BxC;;AY/1BE;EAAsC,gBAAA;AZm2BxC;;AYn2BE;EAAsC,gBAAA;AZu2BxC;;AYv2BE;EAAsC,gBAAA;AZ22BxC;;AY32BE;EAAsC,gBAAA;AZ+2BxC;;AY/2BE;EAAsC,gBAAA;AZm3BxC;;AYn3BE;EAAsC,gBAAA;AZu3BxC;;AYv3BE;EAAsC,gBAAA;AZ23BxC;;AY33BE;EAAsC,gBAAA;AZ+3BxC;;AY/3BE;EAAsC,gBAAA;AZm4BxC;;AYn4BE;EAAsC,gBAAA;AZu4BxC;;AYv4BE;EAAsC,gBAAA;AZ24BxC;;AY34BE;EAAsC,gBAAA;AZ+4BxC;;AY/4BE;EAAsC,gBAAA;AZm5BxC;;AYn5BE;EAAsC,gBAAA;AZu5BxC;;AYv5BE;EAAsC,gBAAA;AZ25BxC;;AY35BE;EAAsC,gBAAA;AZ+5BxC;;AY/5BE;EAAsC,gBAAA;AZm6BxC;;AYn6BE;EAAsC,gBAAA;AZu6BxC;;AYv6BE;EAAsC,gBAAA;AZ26BxC;;AY36BE;EAAsC,gBAAA;AZ+6BxC;;AY/6BE;EAAsC,gBAAA;AZm7BxC;;AYn7BE;EAAsC,gBAAA;AZu7BxC;;AYv7BE;EAAsC,gBAAA;AZ27BxC;;AY37BE;EAAsC,gBAAA;AZ+7BxC;;AY/7BE;EAAsC,gBAAA;AZm8BxC;;AYn8BE;EAAsC,gBAAA;AZu8BxC;;AYv8BE;EAAsC,gBAAA;AZ28BxC;;AY38BE;EAAsC,gBAAA;AZ+8BxC;;AY/8BE;EAAsC,gBAAA;AZm9BxC;;AYn9BE;EAAsC,YAAA;AZu9BxC;;AYv9BE;EAAsC,gBAAA;AZ29BxC;;AY39BE;EAAsC,gBAAA;AZ+9BxC;;AY/9BE;EAAsC,gBAAA;AZm+BxC;;AYn+BE;EAAsC,gBAAA;AZu+BxC;;AYv+BE;EAAsC,gBAAA;AZ2+BxC;;AY3+BE;EAAsC,gBAAA;AZ++BxC;;AY/+BE;EAAsC,gBAAA;AZm/BxC;;AYn/BE;EAAsC,gBAAA;AZu/BxC;;AYv/BE;EAAsC,gBAAA;AZ2/BxC;;AY3/BE;EAAsC,gBAAA;AZ+/BxC;;AY//BE;EAAsC,gBAAA;AZmgCxC;;AYngCE;EAAsC,gBAAA;AZugCxC;;AYvgCE;EAAsC,gBAAA;AZ2gCxC;;AY3gCE;EAAsC,gBAAA;AZ+gCxC;;AY/gCE;EAAsC,gBAAA;AZmhCxC;;AYnhCE;EAAsC,gBAAA;AZuhCxC;;AYvhCE;EAAsC,gBAAA;AZ2hCxC;;AY3hCE;EAAsC,gBAAA;AZ+hCxC;;AY/hCE;EAAsC,gBAAA;AZmiCxC;;AYniCE;EAAsC,gBAAA;AZuiCxC;;AYviCE;EAAsC,gBAAA;AZ2iCxC;;AY3iCE;EAAsC,gBAAA;AZ+iCxC;;AY/iCE;EAAsC,gBAAA;AZmjCxC;;AYnjCE;EAAsC,gBAAA;AZujCxC;;AYvjCE;EAAsC,gBAAA;AZ2jCxC;;AY3jCE;EAAsC,gBAAA;AZ+jCxC;;AY/jCE;EAAsC,gBAAA;AZmkCxC;;AYnkCE;EAAsC,gBAAA;AZukCxC;;AYvkCE;EAAsC,gBAAA;AZ2kCxC;;AY3kCE;EAAsC,gBAAA;AZ+kCxC;;AY/kCE;EAAsC,gBAAA;AZmlCxC;;AYnlCE;EAAsC,gBAAA;AZulCxC;;AYvlCE;EAAsC,gBAAA;AZ2lCxC;;AY3lCE;EAAsC,gBAAA;AZ+lCxC;;AY/lCE;EAAsC,gBAAA;AZmmCxC;;AYnmCE;EAAsC,gBAAA;AZumCxC;;AYvmCE;EAAsC,gBAAA;AZ2mCxC;;AY3mCE;EAAsC,gBAAA;AZ+mCxC;;AY/mCE;EAAsC,gBAAA;AZmnCxC;;AYnnCE;EAAsC,gBAAA;AZunCxC;;AYvnCE;EAAsC,gBAAA;AZ2nCxC;;AY3nCE;EAAsC,gBAAA;AZ+nCxC;;AY/nCE;EAAsC,gBAAA;AZmoCxC;;AYnoCE;EAAsC,gBAAA;AZuoCxC;;AYvoCE;EAAsC,gBAAA;AZ2oCxC;;AY3oCE;EAAsC,gBAAA;AZ+oCxC;;AY/oCE;EAAsC,gBAAA;AZmpCxC;;AYnpCE;EAAsC,gBAAA;AZupCxC;;AYvpCE;EAAsC,gBAAA;AZ2pCxC;;AY3pCE;EAAsC,gBAAA;AZ+pCxC;;AY/pCE;EAAsC,gBAAA;AZmqCxC;;AYnqCE;EAAsC,gBAAA;AZuqCxC;;AYvqCE;EAAsC,gBAAA;AZ2qCxC;;AY3qCE;EAAsC,gBAAA;AZ+qCxC;;AY/qCE;EAAsC,gBAAA;AZmrCxC;;AYnrCE;EAAsC,gBAAA;AZurCxC;;AYvrCE;EAAsC,gBAAA;AZ2rCxC;;AY3rCE;EAAsC,gBAAA;AZ+rCxC;;AY/rCE;EAAsC,gBAAA;AZmsCxC;;AYnsCE;EAAsC,gBAAA;AZusCxC;;AYvsCE;EAAsC,gBAAA;AZ2sCxC;;AY3sCE;EAAsC,gBAAA;AZ+sCxC;;AY/sCE;EAAsC,gBAAA;AZmtCxC;;AYntCE;EAAsC,gBAAA;AZutCxC;;AYvtCE;EAAsC,gBAAA;AZ2tCxC;;AY3tCE;EAAsC,gBAAA;AZ+tCxC;;AY/tCE;EAAsC,gBAAA;AZmuCxC;;AYnuCE;EAAsC,gBAAA;AZuuCxC;;AYvuCE;EAAsC,gBAAA;AZ2uCxC;;AY3uCE;EAAsC,gBAAA;AZ+uCxC;;AY/uCE;EAAsC,gBAAA;AZmvCxC;;AYnvCE;EAAsC,gBAAA;AZuvCxC;;AYvvCE;EAAsC,gBAAA;AZ2vCxC;;AY3vCE;EAAsC,gBAAA;AZ+vCxC;;AY/vCE;EAAsC,gBAAA;AZmwCxC;;AYnwCE;EAAsC,gBAAA;AZuwCxC;;AYvwCE;EAAsC,gBAAA;AZ2wCxC;;AY3wCE;EAAsC,gBAAA;AZ+wCxC;;AY/wCE;EAAsC,gBAAA;AZmxCxC;;AYnxCE;EAAsC,gBAAA;AZuxCxC;;AYvxCE;EAAsC,gBAAA;AZ2xCxC;;AY3xCE;EAAsC,gBAAA;AZ+xCxC;;AY/xCE;EAAsC,gBAAA;AZmyCxC;;AYnyCE;EAAsC,gBAAA;AZuyCxC;;AYvyCE;EAAsC,gBAAA;AZ2yCxC;;AY3yCE;EAAsC,gBAAA;AZ+yCxC;;AY/yCE;EAAsC,gBAAA;AZmzCxC;;AYnzCE;EAAsC,gBAAA;AZuzCxC;;AYvzCE;EAAsC,gBAAA;AZ2zCxC;;AY3zCE;EAAsC,gBAAA;AZ+zCxC;;AY/zCE;EAAsC,gBAAA;AZm0CxC;;AYn0CE;EAAsC,gBAAA;AZu0CxC;;AYv0CE;EAAsC,gBAAA;AZ20CxC;;AY30CE;EAAsC,gBAAA;AZ+0CxC;;AY/0CE;EAAsC,gBAAA;AZm1CxC;;AYn1CE;EAAsC,gBAAA;AZu1CxC;;AYv1CE;EAAsC,gBAAA;AZ21CxC;;AY31CE;EAAsC,gBAAA;AZ+1CxC;;AY/1CE;EAAsC,gBAAA;AZm2CxC;;AYn2CE;EAAsC,aAAA;AZu2CxC;;AYv2CE;EAAsC,gBAAA;AZ22CxC;;AY32CE;EAAsC,gBAAA;AZ+2CxC;;AY/2CE;EAAsC,gBAAA;AZm3CxC;;AYn3CE;EAAsC,gBAAA;AZu3CxC;;AYv3CE;EAAsC,gBAAA;AZ23CxC;;AY33CE;EAAsC,gBAAA;AZ+3CxC;;AY/3CE;EAAsC,gBAAA;AZm4CxC;;AYn4CE;EAAsC,gBAAA;AZu4CxC;;AYv4CE;EAAsC,gBAAA;AZ24CxC;;AY34CE;EAAsC,gBAAA;AZ+4CxC;;AY/4CE;EAAsC,gBAAA;AZm5CxC;;AYn5CE;EAAsC,gBAAA;AZu5CxC;;AYv5CE;EAAsC,gBAAA;AZ25CxC;;AY35CE;EAAsC,gBAAA;AZ+5CxC;;AY/5CE;EAAsC,gBAAA;AZm6CxC;;AYn6CE;EAAsC,gBAAA;AZu6CxC;;AYv6CE;EAAsC,gBAAA;AZ26CxC;;AY36CE;EAAsC,gBAAA;AZ+6CxC;;AY/6CE;EAAsC,gBAAA;AZm7CxC;;AYn7CE;EAAsC,gBAAA;AZu7CxC;;AYv7CE;EAAsC,gBAAA;AZ27CxC;;AY37CE;EAAsC,gBAAA;AZ+7CxC;;AY/7CE;EAAsC,gBAAA;AZm8CxC;;AYn8CE;EAAsC,gBAAA;AZu8CxC;;AYv8CE;EAAsC,gBAAA;AZ28CxC;;AY38CE;EAAsC,gBAAA;AZ+8CxC;;AY/8CE;EAAsC,gBAAA;AZm9CxC;;AYn9CE;EAAsC,gBAAA;AZu9CxC;;AYv9CE;EAAsC,gBAAA;AZ29CxC;;AY39CE;EAAsC,gBAAA;AZ+9CxC;;AY/9CE;EAAsC,gBAAA;AZm+CxC;;AYn+CE;EAAsC,gBAAA;AZu+CxC;;AYv+CE;EAAsC,gBAAA;AZ2+CxC;;AY3+CE;EAAsC,gBAAA;AZ++CxC;;AY/+CE;EAAsC,gBAAA;AZm/CxC;;AYn/CE;EAAsC,gBAAA;AZu/CxC;;AYv/CE;EAAsC,gBAAA;AZ2/CxC;;AY3/CE;EAAsC,gBAAA;AZ+/CxC;;AY//CE;EAAsC,gBAAA;AZmgDxC;;AYngDE;EAAsC,gBAAA;AZugDxC;;AYvgDE;EAAsC,gBAAA;AZ2gDxC;;AY3gDE;EAAsC,gBAAA;AZ+gDxC;;AY/gDE;EAAsC,gBAAA;AZmhDxC;;AYnhDE;EAAsC,gBAAA;AZuhDxC;;AYvhDE;EAAsC,gBAAA;AZ2hDxC;;AY3hDE;EAAsC,gBAAA;AZ+hDxC;;AY/hDE;EAAsC,gBAAA;AZmiDxC;;AYniDE;EAAsC,gBAAA;AZuiDxC;;AYviDE;EAAsC,gBAAA;AZ2iDxC;;AY3iDE;EAAsC,gBAAA;AZ+iDxC;;AY/iDE;EAAsC,gBAAA;AZmjDxC;;AYnjDE;EAAsC,gBAAA;AZujDxC;;AYvjDE;EAAsC,gBAAA;AZ2jDxC;;AY3jDE;EAAsC,gBAAA;AZ+jDxC;;AY/jDE;EAAsC,gBAAA;AZmkDxC;;AYnkDE;EAAsC,gBAAA;AZukDxC;;AYvkDE;EAAsC,gBAAA;AZ2kDxC;;AY3kDE;EAAsC,gBAAA;AZ+kDxC;;AY/kDE;EAAsC,gBAAA;AZmlDxC;;AYnlDE;EAAsC,gBAAA;AZulDxC;;AYvlDE;EAAsC,gBAAA;AZ2lDxC;;AY3lDE;EAAsC,gBAAA;AZ+lDxC;;AY/lDE;EAAsC,gBAAA;AZmmDxC;;AYnmDE;EAAsC,gBAAA;AZumDxC;;AYvmDE;EAAsC,gBAAA;AZ2mDxC;;AY3mDE;EAAsC,gBAAA;AZ+mDxC;;AY/mDE;EAAsC,gBAAA;AZmnDxC;;AYnnDE;EAAsC,gBAAA;AZunDxC;;AYvnDE;EAAsC,gBAAA;AZ2nDxC;;AY3nDE;EAAsC,gBAAA;AZ+nDxC;;AY/nDE;EAAsC,gBAAA;AZmoDxC;;AYnoDE;EAAsC,gBAAA;AZuoDxC;;AYvoDE;EAAsC,gBAAA;AZ2oDxC;;AY3oDE;EAAsC,gBAAA;AZ+oDxC;;AY/oDE;EAAsC,gBAAA;AZmpDxC;;AYnpDE;EAAsC,gBAAA;AZupDxC;;AYvpDE;EAAsC,gBAAA;AZ2pDxC;;AY3pDE;EAAsC,gBAAA;AZ+pDxC;;AY/pDE;EAAsC,gBAAA;AZmqDxC;;AYnqDE;EAAsC,gBAAA;AZuqDxC;;AYvqDE;EAAsC,gBAAA;AZ2qDxC;;AY3qDE;EAAsC,gBAAA;AZ+qDxC;;AY/qDE;EAAsC,gBAAA;AZmrDxC;;AYnrDE;EAAsC,gBAAA;AZurDxC;;AYvrDE;EAAsC,YAAA;AZ2rDxC;;AY3rDE;EAAsC,gBAAA;AZ+rDxC;;AY/rDE;EAAsC,gBAAA;AZmsDxC;;AYnsDE;EAAsC,gBAAA;AZusDxC;;AYvsDE;EAAsC,gBAAA;AZ2sDxC;;AY3sDE;EAAsC,gBAAA;AZ+sDxC;;AY/sDE;EAAsC,gBAAA;AZmtDxC;;AYntDE;EAAsC,YAAA;AZutDxC;;AYvtDE;EAAsC,gBAAA;AZ2tDxC;;AY3tDE;EAAsC,gBAAA;AZ+tDxC;;AY/tDE;EAAsC,gBAAA;AZmuDxC;;AYnuDE;EAAsC,gBAAA;AZuuDxC;;AYvuDE;EAAsC,gBAAA;AZ2uDxC;;AY3uDE;EAAsC,gBAAA;AZ+uDxC;;AY/uDE;EAAsC,gBAAA;AZmvDxC;;AYnvDE;EAAsC,gBAAA;AZuvDxC;;AYvvDE;EAAsC,gBAAA;AZ2vDxC;;AY3vDE;EAAsC,gBAAA;AZ+vDxC;;AY/vDE;EAAsC,gBAAA;AZmwDxC;;AYnwDE;EAAsC,gBAAA;AZuwDxC;;AYvwDE;EAAsC,gBAAA;AZ2wDxC;;AY3wDE;EAAsC,gBAAA;AZ+wDxC;;AY/wDE;EAAsC,gBAAA;AZmxDxC;;AYnxDE;EAAsC,gBAAA;AZuxDxC;;AYvxDE;EAAsC,gBAAA;AZ2xDxC;;AY3xDE;EAAsC,gBAAA;AZ+xDxC;;AY/xDE;EAAsC,YAAA;AZmyDxC;;AYnyDE;EAAsC,YAAA;AZuyDxC;;AYvyDE;EAAsC,gBAAA;AZ2yDxC;;AY3yDE;EAAsC,gBAAA;AZ+yDxC;;AY/yDE;EAAsC,gBAAA;AZmzDxC;;AYnzDE;EAAsC,gBAAA;AZuzDxC;;AYvzDE;EAAsC,gBAAA;AZ2zDxC;;AY3zDE;EAAsC,gBAAA;AZ+zDxC;;AY/zDE;EAAsC,gBAAA;AZm0DxC;;AYn0DE;EAAsC,gBAAA;AZu0DxC;;AYv0DE;EAAsC,gBAAA;AZ20DxC;;AY30DE;EAAsC,gBAAA;AZ+0DxC;;AY/0DE;EAAsC,gBAAA;AZm1DxC;;AYn1DE;EAAsC,gBAAA;AZu1DxC;;AYv1DE;EAAsC,gBAAA;AZ21DxC;;AY31DE;EAAsC,gBAAA;AZ+1DxC;;AY/1DE;EAAsC,gBAAA;AZm2DxC;;AYn2DE;EAAsC,gBAAA;AZu2DxC;;AYv2DE;EAAsC,gBAAA;AZ22DxC;;AY32DE;EAAsC,gBAAA;AZ+2DxC;;AY/2DE;EAAsC,gBAAA;AZm3DxC;;AYn3DE;EAAsC,gBAAA;AZu3DxC;;AYv3DE;EAAsC,gBAAA;AZ23DxC;;AY33DE;EAAsC,gBAAA;AZ+3DxC;;AY/3DE;EAAsC,gBAAA;AZm4DxC;;AYn4DE;EAAsC,gBAAA;AZu4DxC;;AYv4DE;EAAsC,gBAAA;AZ24DxC;;AY34DE;EAAsC,gBAAA;AZ+4DxC;;AY/4DE;EAAsC,gBAAA;AZm5DxC;;AYn5DE;EAAsC,gBAAA;AZu5DxC;;AYv5DE;EAAsC,gBAAA;AZ25DxC;;AY35DE;EAAsC,gBAAA;AZ+5DxC;;AY/5DE;EAAsC,gBAAA;AZm6DxC;;AYn6DE;EAAsC,gBAAA;AZu6DxC;;AYv6DE;EAAsC,gBAAA;AZ26DxC;;AY36DE;EAAsC,gBAAA;AZ+6DxC;;AY/6DE;EAAsC,gBAAA;AZm7DxC;;AYn7DE;EAAsC,YAAA;AZu7DxC;;AYv7DE;EAAsC,gBAAA;AZ27DxC;;AY37DE;EAAsC,gBAAA;AZ+7DxC;;AY/7DE;EAAsC,gBAAA;AZm8DxC;;AYn8DE;EAAsC,gBAAA;AZu8DxC;;AYv8DE;EAAsC,gBAAA;AZ28DxC;;AY38DE;EAAsC,gBAAA;AZ+8DxC;;AY/8DE;EAAsC,gBAAA;AZm9DxC;;AYn9DE;EAAsC,gBAAA;AZu9DxC;;AYv9DE;EAAsC,gBAAA;AZ29DxC;;AY39DE;EAAsC,gBAAA;AZ+9DxC;;AY/9DE;EAAsC,gBAAA;AZm+DxC;;AYn+DE;EAAsC,gBAAA;AZu+DxC;;AYv+DE;EAAsC,gBAAA;AZ2+DxC;;AY3+DE;EAAsC,gBAAA;AZ++DxC;;AY/+DE;EAAsC,gBAAA;AZm/DxC;;AYn/DE;EAAsC,gBAAA;AZu/DxC;;AYv/DE;EAAsC,gBAAA;AZ2/DxC;;AY3/DE;EAAsC,gBAAA;AZ+/DxC;;AY//DE;EAAsC,gBAAA;AZmgExC;;AYngEE;EAAsC,YAAA;AZugExC;;AYvgEE;EAAsC,gBAAA;AZ2gExC;;AY3gEE;EAAsC,gBAAA;AZ+gExC;;AY/gEE;EAAsC,gBAAA;AZmhExC;;AYnhEE;EAAsC,gBAAA;AZuhExC;;AYvhEE;EAAsC,gBAAA;AZ2hExC;;AY3hEE;EAAsC,gBAAA;AZ+hExC;;AY/hEE;EAAsC,gBAAA;AZmiExC;;AYniEE;EAAsC,gBAAA;AZuiExC;;AYviEE;EAAsC,gBAAA;AZ2iExC;;AY3iEE;EAAsC,gBAAA;AZ+iExC;;AY/iEE;EAAsC,gBAAA;AZmjExC;;AYnjEE;EAAsC,gBAAA;AZujExC;;AYvjEE;EAAsC,gBAAA;AZ2jExC;;AY3jEE;EAAsC,gBAAA;AZ+jExC;;AY/jEE;EAAsC,gBAAA;AZmkExC;;AYnkEE;EAAsC,gBAAA;AZukExC;;AYvkEE;EAAsC,gBAAA;AZ2kExC;;AY3kEE;EAAsC,gBAAA;AZ+kExC;;AY/kEE;EAAsC,gBAAA;AZmlExC;;AYnlEE;EAAsC,gBAAA;AZulExC;;AYvlEE;EAAsC,gBAAA;AZ2lExC;;AY3lEE;EAAsC,gBAAA;AZ+lExC;;AY/lEE;EAAsC,gBAAA;AZmmExC;;AYnmEE;EAAsC,gBAAA;AZumExC;;AYvmEE;EAAsC,gBAAA;AZ2mExC;;AY3mEE;EAAsC,gBAAA;AZ+mExC;;AY/mEE;EAAsC,gBAAA;AZmnExC;;AYnnEE;EAAsC,gBAAA;AZunExC;;AYvnEE;EAAsC,gBAAA;AZ2nExC;;AY3nEE;EAAsC,gBAAA;AZ+nExC;;AY/nEE;EAAsC,gBAAA;AZmoExC;;AYnoEE;EAAsC,gBAAA;AZuoExC;;AYvoEE;EAAsC,gBAAA;AZ2oExC;;AY3oEE;EAAsC,gBAAA;AZ+oExC;;AY/oEE;EAAsC,gBAAA;AZmpExC;;AYnpEE;EAAsC,gBAAA;AZupExC;;AYvpEE;EAAsC,gBAAA;AZ2pExC;;AY3pEE;EAAsC,gBAAA;AZ+pExC;;AY/pEE;EAAsC,gBAAA;AZmqExC;;AYnqEE;EAAsC,gBAAA;AZuqExC;;AYvqEE;EAAsC,gBAAA;AZ2qExC;;AY3qEE;EAAsC,gBAAA;AZ+qExC;;AY/qEE;EAAsC,gBAAA;AZmrExC;;AYnrEE;EAAsC,gBAAA;AZurExC;;AYvrEE;EAAsC,gBAAA;AZ2rExC;;AY3rEE;EAAsC,gBAAA;AZ+rExC;;AY/rEE;EAAsC,gBAAA;AZmsExC;;AYnsEE;EAAsC,gBAAA;AZusExC;;AYvsEE;EAAsC,gBAAA;AZ2sExC;;AY3sEE;EAAsC,gBAAA;AZ+sExC;;AY/sEE;EAAsC,gBAAA;AZmtExC;;AYntEE;EAAsC,gBAAA;AZutExC;;AYvtEE;EAAsC,gBAAA;AZ2tExC;;AY3tEE;EAAsC,gBAAA;AZ+tExC;;AY/tEE;EAAsC,gBAAA;AZmuExC;;AYnuEE;EAAsC,gBAAA;AZuuExC;;AYvuEE;EAAsC,gBAAA;AZ2uExC;;AY3uEE;EAAsC,gBAAA;AZ+uExC;;AY/uEE;EAAsC,gBAAA;AZmvExC;;AYnvEE;EAAsC,gBAAA;AZuvExC;;AYvvEE;EAAsC,gBAAA;AZ2vExC;;AY3vEE;EAAsC,gBAAA;AZ+vExC;;AY/vEE;EAAsC,gBAAA;AZmwExC;;AYnwEE;EAAsC,gBAAA;AZuwExC;;AYvwEE;EAAsC,gBAAA;AZ2wExC;;AY3wEE;EAAsC,gBAAA;AZ+wExC;;AY/wEE;EAAsC,gBAAA;AZmxExC;;AYnxEE;EAAsC,gBAAA;AZuxExC;;AYvxEE;EAAsC,gBAAA;AZ2xExC;;AY3xEE;EAAsC,gBAAA;AZ+xExC;;AY/xEE;EAAsC,gBAAA;AZmyExC;;AYnyEE;EAAsC,gBAAA;AZuyExC;;AYvyEE;EAAsC,gBAAA;AZ2yExC;;AY3yEE;EAAsC,gBAAA;AZ+yExC;;AY/yEE;EAAsC,gBAAA;AZmzExC;;AYnzEE;EAAsC,gBAAA;AZuzExC;;AYvzEE;EAAsC,gBAAA;AZ2zExC;;AY3zEE;EAAsC,gBAAA;AZ+zExC;;AY/zEE;EAAsC,gBAAA;AZm0ExC;;AYn0EE;EAAsC,gBAAA;AZu0ExC;;AYv0EE;EAAsC,gBAAA;AZ20ExC;;AY30EE;EAAsC,gBAAA;AZ+0ExC;;AY/0EE;EAAsC,gBAAA;AZm1ExC;;AYn1EE;EAAsC,YAAA;AZu1ExC;;AYv1EE;EAAsC,gBAAA;AZ21ExC;;AY31EE;EAAsC,gBAAA;AZ+1ExC;;AY/1EE;EAAsC,gBAAA;AZm2ExC;;AYn2EE;EAAsC,gBAAA;AZu2ExC;;AYv2EE;EAAsC,gBAAA;AZ22ExC;;AY32EE;EAAsC,gBAAA;AZ+2ExC;;AY/2EE;EAAsC,gBAAA;AZm3ExC;;AYn3EE;EAAsC,gBAAA;AZu3ExC;;AYv3EE;EAAsC,gBAAA;AZ23ExC;;AY33EE;EAAsC,gBAAA;AZ+3ExC;;AY/3EE;EAAsC,gBAAA;AZm4ExC;;AYn4EE;EAAsC,gBAAA;AZu4ExC;;AYv4EE;EAAsC,gBAAA;AZ24ExC;;AY34EE;EAAsC,gBAAA;AZ+4ExC;;AY/4EE;EAAsC,gBAAA;AZm5ExC;;AYn5EE;EAAsC,gBAAA;AZu5ExC;;AYv5EE;EAAsC,gBAAA;AZ25ExC;;AY35EE;EAAsC,gBAAA;AZ+5ExC;;AY/5EE;EAAsC,gBAAA;AZm6ExC;;AYn6EE;EAAsC,gBAAA;AZu6ExC;;AYv6EE;EAAsC,gBAAA;AZ26ExC;;AY36EE;EAAsC,gBAAA;AZ+6ExC;;AY/6EE;EAAsC,gBAAA;AZm7ExC;;AYn7EE;EAAsC,gBAAA;AZu7ExC;;AYv7EE;EAAsC,gBAAA;AZ27ExC;;AY37EE;EAAsC,gBAAA;AZ+7ExC;;AY/7EE;EAAsC,gBAAA;AZm8ExC;;AYn8EE;EAAsC,gBAAA;AZu8ExC;;AYv8EE;EAAsC,gBAAA;AZ28ExC;;AY38EE;EAAsC,gBAAA;AZ+8ExC;;AY/8EE;EAAsC,gBAAA;AZm9ExC;;AYn9EE;EAAsC,gBAAA;AZu9ExC;;AYv9EE;EAAsC,gBAAA;AZ29ExC;;AY39EE;EAAsC,gBAAA;AZ+9ExC;;AY/9EE;EAAsC,gBAAA;AZm+ExC;;AYn+EE;EAAsC,gBAAA;AZu+ExC;;AYv+EE;EAAsC,gBAAA;AZ2+ExC;;AY3+EE;EAAsC,gBAAA;AZ++ExC;;AY/+EE;EAAsC,gBAAA;AZm/ExC;;AYn/EE;EAAsC,gBAAA;AZu/ExC;;AYv/EE;EAAsC,gBAAA;AZ2/ExC;;AY3/EE;EAAsC,gBAAA;AZ+/ExC;;AY//EE;EAAsC,gBAAA;AZmgFxC;;AYngFE;EAAsC,gBAAA;AZugFxC;;AYvgFE;EAAsC,gBAAA;AZ2gFxC;;AY3gFE;EAAsC,gBAAA;AZ+gFxC;;AY/gFE;EAAsC,gBAAA;AZmhFxC;;AYnhFE;EAAsC,gBAAA;AZuhFxC;;AYvhFE;EAAsC,gBAAA;AZ2hFxC;;AY3hFE;EAAsC,gBAAA;AZ+hFxC;;AY/hFE;EAAsC,gBAAA;AZmiFxC;;AYniFE;EAAsC,gBAAA;AZuiFxC;;AYviFE;EAAsC,gBAAA;AZ2iFxC;;AY3iFE;EAAsC,gBAAA;AZ+iFxC;;AY/iFE;EAAsC,gBAAA;AZmjFxC;;AYnjFE;EAAsC,gBAAA;AZujFxC;;AYvjFE;EAAsC,gBAAA;AZ2jFxC;;AY3jFE;EAAsC,gBAAA;AZ+jFxC;;AY/jFE;EAAsC,gBAAA;AZmkFxC;;AYnkFE;EAAsC,gBAAA;AZukFxC;;AYvkFE;EAAsC,gBAAA;AZ2kFxC;;AY3kFE;EAAsC,gBAAA;AZ+kFxC;;AY/kFE;EAAsC,gBAAA;AZmlFxC;;AYnlFE;EAAsC,gBAAA;AZulFxC;;AYvlFE;EAAsC,gBAAA;AZ2lFxC;;AY3lFE;EAAsC,gBAAA;AZ+lFxC;;AY/lFE;EAAsC,gBAAA;AZmmFxC;;AYnmFE;EAAsC,gBAAA;AZumFxC;;AYvmFE;EAAsC,gBAAA;AZ2mFxC;;AY3mFE;EAAsC,gBAAA;AZ+mFxC;;AY/mFE;EAAsC,gBAAA;AZmnFxC;;AYnnFE;EAAsC,gBAAA;AZunFxC;;AYvnFE;EAAsC,gBAAA;AZ2nFxC;;AY3nFE;EAAsC,gBAAA;AZ+nFxC;;AY/nFE;EAAsC,gBAAA;AZmoFxC;;AYnoFE;EAAsC,gBAAA;AZuoFxC;;AYvoFE;EAAsC,gBAAA;AZ2oFxC;;AY3oFE;EAAsC,gBAAA;AZ+oFxC;;AY/oFE;EAAsC,gBAAA;AZmpFxC;;AYnpFE;EAAsC,gBAAA;AZupFxC;;AYvpFE;EAAsC,gBAAA;AZ2pFxC;;AY3pFE;EAAsC,gBAAA;AZ+pFxC;;AY/pFE;EAAsC,gBAAA;AZmqFxC;;AYnqFE;EAAsC,gBAAA;AZuqFxC;;AYvqFE;EAAsC,gBAAA;AZ2qFxC;;AY3qFE;EAAsC,gBAAA;AZ+qFxC;;AY/qFE;EAAsC,gBAAA;AZmrFxC;;AYnrFE;EAAsC,gBAAA;AZurFxC;;AYvrFE;EAAsC,gBAAA;AZ2rFxC;;AY3rFE;EAAsC,gBAAA;AZ+rFxC;;AY/rFE;EAAsC,gBAAA;AZmsFxC;;AYnsFE;EAAsC,gBAAA;AZusFxC;;AYvsFE;EAAsC,gBAAA;AZ2sFxC;;AY3sFE;EAAsC,gBAAA;AZ+sFxC;;AY/sFE;EAAsC,gBAAA;AZmtFxC;;AYntFE;EAAsC,gBAAA;AZutFxC;;AYvtFE;EAAsC,gBAAA;AZ2tFxC;;AY3tFE;EAAsC,gBAAA;AZ+tFxC;;AY/tFE;EAAsC,gBAAA;AZmuFxC;;AYnuFE;EAAsC,gBAAA;AZuuFxC;;AYvuFE;EAAsC,gBAAA;AZ2uFxC;;AY3uFE;EAAsC,gBAAA;AZ+uFxC;;AY/uFE;EAAsC,gBAAA;AZmvFxC;;AYnvFE;EAAsC,gBAAA;AZuvFxC;;AYvvFE;EAAsC,gBAAA;AZ2vFxC;;AY3vFE;EAAsC,gBAAA;AZ+vFxC;;AY/vFE;EAAsC,gBAAA;AZmwFxC;;AYnwFE;EAAsC,gBAAA;AZuwFxC;;AYvwFE;EAAsC,gBAAA;AZ2wFxC;;AY3wFE;EAAsC,gBAAA;AZ+wFxC;;AY/wFE;EAAsC,gBAAA;AZmxFxC;;AYnxFE;EAAsC,gBAAA;AZuxFxC;;AYvxFE;EAAsC,gBAAA;AZ2xFxC;;AY3xFE;EAAsC,gBAAA;AZ+xFxC;;AY/xFE;EAAsC,gBAAA;AZmyFxC;;AYnyFE;EAAsC,gBAAA;AZuyFxC;;AYvyFE;EAAsC,gBAAA;AZ2yFxC;;AY3yFE;EAAsC,gBAAA;AZ+yFxC;;AY/yFE;EAAsC,gBAAA;AZmzFxC;;AYnzFE;EAAsC,gBAAA;AZuzFxC;;AYvzFE;EAAsC,gBAAA;AZ2zFxC;;AY3zFE;EAAsC,gBAAA;AZ+zFxC;;AY/zFE;EAAsC,gBAAA;AZm0FxC;;AYn0FE;EAAsC,gBAAA;AZu0FxC;;AYv0FE;EAAsC,gBAAA;AZ20FxC;;AY30FE;EAAsC,gBAAA;AZ+0FxC;;AY/0FE;EAAsC,gBAAA;AZm1FxC;;AYn1FE;EAAsC,gBAAA;AZu1FxC;;AYv1FE;EAAsC,gBAAA;AZ21FxC;;AY31FE;EAAsC,gBAAA;AZ+1FxC;;AY/1FE;EAAsC,gBAAA;AZm2FxC;;AYn2FE;EAAsC,gBAAA;AZu2FxC;;AYv2FE;EAAsC,gBAAA;AZ22FxC;;AY32FE;EAAsC,gBAAA;AZ+2FxC;;AY/2FE;EAAsC,gBAAA;AZm3FxC;;AYn3FE;EAAsC,gBAAA;AZu3FxC;;AYv3FE;EAAsC,gBAAA;AZ23FxC;;AY33FE;EAAsC,gBAAA;AZ+3FxC;;AY/3FE;EAAsC,gBAAA;AZm4FxC;;AYn4FE;EAAsC,gBAAA;AZu4FxC;;AYv4FE;EAAsC,gBAAA;AZ24FxC;;AY34FE;EAAsC,gBAAA;AZ+4FxC;;AY/4FE;EAAsC,gBAAA;AZm5FxC;;AYn5FE;EAAsC,gBAAA;AZu5FxC;;AYv5FE;EAAsC,gBAAA;AZ25FxC;;AY35FE;EAAsC,gBAAA;AZ+5FxC;;AY/5FE;EAAsC,gBAAA;AZm6FxC;;AYn6FE;EAAsC,gBAAA;AZu6FxC;;AYv6FE;EAAsC,gBAAA;AZ26FxC;;AY36FE;EAAsC,gBAAA;AZ+6FxC;;AY/6FE;EAAsC,gBAAA;AZm7FxC;;AYn7FE;EAAsC,gBAAA;AZu7FxC;;AYv7FE;EAAsC,gBAAA;AZ27FxC;;AY37FE;EAAsC,gBAAA;AZ+7FxC;;AY/7FE;EAAsC,gBAAA;AZm8FxC;;AYn8FE;EAAsC,gBAAA;AZu8FxC;;AYv8FE;EAAsC,gBAAA;AZ28FxC;;AY38FE;EAAsC,gBAAA;AZ+8FxC;;AY/8FE;EAAsC,gBAAA;AZm9FxC;;AYn9FE;EAAsC,gBAAA;AZu9FxC;;AYv9FE;EAAsC,gBAAA;AZ29FxC;;AY39FE;EAAsC,gBAAA;AZ+9FxC;;AY/9FE;EAAsC,gBAAA;AZm+FxC;;AYn+FE;EAAsC,gBAAA;AZu+FxC;;AYv+FE;EAAsC,gBAAA;AZ2+FxC;;AY3+FE;EAAsC,gBAAA;AZ++FxC;;AY/+FE;EAAsC,gBAAA;AZm/FxC;;AYn/FE;EAAsC,gBAAA;AZu/FxC;;AYv/FE;EAAsC,gBAAA;AZ2/FxC;;AY3/FE;EAAsC,gBAAA;AZ+/FxC;;AY//FE;EAAsC,gBAAA;AZmgGxC;;AYngGE;EAAsC,gBAAA;AZugGxC;;AYvgGE;EAAsC,gBAAA;AZ2gGxC;;AY3gGE;EAAsC,gBAAA;AZ+gGxC;;AY/gGE;EAAsC,gBAAA;AZmhGxC;;AYnhGE;EAAsC,gBAAA;AZuhGxC;;AYvhGE;EAAsC,gBAAA;AZ2hGxC;;AY3hGE;EAAsC,gBAAA;AZ+hGxC;;AY/hGE;EAAsC,gBAAA;AZmiGxC;;AYniGE;EAAsC,gBAAA;AZuiGxC;;AYviGE;EAAsC,gBAAA;AZ2iGxC;;AY3iGE;EAAsC,gBAAA;AZ+iGxC;;AY/iGE;EAAsC,gBAAA;AZmjGxC;;AYnjGE;EAAsC,gBAAA;AZujGxC;;AYvjGE;EAAsC,gBAAA;AZ2jGxC;;AY3jGE;EAAsC,gBAAA;AZ+jGxC;;AY/jGE;EAAsC,gBAAA;AZmkGxC;;AYnkGE;EAAsC,gBAAA;AZukGxC;;AYvkGE;EAAsC,gBAAA;AZ2kGxC;;AY3kGE;EAAsC,gBAAA;AZ+kGxC;;AY/kGE;EAAsC,gBAAA;AZmlGxC;;AYnlGE;EAAsC,gBAAA;AZulGxC;;AYvlGE;EAAsC,gBAAA;AZ2lGxC;;AY3lGE;EAAsC,gBAAA;AZ+lGxC;;AY/lGE;EAAsC,gBAAA;AZmmGxC;;AYnmGE;EAAsC,gBAAA;AZumGxC;;AYvmGE;EAAsC,gBAAA;AZ2mGxC;;AY3mGE;EAAsC,gBAAA;AZ+mGxC;;AY/mGE;EAAsC,gBAAA;AZmnGxC;;AYnnGE;EAAsC,gBAAA;AZunGxC;;AYvnGE;EAAsC,gBAAA;AZ2nGxC;;AY3nGE;EAAsC,gBAAA;AZ+nGxC;;AY/nGE;EAAsC,gBAAA;AZmoGxC;;AYnoGE;EAAsC,gBAAA;AZuoGxC;;AYvoGE;EAAsC,gBAAA;AZ2oGxC;;AY3oGE;EAAsC,gBAAA;AZ+oGxC;;AY/oGE;EAAsC,gBAAA;AZmpGxC;;AYnpGE;EAAsC,gBAAA;AZupGxC;;AYvpGE;EAAsC,gBAAA;AZ2pGxC;;AY3pGE;EAAsC,gBAAA;AZ+pGxC;;AY/pGE;EAAsC,gBAAA;AZmqGxC;;AYnqGE;EAAsC,gBAAA;AZuqGxC;;AYvqGE;EAAsC,gBAAA;AZ2qGxC;;AY3qGE;EAAsC,gBAAA;AZ+qGxC;;AY/qGE;EAAsC,gBAAA;AZmrGxC;;AYnrGE;EAAsC,gBAAA;AZurGxC;;AYvrGE;EAAsC,gBAAA;AZ2rGxC;;AY3rGE;EAAsC,gBAAA;AZ+rGxC;;AY/rGE;EAAsC,gBAAA;AZmsGxC;;AYnsGE;EAAsC,gBAAA;AZusGxC;;AYvsGE;EAAsC,gBAAA;AZ2sGxC;;AY3sGE;EAAsC,gBAAA;AZ+sGxC;;AY/sGE;EAAsC,gBAAA;AZmtGxC;;AYntGE;EAAsC,gBAAA;AZutGxC;;AYvtGE;EAAsC,gBAAA;AZ2tGxC;;AY3tGE;EAAsC,gBAAA;AZ+tGxC;;AY/tGE;EAAsC,gBAAA;AZmuGxC;;AYnuGE;EAAsC,gBAAA;AZuuGxC;;AYvuGE;EAAsC,gBAAA;AZ2uGxC;;AY3uGE;EAAsC,gBAAA;AZ+uGxC;;AY/uGE;EAAsC,gBAAA;AZmvGxC;;AYnvGE;EAAsC,gBAAA;AZuvGxC;;AYvvGE;EAAsC,gBAAA;AZ2vGxC;;AY3vGE;EAAsC,gBAAA;AZ+vGxC;;AY/vGE;EAAsC,gBAAA;AZmwGxC;;AYnwGE;EAAsC,gBAAA;AZuwGxC;;AYvwGE;EAAsC,gBAAA;AZ2wGxC;;AY3wGE;EAAsC,gBAAA;AZ+wGxC;;AY/wGE;EAAsC,gBAAA;AZmxGxC;;AYnxGE;EAAsC,gBAAA;AZuxGxC;;AYvxGE;EAAsC,gBAAA;AZ2xGxC;;AY3xGE;EAAsC,gBAAA;AZ+xGxC;;AY/xGE;EAAsC,gBAAA;AZmyGxC;;AYnyGE;EAAsC,gBAAA;AZuyGxC;;AYvyGE;EAAsC,gBAAA;AZ2yGxC;;AY3yGE;EAAsC,gBAAA;AZ+yGxC;;AY/yGE;EAAsC,gBAAA;AZmzGxC;;AYnzGE;EAAsC,gBAAA;AZuzGxC;;AYvzGE;EAAsC,gBAAA;AZ2zGxC;;AY3zGE;EAAsC,gBAAA;AZ+zGxC;;AY/zGE;EAAsC,gBAAA;AZm0GxC;;AYn0GE;EAAsC,gBAAA;AZu0GxC;;AYv0GE;EAAsC,gBAAA;AZ20GxC;;AY30GE;EAAsC,gBAAA;AZ+0GxC;;AY/0GE;EAAsC,gBAAA;AZm1GxC;;AYn1GE;EAAsC,gBAAA;AZu1GxC;;AYv1GE;EAAsC,gBAAA;AZ21GxC;;AY31GE;EAAsC,gBAAA;AZ+1GxC;;AY/1GE;EAAsC,gBAAA;AZm2GxC;;AYn2GE;EAAsC,gBAAA;AZu2GxC;;AYv2GE;EAAsC,gBAAA;AZ22GxC;;AY32GE;EAAsC,gBAAA;AZ+2GxC;;AY/2GE;EAAsC,gBAAA;AZm3GxC;;AYn3GE;EAAsC,gBAAA;AZu3GxC;;AYv3GE;EAAsC,gBAAA;AZ23GxC;;AY33GE;EAAsC,gBAAA;AZ+3GxC;;AY/3GE;EAAsC,gBAAA;AZm4GxC;;AYn4GE;EAAsC,gBAAA;AZu4GxC;;AYv4GE;EAAsC,gBAAA;AZ24GxC;;AY34GE;EAAsC,gBAAA;AZ+4GxC;;AY/4GE;EAAsC,YAAA;AZm5GxC;;AYn5GE;EAAsC,gBAAA;AZu5GxC;;AYv5GE;EAAsC,gBAAA;AZ25GxC;;AY35GE;EAAsC,gBAAA;AZ+5GxC;;AY/5GE;EAAsC,YAAA;AZm6GxC;;AYn6GE;EAAsC,gBAAA;AZu6GxC;;AYv6GE;EAAsC,gBAAA;AZ26GxC;;AY36GE;EAAsC,gBAAA;AZ+6GxC;;AY/6GE;EAAsC,gBAAA;AZm7GxC;;AYn7GE;EAAsC,YAAA;AZu7GxC;;AYv7GE;EAAsC,gBAAA;AZ27GxC;;AY37GE;EAAsC,gBAAA;AZ+7GxC;;AY/7GE;EAAsC,gBAAA;AZm8GxC;;AYn8GE;EAAsC,gBAAA;AZu8GxC;;AYv8GE;EAAsC,gBAAA;AZ28GxC;;AY38GE;EAAsC,gBAAA;AZ+8GxC;;AY/8GE;EAAsC,gBAAA;AZm9GxC;;AYn9GE;EAAsC,gBAAA;AZu9GxC;;AYv9GE;EAAsC,gBAAA;AZ29GxC;;AY39GE;EAAsC,gBAAA;AZ+9GxC;;AY/9GE;EAAsC,gBAAA;AZm+GxC;;AYn+GE;EAAsC,gBAAA;AZu+GxC;;AYv+GE;EAAsC,gBAAA;AZ2+GxC;;AY3+GE;EAAsC,gBAAA;AZ++GxC;;AY/+GE;EAAsC,gBAAA;AZm/GxC;;AYn/GE;EAAsC,gBAAA;AZu/GxC;;AYv/GE;EAAsC,gBAAA;AZ2/GxC;;AY3/GE;EAAsC,gBAAA;AZ+/GxC;;AY//GE;EAAsC,gBAAA;AZmgHxC;;AYngHE;EAAsC,gBAAA;AZugHxC;;AYvgHE;EAAsC,gBAAA;AZ2gHxC;;AY3gHE;EAAsC,gBAAA;AZ+gHxC;;AY/gHE;EAAsC,aAAA;AZmhHxC;;AYnhHE;EAAsC,gBAAA;AZuhHxC;;AYvhHE;EAAsC,gBAAA;AZ2hHxC;;AY3hHE;EAAsC,gBAAA;AZ+hHxC;;AY/hHE;EAAsC,gBAAA;AZmiHxC;;AYniHE;EAAsC,gBAAA;AZuiHxC;;AYviHE;EAAsC,gBAAA;AZ2iHxC;;AY3iHE;EAAsC,gBAAA;AZ+iHxC;;AY/iHE;EAAsC,gBAAA;AZmjHxC;;AYnjHE;EAAsC,gBAAA;AZujHxC;;AYvjHE;EAAsC,gBAAA;AZ2jHxC;;AY3jHE;EAAsC,gBAAA;AZ+jHxC;;AY/jHE;EAAsC,gBAAA;AZmkHxC;;AYnkHE;EAAsC,gBAAA;AZukHxC;;AYvkHE;EAAsC,gBAAA;AZ2kHxC;;AY3kHE;EAAsC,gBAAA;AZ+kHxC;;AY/kHE;EAAsC,gBAAA;AZmlHxC;;AYnlHE;EAAsC,gBAAA;AZulHxC;;AYvlHE;EAAsC,gBAAA;AZ2lHxC;;AY3lHE;EAAsC,gBAAA;AZ+lHxC;;AY/lHE;EAAsC,gBAAA;AZmmHxC;;AYnmHE;EAAsC,gBAAA;AZumHxC;;AYvmHE;EAAsC,gBAAA;AZ2mHxC;;AY3mHE;EAAsC,YAAA;AZ+mHxC;;AY/mHE;EAAsC,gBAAA;AZmnHxC;;AYnnHE;EAAsC,gBAAA;AZunHxC;;AYvnHE;EAAsC,gBAAA;AZ2nHxC;;AY3nHE;EAAsC,gBAAA;AZ+nHxC;;AY/nHE;EAAsC,gBAAA;AZmoHxC;;AYnoHE;EAAsC,gBAAA;AZuoHxC;;AYvoHE;EAAsC,gBAAA;AZ2oHxC;;AY3oHE;EAAsC,gBAAA;AZ+oHxC;;AY/oHE;EAAsC,gBAAA;AZmpHxC;;AYnpHE;EAAsC,gBAAA;AZupHxC;;AYvpHE;EAAsC,gBAAA;AZ2pHxC;;AY3pHE;EAAsC,gBAAA;AZ+pHxC;;AY/pHE;EAAsC,gBAAA;AZmqHxC;;AYnqHE;EAAsC,gBAAA;AZuqHxC;;AYvqHE;EAAsC,gBAAA;AZ2qHxC;;AY3qHE;EAAsC,gBAAA;AZ+qHxC;;AY/qHE;EAAsC,gBAAA;AZmrHxC;;AYnrHE;EAAsC,gBAAA;AZurHxC;;AYvrHE;EAAsC,gBAAA;AZ2rHxC;;AY3rHE;EAAsC,gBAAA;AZ+rHxC;;AY/rHE;EAAsC,gBAAA;AZmsHxC;;AYnsHE;EAAsC,gBAAA;AZusHxC;;AYvsHE;EAAsC,gBAAA;AZ2sHxC;;AY3sHE;EAAsC,gBAAA;AZ+sHxC;;AY/sHE;EAAsC,gBAAA;AZmtHxC;;AYntHE;EAAsC,gBAAA;AZutHxC;;AYvtHE;EAAsC,gBAAA;AZ2tHxC;;AY3tHE;EAAsC,gBAAA;AZ+tHxC;;AY/tHE;EAAsC,gBAAA;AZmuHxC;;AYnuHE;EAAsC,gBAAA;AZuuHxC;;AYvuHE;EAAsC,gBAAA;AZ2uHxC;;AY3uHE;EAAsC,gBAAA;AZ+uHxC;;AY/uHE;EAAsC,gBAAA;AZmvHxC;;AYnvHE;EAAsC,gBAAA;AZuvHxC;;AYvvHE;EAAsC,gBAAA;AZ2vHxC;;AY3vHE;EAAsC,gBAAA;AZ+vHxC;;AY/vHE;EAAsC,gBAAA;AZmwHxC;;AYnwHE;EAAsC,gBAAA;AZuwHxC;;AYvwHE;EAAsC,gBAAA;AZ2wHxC;;AY3wHE;EAAsC,YAAA;AZ+wHxC;;AY/wHE;EAAsC,gBAAA;AZmxHxC;;AYnxHE;EAAsC,gBAAA;AZuxHxC;;AYvxHE;EAAsC,gBAAA;AZ2xHxC;;AY3xHE;EAAsC,gBAAA;AZ+xHxC;;AY/xHE;EAAsC,gBAAA;AZmyHxC;;AYnyHE;EAAsC,gBAAA;AZuyHxC;;AYvyHE;EAAsC,gBAAA;AZ2yHxC;;AY3yHE;EAAsC,gBAAA;AZ+yHxC;;AY/yHE;EAAsC,gBAAA;AZmzHxC;;AYnzHE;EAAsC,gBAAA;AZuzHxC;;AYvzHE;EAAsC,gBAAA;AZ2zHxC;;AY3zHE;EAAsC,gBAAA;AZ+zHxC;;AY/zHE;EAAsC,gBAAA;AZm0HxC;;AYn0HE;EAAsC,gBAAA;AZu0HxC;;AYv0HE;EAAsC,gBAAA;AZ20HxC;;AY30HE;EAAsC,gBAAA;AZ+0HxC;;AY/0HE;EAAsC,gBAAA;AZm1HxC;;AYn1HE;EAAsC,gBAAA;AZu1HxC;;AYv1HE;EAAsC,gBAAA;AZ21HxC;;AY31HE;EAAsC,gBAAA;AZ+1HxC;;AY/1HE;EAAsC,gBAAA;AZm2HxC;;AYn2HE;EAAsC,gBAAA;AZu2HxC;;AYv2HE;EAAsC,YAAA;AZ22HxC;;AY32HE;EAAsC,gBAAA;AZ+2HxC;;AY/2HE;EAAsC,gBAAA;AZm3HxC;;AYn3HE;EAAsC,gBAAA;AZu3HxC;;AYv3HE;EAAsC,gBAAA;AZ23HxC;;AY33HE;EAAsC,gBAAA;AZ+3HxC;;AY/3HE;EAAsC,gBAAA;AZm4HxC;;AYn4HE;EAAsC,gBAAA;AZu4HxC;;AYv4HE;EAAsC,gBAAA;AZ24HxC;;AY34HE;EAAsC,gBAAA;AZ+4HxC;;AY/4HE;EAAsC,gBAAA;AZm5HxC;;AYn5HE;EAAsC,gBAAA;AZu5HxC;;AYv5HE;EAAsC,gBAAA;AZ25HxC;;AY35HE;EAAsC,gBAAA;AZ+5HxC;;AY/5HE;EAAsC,gBAAA;AZm6HxC;;AYn6HE;EAAsC,gBAAA;AZu6HxC;;AYv6HE;EAAsC,gBAAA;AZ26HxC;;AY36HE;EAAsC,gBAAA;AZ+6HxC;;AY/6HE;EAAsC,gBAAA;AZm7HxC;;AYn7HE;EAAsC,gBAAA;AZu7HxC;;AYv7HE;EAAsC,gBAAA;AZ27HxC;;AY37HE;EAAsC,gBAAA;AZ+7HxC;;AY/7HE;EAAsC,gBAAA;AZm8HxC;;AYn8HE;EAAsC,gBAAA;AZu8HxC;;AYv8HE;EAAsC,gBAAA;AZ28HxC;;AY38HE;EAAsC,gBAAA;AZ+8HxC;;AY/8HE;EAAsC,gBAAA;AZm9HxC;;AYn9HE;EAAsC,gBAAA;AZu9HxC;;AYv9HE;EAAsC,gBAAA;AZ29HxC;;AY39HE;EAAsC,gBAAA;AZ+9HxC;;AY/9HE;EAAsC,gBAAA;AZm+HxC;;AYn+HE;EAAsC,gBAAA;AZu+HxC;;AYv+HE;EAAsC,gBAAA;AZ2+HxC;;AY3+HE;EAAsC,gBAAA;AZ++HxC;;AY/+HE;EAAsC,gBAAA;AZm/HxC;;AYn/HE;EAAsC,gBAAA;AZu/HxC;;AYv/HE;EAAsC,gBAAA;AZ2/HxC;;AY3/HE;EAAsC,gBAAA;AZ+/HxC;;AY//HE;EAAsC,gBAAA;AZmgIxC;;AYngIE;EAAsC,gBAAA;AZugIxC;;AYvgIE;EAAsC,gBAAA;AZ2gIxC;;AY3gIE;EAAsC,gBAAA;AZ+gIxC;;AY/gIE;EAAsC,gBAAA;AZmhIxC;;AYnhIE;EAAsC,gBAAA;AZuhIxC;;AYvhIE;EAAsC,gBAAA;AZ2hIxC;;AY3hIE;EAAsC,gBAAA;AZ+hIxC;;AY/hIE;EAAsC,gBAAA;AZmiIxC;;AYniIE;EAAsC,gBAAA;AZuiIxC;;AYviIE;EAAsC,gBAAA;AZ2iIxC;;AY3iIE;EAAsC,gBAAA;AZ+iIxC;;AY/iIE;EAAsC,gBAAA;AZmjIxC;;AYnjIE;EAAsC,gBAAA;AZujIxC;;AYvjIE;EAAsC,gBAAA;AZ2jIxC;;AY3jIE;EAAsC,gBAAA;AZ+jIxC;;AY/jIE;EAAsC,gBAAA;AZmkIxC;;AYnkIE;EAAsC,gBAAA;AZukIxC;;AYvkIE;EAAsC,gBAAA;AZ2kIxC;;AY3kIE;EAAsC,gBAAA;AZ+kIxC;;AY/kIE;EAAsC,gBAAA;AZmlIxC;;AYnlIE;EAAsC,gBAAA;AZulIxC;;AYvlIE;EAAsC,gBAAA;AZ2lIxC;;AY3lIE;EAAsC,gBAAA;AZ+lIxC;;AY/lIE;EAAsC,gBAAA;AZmmIxC;;AYnmIE;EAAsC,gBAAA;AZumIxC;;AYvmIE;EAAsC,gBAAA;AZ2mIxC;;AY3mIE;EAAsC,gBAAA;AZ+mIxC;;AY/mIE;EAAsC,gBAAA;AZmnIxC;;AYnnIE;EAAsC,gBAAA;AZunIxC;;AYvnIE;EAAsC,gBAAA;AZ2nIxC;;AY3nIE;EAAsC,gBAAA;AZ+nIxC;;AY/nIE;EAAsC,gBAAA;AZmoIxC;;AYnoIE;EAAsC,gBAAA;AZuoIxC;;AYvoIE;EAAsC,gBAAA;AZ2oIxC;;AY3oIE;EAAsC,gBAAA;AZ+oIxC;;AY/oIE;EAAsC,gBAAA;AZmpIxC;;AYnpIE;EAAsC,gBAAA;AZupIxC;;AYvpIE;EAAsC,gBAAA;AZ2pIxC;;AY3pIE;EAAsC,gBAAA;AZ+pIxC;;AY/pIE;EAAsC,gBAAA;AZmqIxC;;AYnqIE;EAAsC,gBAAA;AZuqIxC;;AYvqIE;EAAsC,gBAAA;AZ2qIxC;;AY3qIE;EAAsC,gBAAA;AZ+qIxC;;AY/qIE;EAAsC,gBAAA;AZmrIxC;;AYnrIE;EAAsC,gBAAA;AZurIxC;;AYvrIE;EAAsC,gBAAA;AZ2rIxC;;AY3rIE;EAAsC,gBAAA;AZ+rIxC;;AY/rIE;EAAsC,gBAAA;AZmsIxC;;AYnsIE;EAAsC,gBAAA;AZusIxC;;AYvsIE;EAAsC,gBAAA;AZ2sIxC;;AY3sIE;EAAsC,gBAAA;AZ+sIxC;;AY/sIE;EAAsC,gBAAA;AZmtIxC;;AYntIE;EAAsC,gBAAA;AZutIxC;;AYvtIE;EAAsC,gBAAA;AZ2tIxC;;AY3tIE;EAAsC,gBAAA;AZ+tIxC;;AY/tIE;EAAsC,gBAAA;AZmuIxC;;AYnuIE;EAAsC,gBAAA;AZuuIxC;;AYvuIE;EAAsC,gBAAA;AZ2uIxC;;AY3uIE;EAAsC,gBAAA;AZ+uIxC;;AY/uIE;EAAsC,gBAAA;AZmvIxC;;AYnvIE;EAAsC,gBAAA;AZuvIxC;;AYvvIE;EAAsC,gBAAA;AZ2vIxC;;AY3vIE;EAAsC,gBAAA;AZ+vIxC;;AY/vIE;EAAsC,gBAAA;AZmwIxC;;AYnwIE;EAAsC,gBAAA;AZuwIxC;;AYvwIE;EAAsC,gBAAA;AZ2wIxC;;AY3wIE;EAAsC,gBAAA;AZ+wIxC;;AY/wIE;EAAsC,gBAAA;AZmxIxC;;AYnxIE;EAAsC,gBAAA;AZuxIxC;;AYvxIE;EAAsC,gBAAA;AZ2xIxC;;AY3xIE;EAAsC,gBAAA;AZ+xIxC;;AY/xIE;EAAsC,gBAAA;AZmyIxC;;AYnyIE;EAAsC,gBAAA;AZuyIxC;;AYvyIE;EAAsC,gBAAA;AZ2yIxC;;AY3yIE;EAAsC,gBAAA;AZ+yIxC;;AY/yIE;EAAsC,gBAAA;AZmzIxC;;AYnzIE;EAAsC,gBAAA;AZuzIxC;;AYvzIE;EAAsC,gBAAA;AZ2zIxC;;AY3zIE;EAAsC,gBAAA;AZ+zIxC;;AY/zIE;EAAsC,gBAAA;AZm0IxC;;AYn0IE;EAAsC,gBAAA;AZu0IxC;;AYv0IE;EAAsC,gBAAA;AZ20IxC;;AY30IE;EAAsC,gBAAA;AZ+0IxC;;AY/0IE;EAAsC,gBAAA;AZm1IxC;;AYn1IE;EAAsC,gBAAA;AZu1IxC;;AYv1IE;EAAsC,gBAAA;AZ21IxC;;AY31IE;EAAsC,gBAAA;AZ+1IxC;;AY/1IE;EAAsC,gBAAA;AZm2IxC;;AYn2IE;EAAsC,gBAAA;AZu2IxC;;AYv2IE;EAAsC,gBAAA;AZ22IxC;;AY32IE;EAAsC,gBAAA;AZ+2IxC;;AY/2IE;EAAsC,gBAAA;AZm3IxC;;AYn3IE;EAAsC,gBAAA;AZu3IxC;;AYv3IE;EAAsC,gBAAA;AZ23IxC;;AY33IE;EAAsC,gBAAA;AZ+3IxC;;AY/3IE;EAAsC,gBAAA;AZm4IxC;;AYn4IE;EAAsC,gBAAA;AZu4IxC;;AYv4IE;EAAsC,gBAAA;AZ24IxC;;AY34IE;EAAsC,gBAAA;AZ+4IxC;;AY/4IE;EAAsC,gBAAA;AZm5IxC;;AYn5IE;EAAsC,gBAAA;AZu5IxC;;AYv5IE;EAAsC,gBAAA;AZ25IxC;;AY35IE;EAAsC,gBAAA;AZ+5IxC;;AY/5IE;EAAsC,gBAAA;AZm6IxC;;AYn6IE;EAAsC,gBAAA;AZu6IxC;;AYv6IE;EAAsC,gBAAA;AZ26IxC;;AY36IE;EAAsC,gBAAA;AZ+6IxC;;AY/6IE;EAAsC,gBAAA;AZm7IxC;;AYn7IE;EAAsC,gBAAA;AZu7IxC;;AYv7IE;EAAsC,gBAAA;AZ27IxC;;AY37IE;EAAsC,gBAAA;AZ+7IxC;;AY/7IE;EAAsC,gBAAA;AZm8IxC;;AYn8IE;EAAsC,gBAAA;AZu8IxC;;AYv8IE;EAAsC,gBAAA;AZ28IxC;;AY38IE;EAAsC,gBAAA;AZ+8IxC;;AY/8IE;EAAsC,gBAAA;AZm9IxC;;AYn9IE;EAAsC,gBAAA;AZu9IxC;;AYv9IE;EAAsC,gBAAA;AZ29IxC;;AY39IE;EAAsC,gBAAA;AZ+9IxC;;AY/9IE;EAAsC,gBAAA;AZm+IxC;;AYn+IE;EAAsC,gBAAA;AZu+IxC;;AYv+IE;EAAsC,gBAAA;AZ2+IxC;;AY3+IE;EAAsC,gBAAA;AZ++IxC;;AY/+IE;EAAsC,gBAAA;AZm/IxC;;AYn/IE;EAAsC,gBAAA;AZu/IxC;;AYv/IE;EAAsC,gBAAA;AZ2/IxC;;AY3/IE;EAAsC,gBAAA;AZ+/IxC;;AY//IE;EAAsC,gBAAA;AZmgJxC;;AYngJE;EAAsC,gBAAA;AZugJxC;;AYvgJE;EAAsC,gBAAA;AZ2gJxC;;AY3gJE;EAAsC,gBAAA;AZ+gJxC;;AY/gJE;EAAsC,gBAAA;AZmhJxC;;AYnhJE;EAAsC,gBAAA;AZuhJxC;;AYvhJE;EAAsC,gBAAA;AZ2hJxC;;AY3hJE;EAAsC,gBAAA;AZ+hJxC;;AY/hJE;EAAsC,gBAAA;AZmiJxC;;AYniJE;EAAsC,gBAAA;AZuiJxC;;AYviJE;EAAsC,gBAAA;AZ2iJxC;;AY3iJE;EAAsC,gBAAA;AZ+iJxC;;AY/iJE;EAAsC,gBAAA;AZmjJxC;;AYnjJE;EAAsC,gBAAA;AZujJxC;;AYvjJE;EAAsC,gBAAA;AZ2jJxC;;AY3jJE;EAAsC,gBAAA;AZ+jJxC;;AY/jJE;EAAsC,gBAAA;AZmkJxC;;AYnkJE;EAAsC,gBAAA;AZukJxC;;AYvkJE;EAAsC,gBAAA;AZ2kJxC;;AY3kJE;EAAsC,gBAAA;AZ+kJxC;;AY/kJE;EAAsC,gBAAA;AZmlJxC;;AYnlJE;EAAsC,gBAAA;AZulJxC;;AYvlJE;EAAsC,gBAAA;AZ2lJxC;;AY3lJE;EAAsC,YAAA;AZ+lJxC;;AY/lJE;EAAsC,gBAAA;AZmmJxC;;AYnmJE;EAAsC,gBAAA;AZumJxC;;AYvmJE;EAAsC,gBAAA;AZ2mJxC;;AY3mJE;EAAsC,gBAAA;AZ+mJxC;;AY/mJE;EAAsC,gBAAA;AZmnJxC;;AYnnJE;EAAsC,gBAAA;AZunJxC;;AYvnJE;EAAsC,gBAAA;AZ2nJxC;;AY3nJE;EAAsC,gBAAA;AZ+nJxC;;AY/nJE;EAAsC,gBAAA;AZmoJxC;;AYnoJE;EAAsC,YAAA;AZuoJxC;;AYvoJE;EAAsC,gBAAA;AZ2oJxC;;AY3oJE;EAAsC,gBAAA;AZ+oJxC;;AY/oJE;EAAsC,gBAAA;AZmpJxC;;AYnpJE;EAAsC,gBAAA;AZupJxC;;AYvpJE;EAAsC,gBAAA;AZ2pJxC;;AY3pJE;EAAsC,gBAAA;AZ+pJxC;;AY/pJE;EAAsC,gBAAA;AZmqJxC;;AYnqJE;EAAsC,gBAAA;AZuqJxC;;AYvqJE;EAAsC,gBAAA;AZ2qJxC;;AY3qJE;EAAsC,gBAAA;AZ+qJxC;;AY/qJE;EAAsC,gBAAA;AZmrJxC;;AYnrJE;EAAsC,gBAAA;AZurJxC;;AYvrJE;EAAsC,gBAAA;AZ2rJxC;;AY3rJE;EAAsC,gBAAA;AZ+rJxC;;AY/rJE;EAAsC,gBAAA;AZmsJxC;;AYnsJE;EAAsC,gBAAA;AZusJxC;;AYvsJE;EAAsC,gBAAA;AZ2sJxC;;AY3sJE;EAAsC,gBAAA;AZ+sJxC;;AY/sJE;EAAsC,gBAAA;AZmtJxC;;AYntJE;EAAsC,gBAAA;AZutJxC;;AYvtJE;EAAsC,gBAAA;AZ2tJxC;;AY3tJE;EAAsC,gBAAA;AZ+tJxC;;AY/tJE;EAAsC,gBAAA;AZmuJxC;;AYnuJE;EAAsC,gBAAA;AZuuJxC;;AYvuJE;EAAsC,gBAAA;AZ2uJxC;;AY3uJE;EAAsC,gBAAA;AZ+uJxC;;AY/uJE;EAAsC,gBAAA;AZmvJxC;;AYnvJE;EAAsC,gBAAA;AZuvJxC;;AYvvJE;EAAsC,gBAAA;AZ2vJxC;;AY3vJE;EAAsC,gBAAA;AZ+vJxC;;AY/vJE;EAAsC,gBAAA;AZmwJxC;;AYnwJE;EAAsC,gBAAA;AZuwJxC;;AYvwJE;EAAsC,gBAAA;AZ2wJxC;;AY3wJE;EAAsC,gBAAA;AZ+wJxC;;AY/wJE;EAAsC,gBAAA;AZmxJxC;;AYnxJE;EAAsC,gBAAA;AZuxJxC;;AYvxJE;EAAsC,gBAAA;AZ2xJxC;;AY3xJE;EAAsC,gBAAA;AZ+xJxC;;AY/xJE;EAAsC,gBAAA;AZmyJxC;;AYnyJE;EAAsC,gBAAA;AZuyJxC;;AYvyJE;EAAsC,gBAAA;AZ2yJxC;;AY3yJE;EAAsC,gBAAA;AZ+yJxC;;AY/yJE;EAAsC,gBAAA;AZmzJxC;;AYnzJE;EAAsC,gBAAA;AZuzJxC;;AYvzJE;EAAsC,gBAAA;AZ2zJxC;;AY3zJE;EAAsC,gBAAA;AZ+zJxC;;AY/zJE;EAAsC,gBAAA;AZm0JxC;;AYn0JE;EAAsC,gBAAA;AZu0JxC;;AYv0JE;EAAsC,gBAAA;AZ20JxC;;AY30JE;EAAsC,gBAAA;AZ+0JxC;;AY/0JE;EAAsC,gBAAA;AZm1JxC;;AYn1JE;EAAsC,gBAAA;AZu1JxC;;AYv1JE;EAAsC,gBAAA;AZ21JxC;;AY31JE;EAAsC,gBAAA;AZ+1JxC;;AY/1JE;EAAsC,gBAAA;AZm2JxC;;AYn2JE;EAAsC,gBAAA;AZu2JxC;;AYv2JE;EAAsC,gBAAA;AZ22JxC;;AY32JE;EAAsC,gBAAA;AZ+2JxC;;AY/2JE;EAAsC,gBAAA;AZm3JxC;;AYn3JE;EAAsC,gBAAA;AZu3JxC;;AYv3JE;EAAsC,gBAAA;AZ23JxC;;AY33JE;EAAsC,gBAAA;AZ+3JxC;;AY/3JE;EAAsC,gBAAA;AZm4JxC;;AYn4JE;EAAsC,gBAAA;AZu4JxC;;AYv4JE;EAAsC,gBAAA;AZ24JxC;;AY34JE;EAAsC,gBAAA;AZ+4JxC;;AY/4JE;EAAsC,gBAAA;AZm5JxC;;AYn5JE;EAAsC,gBAAA;AZu5JxC;;AYv5JE;EAAsC,gBAAA;AZ25JxC;;AY35JE;EAAsC,gBAAA;AZ+5JxC;;AY/5JE;EAAsC,gBAAA;AZm6JxC;;AYn6JE;EAAsC,gBAAA;AZu6JxC;;AYv6JE;EAAsC,gBAAA;AZ26JxC;;AY36JE;EAAsC,gBAAA;AZ+6JxC;;AY/6JE;EAAsC,gBAAA;AZm7JxC;;AYn7JE;EAAsC,gBAAA;AZu7JxC;;AYv7JE;EAAsC,gBAAA;AZ27JxC;;AY37JE;EAAsC,gBAAA;AZ+7JxC;;AY/7JE;EAAsC,gBAAA;AZm8JxC;;AYn8JE;EAAsC,gBAAA;AZu8JxC;;AYv8JE;EAAsC,gBAAA;AZ28JxC;;AY38JE;EAAsC,gBAAA;AZ+8JxC;;AY/8JE;EAAsC,gBAAA;AZm9JxC;;AYn9JE;EAAsC,gBAAA;AZu9JxC;;AYv9JE;EAAsC,gBAAA;AZ29JxC;;AY39JE;EAAsC,gBAAA;AZ+9JxC;;AY/9JE;EAAsC,gBAAA;AZm+JxC;;AYn+JE;EAAsC,gBAAA;AZu+JxC;;AYv+JE;EAAsC,gBAAA;AZ2+JxC;;AY3+JE;EAAsC,gBAAA;AZ++JxC;;AY/+JE;EAAsC,gBAAA;AZm/JxC;;AYn/JE;EAAsC,gBAAA;AZu/JxC;;AYv/JE;EAAsC,gBAAA;AZ2/JxC;;AY3/JE;EAAsC,gBAAA;AZ+/JxC;;AY//JE;EAAsC,gBAAA;AZmgKxC;;AYngKE;EAAsC,gBAAA;AZugKxC;;AYvgKE;EAAsC,gBAAA;AZ2gKxC;;AY3gKE;EAAsC,gBAAA;AZ+gKxC;;AY/gKE;EAAsC,gBAAA;AZmhKxC;;AYnhKE;EAAsC,gBAAA;AZuhKxC;;AYvhKE;EAAsC,gBAAA;AZ2hKxC;;AY3hKE;EAAsC,gBAAA;AZ+hKxC;;AY/hKE;EAAsC,gBAAA;AZmiKxC;;AYniKE;EAAsC,gBAAA;AZuiKxC;;AYviKE;EAAsC,gBAAA;AZ2iKxC;;AY3iKE;EAAsC,gBAAA;AZ+iKxC;;AY/iKE;EAAsC,gBAAA;AZmjKxC;;AYnjKE;EAAsC,gBAAA;AZujKxC;;AYvjKE;EAAsC,gBAAA;AZ2jKxC;;AY3jKE;EAAsC,gBAAA;AZ+jKxC;;AY/jKE;EAAsC,gBAAA;AZmkKxC;;AYnkKE;EAAsC,gBAAA;AZukKxC;;AYvkKE;EAAsC,gBAAA;AZ2kKxC;;AY3kKE;EAAsC,gBAAA;AZ+kKxC;;AY/kKE;EAAsC,gBAAA;AZmlKxC;;AYnlKE;EAAsC,gBAAA;AZulKxC;;AYvlKE;EAAsC,gBAAA;AZ2lKxC;;AY3lKE;EAAsC,gBAAA;AZ+lKxC;;AY/lKE;EAAsC,gBAAA;AZmmKxC;;AYnmKE;EAAsC,gBAAA;AZumKxC;;AYvmKE;EAAsC,gBAAA;AZ2mKxC;;AY3mKE;EAAsC,gBAAA;AZ+mKxC;;AY/mKE;EAAsC,gBAAA;AZmnKxC;;AYnnKE;EAAsC,gBAAA;AZunKxC;;AYvnKE;EAAsC,gBAAA;AZ2nKxC;;AY3nKE;EAAsC,gBAAA;AZ+nKxC;;AY/nKE;EAAsC,gBAAA;AZmoKxC;;AYnoKE;EAAsC,gBAAA;AZuoKxC;;AYvoKE;EAAsC,gBAAA;AZ2oKxC;;AY3oKE;EAAsC,gBAAA;AZ+oKxC;;AY/oKE;EAAsC,gBAAA;AZmpKxC;;AYnpKE;EAAsC,gBAAA;AZupKxC;;AYvpKE;EAAsC,gBAAA;AZ2pKxC;;AY3pKE;EAAsC,gBAAA;AZ+pKxC;;AY/pKE;EAAsC,gBAAA;AZmqKxC;;AYnqKE;EAAsC,gBAAA;AZuqKxC;;AYvqKE;EAAsC,gBAAA;AZ2qKxC;;AY3qKE;EAAsC,gBAAA;AZ+qKxC;;AY/qKE;EAAsC,gBAAA;AZmrKxC;;AYnrKE;EAAsC,gBAAA;AZurKxC;;AYvrKE;EAAsC,YAAA;AZ2rKxC;;AY3rKE;EAAsC,gBAAA;AZ+rKxC;;AY/rKE;EAAsC,gBAAA;AZmsKxC;;AYnsKE;EAAsC,gBAAA;AZusKxC;;AYvsKE;EAAsC,gBAAA;AZ2sKxC;;AY3sKE;EAAsC,gBAAA;AZ+sKxC;;AY/sKE;EAAsC,gBAAA;AZmtKxC;;AYntKE;EAAsC,gBAAA;AZutKxC;;AYvtKE;EAAsC,gBAAA;AZ2tKxC;;AY3tKE;EAAsC,gBAAA;AZ+tKxC;;AY/tKE;EAAsC,YAAA;AZmuKxC;;AYnuKE;EAAsC,gBAAA;AZuuKxC;;AYvuKE;EAAsC,gBAAA;AZ2uKxC;;AY3uKE;EAAsC,gBAAA;AZ+uKxC;;AY/uKE;EAAsC,gBAAA;AZmvKxC;;AYnvKE;EAAsC,gBAAA;AZuvKxC;;AYvvKE;EAAsC,gBAAA;AZ2vKxC;;AY3vKE;EAAsC,gBAAA;AZ+vKxC;;AY/vKE;EAAsC,gBAAA;AZmwKxC;;AYnwKE;EAAsC,gBAAA;AZuwKxC;;AYvwKE;EAAsC,gBAAA;AZ2wKxC;;AY3wKE;EAAsC,gBAAA;AZ+wKxC;;AY/wKE;EAAsC,gBAAA;AZmxKxC;;AYnxKE;EAAsC,gBAAA;AZuxKxC;;AYvxKE;EAAsC,gBAAA;AZ2xKxC;;AY3xKE;EAAsC,gBAAA;AZ+xKxC;;AY/xKE;EAAsC,gBAAA;AZmyKxC;;AYnyKE;EAAsC,gBAAA;AZuyKxC;;AYvyKE;EAAsC,gBAAA;AZ2yKxC;;AY3yKE;EAAsC,gBAAA;AZ+yKxC;;AY/yKE;EAAsC,gBAAA;AZmzKxC;;AYnzKE;EAAsC,gBAAA;AZuzKxC;;AYvzKE;EAAsC,gBAAA;AZ2zKxC;;AY3zKE;EAAsC,gBAAA;AZ+zKxC;;AY/zKE;EAAsC,gBAAA;AZm0KxC;;AYn0KE;EAAsC,gBAAA;AZu0KxC;;AYv0KE;EAAsC,gBAAA;AZ20KxC;;AY30KE;EAAsC,gBAAA;AZ+0KxC;;AY/0KE;EAAsC,gBAAA;AZm1KxC;;AYn1KE;EAAsC,gBAAA;AZu1KxC;;AYv1KE;EAAsC,gBAAA;AZ21KxC;;AY31KE;EAAsC,gBAAA;AZ+1KxC;;AY/1KE;EAAsC,gBAAA;AZm2KxC;;AYn2KE;EAAsC,gBAAA;AZu2KxC;;AYv2KE;EAAsC,gBAAA;AZ22KxC;;AY32KE;EAAsC,gBAAA;AZ+2KxC;;AY/2KE;EAAsC,gBAAA;AZm3KxC;;AYn3KE;EAAsC,gBAAA;AZu3KxC;;AYv3KE;EAAsC,gBAAA;AZ23KxC;;AY33KE;EAAsC,gBAAA;AZ+3KxC;;AY/3KE;EAAsC,gBAAA;AZm4KxC;;AYn4KE;EAAsC,gBAAA;AZu4KxC;;AYv4KE;EAAsC,gBAAA;AZ24KxC;;AY34KE;EAAsC,gBAAA;AZ+4KxC;;AY/4KE;EAAsC,gBAAA;AZm5KxC;;AYn5KE;EAAsC,gBAAA;AZu5KxC;;AYv5KE;EAAsC,gBAAA;AZ25KxC;;AY35KE;EAAsC,gBAAA;AZ+5KxC;;AY/5KE;EAAsC,gBAAA;AZm6KxC;;AYn6KE;EAAsC,YAAA;AZu6KxC;;AYv6KE;EAAsC,gBAAA;AZ26KxC;;AY36KE;EAAsC,gBAAA;AZ+6KxC;;AY/6KE;EAAsC,gBAAA;AZm7KxC;;AYn7KE;EAAsC,gBAAA;AZu7KxC;;AYv7KE;EAAsC,gBAAA;AZ27KxC;;AY37KE;EAAsC,gBAAA;AZ+7KxC;;AY/7KE;EAAsC,gBAAA;AZm8KxC;;AYn8KE;EAAsC,gBAAA;AZu8KxC;;AYv8KE;EAAsC,gBAAA;AZ28KxC;;AY38KE;EAAsC,gBAAA;AZ+8KxC;;AY/8KE;EAAsC,gBAAA;AZm9KxC;;AYn9KE;EAAsC,gBAAA;AZu9KxC;;AYv9KE;EAAsC,gBAAA;AZ29KxC;;AY39KE;EAAsC,gBAAA;AZ+9KxC;;AY/9KE;EAAsC,gBAAA;AZm+KxC;;AYn+KE;EAAsC,gBAAA;AZu+KxC;;AYv+KE;EAAsC,gBAAA;AZ2+KxC;;AY3+KE;EAAsC,gBAAA;AZ++KxC;;AY/+KE;EAAsC,gBAAA;AZm/KxC;;AYn/KE;EAAsC,gBAAA;AZu/KxC;;AYv/KE;EAAsC,gBAAA;AZ2/KxC;;AY3/KE;EAAsC,gBAAA;AZ+/KxC;;AY//KE;EAAsC,gBAAA;AZmgLxC;;AYngLE;EAAsC,gBAAA;AZugLxC;;AYvgLE;EAAsC,gBAAA;AZ2gLxC;;AY3gLE;EAAsC,gBAAA;AZ+gLxC;;AY/gLE;EAAsC,gBAAA;AZmhLxC;;AYnhLE;EAAsC,gBAAA;AZuhLxC;;AYvhLE;EAAsC,gBAAA;AZ2hLxC;;AY3hLE;EAAsC,gBAAA;AZ+hLxC;;AY/hLE;EAAsC,gBAAA;AZmiLxC;;AYniLE;EAAsC,gBAAA;AZuiLxC;;AYviLE;EAAsC,gBAAA;AZ2iLxC;;AY3iLE;EAAsC,gBAAA;AZ+iLxC;;AY/iLE;EAAsC,gBAAA;AZmjLxC;;AYnjLE;EAAsC,YAAA;AZujLxC;;AYvjLE;EAAsC,gBAAA;AZ2jLxC;;AY3jLE;EAAsC,gBAAA;AZ+jLxC;;AY/jLE;EAAsC,gBAAA;AZmkLxC;;AYnkLE;EAAsC,gBAAA;AZukLxC;;AYvkLE;EAAsC,gBAAA;AZ2kLxC;;AY3kLE;EAAsC,gBAAA;AZ+kLxC;;AY/kLE;EAAsC,gBAAA;AZmlLxC;;AYnlLE;EAAsC,gBAAA;AZulLxC;;AYvlLE;EAAsC,gBAAA;AZ2lLxC;;AY3lLE;EAAsC,gBAAA;AZ+lLxC;;AY/lLE;EAAsC,gBAAA;AZmmLxC;;AYnmLE;EAAsC,gBAAA;AZumLxC;;AYvmLE;EAAsC,gBAAA;AZ2mLxC;;AY3mLE;EAAsC,gBAAA;AZ+mLxC;;AY/mLE;EAAsC,gBAAA;AZmnLxC;;AYnnLE;EAAsC,gBAAA;AZunLxC;;AYvnLE;EAAsC,gBAAA;AZ2nLxC;;AY3nLE;EAAsC,gBAAA;AZ+nLxC;;AY/nLE;EAAsC,gBAAA;AZmoLxC;;AYnoLE;EAAsC,gBAAA;AZuoLxC;;AYvoLE;EAAsC,gBAAA;AZ2oLxC;;AY3oLE;EAAsC,gBAAA;AZ+oLxC;;AY/oLE;EAAsC,gBAAA;AZmpLxC;;AYnpLE;EAAsC,gBAAA;AZupLxC;;AYvpLE;EAAsC,gBAAA;AZ2pLxC;;AY3pLE;EAAsC,gBAAA;AZ+pLxC;;AY/pLE;EAAsC,gBAAA;AZmqLxC;;AYnqLE;EAAsC,gBAAA;AZuqLxC;;AYvqLE;EAAsC,gBAAA;AZ2qLxC;;AY3qLE;EAAsC,gBAAA;AZ+qLxC;;AY/qLE;EAAsC,gBAAA;AZmrLxC;;AYnrLE;EAAsC,gBAAA;AZurLxC;;AYvrLE;EAAsC,gBAAA;AZ2rLxC;;AY3rLE;EAAsC,gBAAA;AZ+rLxC;;AY/rLE;EAAsC,gBAAA;AZmsLxC;;AYnsLE;EAAsC,gBAAA;AZusLxC;;AYvsLE;EAAsC,gBAAA;AZ2sLxC;;AY3sLE;EAAsC,gBAAA;AZ+sLxC;;AY/sLE;EAAsC,gBAAA;AZmtLxC;;AYntLE;EAAsC,gBAAA;AZutLxC;;AYvtLE;EAAsC,gBAAA;AZ2tLxC;;AY3tLE;EAAsC,gBAAA;AZ+tLxC;;AY/tLE;EAAsC,gBAAA;AZmuLxC;;AYnuLE;EAAsC,gBAAA;AZuuLxC;;AYvuLE;EAAsC,gBAAA;AZ2uLxC;;AY3uLE;EAAsC,gBAAA;AZ+uLxC;;AY/uLE;EAAsC,gBAAA;AZmvLxC;;AYnvLE;EAAsC,gBAAA;AZuvLxC;;AYvvLE;EAAsC,gBAAA;AZ2vLxC;;AY3vLE;EAAsC,gBAAA;AZ+vLxC;;AY/vLE;EAAsC,gBAAA;AZmwLxC;;AYnwLE;EAAsC,gBAAA;AZuwLxC;;AYvwLE;EAAsC,gBAAA;AZ2wLxC;;AY3wLE;EAAsC,gBAAA;AZ+wLxC;;AY/wLE;EAAsC,gBAAA;AZmxLxC;;AYnxLE;EAAsC,gBAAA;AZuxLxC;;AYvxLE;EAAsC,gBAAA;AZ2xLxC;;AY3xLE;EAAsC,gBAAA;AZ+xLxC;;AY/xLE;EAAsC,gBAAA;AZmyLxC;;AYnyLE;EAAsC,gBAAA;AZuyLxC;;AYvyLE;EAAsC,gBAAA;AZ2yLxC;;AY3yLE;EAAsC,gBAAA;AZ+yLxC;;AY/yLE;EAAsC,aAAA;AZmzLxC;;AYnzLE;EAAsC,gBAAA;AZuzLxC;;AYvzLE;EAAsC,gBAAA;AZ2zLxC;;AY3zLE;EAAsC,gBAAA;AZ+zLxC;;AY/zLE;EAAsC,gBAAA;AZm0LxC;;AYn0LE;EAAsC,gBAAA;AZu0LxC;;AYv0LE;EAAsC,gBAAA;AZ20LxC;;AY30LE;EAAsC,gBAAA;AZ+0LxC;;AY/0LE;EAAsC,gBAAA;AZm1LxC;;AYn1LE;EAAsC,gBAAA;AZu1LxC;;AYv1LE;EAAsC,gBAAA;AZ21LxC;;AY31LE;EAAsC,gBAAA;AZ+1LxC;;AY/1LE;EAAsC,gBAAA;AZm2LxC;;AYn2LE;EAAsC,gBAAA;AZu2LxC;;AYv2LE;EAAsC,gBAAA;AZ22LxC;;AY32LE;EAAsC,gBAAA;AZ+2LxC;;AY/2LE;EAAsC,gBAAA;AZm3LxC;;AYn3LE;EAAsC,gBAAA;AZu3LxC;;AYv3LE;EAAsC,gBAAA;AZ23LxC;;AY33LE;EAAsC,gBAAA;AZ+3LxC;;AY/3LE;EAAsC,gBAAA;AZm4LxC;;AYn4LE;EAAsC,gBAAA;AZu4LxC;;AYv4LE;EAAsC,gBAAA;AZ24LxC;;AY34LE;EAAsC,gBAAA;AZ+4LxC;;AY/4LE;EAAsC,gBAAA;AZm5LxC;;AYn5LE;EAAsC,gBAAA;AZu5LxC;;AYv5LE;EAAsC,gBAAA;AZ25LxC;;AY35LE;EAAsC,gBAAA;AZ+5LxC;;AY/5LE;EAAsC,gBAAA;AZm6LxC;;AYn6LE;EAAsC,gBAAA;AZu6LxC;;AYv6LE;EAAsC,gBAAA;AZ26LxC;;AY36LE;EAAsC,gBAAA;AZ+6LxC;;AY/6LE;EAAsC,gBAAA;AZm7LxC;;AYn7LE;EAAsC,gBAAA;AZu7LxC;;AYv7LE;EAAsC,gBAAA;AZ27LxC;;AY37LE;EAAsC,gBAAA;AZ+7LxC;;AY/7LE;EAAsC,gBAAA;AZm8LxC;;AYn8LE;EAAsC,gBAAA;AZu8LxC;;AYv8LE;EAAsC,gBAAA;AZ28LxC;;AY38LE;EAAsC,gBAAA;AZ+8LxC;;AY/8LE;EAAsC,gBAAA;AZm9LxC;;AYn9LE;EAAsC,gBAAA;AZu9LxC;;AYv9LE;EAAsC,gBAAA;AZ29LxC;;AY39LE;EAAsC,gBAAA;AZ+9LxC;;AY/9LE;EAAsC,gBAAA;AZm+LxC;;AYn+LE;EAAsC,gBAAA;AZu+LxC;;AYv+LE;EAAsC,gBAAA;AZ2+LxC;;AY3+LE;EAAsC,gBAAA;AZ++LxC;;AY/+LE;EAAsC,gBAAA;AZm/LxC;;AYn/LE;EAAsC,gBAAA;AZu/LxC;;AYv/LE;EAAsC,gBAAA;AZ2/LxC;;AY3/LE;EAAsC,gBAAA;AZ+/LxC;;AY//LE;EAAsC,gBAAA;AZmgMxC;;AYngME;EAAsC,aAAA;AZugMxC;;AYvgME;EAAsC,gBAAA;AZ2gMxC;;AY3gME;EAAsC,gBAAA;AZ+gMxC;;AY/gME;EAAsC,gBAAA;AZmhMxC;;AYnhME;EAAsC,gBAAA;AZuhMxC;;AYvhME;EAAsC,gBAAA;AZ2hMxC;;AY3hME;EAAsC,gBAAA;AZ+hMxC;;AY/hME;EAAsC,gBAAA;AZmiMxC;;AYniME;EAAsC,gBAAA;AZuiMxC;;AYviME;EAAsC,gBAAA;AZ2iMxC;;AY3iME;EAAsC,gBAAA;AZ+iMxC;;AY/iME;EAAsC,gBAAA;AZmjMxC;;AYnjME;EAAsC,gBAAA;AZujMxC;;AYvjME;EAAsC,gBAAA;AZ2jMxC;;AY3jME;EAAsC,gBAAA;AZ+jMxC;;AY/jME;EAAsC,gBAAA;AZmkMxC;;AYnkME;EAAsC,gBAAA;AZukMxC;;AYvkME;EAAsC,gBAAA;AZ2kMxC;;AY3kME;EAAsC,gBAAA;AZ+kMxC;;AY/kME;EAAsC,gBAAA;AZmlMxC;;AYnlME;EAAsC,gBAAA;AZulMxC;;AYvlME;EAAsC,gBAAA;AZ2lMxC;;AY3lME;EAAsC,gBAAA;AZ+lMxC;;AY/lME;EAAsC,gBAAA;AZmmMxC;;AYnmME;EAAsC,gBAAA;AZumMxC;;AYvmME;EAAsC,gBAAA;AZ2mMxC;;AY3mME;EAAsC,gBAAA;AZ+mMxC;;AY/mME;EAAsC,gBAAA;AZmnMxC;;AYnnME;EAAsC,gBAAA;AZunMxC;;AYvnME;EAAsC,gBAAA;AZ2nMxC;;AY3nME;EAAsC,gBAAA;AZ+nMxC;;AY/nME;EAAsC,gBAAA;AZmoMxC;;AYnoME;EAAsC,gBAAA;AZuoMxC;;AYvoME;EAAsC,gBAAA;AZ2oMxC;;AY3oME;EAAsC,gBAAA;AZ+oMxC;;AY/oME;EAAsC,gBAAA;AZmpMxC;;AYnpME;EAAsC,gBAAA;AZupMxC;;AYvpME;EAAsC,gBAAA;AZ2pMxC;;AY3pME;EAAsC,gBAAA;AZ+pMxC;;AY/pME;EAAsC,gBAAA;AZmqMxC;;AYnqME;EAAsC,gBAAA;AZuqMxC;;AYvqME;EAAsC,gBAAA;AZ2qMxC;;AY3qME;EAAsC,gBAAA;AZ+qMxC;;AY/qME;EAAsC,gBAAA;AZmrMxC;;AYnrME;EAAsC,gBAAA;AZurMxC;;AYvrME;EAAsC,gBAAA;AZ2rMxC;;AY3rME;EAAsC,gBAAA;AZ+rMxC;;AY/rME;EAAsC,gBAAA;AZmsMxC;;AYnsME;EAAsC,gBAAA;AZusMxC;;AYvsME;EAAsC,gBAAA;AZ2sMxC;;AY3sME;EAAsC,gBAAA;AZ+sMxC;;AY/sME;EAAsC,gBAAA;AZmtMxC;;AYntME;EAAsC,gBAAA;AZutMxC;;AYvtME;EAAsC,gBAAA;AZ2tMxC;;AY3tME;EAAsC,gBAAA;AZ+tMxC;;AY/tME;EAAsC,gBAAA;AZmuMxC;;AYnuME;EAAsC,gBAAA;AZuuMxC;;AYvuME;EAAsC,gBAAA;AZ2uMxC;;AY3uME;EAAsC,gBAAA;AZ+uMxC;;AY/uME;EAAsC,gBAAA;AZmvMxC;;AYnvME;EAAsC,gBAAA;AZuvMxC;;AYvvME;EAAsC,gBAAA;AZ2vMxC;;AY3vME;EAAsC,gBAAA;AZ+vMxC;;AY/vME;EAAsC,gBAAA;AZmwMxC;;AYnwME;EAAsC,gBAAA;AZuwMxC;;AYvwME;EAAsC,gBAAA;AZ2wMxC;;AY3wME;EAAsC,gBAAA;AZ+wMxC;;AY/wME;EAAsC,gBAAA;AZmxMxC;;AYnxME;EAAsC,gBAAA;AZuxMxC;;AYvxME;EAAsC,gBAAA;AZ2xMxC;;AY3xME;EAAsC,gBAAA;AZ+xMxC;;AY/xME;EAAsC,gBAAA;AZmyMxC;;AYnyME;EAAsC,gBAAA;AZuyMxC;;AYvyME;EAAsC,gBAAA;AZ2yMxC;;AY3yME;EAAsC,gBAAA;AZ+yMxC;;AY/yME;EAAsC,gBAAA;AZmzMxC;;AYnzME;EAAsC,gBAAA;AZuzMxC;;AYvzME;EAAsC,gBAAA;AZ2zMxC;;AY3zME;EAAsC,gBAAA;AZ+zMxC;;AY/zME;EAAsC,gBAAA;AZm0MxC;;AYn0ME;EAAsC,gBAAA;AZu0MxC;;AYv0ME;EAAsC,gBAAA;AZ20MxC;;AY30ME;EAAsC,gBAAA;AZ+0MxC;;AY/0ME;EAAsC,gBAAA;AZm1MxC;;AYn1ME;EAAsC,gBAAA;AZu1MxC;;AYv1ME;EAAsC,gBAAA;AZ21MxC;;AY31ME;EAAsC,gBAAA;AZ+1MxC;;AY/1ME;EAAsC,gBAAA;AZm2MxC;;AYn2ME;EAAsC,gBAAA;AZu2MxC;;AYv2ME;EAAsC,gBAAA;AZ22MxC;;AY32ME;EAAsC,gBAAA;AZ+2MxC;;AY/2ME;EAAsC,gBAAA;AZm3MxC;;AYn3ME;EAAsC,gBAAA;AZu3MxC;;AYv3ME;EAAsC,gBAAA;AZ23MxC;;AY33ME;EAAsC,gBAAA;AZ+3MxC;;AY/3ME;EAAsC,gBAAA;AZm4MxC;;AYn4ME;EAAsC,gBAAA;AZu4MxC;;AYv4ME;EAAsC,gBAAA;AZ24MxC;;AY34ME;EAAsC,gBAAA;AZ+4MxC;;AY/4ME;EAAsC,gBAAA;AZm5MxC;;AYn5ME;EAAsC,gBAAA;AZu5MxC;;AYv5ME;EAAsC,gBAAA;AZ25MxC;;AY35ME;EAAsC,gBAAA;AZ+5MxC;;AY/5ME;EAAsC,gBAAA;AZm6MxC;;AYn6ME;EAAsC,gBAAA;AZu6MxC;;AYv6ME;EAAsC,gBAAA;AZ26MxC;;AY36ME;EAAsC,YAAA;AZ+6MxC;;AY/6ME;EAAsC,gBAAA;AZm7MxC;;AYn7ME;EAAsC,gBAAA;AZu7MxC;;AYv7ME;EAAsC,gBAAA;AZ27MxC;;AY37ME;EAAsC,gBAAA;AZ+7MxC;;AY/7ME;EAAsC,gBAAA;AZm8MxC;;AYn8ME;EAAsC,gBAAA;AZu8MxC;;AYv8ME;EAAsC,gBAAA;AZ28MxC;;AY38ME;EAAsC,gBAAA;AZ+8MxC;;AY/8ME;EAAsC,gBAAA;AZm9MxC;;AYn9ME;EAAsC,gBAAA;AZu9MxC;;AYv9ME;EAAsC,gBAAA;AZ29MxC;;AY39ME;EAAsC,gBAAA;AZ+9MxC;;AY/9ME;EAAsC,gBAAA;AZm+MxC;;AYn+ME;EAAsC,gBAAA;AZu+MxC;;AYv+ME;EAAsC,gBAAA;AZ2+MxC;;AY3+ME;EAAsC,gBAAA;AZ++MxC;;AY/+ME;EAAsC,gBAAA;AZm/MxC;;AYn/ME;EAAsC,gBAAA;AZu/MxC;;AYv/ME;EAAsC,gBAAA;AZ2/MxC;;AY3/ME;EAAsC,gBAAA;AZ+/MxC;;AY//ME;EAAsC,gBAAA;AZmgNxC;;AYngNE;EAAsC,gBAAA;AZugNxC;;AYvgNE;EAAsC,gBAAA;AZ2gNxC;;AY3gNE;EAAsC,gBAAA;AZ+gNxC;;AY/gNE;EAAsC,gBAAA;AZmhNxC;;AYnhNE;EAAsC,gBAAA;AZuhNxC;;AYvhNE;EAAsC,gBAAA;AZ2hNxC;;AY3hNE;EAAsC,gBAAA;AZ+hNxC;;AY/hNE;EAAsC,gBAAA;AZmiNxC;;AYniNE;EAAsC,gBAAA;AZuiNxC;;AYviNE;EAAsC,aAAA;AZ2iNxC;;AY3iNE;EAAsC,aAAA;AZ+iNxC;;AY/iNE;EAAsC,gBAAA;AZmjNxC;;AYnjNE;EAAsC,gBAAA;AZujNxC;;AYvjNE;EAAsC,gBAAA;AZ2jNxC;;AY3jNE;EAAsC,gBAAA;AZ+jNxC;;AY/jNE;EAAsC,gBAAA;AZmkNxC;;AYnkNE;EAAsC,gBAAA;AZukNxC;;AYvkNE;EAAsC,gBAAA;AZ2kNxC;;AY3kNE;EAAsC,gBAAA;AZ+kNxC;;AY/kNE;EAAsC,gBAAA;AZmlNxC;;AYnlNE;EAAsC,gBAAA;AZulNxC;;AYvlNE;EAAsC,gBAAA;AZ2lNxC;;AY3lNE;EAAsC,gBAAA;AZ+lNxC;;AY/lNE;EAAsC,gBAAA;AZmmNxC;;AYnmNE;EAAsC,gBAAA;AZumNxC;;AYvmNE;EAAsC,gBAAA;AZ2mNxC;;AY3mNE;EAAsC,gBAAA;AZ+mNxC;;AY/mNE;EAAsC,gBAAA;AZmnNxC;;AYnnNE;EAAsC,gBAAA;AZunNxC;;AYvnNE;EAAsC,gBAAA;AZ2nNxC;;AY3nNE;EAAsC,gBAAA;AZ+nNxC;;AY/nNE;EAAsC,gBAAA;AZmoNxC;;AYnoNE;EAAsC,gBAAA;AZuoNxC;;AYvoNE;EAAsC,gBAAA;AZ2oNxC;;AY3oNE;EAAsC,gBAAA;AZ+oNxC;;AY/oNE;EAAsC,aAAA;AZmpNxC;;AYnpNE;EAAsC,gBAAA;AZupNxC;;AYvpNE;EAAsC,gBAAA;AZ2pNxC;;AY3pNE;EAAsC,gBAAA;AZ+pNxC;;AY/pNE;EAAsC,gBAAA;AZmqNxC;;AYnqNE;EAAsC,gBAAA;AZuqNxC;;AYvqNE;EAAsC,gBAAA;AZ2qNxC;;AY3qNE;EAAsC,gBAAA;AZ+qNxC;;AY/qNE;EAAsC,gBAAA;AZmrNxC;;AYnrNE;EAAsC,gBAAA;AZurNxC;;AYvrNE;EAAsC,gBAAA;AZ2rNxC;;AY3rNE;EAAsC,gBAAA;AZ+rNxC;;AY/rNE;EAAsC,gBAAA;AZmsNxC;;AYnsNE;EAAsC,gBAAA;AZusNxC;;AYvsNE;EAAsC,gBAAA;AZ2sNxC;;AY3sNE;EAAsC,gBAAA;AZ+sNxC;;AY/sNE;EAAsC,gBAAA;AZmtNxC;;AYntNE;EAAsC,gBAAA;AZutNxC;;AYvtNE;EAAsC,gBAAA;AZ2tNxC;;AY3tNE;EAAsC,gBAAA;AZ+tNxC;;AY/tNE;EAAsC,gBAAA;AZmuNxC;;AYnuNE;EAAsC,gBAAA;AZuuNxC;;AYvuNE;EAAsC,gBAAA;AZ2uNxC;;AY3uNE;EAAsC,gBAAA;AZ+uNxC;;AY/uNE;EAAsC,gBAAA;AZmvNxC;;AYnvNE;EAAsC,gBAAA;AZuvNxC;;AYvvNE;EAAsC,gBAAA;AZ2vNxC;;AY3vNE;EAAsC,gBAAA;AZ+vNxC;;AY/vNE;EAAsC,gBAAA;AZmwNxC;;AYnwNE;EAAsC,gBAAA;AZuwNxC;;AYvwNE;EAAsC,gBAAA;AZ2wNxC;;AY3wNE;EAAsC,gBAAA;AZ+wNxC;;AY/wNE;EAAsC,gBAAA;AZmxNxC;;AYnxNE;EAAsC,gBAAA;AZuxNxC;;AYvxNE;EAAsC,gBAAA;AZ2xNxC;;AY3xNE;EAAsC,gBAAA;AZ+xNxC;;AY/xNE;EAAsC,gBAAA;AZmyNxC;;AYnyNE;EAAsC,gBAAA;AZuyNxC;;AYvyNE;EAAsC,gBAAA;AZ2yNxC;;AY3yNE;EAAsC,gBAAA;AZ+yNxC;;AY/yNE;EAAsC,gBAAA;AZmzNxC;;AYnzNE;EAAsC,gBAAA;AZuzNxC;;AYvzNE;EAAsC,gBAAA;AZ2zNxC;;AY3zNE;EAAsC,gBAAA;AZ+zNxC;;AY/zNE;EAAsC,gBAAA;AZm0NxC;;AYn0NE;EAAsC,gBAAA;AZu0NxC;;AYv0NE;EAAsC,gBAAA;AZ20NxC;;AY30NE;EAAsC,gBAAA;AZ+0NxC;;AY/0NE;EAAsC,gBAAA;AZm1NxC;;AYn1NE;EAAsC,aAAA;AZu1NxC;;AYv1NE;EAAsC,aAAA;AZ21NxC;;AY31NE;EAAsC,gBAAA;AZ+1NxC;;AY/1NE;EAAsC,gBAAA;AZm2NxC;;AYn2NE;EAAsC,gBAAA;AZu2NxC;;AYv2NE;EAAsC,gBAAA;AZ22NxC;;AY32NE;EAAsC,gBAAA;AZ+2NxC;;AY/2NE;EAAsC,gBAAA;AZm3NxC;;AYn3NE;EAAsC,gBAAA;AZu3NxC;;AYv3NE;EAAsC,gBAAA;AZ23NxC;;AY33NE;EAAsC,gBAAA;AZ+3NxC;;AY/3NE;EAAsC,gBAAA;AZm4NxC;;AYn4NE;EAAsC,gBAAA;AZu4NxC;;AYv4NE;EAAsC,gBAAA;AZ24NxC;;AY34NE;EAAsC,gBAAA;AZ+4NxC;;AY/4NE;EAAsC,gBAAA;AZm5NxC;;AYn5NE;EAAsC,gBAAA;AZu5NxC;;AYv5NE;EAAsC,gBAAA;AZ25NxC;;AY35NE;EAAsC,gBAAA;AZ+5NxC;;AY/5NE;EAAsC,gBAAA;AZm6NxC;;AYn6NE;EAAsC,gBAAA;AZu6NxC;;AYv6NE;EAAsC,gBAAA;AZ26NxC;;AY36NE;EAAsC,gBAAA;AZ+6NxC;;AY/6NE;EAAsC,gBAAA;AZm7NxC;;AYn7NE;EAAsC,gBAAA;AZu7NxC;;AYv7NE;EAAsC,gBAAA;AZ27NxC;;AY37NE;EAAsC,gBAAA;AZ+7NxC;;AY/7NE;EAAsC,gBAAA;AZm8NxC;;AYn8NE;EAAsC,gBAAA;AZu8NxC;;AYv8NE;EAAsC,gBAAA;AZ28NxC;;AY38NE;EAAsC,gBAAA;AZ+8NxC;;AY/8NE;EAAsC,gBAAA;AZm9NxC;;AYn9NE;EAAsC,gBAAA;AZu9NxC;;AYv9NE;EAAsC,gBAAA;AZ29NxC;;AY39NE;EAAsC,gBAAA;AZ+9NxC;;AY/9NE;EAAsC,gBAAA;AZm+NxC;;AYn+NE;EAAsC,gBAAA;AZu+NxC;;AYv+NE;EAAsC,gBAAA;AZ2+NxC;;AY3+NE;EAAsC,gBAAA;AZ++NxC;;AY/+NE;EAAsC,gBAAA;AZm/NxC;;AYn/NE;EAAsC,gBAAA;AZu/NxC;;AYv/NE;EAAsC,gBAAA;AZ2/NxC;;AY3/NE;EAAsC,gBAAA;AZ+/NxC;;AY//NE;EAAsC,gBAAA;AZmgOxC;;AYngOE;EAAsC,gBAAA;AZugOxC;;AYvgOE;EAAsC,gBAAA;AZ2gOxC;;AY3gOE;EAAsC,gBAAA;AZ+gOxC;;AY/gOE;EAAsC,gBAAA;AZmhOxC;;AYnhOE;EAAsC,gBAAA;AZuhOxC;;AYvhOE;EAAsC,gBAAA;AZ2hOxC;;AY3hOE;EAAsC,gBAAA;AZ+hOxC;;AY/hOE;EAAsC,gBAAA;AZmiOxC;;AYniOE;EAAsC,gBAAA;AZuiOxC;;AYviOE;EAAsC,gBAAA;AZ2iOxC;;AY3iOE;EAAsC,gBAAA;AZ+iOxC;;AY/iOE;EAAsC,gBAAA;AZmjOxC;;AYnjOE;EAAsC,gBAAA;AZujOxC;;AYvjOE;EAAsC,gBAAA;AZ2jOxC;;AY3jOE;EAAsC,gBAAA;AZ+jOxC;;AY/jOE;EAAsC,gBAAA;AZmkOxC;;AYnkOE;EAAsC,gBAAA;AZukOxC;;AYvkOE;EAAsC,gBAAA;AZ2kOxC;;AY3kOE;EAAsC,gBAAA;AZ+kOxC;;AY/kOE;EAAsC,gBAAA;AZmlOxC;;AYnlOE;EAAsC,gBAAA;AZulOxC;;AYvlOE;EAAsC,gBAAA;AZ2lOxC;;AY3lOE;EAAsC,gBAAA;AZ+lOxC;;AY/lOE;EAAsC,gBAAA;AZmmOxC;;AYnmOE;EAAsC,gBAAA;AZumOxC;;AYvmOE;EAAsC,gBAAA;AZ2mOxC;;AY3mOE;EAAsC,gBAAA;AZ+mOxC;;AY/mOE;EAAsC,gBAAA;AZmnOxC;;AYnnOE;EAAsC,gBAAA;AZunOxC;;AYvnOE;EAAsC,gBAAA;AZ2nOxC;;AY3nOE;EAAsC,gBAAA;AZ+nOxC;;AY/nOE;EAAsC,gBAAA;AZmoOxC;;AYnoOE;EAAsC,gBAAA;AZuoOxC;;AYvoOE;EAAsC,gBAAA;AZ2oOxC;;AY3oOE;EAAsC,gBAAA;AZ+oOxC;;AY/oOE;EAAsC,gBAAA;AZmpOxC;;AYnpOE;EAAsC,gBAAA;AZupOxC;;AYvpOE;EAAsC,gBAAA;AZ2pOxC;;AY3pOE;EAAsC,aAAA;AZ+pOxC;;AY/pOE;EAAsC,gBAAA;AZmqOxC;;AYnqOE;EAAsC,gBAAA;AZuqOxC;;AYvqOE;EAAsC,gBAAA;AZ2qOxC;;AY3qOE;EAAsC,YAAA;AZ+qOxC;;AY/qOE;EAAsC,gBAAA;AZmrOxC;;AYnrOE;EAAsC,gBAAA;AZurOxC;;AYvrOE;EAAsC,gBAAA;AZ2rOxC;;AY3rOE;EAAsC,gBAAA;AZ+rOxC;;AY/rOE;EAAsC,gBAAA;AZmsOxC;;AYnsOE;EAAsC,gBAAA;AZusOxC;;AYvsOE;EAAsC,gBAAA;AZ2sOxC;;AY3sOE;EAAsC,gBAAA;AZ+sOxC;;AY/sOE;EAAsC,gBAAA;AZmtOxC;;AYntOE;EAAsC,gBAAA;AZutOxC;;AYvtOE;EAAsC,gBAAA;AZ2tOxC;;AY3tOE;EAAsC,gBAAA;AZ+tOxC;;AY/tOE;EAAsC,gBAAA;AZmuOxC;;AYnuOE;EAAsC,gBAAA;AZuuOxC;;AYvuOE;EAAsC,gBAAA;AZ2uOxC;;AY3uOE;EAAsC,gBAAA;AZ+uOxC;;AY/uOE;EAAsC,gBAAA;AZmvOxC;;AYnvOE;EAAsC,gBAAA;AZuvOxC;;AYvvOE;EAAsC,gBAAA;AZ2vOxC;;AY3vOE;EAAsC,gBAAA;AZ+vOxC;;AY/vOE;EAAsC,gBAAA;AZmwOxC;;AYnwOE;EAAsC,gBAAA;AZuwOxC;;AYvwOE;EAAsC,gBAAA;AZ2wOxC;;AY3wOE;EAAsC,gBAAA;AZ+wOxC;;AY/wOE;EAAsC,gBAAA;AZmxOxC;;AYnxOE;EAAsC,gBAAA;AZuxOxC;;AYvxOE;EAAsC,gBAAA;AZ2xOxC;;AY3xOE;EAAsC,gBAAA;AZ+xOxC;;AY/xOE;EAAsC,gBAAA;AZmyOxC;;AYnyOE;EAAsC,gBAAA;AZuyOxC;;AYvyOE;EAAsC,gBAAA;AZ2yOxC;;AY3yOE;EAAsC,gBAAA;AZ+yOxC;;AY/yOE;EAAsC,gBAAA;AZmzOxC;;AYnzOE;EAAsC,gBAAA;AZuzOxC;;AYvzOE;EAAsC,gBAAA;AZ2zOxC;;AY3zOE;EAAsC,gBAAA;AZ+zOxC;;AY/zOE;EAAsC,gBAAA;AZm0OxC;;AYn0OE;EAAsC,gBAAA;AZu0OxC;;AYv0OE;EAAsC,gBAAA;AZ20OxC;;AY30OE;EAAsC,gBAAA;AZ+0OxC;;AY/0OE;EAAsC,gBAAA;AZm1OxC;;AYn1OE;EAAsC,gBAAA;AZu1OxC;;AYv1OE;EAAsC,gBAAA;AZ21OxC;;AY31OE;EAAsC,gBAAA;AZ+1OxC;;AY/1OE;EAAsC,gBAAA;AZm2OxC;;AYn2OE;EAAsC,gBAAA;AZu2OxC;;AYv2OE;EAAsC,gBAAA;AZ22OxC;;AY32OE;EAAsC,gBAAA;AZ+2OxC;;AY/2OE;EAAsC,gBAAA;AZm3OxC;;AYn3OE;EAAsC,gBAAA;AZu3OxC;;AYv3OE;EAAsC,gBAAA;AZ23OxC;;AY33OE;EAAsC,gBAAA;AZ+3OxC;;AY/3OE;EAAsC,gBAAA;AZm4OxC;;AYn4OE;EAAsC,gBAAA;AZu4OxC;;AYv4OE;EAAsC,gBAAA;AZ24OxC;;AY34OE;EAAsC,YAAA;AZ+4OxC;;AY/4OE;EAAsC,gBAAA;AZm5OxC;;AYn5OE;EAAsC,gBAAA;AZu5OxC;;AYv5OE;EAAsC,gBAAA;AZ25OxC;;AY35OE;EAAsC,gBAAA;AZ+5OxC;;AY/5OE;EAAsC,gBAAA;AZm6OxC;;AYn6OE;EAAsC,gBAAA;AZu6OxC;;AYv6OE;EAAsC,gBAAA;AZ26OxC;;AY36OE;EAAsC,gBAAA;AZ+6OxC;;AY/6OE;EAAsC,gBAAA;AZm7OxC;;AYn7OE;EAAsC,gBAAA;AZu7OxC;;AYv7OE;EAAsC,gBAAA;AZ27OxC;;AY37OE;EAAsC,gBAAA;AZ+7OxC;;AY/7OE;EAAsC,gBAAA;AZm8OxC;;AYn8OE;EAAsC,gBAAA;AZu8OxC;;AYv8OE;EAAsC,gBAAA;AZ28OxC;;AY38OE;EAAsC,gBAAA;AZ+8OxC;;AY/8OE;EAAsC,gBAAA;AZm9OxC;;AYn9OE;EAAsC,gBAAA;AZu9OxC;;AYv9OE;EAAsC,gBAAA;AZ29OxC;;AY39OE;EAAsC,gBAAA;AZ+9OxC;;AY/9OE;EAAsC,gBAAA;AZm+OxC;;AYn+OE;EAAsC,gBAAA;AZu+OxC;;AYv+OE;EAAsC,gBAAA;AZ2+OxC;;AY3+OE;EAAsC,gBAAA;AZ++OxC;;AY/+OE;EAAsC,gBAAA;AZm/OxC;;AYn/OE;EAAsC,gBAAA;AZu/OxC;;AYv/OE;EAAsC,gBAAA;AZ2/OxC;;AY3/OE;EAAsC,gBAAA;AZ+/OxC;;AY//OE;EAAsC,gBAAA;AZmgPxC;;AYngPE;EAAsC,gBAAA;AZugPxC;;AYvgPE;EAAsC,gBAAA;AZ2gPxC;;AY3gPE;EAAsC,gBAAA;AZ+gPxC;;AY/gPE;EAAsC,gBAAA;AZmhPxC;;AYnhPE;EAAsC,gBAAA;AZuhPxC;;AYvhPE;EAAsC,gBAAA;AZ2hPxC;;AY3hPE;EAAsC,gBAAA;AZ+hPxC;;AY/hPE;EAAsC,gBAAA;AZmiPxC;;AYniPE;EAAsC,gBAAA;AZuiPxC;;AYviPE;EAAsC,gBAAA;AZ2iPxC;;AY3iPE;EAAsC,gBAAA;AZ+iPxC;;AY/iPE;EAAsC,gBAAA;AZmjPxC;;AYnjPE;EAAsC,gBAAA;AZujPxC;;AYvjPE;EAAsC,gBAAA;AZ2jPxC;;AY3jPE;EAAsC,gBAAA;AZ+jPxC;;AY/jPE;EAAsC,gBAAA;AZmkPxC;;AYnkPE;EAAsC,gBAAA;AZukPxC;;AYvkPE;EAAsC,gBAAA;AZ2kPxC;;AY3kPE;EAAsC,gBAAA;AZ+kPxC;;AY/kPE;EAAsC,gBAAA;AZmlPxC;;AYnlPE;EAAsC,gBAAA;AZulPxC;;AYvlPE;EAAsC,gBAAA;AZ2lPxC;;AY3lPE;EAAsC,gBAAA;AZ+lPxC;;AY/lPE;EAAsC,gBAAA;AZmmPxC;;AYnmPE;EAAsC,gBAAA;AZumPxC;;AYvmPE;EAAsC,gBAAA;AZ2mPxC;;AY3mPE;EAAsC,gBAAA;AZ+mPxC;;AY/mPE;EAAsC,gBAAA;AZmnPxC;;AYnnPE;EAAsC,gBAAA;AZunPxC;;AYvnPE;EAAsC,gBAAA;AZ2nPxC;;AY3nPE;EAAsC,gBAAA;AZ+nPxC;;AY/nPE;EAAsC,gBAAA;AZmoPxC;;AYnoPE;EAAsC,gBAAA;AZuoPxC;;AYvoPE;EAAsC,gBAAA;AZ2oPxC;;AY3oPE;EAAsC,gBAAA;AZ+oPxC;;AY/oPE;EAAsC,gBAAA;AZmpPxC;;AYnpPE;EAAsC,gBAAA;AZupPxC;;AYvpPE;EAAsC,gBAAA;AZ2pPxC;;AY3pPE;EAAsC,gBAAA;AZ+pPxC;;AY/pPE;EAAsC,gBAAA;AZmqPxC;;AYnqPE;EAAsC,gBAAA;AZuqPxC;;AYvqPE;EAAsC,gBAAA;AZ2qPxC;;AY3qPE;EAAsC,gBAAA;AZ+qPxC;;AY/qPE;EAAsC,gBAAA;AZmrPxC;;AYnrPE;EAAsC,gBAAA;AZurPxC;;AYvrPE;EAAsC,gBAAA;AZ2rPxC;;AY3rPE;EAAsC,gBAAA;AZ+rPxC;;AY/rPE;EAAsC,gBAAA;AZmsPxC;;AYnsPE;EAAsC,gBAAA;AZusPxC;;AYvsPE;EAAsC,gBAAA;AZ2sPxC;;AY3sPE;EAAsC,gBAAA;AZ+sPxC;;AY/sPE;EAAsC,gBAAA;AZmtPxC;;AYntPE;EAAsC,gBAAA;AZutPxC;;AYvtPE;EAAsC,gBAAA;AZ2tPxC;;AY3tPE;EAAsC,gBAAA;AZ+tPxC;;AY/tPE;EAAsC,gBAAA;AZmuPxC;;AYnuPE;EAAsC,gBAAA;AZuuPxC;;AYvuPE;EAAsC,gBAAA;AZ2uPxC;;AY3uPE;EAAsC,gBAAA;AZ+uPxC;;AY/uPE;EAAsC,gBAAA;AZmvPxC;;AYnvPE;EAAsC,gBAAA;AZuvPxC;;AYvvPE;EAAsC,gBAAA;AZ2vPxC;;AY3vPE;EAAsC,gBAAA;AZ+vPxC;;AY/vPE;EAAsC,gBAAA;AZmwPxC;;AYnwPE;EAAsC,gBAAA;AZuwPxC;;AYvwPE;EAAsC,gBAAA;AZ2wPxC;;AY3wPE;EAAsC,gBAAA;AZ+wPxC;;AY/wPE;EAAsC,gBAAA;AZmxPxC;;AYnxPE;EAAsC,gBAAA;AZuxPxC;;AYvxPE;EAAsC,gBAAA;AZ2xPxC;;AY3xPE;EAAsC,gBAAA;AZ+xPxC;;AY/xPE;EAAsC,gBAAA;AZmyPxC;;AYnyPE;EAAsC,gBAAA;AZuyPxC;;AYvyPE;EAAsC,gBAAA;AZ2yPxC;;AY3yPE;EAAsC,gBAAA;AZ+yPxC;;AY/yPE;EAAsC,gBAAA;AZmzPxC;;AYnzPE;EAAsC,gBAAA;AZuzPxC;;AYvzPE;EAAsC,gBAAA;AZ2zPxC;;AY3zPE;EAAsC,gBAAA;AZ+zPxC;;AY/zPE;EAAsC,gBAAA;AZm0PxC;;AYn0PE;EAAsC,gBAAA;AZu0PxC;;AYv0PE;EAAsC,gBAAA;AZ20PxC;;AY30PE;EAAsC,gBAAA;AZ+0PxC;;AY/0PE;EAAsC,gBAAA;AZm1PxC;;AYn1PE;EAAsC,gBAAA;AZu1PxC;;AYv1PE;EAAsC,gBAAA;AZ21PxC;;AY31PE;EAAsC,gBAAA;AZ+1PxC;;AY/1PE;EAAsC,gBAAA;AZm2PxC;;AYn2PE;EAAsC,gBAAA;AZu2PxC;;AYv2PE;EAAsC,gBAAA;AZ22PxC;;AY32PE;EAAsC,gBAAA;AZ+2PxC;;AY/2PE;EAAsC,gBAAA;AZm3PxC;;AYn3PE;EAAsC,gBAAA;AZu3PxC;;AYv3PE;EAAsC,gBAAA;AZ23PxC;;AY33PE;EAAsC,aAAA;AZ+3PxC;;AY/3PE;EAAsC,gBAAA;AZm4PxC;;AYn4PE;EAAsC,gBAAA;AZu4PxC;;AYv4PE;EAAsC,gBAAA;AZ24PxC;;AY34PE;EAAsC,gBAAA;AZ+4PxC;;AY/4PE;EAAsC,gBAAA;AZm5PxC;;AYn5PE;EAAsC,aAAA;AZu5PxC;;AYv5PE;EAAsC,aAAA;AZ25PxC;;AY35PE;EAAsC,aAAA;AZ+5PxC;;AY/5PE;EAAsC,YAAA;AZm6PxC;;AYn6PE;EAAsC,gBAAA;AZu6PxC;;AYv6PE;EAAsC,gBAAA;AZ26PxC;;AY36PE;EAAsC,gBAAA;AZ+6PxC;;AY/6PE;EAAsC,gBAAA;AZm7PxC;;AYn7PE;EAAsC,gBAAA;AZu7PxC;;AYv7PE;EAAsC,gBAAA;AZ27PxC;;AY37PE;EAAsC,gBAAA;AZ+7PxC;;AY/7PE;EAAsC,gBAAA;AZm8PxC;;AYn8PE;EAAsC,gBAAA;AZu8PxC;;AYv8PE;EAAsC,gBAAA;AZ28PxC;;AY38PE;EAAsC,gBAAA;AZ+8PxC;;AY/8PE;EAAsC,gBAAA;AZm9PxC;;AYn9PE;EAAsC,YAAA;AZu9PxC;;AYv9PE;EAAsC,gBAAA;AZ29PxC;;AY39PE;EAAsC,gBAAA;AZ+9PxC;;AY/9PE;EAAsC,gBAAA;AZm+PxC;;AYn+PE;EAAsC,gBAAA;AZu+PxC;;AYv+PE;EAAsC,gBAAA;AZ2+PxC;;AY3+PE;EAAsC,gBAAA;AZ++PxC;;AY/+PE;EAAsC,gBAAA;AZm/PxC;;AYn/PE;EAAsC,gBAAA;AZu/PxC;;AYv/PE;EAAsC,gBAAA;AZ2/PxC;;AY3/PE;EAAsC,gBAAA;AZ+/PxC;;AY//PE;EAAsC,gBAAA;AZmgQxC;;AYngQE;EAAsC,gBAAA;AZugQxC;;AYvgQE;EAAsC,gBAAA;AZ2gQxC;;AY3gQE;EAAsC,gBAAA;AZ+gQxC;;AY/gQE;EAAsC,gBAAA;AZmhQxC;;AYnhQE;EAAsC,gBAAA;AZuhQxC;;AYvhQE;EAAsC,gBAAA;AZ2hQxC;;AY3hQE;EAAsC,gBAAA;AZ+hQxC;;AY/hQE;EAAsC,gBAAA;AZmiQxC;;AYniQE;EAAsC,gBAAA;AZuiQxC;;AYviQE;EAAsC,gBAAA;AZ2iQxC;;Aa9iQA;;ETqBE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AJ8hQF;;AIzhQE;;EAbA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AJ2iQF;;Ac5kQA;;;;EAAA;AAQA;EACE,4DAAA;EACA,mEAAA;Ad4kQF;;AcxkQA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBR6BgB;EQ5BhB,wHAAA;Ad2kQF;AcvkQA;;EAEE,gBAAA;AdykQF;;AelmQA;;;;EAAA;AAQA;EACE,4DAAA;EACA,qEAAA;AfkmQF;;Ae9lQA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBT6BgB;ES5BhB,wHAAA;AfimQF;Ae7lQA;;EAEE,gBAAA;Af+lQF;;AgB/mQE;ECoHA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;AjB+/PF;AiBhoQE;EAEE,gBAAA;AjBioQJ;AiB9nQQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yJAAA;EAQA,SAAA;EACA,UAAA;EACA,UAAA;EACA,+CACE;AjBwnQZ;AiBjnQQ;EACE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,4JAAA;EAQA,SAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;AjB4mQV;AiBtmQQ;EACE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yJAAA;EAQA,SAAA;EACA,UAAA;EACA,UAAA;EACA,+CACE;AjBgmQZ;AiB3lQQ;EACE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,4JAAA;EAQA,SAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;AjBslQV;AiBjlQM;EACE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,qCAAA;EACA,8IAAA;EAOA,OAAA;EACA,SAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AjB6kQR;AiBhkQE;EAGE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,UAAA;EACA,iEAAA;EACA,6EC3IY;ED4IZ,WAAA;AjBgkQJ;AiB/jQI;EAGE,aAAA;EACA,mBAAA;EACA,oBAAA;AjB+jQN;AiB7jQI;EACE,YAAA;AjB+jQN;AiB5jQE;EACE,eAAA;EACA,MAAA;AjB8jQJ;AiB5jQE;EACE,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;AjB8jQJ;AiB5jQE;EAEE,UAAA;AjB6jQJ;;AiBvjQI;;EACE,UAAA;AjB2jQN;AiBtjQM;;EACE,YAAA;EACA,gBAAA;EACA,UAAA;AjByjQR;AiBnjQM;;EACE,YAAA;EACA,gBAAA;EACA,UAAA;AjBsjQR;AiBhjQM;;EACE,YAAA;EACA,gBAAA;EACA,UAAA;AjBmjQR;AiB/iQM;;EACE,YAAA;EACA,gBAAA;EACA,UAAA;AjBkjQR;;AiB7iQA;EACE,WAAA;AjBgjQF;;AgBvwQE;;EC4NE,UAAA;AjBgjQJ;;AgB5wQE;ECiOA,gBAAA;EACA,YAAA;EACA,6ECrOc;EDsOd,eAAA;EACA,cAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA;;;;IAAA;AjBmjQF;;AgB5xQE;ECiPE,eAAA;EACA,iBAAA;AjB+iQJ;;AgBjyQE;;ECyPI,eAAA;EACA,YAAA;AjB6iQN;;AgBvyQE;ECsQA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AjBqiQF;AiBxjQE;EACE,sDAAA;AjB0jQJ;AiBxjQE;EACE,aAAA;AjB0jQJ;AiB1iQE;EACE,UAAA;AjB4iQJ;AgBj0QE;ECwRE,aAAA;AjB4iQJ;AgBp0QE;EC2RE,aAAA;AjB4iQJ;AiB1iQE;EACE,kBAAA;AjB4iQJ;AgB10QE;ECgSI,cAAA;EACA,kBAAA;AjB6iQN;AgB90QE;ECmSM,aAAA;AjB8iQR;AgBj1QE;ECwSE,aAAA;EACA,uBAAA;AjB4iQJ;AgBr1QE;EC6SI,sDAAA;EACA,wBAAA;AjB2iQN;AgBz1QE;ECkTM,0BAAA;AjB0iQR;;AgB51QE;ECwTA,eAAA;AjBwiQF;;AmBr2QE;EACE,WAAA;AnBw2QJ;AgBp2QE;EGFI,sDAAA;EACA,wBAAA;AnBy2QN;;AgBx2QE;EGME,eAAA;EACA,iBAAA;AnBs2QJ;AmBr2QI;EACE,qCAAA;AnBu2QN;AgBh3QE;EGYI,WAAA;AnBu2QN;AgBn3QE;EGeI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;AnBu2QN;AgB53QE;EGuBM,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;AnBw2QR;AgBt4QE;EGgCQ,kBAAA;AnBy2QV;AgBz4QE;EGqCI,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA;;;GAAA;AnB02QN;AmBt2QM;EACE,0BAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AnBw2QR;AmBt2QM;EACE,gBAAA;AnBw2QR;AgBh6QE;EG2DM,eAAA;AnBw2QR;;AmBj2QI;EACE,gBAAA;AnBo2QN;AgBv6QE;EGwEI,wBAAA;AnBk2QN;AgB16QE;EG4EM,cAAA;AnBi2QR;AmB/1QM;EACE,UAAA;AnBi2QR;AmBh2QQ;EACE,gBAAA;AnBk2QV;;AgBn7QE;EGwFA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kGACE;EAGF,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,qEDzGW;EC0GX,UAAA;AnB41QF;AmB11QE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AnB41QJ;AmB11QE;EACE,aAAA;AnB41QJ;AmB11QE;EACE,gDAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AnB41QJ;AmB31QI;EACE,aAAA;AnB61QN;AmB31QI;EACE,YAAA;AnB61QN;AmB31QI;EACE,qCAAA;AnB61QN;AmB31QI;EACE,oCAAA;EACA,iBAAA;AnB61QN;;AgBj+QE;EGyIA,aAAA;AnB41QF;AgBr+QE;EG4IE,aAAA;EACA,UAAA;EACA,wBAAA;EACA,6CAAA;EACA,gBAAA;EACA,gBAAA;AnB41QJ;AmB31QI;EACE,gBAAA;AnB61QN;AmB31QI;EACE,UAAA;AnB61QN;AmB11QI;EACE,yBDhKY;ECiKZ,kBAAA;AnB41QN;AmBz1QI;EACE,yBAAA;EACA,kBAAA;AnB21QN;AmBx1QI;EACE,yBAAA;AnB01QN;AgB9/QE;EGwKE,aAAA;AnBy1QJ;AgBjgRE;EG8KM,aAAA;EACA,UAAA;EACA,wBAAA;EACA,kBAAA;EACA,iEACE;EAEF,cAAA;AnBo1QR;;AgBzgRE;EG6LE,2BAAA;EACA,SAAA;AnBg1QJ;;AgB9gRE;;EGqME,OAAA;EACA,cAAA;AnB80QJ;;AgBphRE;;EG8MM,8BAAA;AnB20QR;AgBzhRE;;EGmNM,0BAAA;AnB00QR;;AgB7hRE;EG0NE,eAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AnBu0QJ;AmBt0QI;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,UAAA;EACA,oCAAA;AnBw0QN;AmBt0QI;EACE,eAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,gBAAA;AnBw0QN;AmBt0QI;EACE,iBAAA;EACA,gBAAA;AnBw0QN;AgB1kRE;EGsQM,UAAA;EACA,gBAAA;AnBu0QR;AgB9kRE;EG0QQ,YAAA;AnBu0QV;AmBp0QU;EACE,aAAA;AnBs0QZ;AmBp0QU;EACE,YAAA;EACA,SAAA;AnBs0QZ;AmBj0QQ;EACE,gBAAA;AnBm0QV;AgB3lRE;EG4RM,YAAA;EACA,iBAAA;EACA,iBAAA;AnBk0QR;AmB5zQM;EACE,UAAA;AnB8zQR;;AgBnmRE;EILA,aAAA;EACA,mBAAA;ApB4mRF;AoB3mRE;EACE,kBAAA;EACA,qBAAA;ApB6mRJ;AoB3mRE;EACE,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,wFFXgB;EEYhB,kBAAA;EACA,UAAA;EACA,sCAAA;EACA,gEACE;ApB4mRN;AoBvmRE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,iIAAA;EAQA,yFACE;ApBkmRN;AoB9lRI;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;ApBgmRN;AoB9lRI;EACE,UAAA;EACA,WAAA;EACA,UAAA;EACA,+HAAA;EAQA,0FACE;ApBylRR;AoBtlRM;EACE,kBAAA;EACA,SAAA;EACA,+BAAA;EACA,+BAAA;EACA,YAAA;ApBwlRR;AoBnlRI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;ApBqlRN;AoBnlRI;EACE,YAAA;ApBqlRN;AoBplRM;EACE,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;ApBslRR;AoBllRE;EACE,2CFlGW;AlBsrRf;AoBnlRI;EACE,2CFpGS;AlByrRf;AgBprRE;EIkGI,gBAAA;ApBqlRN;;AgBvrRE;;EIyGE,2BAAA;ApBmlRJ;;AgB5rRE;EKLA,aAAA;ArBqsRF;;AgBhsRE;EMLA,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;EACA,eAAA;AtBysRF;AsBvsRE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mDAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;AtBysRJ;AsBvsRI;EACE,+CAAA;AtBysRN;AsBtsRE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AtBwsRJ;AsBtsRE;EACE,kBAAA;EACA,YAAA;EACA,wFJnCgB;EIoChB,kBAAA;EACA,UAAA;EACA,uBAAA;AtBwsRJ;AsBrsRE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,wFJhDgB;EIiDhB,kBAAA;EACA,UAAA;EACA,sCAAA;EACA,gEACE;EAGF,UAAA;AtBosRJ;AsBlsRE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,gEACE;AtBmsRN;AsB/rRE;EAEE,UAAA;AtBgsRJ;AsB7rRE;EACE,QAAA;EACA,SAAA;EACA,UAAA;AtB+rRJ;AsB5rRE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,UAAA;EACA,oBAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CJjGY;EIkGZ,mDAAA;AtB8rRJ;AsB3rRE;EACE,kBAAA;EACA,OAAA;EACA,UAAA;AtB6rRJ;AsB3rRE;EACE,eAAA;EACA,gBAAA;AtB6rRJ;AgBlyRE;EMuGI,YAAA;AtB8rRN;AsB3rRE;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;AtB6rRJ;AgB7yRE;EMkHI,gBAAA;AtB8rRN;AgBhzRE;EMsHI,gBAAA;AtB6rRN;AgBnzRE;EM0HI,gBAAA;AtB4rRN;;AgBtzRE;EOLA,eAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA;;IAAA;AvBi0RF;AuB9zRE;EACE,eAAA;EACA,cAAA;AvBg0RJ;;AgBr0RE;EQJE,qBAAA;AxB60RJ;;AgBz0RE;ESLA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,4CAAA;EACA,YAAA;EACA,WAAA;EACA,6EPHc;EOId,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AzBk1RF;AyBh1RE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kFPrBY;EOsBZ,YAAA;AzBk1RJ;AyBh1RE;;EAEE,WAAA;EACA,YAAA;AzBk1RJ;AyBh1RE;EACE,aAAA;AzBk1RJ;AgB92RE;ES+BE,eAAA;EACA,2CAAA;EACA,oBAAA;AzBk1RJ;AgBn3RE;ESmCI,cAAA;EACA,eAAA;EACA,2CAAA;AzBm1RN;AgBx3RE;ESwCM,aAAA;AzBm1RR;AyB/0RE;EAEE,UAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,aAAA;AzBg1RJ;AgBt4RE;ESwDI,aAAA;EACA,mBAAA;EACA,eAAA;AzBi1RN;AgB34RE;ES4DM,kBAAA;AzBk1RR;AyB90RE;EACE,aAAA;EACA,WAAA;AzBg1RJ;AyB90RE;EAKE,iEAAA;AzB40RJ;AgBr5RE;ESsEI,yBAAA;EACA,gBAAA;AzBk1RN;AgBz5RE;ES6EI,UAAA;EACA,gBAAA;EACA,4BAAA;AzB+0RN;AyB50RE;EACE,UAAA;AzB80RJ;;AgBj6RE;EULA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,4CAAA;EACA,YAAA;EACA,WAAA;EACA,2CRRc;EQSd,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,2CAAA;A1B06RF;;AgBt7RE;EWLA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,4CAAA;EACA,eAAA;EACA,gBAAA;EACA,wFTKmB;ESJnB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,2CAAA;A3B+7RF;A2B77RE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,2DTpBuB;ESqBvB,YAAA;A3B+7RJ;A2B77RE;EACE,aAAA;EACA,eAAA;A3B+7RJ;;AgBz9RE;EW+BE,aAAA;A3B87RJ;;AgB79RE;EYLA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,6EVHc;EUId,aAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,0DAAA;EACA,oBAAA;EACA,wBAAA;EACA,mCAAA;EACA,6CAAA;A5Bs+RF;A4Br+RE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,2DVvBuB;EUwBvB,YAAA;A5Bu+RJ;;AgBhgSE;EaRA,kBAAA;EACA,aAAA;EACA,aAAA;A7B4gSF;;AgBtgSE;EaHA,kBAAA;EACA,6CAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,8BAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;A7B6gSF;A6B5gSE;EACE,SAAA;EACA,2CAAA;A7B8gSJ;A6B3gSE;EACE,aAAA;EACA,UAAA;EACA,yCAAA;A7B6gSJ;A6B1gSE;EACE,SAAA;EACA,yCAAA;A7B4gSJ;A6B1gSE;EACE,YAAA;A7B4gSJ;A6B1gSE;EACE,SAAA;EACA,eAAA;A7B4gSJ;A6B1gSE;EACE,UAAA;A7B4gSJ;A6BzgSE;EACE,UAAA;A7B2gSJ;;A8BxjSE;EACE,8GZca;EYbb,oFZQmB;EYPnB,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;A9B2jSJ;A8BzjSI;EACE,8GZMW;EYLX,uBAAA;A9B2jSN;;AgBhkSE;EeLA,sEbIY;AlBqkSd;;AgBpkSE;EgBLA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;AhC6kSF;AgC5kSE;EACE,WAAA;EACA;mBAAA;EAEA,YAAA;EACA,cAAA;EACA,cAAA;AhC8kSJ;;AgBtlSE;EiBLA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,6BAAA;EACA,sBAAA;EACA,4BAAA;EACA,4BAAA;AjC+lSF;;AAplSA;;;;;;;CAAA;AgBlBE;EhB4BA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qFAAA;AAslSF;AAplSE;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAslSJ;AAplSE;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA;;GAAA;AAwlSJ;AAplSE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AAslSJ;AArlSI;EACE,YAAA;AAulSN;AAplSE;EACE,iBAAA;AAslSJ;AArlSI;EACE,iBAAA;EACA,YAAA;AAulSN;AAplSE;EACE,mBAAA;AAslSJ;AAnlSE;EACE,YAAA;AAqlSJ;AgB5pSE;EhByEI,6BAAA;EACA,UAAA;AAslSN","sourcesContent":["@keyframes iconPulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes notificationAction {\n  0% {\n    opacity: 0.4;\n    transform: translate(-50%, -50%) scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: translate(-50%, -50%) scale(1.2);\n  }\n  100% {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(0);\n  }\n}\n","@import './utils/variables';\n@import './utils/mixins';\n@import './utils/functions';\n@import './utils/animation';\n\n@import './fontawesome/fontawesome';\n@import './fontawesome/solid';\n@import './fontawesome/regular';\n\n@import './components/play';\n@import './components/controls';\n@import './components/submenu.scss';\n@import './components/volume';\n@import './components/quality';\n@import './components/progressbar';\n@import './components/timeInfo';\n@import './components/pip';\n@import './components/bigbutton';\n@import './components/loading';\n@import './components/error';\n@import './components/notification';\n@import './components/tooltip';\n@import './components/cta';\n@import './components/title';\n@import './components/logo';\n@import './components/poster';\n\n/*\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: Verdana, sans-serif;\n}\n*/\n\n@include prefix('player') {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  user-select: none;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto,\n    Ubuntu;\n  &-inner {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    height: 100%;\n    overflow: hidden;\n  }\n  video {\n    width: 100%;\n    display: block;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    /*background: $primary-color; \n    that doesn't work when video height is inferior to the container height\n    */\n  }\n  &-background {\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    video {\n      height: 100%;\n    }\n  }\n  &-fit-cover {\n    object-fit: cover;\n    video {\n      object-fit: cover;\n      height: 100%;\n    }\n  }\n  &-fit-contain {\n    object-fit: contain;\n  }\n\n  &-inactivity {\n    cursor: none;\n    @include prefix('player-controls') {\n      transition: opacity 0.2s ease;\n      opacity: 0;\n    }\n  }\n}\n","/*!\n * Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n// Font Awesome core compile (Web Fonts-based)\n// -------------------------\n\n@import 'functions';\n@import 'variables';\n@import 'mixins';\n@import 'core';\n@import 'sizing';\n@import 'fixed-width';\n@import 'list';\n@import 'bordered-pulled';\n@import 'animated';\n@import 'rotated-flipped';\n@import 'stacked';\n@import 'icons';\n@import 'screen-reader';\n","// base icon class definition\n// -------------------------\n\n.#{$fa-css-prefix} {\n  font-family: var(--#{$fa-css-prefix}-style-family, '#{$fa-style-family}');\n  font-weight: var(--#{$fa-css-prefix}-style, #{$fa-style});\n}\n\n.#{$fa-css-prefix}-solid,\n.#{$fa-css-prefix}-regular,\n.#{$fa-css-prefix}-brands,\n.fas,\n.far,\n.fab,\n.#{$fa-css-prefix}-sharp-solid,\n.#{$fa-css-prefix}-classic,\n.#{$fa-css-prefix} {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: var(--#{$fa-css-prefix}-display, #{$fa-display});\n  font-style: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-rendering: auto;\n}\n\n.fas,\n.#{$fa-css-prefix}-classic,\n.#{$fa-css-prefix}-solid,\n.far,\n.#{$fa-css-prefix}-regular {\n  font-family: 'Font Awesome 6 Free';\n}\n\n.fab,\n.#{$fa-css-prefix}-brands {\n  font-family: 'Font Awesome 6 Brands';\n}\n\n\n%fa-icon {\n  @include fa-icon;\n}\n","// sizing icons\n// -------------------------\n\n// literal magnification scale\n@for $i from 1 through 10 {\n  .#{$fa-css-prefix}-#{$i}x {\n    font-size: $i * 1em;\n  }\n}\n\n// step-based scale (with alignment)\n@each $size, $value in $fa-sizes {\n  .#{$fa-css-prefix}-#{$size} {\n     @include fa-size($value);\n  }\n}\n","// mixins\n// --------------------------\n\n// base rendering for an icon\n@mixin fa-icon {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  line-height: 1;\n}\n\n// sets relative font-sizing and alignment (in _sizing)\n@mixin fa-size ($font-size) {\n  font-size: fa-divide($font-size, $fa-size-scale-base) * 1em; // converts step in sizing scale into an em-based value that's relative to the scale's base\n  line-height: fa-divide(1, $font-size) * 1em; // sets the line-height of the icon back to that of it's parent\n  vertical-align: (fa-divide(6, $font-size) - fa-divide(3, 8)) * 1em; // vertically centers the icon taking into account the surrounding text's descender\n}\n\n// only display content to screen readers\n// see: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// see: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n@mixin fa-sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n@mixin fa-sr-only-focusable() {\n  &:not(:focus) {\n    @include fa-sr-only();\n  }\n}\n\n// sets a specific icon family to use alongside style + icon mixins\n\n// convenience mixins for declaring pseudo-elements by CSS variable,\n// including all style-specific font properties, and both the ::before\n// and ::after elements in the duotone case.\n@mixin fa-icon-solid($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-solid;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n@mixin fa-icon-regular($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-regular;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n@mixin fa-icon-brands($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-brands;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n","// fixed-width icons\n// -------------------------\n\n.#{$fa-css-prefix}-fw {\n  text-align: center;\n  width: $fa-fw-width;\n}\n","// variables\n// --------------------------\n\n$fa-css-prefix: blastream-icon !default;\n$fa-style: 900 !default;\n$fa-style-family: 'Font Awesome 6 Free' !default;\n\n$fa-display: inline-block !default;\n\n$fa-fw-width: fa-divide(20em, 16) !default;\n$fa-inverse: #fff !default;\n\n$fa-border-color: #eee !default;\n$fa-border-padding: 0.2em 0.25em 0.15em !default;\n$fa-border-radius: 0.1em !default;\n$fa-border-style: solid !default;\n$fa-border-width: 0.08em !default;\n\n$fa-size-scale-2xs: 10 !default;\n$fa-size-scale-xs: 12 !default;\n$fa-size-scale-sm: 14 !default;\n$fa-size-scale-base: 16 !default;\n$fa-size-scale-lg: 20 !default;\n$fa-size-scale-xl: 24 !default;\n$fa-size-scale-2xl: 32 !default;\n\n$fa-sizes: (\n  '2xs': $fa-size-scale-2xs,\n  'xs': $fa-size-scale-xs,\n  'sm': $fa-size-scale-sm,\n  'lg': $fa-size-scale-lg,\n  'xl': $fa-size-scale-xl,\n  '2xl': $fa-size-scale-2xl,\n) !default;\n\n$fa-li-width: 2em !default;\n$fa-li-margin: $fa-li-width * fa-divide(5, 4) !default;\n\n$fa-pull-margin: 0.3em !default;\n\n$fa-primary-opacity: 1 !default;\n$fa-secondary-opacity: 0.4 !default;\n\n$fa-stack-vertical-align: middle !default;\n$fa-stack-width: ($fa-fw-width * 2) !default;\n$fa-stack-z-index: auto !default;\n\n$fa-font-display: block !default;\n\n$fa-font-path: '../webfonts' !default;\n\n$fa-var-0: \\30;\n$fa-var-1: \\31;\n$fa-var-2: \\32;\n$fa-var-3: \\33;\n$fa-var-4: \\34;\n$fa-var-5: \\35;\n$fa-var-6: \\36;\n$fa-var-7: \\37;\n$fa-var-8: \\38;\n$fa-var-9: \\39;\n$fa-var-fill-drip: \\f576;\n$fa-var-arrows-to-circle: \\e4bd;\n$fa-var-circle-chevron-right: \\f138;\n$fa-var-chevron-circle-right: \\f138;\n$fa-var-at: \\40;\n$fa-var-trash-can: \\f2ed;\n$fa-var-trash-alt: \\f2ed;\n$fa-var-text-height: \\f034;\n$fa-var-user-xmark: \\f235;\n$fa-var-user-times: \\f235;\n$fa-var-stethoscope: \\f0f1;\n$fa-var-message: \\f27a;\n$fa-var-comment-alt: \\f27a;\n$fa-var-info: \\f129;\n$fa-var-down-left-and-up-right-to-center: \\f422;\n$fa-var-compress-alt: \\f422;\n$fa-var-explosion: \\e4e9;\n$fa-var-file-lines: \\f15c;\n$fa-var-file-alt: \\f15c;\n$fa-var-file-text: \\f15c;\n$fa-var-wave-square: \\f83e;\n$fa-var-ring: \\f70b;\n$fa-var-building-un: \\e4d9;\n$fa-var-dice-three: \\f527;\n$fa-var-calendar-days: \\f073;\n$fa-var-calendar-alt: \\f073;\n$fa-var-anchor-circle-check: \\e4aa;\n$fa-var-building-circle-arrow-right: \\e4d1;\n$fa-var-volleyball: \\f45f;\n$fa-var-volleyball-ball: \\f45f;\n$fa-var-arrows-up-to-line: \\e4c2;\n$fa-var-sort-down: \\f0dd;\n$fa-var-sort-desc: \\f0dd;\n$fa-var-circle-minus: \\f056;\n$fa-var-minus-circle: \\f056;\n$fa-var-door-open: \\f52b;\n$fa-var-right-from-bracket: \\f2f5;\n$fa-var-sign-out-alt: \\f2f5;\n$fa-var-atom: \\f5d2;\n$fa-var-soap: \\e06e;\n$fa-var-icons: \\f86d;\n$fa-var-heart-music-camera-bolt: \\f86d;\n$fa-var-microphone-lines-slash: \\f539;\n$fa-var-microphone-alt-slash: \\f539;\n$fa-var-bridge-circle-check: \\e4c9;\n$fa-var-pump-medical: \\e06a;\n$fa-var-fingerprint: \\f577;\n$fa-var-hand-point-right: \\f0a4;\n$fa-var-magnifying-glass-location: \\f689;\n$fa-var-search-location: \\f689;\n$fa-var-forward-step: \\f051;\n$fa-var-step-forward: \\f051;\n$fa-var-face-smile-beam: \\f5b8;\n$fa-var-smile-beam: \\f5b8;\n$fa-var-flag-checkered: \\f11e;\n$fa-var-football: \\f44e;\n$fa-var-football-ball: \\f44e;\n$fa-var-school-circle-exclamation: \\e56c;\n$fa-var-crop: \\f125;\n$fa-var-angles-down: \\f103;\n$fa-var-angle-double-down: \\f103;\n$fa-var-users-rectangle: \\e594;\n$fa-var-people-roof: \\e537;\n$fa-var-people-line: \\e534;\n$fa-var-beer-mug-empty: \\f0fc;\n$fa-var-beer: \\f0fc;\n$fa-var-diagram-predecessor: \\e477;\n$fa-var-arrow-up-long: \\f176;\n$fa-var-long-arrow-up: \\f176;\n$fa-var-fire-flame-simple: \\f46a;\n$fa-var-burn: \\f46a;\n$fa-var-person: \\f183;\n$fa-var-male: \\f183;\n$fa-var-laptop: \\f109;\n$fa-var-file-csv: \\f6dd;\n$fa-var-menorah: \\f676;\n$fa-var-truck-plane: \\e58f;\n$fa-var-record-vinyl: \\f8d9;\n$fa-var-face-grin-stars: \\f587;\n$fa-var-grin-stars: \\f587;\n$fa-var-bong: \\f55c;\n$fa-var-spaghetti-monster-flying: \\f67b;\n$fa-var-pastafarianism: \\f67b;\n$fa-var-arrow-down-up-across-line: \\e4af;\n$fa-var-spoon: \\f2e5;\n$fa-var-utensil-spoon: \\f2e5;\n$fa-var-jar-wheat: \\e517;\n$fa-var-envelopes-bulk: \\f674;\n$fa-var-mail-bulk: \\f674;\n$fa-var-file-circle-exclamation: \\e4eb;\n$fa-var-circle-h: \\f47e;\n$fa-var-hospital-symbol: \\f47e;\n$fa-var-pager: \\f815;\n$fa-var-address-book: \\f2b9;\n$fa-var-contact-book: \\f2b9;\n$fa-var-strikethrough: \\f0cc;\n$fa-var-k: \\4b;\n$fa-var-landmark-flag: \\e51c;\n$fa-var-pencil: \\f303;\n$fa-var-pencil-alt: \\f303;\n$fa-var-backward: \\f04a;\n$fa-var-caret-right: \\f0da;\n$fa-var-comments: \\f086;\n$fa-var-paste: \\f0ea;\n$fa-var-file-clipboard: \\f0ea;\n$fa-var-code-pull-request: \\e13c;\n$fa-var-clipboard-list: \\f46d;\n$fa-var-truck-ramp-box: \\f4de;\n$fa-var-truck-loading: \\f4de;\n$fa-var-user-check: \\f4fc;\n$fa-var-vial-virus: \\e597;\n$fa-var-sheet-plastic: \\e571;\n$fa-var-blog: \\f781;\n$fa-var-user-ninja: \\f504;\n$fa-var-person-arrow-up-from-line: \\e539;\n$fa-var-scroll-torah: \\f6a0;\n$fa-var-torah: \\f6a0;\n$fa-var-broom-ball: \\f458;\n$fa-var-quidditch: \\f458;\n$fa-var-quidditch-broom-ball: \\f458;\n$fa-var-toggle-off: \\f204;\n$fa-var-box-archive: \\f187;\n$fa-var-archive: \\f187;\n$fa-var-person-drowning: \\e545;\n$fa-var-arrow-down-9-1: \\f886;\n$fa-var-sort-numeric-desc: \\f886;\n$fa-var-sort-numeric-down-alt: \\f886;\n$fa-var-face-grin-tongue-squint: \\f58a;\n$fa-var-grin-tongue-squint: \\f58a;\n$fa-var-spray-can: \\f5bd;\n$fa-var-truck-monster: \\f63b;\n$fa-var-w: \\57;\n$fa-var-earth-africa: \\f57c;\n$fa-var-globe-africa: \\f57c;\n$fa-var-rainbow: \\f75b;\n$fa-var-circle-notch: \\f1ce;\n$fa-var-tablet-screen-button: \\f3fa;\n$fa-var-tablet-alt: \\f3fa;\n$fa-var-paw: \\f1b0;\n$fa-var-cloud: \\f0c2;\n$fa-var-trowel-bricks: \\e58a;\n$fa-var-face-flushed: \\f579;\n$fa-var-flushed: \\f579;\n$fa-var-hospital-user: \\f80d;\n$fa-var-tent-arrow-left-right: \\e57f;\n$fa-var-gavel: \\f0e3;\n$fa-var-legal: \\f0e3;\n$fa-var-binoculars: \\f1e5;\n$fa-var-microphone-slash: \\f131;\n$fa-var-box-tissue: \\e05b;\n$fa-var-motorcycle: \\f21c;\n$fa-var-bell-concierge: \\f562;\n$fa-var-concierge-bell: \\f562;\n$fa-var-pen-ruler: \\f5ae;\n$fa-var-pencil-ruler: \\f5ae;\n$fa-var-people-arrows: \\e068;\n$fa-var-people-arrows-left-right: \\e068;\n$fa-var-mars-and-venus-burst: \\e523;\n$fa-var-square-caret-right: \\f152;\n$fa-var-caret-square-right: \\f152;\n$fa-var-scissors: \\f0c4;\n$fa-var-cut: \\f0c4;\n$fa-var-sun-plant-wilt: \\e57a;\n$fa-var-toilets-portable: \\e584;\n$fa-var-hockey-puck: \\f453;\n$fa-var-table: \\f0ce;\n$fa-var-magnifying-glass-arrow-right: \\e521;\n$fa-var-tachograph-digital: \\f566;\n$fa-var-digital-tachograph: \\f566;\n$fa-var-users-slash: \\e073;\n$fa-var-clover: \\e139;\n$fa-var-reply: \\f3e5;\n$fa-var-mail-reply: \\f3e5;\n$fa-var-star-and-crescent: \\f699;\n$fa-var-house-fire: \\e50c;\n$fa-var-square-minus: \\f146;\n$fa-var-minus-square: \\f146;\n$fa-var-helicopter: \\f533;\n$fa-var-compass: \\f14e;\n$fa-var-square-caret-down: \\f150;\n$fa-var-caret-square-down: \\f150;\n$fa-var-file-circle-question: \\e4ef;\n$fa-var-laptop-code: \\f5fc;\n$fa-var-swatchbook: \\f5c3;\n$fa-var-prescription-bottle: \\f485;\n$fa-var-bars: \\f0c9;\n$fa-var-navicon: \\f0c9;\n$fa-var-people-group: \\e533;\n$fa-var-hourglass-end: \\f253;\n$fa-var-hourglass-3: \\f253;\n$fa-var-heart-crack: \\f7a9;\n$fa-var-heart-broken: \\f7a9;\n$fa-var-square-up-right: \\f360;\n$fa-var-external-link-square-alt: \\f360;\n$fa-var-face-kiss-beam: \\f597;\n$fa-var-kiss-beam: \\f597;\n$fa-var-film: \\f008;\n$fa-var-ruler-horizontal: \\f547;\n$fa-var-people-robbery: \\e536;\n$fa-var-lightbulb: \\f0eb;\n$fa-var-caret-left: \\f0d9;\n$fa-var-circle-exclamation: \\f06a;\n$fa-var-exclamation-circle: \\f06a;\n$fa-var-school-circle-xmark: \\e56d;\n$fa-var-arrow-right-from-bracket: \\f08b;\n$fa-var-sign-out: \\f08b;\n$fa-var-circle-chevron-down: \\f13a;\n$fa-var-chevron-circle-down: \\f13a;\n$fa-var-unlock-keyhole: \\f13e;\n$fa-var-unlock-alt: \\f13e;\n$fa-var-cloud-showers-heavy: \\f740;\n$fa-var-headphones-simple: \\f58f;\n$fa-var-headphones-alt: \\f58f;\n$fa-var-sitemap: \\f0e8;\n$fa-var-circle-dollar-to-slot: \\f4b9;\n$fa-var-donate: \\f4b9;\n$fa-var-memory: \\f538;\n$fa-var-road-spikes: \\e568;\n$fa-var-fire-burner: \\e4f1;\n$fa-var-flag: \\f024;\n$fa-var-hanukiah: \\f6e6;\n$fa-var-feather: \\f52d;\n$fa-var-volume-low: \\f027;\n$fa-var-volume-down: \\f027;\n$fa-var-comment-slash: \\f4b3;\n$fa-var-cloud-sun-rain: \\f743;\n$fa-var-compress: \\f066;\n$fa-var-wheat-awn: \\e2cd;\n$fa-var-wheat-alt: \\e2cd;\n$fa-var-ankh: \\f644;\n$fa-var-hands-holding-child: \\e4fa;\n$fa-var-asterisk: \\2a;\n$fa-var-square-check: \\f14a;\n$fa-var-check-square: \\f14a;\n$fa-var-peseta-sign: \\e221;\n$fa-var-heading: \\f1dc;\n$fa-var-header: \\f1dc;\n$fa-var-ghost: \\f6e2;\n$fa-var-list: \\f03a;\n$fa-var-list-squares: \\f03a;\n$fa-var-square-phone-flip: \\f87b;\n$fa-var-phone-square-alt: \\f87b;\n$fa-var-cart-plus: \\f217;\n$fa-var-gamepad: \\f11b;\n$fa-var-circle-dot: \\f192;\n$fa-var-dot-circle: \\f192;\n$fa-var-face-dizzy: \\f567;\n$fa-var-dizzy: \\f567;\n$fa-var-egg: \\f7fb;\n$fa-var-house-medical-circle-xmark: \\e513;\n$fa-var-campground: \\f6bb;\n$fa-var-folder-plus: \\f65e;\n$fa-var-futbol: \\f1e3;\n$fa-var-futbol-ball: \\f1e3;\n$fa-var-soccer-ball: \\f1e3;\n$fa-var-paintbrush: \\f1fc;\n$fa-var-paint-brush: \\f1fc;\n$fa-var-lock: \\f023;\n$fa-var-gas-pump: \\f52f;\n$fa-var-hot-tub-person: \\f593;\n$fa-var-hot-tub: \\f593;\n$fa-var-map-location: \\f59f;\n$fa-var-map-marked: \\f59f;\n$fa-var-house-flood-water: \\e50e;\n$fa-var-tree: \\f1bb;\n$fa-var-bridge-lock: \\e4cc;\n$fa-var-sack-dollar: \\f81d;\n$fa-var-pen-to-square: \\f044;\n$fa-var-edit: \\f044;\n$fa-var-car-side: \\f5e4;\n$fa-var-share-nodes: \\f1e0;\n$fa-var-share-alt: \\f1e0;\n$fa-var-heart-circle-minus: \\e4ff;\n$fa-var-hourglass-half: \\f252;\n$fa-var-hourglass-2: \\f252;\n$fa-var-microscope: \\f610;\n$fa-var-sink: \\e06d;\n$fa-var-bag-shopping: \\f290;\n$fa-var-shopping-bag: \\f290;\n$fa-var-arrow-down-z-a: \\f881;\n$fa-var-sort-alpha-desc: \\f881;\n$fa-var-sort-alpha-down-alt: \\f881;\n$fa-var-mitten: \\f7b5;\n$fa-var-person-rays: \\e54d;\n$fa-var-users: \\f0c0;\n$fa-var-eye-slash: \\f070;\n$fa-var-flask-vial: \\e4f3;\n$fa-var-hand: \\f256;\n$fa-var-hand-paper: \\f256;\n$fa-var-om: \\f679;\n$fa-var-worm: \\e599;\n$fa-var-house-circle-xmark: \\e50b;\n$fa-var-plug: \\f1e6;\n$fa-var-chevron-up: \\f077;\n$fa-var-hand-spock: \\f259;\n$fa-var-stopwatch: \\f2f2;\n$fa-var-face-kiss: \\f596;\n$fa-var-kiss: \\f596;\n$fa-var-bridge-circle-xmark: \\e4cb;\n$fa-var-face-grin-tongue: \\f589;\n$fa-var-grin-tongue: \\f589;\n$fa-var-chess-bishop: \\f43a;\n$fa-var-face-grin-wink: \\f58c;\n$fa-var-grin-wink: \\f58c;\n$fa-var-ear-deaf: \\f2a4;\n$fa-var-deaf: \\f2a4;\n$fa-var-deafness: \\f2a4;\n$fa-var-hard-of-hearing: \\f2a4;\n$fa-var-road-circle-check: \\e564;\n$fa-var-dice-five: \\f523;\n$fa-var-square-rss: \\f143;\n$fa-var-rss-square: \\f143;\n$fa-var-land-mine-on: \\e51b;\n$fa-var-i-cursor: \\f246;\n$fa-var-stamp: \\f5bf;\n$fa-var-stairs: \\e289;\n$fa-var-i: \\49;\n$fa-var-hryvnia-sign: \\f6f2;\n$fa-var-hryvnia: \\f6f2;\n$fa-var-pills: \\f484;\n$fa-var-face-grin-wide: \\f581;\n$fa-var-grin-alt: \\f581;\n$fa-var-tooth: \\f5c9;\n$fa-var-v: \\56;\n$fa-var-bangladeshi-taka-sign: \\e2e6;\n$fa-var-bicycle: \\f206;\n$fa-var-staff-snake: \\e579;\n$fa-var-rod-asclepius: \\e579;\n$fa-var-rod-snake: \\e579;\n$fa-var-staff-aesculapius: \\e579;\n$fa-var-head-side-cough-slash: \\e062;\n$fa-var-truck-medical: \\f0f9;\n$fa-var-ambulance: \\f0f9;\n$fa-var-wheat-awn-circle-exclamation: \\e598;\n$fa-var-snowman: \\f7d0;\n$fa-var-mortar-pestle: \\f5a7;\n$fa-var-road-barrier: \\e562;\n$fa-var-school: \\f549;\n$fa-var-igloo: \\f7ae;\n$fa-var-joint: \\f595;\n$fa-var-angle-right: \\f105;\n$fa-var-horse: \\f6f0;\n$fa-var-q: \\51;\n$fa-var-g: \\47;\n$fa-var-notes-medical: \\f481;\n$fa-var-temperature-half: \\f2c9;\n$fa-var-temperature-2: \\f2c9;\n$fa-var-thermometer-2: \\f2c9;\n$fa-var-thermometer-half: \\f2c9;\n$fa-var-dong-sign: \\e169;\n$fa-var-capsules: \\f46b;\n$fa-var-poo-storm: \\f75a;\n$fa-var-poo-bolt: \\f75a;\n$fa-var-face-frown-open: \\f57a;\n$fa-var-frown-open: \\f57a;\n$fa-var-hand-point-up: \\f0a6;\n$fa-var-money-bill: \\f0d6;\n$fa-var-bookmark: \\f02e;\n$fa-var-align-justify: \\f039;\n$fa-var-umbrella-beach: \\f5ca;\n$fa-var-helmet-un: \\e503;\n$fa-var-bullseye: \\f140;\n$fa-var-bacon: \\f7e5;\n$fa-var-hand-point-down: \\f0a7;\n$fa-var-arrow-up-from-bracket: \\e09a;\n$fa-var-folder: \\f07b;\n$fa-var-folder-blank: \\f07b;\n$fa-var-file-waveform: \\f478;\n$fa-var-file-medical-alt: \\f478;\n$fa-var-radiation: \\f7b9;\n$fa-var-chart-simple: \\e473;\n$fa-var-mars-stroke: \\f229;\n$fa-var-vial: \\f492;\n$fa-var-gauge: \\f624;\n$fa-var-dashboard: \\f624;\n$fa-var-gauge-med: \\f624;\n$fa-var-tachometer-alt-average: \\f624;\n$fa-var-wand-magic-sparkles: \\e2ca;\n$fa-var-magic-wand-sparkles: \\e2ca;\n$fa-var-e: \\45;\n$fa-var-pen-clip: \\f305;\n$fa-var-pen-alt: \\f305;\n$fa-var-bridge-circle-exclamation: \\e4ca;\n$fa-var-user: \\f007;\n$fa-var-school-circle-check: \\e56b;\n$fa-var-dumpster: \\f793;\n$fa-var-van-shuttle: \\f5b6;\n$fa-var-shuttle-van: \\f5b6;\n$fa-var-building-user: \\e4da;\n$fa-var-square-caret-left: \\f191;\n$fa-var-caret-square-left: \\f191;\n$fa-var-highlighter: \\f591;\n$fa-var-key: \\f084;\n$fa-var-bullhorn: \\f0a1;\n$fa-var-globe: \\f0ac;\n$fa-var-synagogue: \\f69b;\n$fa-var-person-half-dress: \\e548;\n$fa-var-road-bridge: \\e563;\n$fa-var-location-arrow: \\f124;\n$fa-var-c: \\43;\n$fa-var-tablet-button: \\f10a;\n$fa-var-building-lock: \\e4d6;\n$fa-var-pizza-slice: \\f818;\n$fa-var-money-bill-wave: \\f53a;\n$fa-var-chart-area: \\f1fe;\n$fa-var-area-chart: \\f1fe;\n$fa-var-house-flag: \\e50d;\n$fa-var-person-circle-minus: \\e540;\n$fa-var-ban: \\f05e;\n$fa-var-cancel: \\f05e;\n$fa-var-camera-rotate: \\e0d8;\n$fa-var-spray-can-sparkles: \\f5d0;\n$fa-var-air-freshener: \\f5d0;\n$fa-var-star: \\f005;\n$fa-var-repeat: \\f363;\n$fa-var-cross: \\f654;\n$fa-var-box: \\f466;\n$fa-var-venus-mars: \\f228;\n$fa-var-arrow-pointer: \\f245;\n$fa-var-mouse-pointer: \\f245;\n$fa-var-maximize: \\f31e;\n$fa-var-expand-arrows-alt: \\f31e;\n$fa-var-charging-station: \\f5e7;\n$fa-var-shapes: \\f61f;\n$fa-var-triangle-circle-square: \\f61f;\n$fa-var-shuffle: \\f074;\n$fa-var-random: \\f074;\n$fa-var-person-running: \\f70c;\n$fa-var-running: \\f70c;\n$fa-var-mobile-retro: \\e527;\n$fa-var-grip-lines-vertical: \\f7a5;\n$fa-var-spider: \\f717;\n$fa-var-hands-bound: \\e4f9;\n$fa-var-file-invoice-dollar: \\f571;\n$fa-var-plane-circle-exclamation: \\e556;\n$fa-var-x-ray: \\f497;\n$fa-var-spell-check: \\f891;\n$fa-var-slash: \\f715;\n$fa-var-computer-mouse: \\f8cc;\n$fa-var-mouse: \\f8cc;\n$fa-var-arrow-right-to-bracket: \\f090;\n$fa-var-sign-in: \\f090;\n$fa-var-shop-slash: \\e070;\n$fa-var-store-alt-slash: \\e070;\n$fa-var-server: \\f233;\n$fa-var-virus-covid-slash: \\e4a9;\n$fa-var-shop-lock: \\e4a5;\n$fa-var-hourglass-start: \\f251;\n$fa-var-hourglass-1: \\f251;\n$fa-var-blender-phone: \\f6b6;\n$fa-var-building-wheat: \\e4db;\n$fa-var-person-breastfeeding: \\e53a;\n$fa-var-right-to-bracket: \\f2f6;\n$fa-var-sign-in-alt: \\f2f6;\n$fa-var-venus: \\f221;\n$fa-var-passport: \\f5ab;\n$fa-var-thumbtack-slash: \\e68f;\n$fa-var-thumb-tack-slash: \\e68f;\n$fa-var-heart-pulse: \\f21e;\n$fa-var-heartbeat: \\f21e;\n$fa-var-people-carry-box: \\f4ce;\n$fa-var-people-carry: \\f4ce;\n$fa-var-temperature-high: \\f769;\n$fa-var-microchip: \\f2db;\n$fa-var-crown: \\f521;\n$fa-var-weight-hanging: \\f5cd;\n$fa-var-xmarks-lines: \\e59a;\n$fa-var-file-prescription: \\f572;\n$fa-var-weight-scale: \\f496;\n$fa-var-weight: \\f496;\n$fa-var-user-group: \\f500;\n$fa-var-user-friends: \\f500;\n$fa-var-arrow-up-a-z: \\f15e;\n$fa-var-sort-alpha-up: \\f15e;\n$fa-var-chess-knight: \\f441;\n$fa-var-face-laugh-squint: \\f59b;\n$fa-var-laugh-squint: \\f59b;\n$fa-var-wheelchair: \\f193;\n$fa-var-circle-arrow-up: \\f0aa;\n$fa-var-arrow-circle-up: \\f0aa;\n$fa-var-toggle-on: \\f205;\n$fa-var-person-walking: \\f554;\n$fa-var-walking: \\f554;\n$fa-var-l: \\4c;\n$fa-var-fire: \\f06d;\n$fa-var-bed-pulse: \\f487;\n$fa-var-procedures: \\f487;\n$fa-var-shuttle-space: \\f197;\n$fa-var-space-shuttle: \\f197;\n$fa-var-face-laugh: \\f599;\n$fa-var-laugh: \\f599;\n$fa-var-folder-open: \\f07c;\n$fa-var-heart-circle-plus: \\e500;\n$fa-var-code-fork: \\e13b;\n$fa-var-city: \\f64f;\n$fa-var-microphone-lines: \\f3c9;\n$fa-var-microphone-alt: \\f3c9;\n$fa-var-pepper-hot: \\f816;\n$fa-var-unlock: \\f09c;\n$fa-var-colon-sign: \\e140;\n$fa-var-headset: \\f590;\n$fa-var-store-slash: \\e071;\n$fa-var-road-circle-xmark: \\e566;\n$fa-var-user-minus: \\f503;\n$fa-var-mars-stroke-up: \\f22a;\n$fa-var-mars-stroke-v: \\f22a;\n$fa-var-champagne-glasses: \\f79f;\n$fa-var-glass-cheers: \\f79f;\n$fa-var-clipboard: \\f328;\n$fa-var-house-circle-exclamation: \\e50a;\n$fa-var-file-arrow-up: \\f574;\n$fa-var-file-upload: \\f574;\n$fa-var-wifi: \\f1eb;\n$fa-var-wifi-3: \\f1eb;\n$fa-var-wifi-strong: \\f1eb;\n$fa-var-bath: \\f2cd;\n$fa-var-bathtub: \\f2cd;\n$fa-var-underline: \\f0cd;\n$fa-var-user-pen: \\f4ff;\n$fa-var-user-edit: \\f4ff;\n$fa-var-signature: \\f5b7;\n$fa-var-stroopwafel: \\f551;\n$fa-var-bold: \\f032;\n$fa-var-anchor-lock: \\e4ad;\n$fa-var-building-ngo: \\e4d7;\n$fa-var-manat-sign: \\e1d5;\n$fa-var-not-equal: \\f53e;\n$fa-var-border-top-left: \\f853;\n$fa-var-border-style: \\f853;\n$fa-var-map-location-dot: \\f5a0;\n$fa-var-map-marked-alt: \\f5a0;\n$fa-var-jedi: \\f669;\n$fa-var-square-poll-vertical: \\f681;\n$fa-var-poll: \\f681;\n$fa-var-mug-hot: \\f7b6;\n$fa-var-car-battery: \\f5df;\n$fa-var-battery-car: \\f5df;\n$fa-var-gift: \\f06b;\n$fa-var-dice-two: \\f528;\n$fa-var-chess-queen: \\f445;\n$fa-var-glasses: \\f530;\n$fa-var-chess-board: \\f43c;\n$fa-var-building-circle-check: \\e4d2;\n$fa-var-person-chalkboard: \\e53d;\n$fa-var-mars-stroke-right: \\f22b;\n$fa-var-mars-stroke-h: \\f22b;\n$fa-var-hand-back-fist: \\f255;\n$fa-var-hand-rock: \\f255;\n$fa-var-square-caret-up: \\f151;\n$fa-var-caret-square-up: \\f151;\n$fa-var-cloud-showers-water: \\e4e4;\n$fa-var-chart-bar: \\f080;\n$fa-var-bar-chart: \\f080;\n$fa-var-hands-bubbles: \\e05e;\n$fa-var-hands-wash: \\e05e;\n$fa-var-less-than-equal: \\f537;\n$fa-var-train: \\f238;\n$fa-var-eye-low-vision: \\f2a8;\n$fa-var-low-vision: \\f2a8;\n$fa-var-crow: \\f520;\n$fa-var-sailboat: \\e445;\n$fa-var-window-restore: \\f2d2;\n$fa-var-square-plus: \\f0fe;\n$fa-var-plus-square: \\f0fe;\n$fa-var-torii-gate: \\f6a1;\n$fa-var-frog: \\f52e;\n$fa-var-bucket: \\e4cf;\n$fa-var-image: \\f03e;\n$fa-var-microphone: \\f130;\n$fa-var-cow: \\f6c8;\n$fa-var-caret-up: \\f0d8;\n$fa-var-screwdriver: \\f54a;\n$fa-var-folder-closed: \\e185;\n$fa-var-house-tsunami: \\e515;\n$fa-var-square-nfi: \\e576;\n$fa-var-arrow-up-from-ground-water: \\e4b5;\n$fa-var-martini-glass: \\f57b;\n$fa-var-glass-martini-alt: \\f57b;\n$fa-var-rotate-left: \\f2ea;\n$fa-var-rotate-back: \\f2ea;\n$fa-var-rotate-backward: \\f2ea;\n$fa-var-undo-alt: \\f2ea;\n$fa-var-table-columns: \\f0db;\n$fa-var-columns: \\f0db;\n$fa-var-lemon: \\f094;\n$fa-var-head-side-mask: \\e063;\n$fa-var-handshake: \\f2b5;\n$fa-var-gem: \\f3a5;\n$fa-var-dolly: \\f472;\n$fa-var-dolly-box: \\f472;\n$fa-var-smoking: \\f48d;\n$fa-var-minimize: \\f78c;\n$fa-var-compress-arrows-alt: \\f78c;\n$fa-var-monument: \\f5a6;\n$fa-var-snowplow: \\f7d2;\n$fa-var-angles-right: \\f101;\n$fa-var-angle-double-right: \\f101;\n$fa-var-cannabis: \\f55f;\n$fa-var-circle-play: \\f144;\n$fa-var-play-circle: \\f144;\n$fa-var-tablets: \\f490;\n$fa-var-ethernet: \\f796;\n$fa-var-euro-sign: \\f153;\n$fa-var-eur: \\f153;\n$fa-var-euro: \\f153;\n$fa-var-chair: \\f6c0;\n$fa-var-circle-check: \\f058;\n$fa-var-check-circle: \\f058;\n$fa-var-circle-stop: \\f28d;\n$fa-var-stop-circle: \\f28d;\n$fa-var-compass-drafting: \\f568;\n$fa-var-drafting-compass: \\f568;\n$fa-var-plate-wheat: \\e55a;\n$fa-var-icicles: \\f7ad;\n$fa-var-person-shelter: \\e54f;\n$fa-var-neuter: \\f22c;\n$fa-var-id-badge: \\f2c1;\n$fa-var-marker: \\f5a1;\n$fa-var-face-laugh-beam: \\f59a;\n$fa-var-laugh-beam: \\f59a;\n$fa-var-helicopter-symbol: \\e502;\n$fa-var-universal-access: \\f29a;\n$fa-var-circle-chevron-up: \\f139;\n$fa-var-chevron-circle-up: \\f139;\n$fa-var-lari-sign: \\e1c8;\n$fa-var-volcano: \\f770;\n$fa-var-person-walking-dashed-line-arrow-right: \\e553;\n$fa-var-sterling-sign: \\f154;\n$fa-var-gbp: \\f154;\n$fa-var-pound-sign: \\f154;\n$fa-var-viruses: \\e076;\n$fa-var-square-person-confined: \\e577;\n$fa-var-user-tie: \\f508;\n$fa-var-arrow-down-long: \\f175;\n$fa-var-long-arrow-down: \\f175;\n$fa-var-tent-arrow-down-to-line: \\e57e;\n$fa-var-certificate: \\f0a3;\n$fa-var-reply-all: \\f122;\n$fa-var-mail-reply-all: \\f122;\n$fa-var-suitcase: \\f0f2;\n$fa-var-person-skating: \\f7c5;\n$fa-var-skating: \\f7c5;\n$fa-var-filter-circle-dollar: \\f662;\n$fa-var-funnel-dollar: \\f662;\n$fa-var-camera-retro: \\f083;\n$fa-var-circle-arrow-down: \\f0ab;\n$fa-var-arrow-circle-down: \\f0ab;\n$fa-var-file-import: \\f56f;\n$fa-var-arrow-right-to-file: \\f56f;\n$fa-var-square-arrow-up-right: \\f14c;\n$fa-var-external-link-square: \\f14c;\n$fa-var-box-open: \\f49e;\n$fa-var-scroll: \\f70e;\n$fa-var-spa: \\f5bb;\n$fa-var-location-pin-lock: \\e51f;\n$fa-var-pause: \\f04c;\n$fa-var-hill-avalanche: \\e507;\n$fa-var-temperature-empty: \\f2cb;\n$fa-var-temperature-0: \\f2cb;\n$fa-var-thermometer-0: \\f2cb;\n$fa-var-thermometer-empty: \\f2cb;\n$fa-var-bomb: \\f1e2;\n$fa-var-registered: \\f25d;\n$fa-var-address-card: \\f2bb;\n$fa-var-contact-card: \\f2bb;\n$fa-var-vcard: \\f2bb;\n$fa-var-scale-unbalanced-flip: \\f516;\n$fa-var-balance-scale-right: \\f516;\n$fa-var-subscript: \\f12c;\n$fa-var-diamond-turn-right: \\f5eb;\n$fa-var-directions: \\f5eb;\n$fa-var-burst: \\e4dc;\n$fa-var-house-laptop: \\e066;\n$fa-var-laptop-house: \\e066;\n$fa-var-face-tired: \\f5c8;\n$fa-var-tired: \\f5c8;\n$fa-var-money-bills: \\e1f3;\n$fa-var-smog: \\f75f;\n$fa-var-crutch: \\f7f7;\n$fa-var-cloud-arrow-up: \\f0ee;\n$fa-var-cloud-upload: \\f0ee;\n$fa-var-cloud-upload-alt: \\f0ee;\n$fa-var-palette: \\f53f;\n$fa-var-arrows-turn-right: \\e4c0;\n$fa-var-vest: \\e085;\n$fa-var-ferry: \\e4ea;\n$fa-var-arrows-down-to-people: \\e4b9;\n$fa-var-seedling: \\f4d8;\n$fa-var-sprout: \\f4d8;\n$fa-var-left-right: \\f337;\n$fa-var-arrows-alt-h: \\f337;\n$fa-var-boxes-packing: \\e4c7;\n$fa-var-circle-arrow-left: \\f0a8;\n$fa-var-arrow-circle-left: \\f0a8;\n$fa-var-group-arrows-rotate: \\e4f6;\n$fa-var-bowl-food: \\e4c6;\n$fa-var-candy-cane: \\f786;\n$fa-var-arrow-down-wide-short: \\f160;\n$fa-var-sort-amount-asc: \\f160;\n$fa-var-sort-amount-down: \\f160;\n$fa-var-cloud-bolt: \\f76c;\n$fa-var-thunderstorm: \\f76c;\n$fa-var-text-slash: \\f87d;\n$fa-var-remove-format: \\f87d;\n$fa-var-face-smile-wink: \\f4da;\n$fa-var-smile-wink: \\f4da;\n$fa-var-file-word: \\f1c2;\n$fa-var-file-powerpoint: \\f1c4;\n$fa-var-arrows-left-right: \\f07e;\n$fa-var-arrows-h: \\f07e;\n$fa-var-house-lock: \\e510;\n$fa-var-cloud-arrow-down: \\f0ed;\n$fa-var-cloud-download: \\f0ed;\n$fa-var-cloud-download-alt: \\f0ed;\n$fa-var-children: \\e4e1;\n$fa-var-chalkboard: \\f51b;\n$fa-var-blackboard: \\f51b;\n$fa-var-user-large-slash: \\f4fa;\n$fa-var-user-alt-slash: \\f4fa;\n$fa-var-envelope-open: \\f2b6;\n$fa-var-handshake-simple-slash: \\e05f;\n$fa-var-handshake-alt-slash: \\e05f;\n$fa-var-mattress-pillow: \\e525;\n$fa-var-guarani-sign: \\e19a;\n$fa-var-arrows-rotate: \\f021;\n$fa-var-refresh: \\f021;\n$fa-var-sync: \\f021;\n$fa-var-fire-extinguisher: \\f134;\n$fa-var-cruzeiro-sign: \\e152;\n$fa-var-greater-than-equal: \\f532;\n$fa-var-shield-halved: \\f3ed;\n$fa-var-shield-alt: \\f3ed;\n$fa-var-book-atlas: \\f558;\n$fa-var-atlas: \\f558;\n$fa-var-virus: \\e074;\n$fa-var-envelope-circle-check: \\e4e8;\n$fa-var-layer-group: \\f5fd;\n$fa-var-arrows-to-dot: \\e4be;\n$fa-var-archway: \\f557;\n$fa-var-heart-circle-check: \\e4fd;\n$fa-var-house-chimney-crack: \\f6f1;\n$fa-var-house-damage: \\f6f1;\n$fa-var-file-zipper: \\f1c6;\n$fa-var-file-archive: \\f1c6;\n$fa-var-square: \\f0c8;\n$fa-var-martini-glass-empty: \\f000;\n$fa-var-glass-martini: \\f000;\n$fa-var-couch: \\f4b8;\n$fa-var-cedi-sign: \\e0df;\n$fa-var-italic: \\f033;\n$fa-var-table-cells-column-lock: \\e678;\n$fa-var-church: \\f51d;\n$fa-var-comments-dollar: \\f653;\n$fa-var-democrat: \\f747;\n$fa-var-z: \\5a;\n$fa-var-person-skiing: \\f7c9;\n$fa-var-skiing: \\f7c9;\n$fa-var-road-lock: \\e567;\n$fa-var-a: \\41;\n$fa-var-temperature-arrow-down: \\e03f;\n$fa-var-temperature-down: \\e03f;\n$fa-var-feather-pointed: \\f56b;\n$fa-var-feather-alt: \\f56b;\n$fa-var-p: \\50;\n$fa-var-snowflake: \\f2dc;\n$fa-var-newspaper: \\f1ea;\n$fa-var-rectangle-ad: \\f641;\n$fa-var-ad: \\f641;\n$fa-var-circle-arrow-right: \\f0a9;\n$fa-var-arrow-circle-right: \\f0a9;\n$fa-var-filter-circle-xmark: \\e17b;\n$fa-var-locust: \\e520;\n$fa-var-sort: \\f0dc;\n$fa-var-unsorted: \\f0dc;\n$fa-var-list-ol: \\f0cb;\n$fa-var-list-1-2: \\f0cb;\n$fa-var-list-numeric: \\f0cb;\n$fa-var-person-dress-burst: \\e544;\n$fa-var-money-check-dollar: \\f53d;\n$fa-var-money-check-alt: \\f53d;\n$fa-var-vector-square: \\f5cb;\n$fa-var-bread-slice: \\f7ec;\n$fa-var-language: \\f1ab;\n$fa-var-face-kiss-wink-heart: \\f598;\n$fa-var-kiss-wink-heart: \\f598;\n$fa-var-filter: \\f0b0;\n$fa-var-question: \\3f;\n$fa-var-file-signature: \\f573;\n$fa-var-up-down-left-right: \\f0b2;\n$fa-var-arrows-alt: \\f0b2;\n$fa-var-house-chimney-user: \\e065;\n$fa-var-hand-holding-heart: \\f4be;\n$fa-var-puzzle-piece: \\f12e;\n$fa-var-money-check: \\f53c;\n$fa-var-star-half-stroke: \\f5c0;\n$fa-var-star-half-alt: \\f5c0;\n$fa-var-code: \\f121;\n$fa-var-whiskey-glass: \\f7a0;\n$fa-var-glass-whiskey: \\f7a0;\n$fa-var-building-circle-exclamation: \\e4d3;\n$fa-var-magnifying-glass-chart: \\e522;\n$fa-var-arrow-up-right-from-square: \\f08e;\n$fa-var-external-link: \\f08e;\n$fa-var-cubes-stacked: \\e4e6;\n$fa-var-won-sign: \\f159;\n$fa-var-krw: \\f159;\n$fa-var-won: \\f159;\n$fa-var-virus-covid: \\e4a8;\n$fa-var-austral-sign: \\e0a9;\n$fa-var-f: \\46;\n$fa-var-leaf: \\f06c;\n$fa-var-road: \\f018;\n$fa-var-taxi: \\f1ba;\n$fa-var-cab: \\f1ba;\n$fa-var-person-circle-plus: \\e541;\n$fa-var-chart-pie: \\f200;\n$fa-var-pie-chart: \\f200;\n$fa-var-bolt-lightning: \\e0b7;\n$fa-var-sack-xmark: \\e56a;\n$fa-var-file-excel: \\f1c3;\n$fa-var-file-contract: \\f56c;\n$fa-var-fish-fins: \\e4f2;\n$fa-var-building-flag: \\e4d5;\n$fa-var-face-grin-beam: \\f582;\n$fa-var-grin-beam: \\f582;\n$fa-var-object-ungroup: \\f248;\n$fa-var-poop: \\f619;\n$fa-var-location-pin: \\f041;\n$fa-var-map-marker: \\f041;\n$fa-var-kaaba: \\f66b;\n$fa-var-toilet-paper: \\f71e;\n$fa-var-helmet-safety: \\f807;\n$fa-var-hard-hat: \\f807;\n$fa-var-hat-hard: \\f807;\n$fa-var-eject: \\f052;\n$fa-var-circle-right: \\f35a;\n$fa-var-arrow-alt-circle-right: \\f35a;\n$fa-var-plane-circle-check: \\e555;\n$fa-var-face-rolling-eyes: \\f5a5;\n$fa-var-meh-rolling-eyes: \\f5a5;\n$fa-var-object-group: \\f247;\n$fa-var-chart-line: \\f201;\n$fa-var-line-chart: \\f201;\n$fa-var-mask-ventilator: \\e524;\n$fa-var-arrow-right: \\f061;\n$fa-var-signs-post: \\f277;\n$fa-var-map-signs: \\f277;\n$fa-var-cash-register: \\f788;\n$fa-var-person-circle-question: \\e542;\n$fa-var-h: \\48;\n$fa-var-tarp: \\e57b;\n$fa-var-screwdriver-wrench: \\f7d9;\n$fa-var-tools: \\f7d9;\n$fa-var-arrows-to-eye: \\e4bf;\n$fa-var-plug-circle-bolt: \\e55b;\n$fa-var-heart: \\f004;\n$fa-var-mars-and-venus: \\f224;\n$fa-var-house-user: \\e1b0;\n$fa-var-home-user: \\e1b0;\n$fa-var-dumpster-fire: \\f794;\n$fa-var-house-crack: \\e3b1;\n$fa-var-martini-glass-citrus: \\f561;\n$fa-var-cocktail: \\f561;\n$fa-var-face-surprise: \\f5c2;\n$fa-var-surprise: \\f5c2;\n$fa-var-bottle-water: \\e4c5;\n$fa-var-circle-pause: \\f28b;\n$fa-var-pause-circle: \\f28b;\n$fa-var-toilet-paper-slash: \\e072;\n$fa-var-apple-whole: \\f5d1;\n$fa-var-apple-alt: \\f5d1;\n$fa-var-kitchen-set: \\e51a;\n$fa-var-r: \\52;\n$fa-var-temperature-quarter: \\f2ca;\n$fa-var-temperature-1: \\f2ca;\n$fa-var-thermometer-1: \\f2ca;\n$fa-var-thermometer-quarter: \\f2ca;\n$fa-var-cube: \\f1b2;\n$fa-var-bitcoin-sign: \\e0b4;\n$fa-var-shield-dog: \\e573;\n$fa-var-solar-panel: \\f5ba;\n$fa-var-lock-open: \\f3c1;\n$fa-var-elevator: \\e16d;\n$fa-var-money-bill-transfer: \\e528;\n$fa-var-money-bill-trend-up: \\e529;\n$fa-var-house-flood-water-circle-arrow-right: \\e50f;\n$fa-var-square-poll-horizontal: \\f682;\n$fa-var-poll-h: \\f682;\n$fa-var-circle: \\f111;\n$fa-var-backward-fast: \\f049;\n$fa-var-fast-backward: \\f049;\n$fa-var-recycle: \\f1b8;\n$fa-var-user-astronaut: \\f4fb;\n$fa-var-plane-slash: \\e069;\n$fa-var-trademark: \\f25c;\n$fa-var-basketball: \\f434;\n$fa-var-basketball-ball: \\f434;\n$fa-var-satellite-dish: \\f7c0;\n$fa-var-circle-up: \\f35b;\n$fa-var-arrow-alt-circle-up: \\f35b;\n$fa-var-mobile-screen-button: \\f3cd;\n$fa-var-mobile-alt: \\f3cd;\n$fa-var-volume-high: \\f028;\n$fa-var-volume-up: \\f028;\n$fa-var-users-rays: \\e593;\n$fa-var-wallet: \\f555;\n$fa-var-clipboard-check: \\f46c;\n$fa-var-file-audio: \\f1c7;\n$fa-var-burger: \\f805;\n$fa-var-hamburger: \\f805;\n$fa-var-wrench: \\f0ad;\n$fa-var-bugs: \\e4d0;\n$fa-var-rupee-sign: \\f156;\n$fa-var-rupee: \\f156;\n$fa-var-file-image: \\f1c5;\n$fa-var-circle-question: \\f059;\n$fa-var-question-circle: \\f059;\n$fa-var-plane-departure: \\f5b0;\n$fa-var-handshake-slash: \\e060;\n$fa-var-book-bookmark: \\e0bb;\n$fa-var-code-branch: \\f126;\n$fa-var-hat-cowboy: \\f8c0;\n$fa-var-bridge: \\e4c8;\n$fa-var-phone-flip: \\f879;\n$fa-var-phone-alt: \\f879;\n$fa-var-truck-front: \\e2b7;\n$fa-var-cat: \\f6be;\n$fa-var-anchor-circle-exclamation: \\e4ab;\n$fa-var-truck-field: \\e58d;\n$fa-var-route: \\f4d7;\n$fa-var-clipboard-question: \\e4e3;\n$fa-var-panorama: \\e209;\n$fa-var-comment-medical: \\f7f5;\n$fa-var-teeth-open: \\f62f;\n$fa-var-file-circle-minus: \\e4ed;\n$fa-var-tags: \\f02c;\n$fa-var-wine-glass: \\f4e3;\n$fa-var-forward-fast: \\f050;\n$fa-var-fast-forward: \\f050;\n$fa-var-face-meh-blank: \\f5a4;\n$fa-var-meh-blank: \\f5a4;\n$fa-var-square-parking: \\f540;\n$fa-var-parking: \\f540;\n$fa-var-house-signal: \\e012;\n$fa-var-bars-progress: \\f828;\n$fa-var-tasks-alt: \\f828;\n$fa-var-faucet-drip: \\e006;\n$fa-var-cart-flatbed: \\f474;\n$fa-var-dolly-flatbed: \\f474;\n$fa-var-ban-smoking: \\f54d;\n$fa-var-smoking-ban: \\f54d;\n$fa-var-terminal: \\f120;\n$fa-var-mobile-button: \\f10b;\n$fa-var-house-medical-flag: \\e514;\n$fa-var-basket-shopping: \\f291;\n$fa-var-shopping-basket: \\f291;\n$fa-var-tape: \\f4db;\n$fa-var-bus-simple: \\f55e;\n$fa-var-bus-alt: \\f55e;\n$fa-var-eye: \\f06e;\n$fa-var-face-sad-cry: \\f5b3;\n$fa-var-sad-cry: \\f5b3;\n$fa-var-audio-description: \\f29e;\n$fa-var-person-military-to-person: \\e54c;\n$fa-var-file-shield: \\e4f0;\n$fa-var-user-slash: \\f506;\n$fa-var-pen: \\f304;\n$fa-var-tower-observation: \\e586;\n$fa-var-file-code: \\f1c9;\n$fa-var-signal: \\f012;\n$fa-var-signal-5: \\f012;\n$fa-var-signal-perfect: \\f012;\n$fa-var-bus: \\f207;\n$fa-var-heart-circle-xmark: \\e501;\n$fa-var-house-chimney: \\e3af;\n$fa-var-home-lg: \\e3af;\n$fa-var-window-maximize: \\f2d0;\n$fa-var-face-frown: \\f119;\n$fa-var-frown: \\f119;\n$fa-var-prescription: \\f5b1;\n$fa-var-shop: \\f54f;\n$fa-var-store-alt: \\f54f;\n$fa-var-floppy-disk: \\f0c7;\n$fa-var-save: \\f0c7;\n$fa-var-vihara: \\f6a7;\n$fa-var-scale-unbalanced: \\f515;\n$fa-var-balance-scale-left: \\f515;\n$fa-var-sort-up: \\f0de;\n$fa-var-sort-asc: \\f0de;\n$fa-var-comment-dots: \\f4ad;\n$fa-var-commenting: \\f4ad;\n$fa-var-plant-wilt: \\e5aa;\n$fa-var-diamond: \\f219;\n$fa-var-face-grin-squint: \\f585;\n$fa-var-grin-squint: \\f585;\n$fa-var-hand-holding-dollar: \\f4c0;\n$fa-var-hand-holding-usd: \\f4c0;\n$fa-var-bacterium: \\e05a;\n$fa-var-hand-pointer: \\f25a;\n$fa-var-drum-steelpan: \\f56a;\n$fa-var-hand-scissors: \\f257;\n$fa-var-hands-praying: \\f684;\n$fa-var-praying-hands: \\f684;\n$fa-var-arrow-rotate-right: \\f01e;\n$fa-var-arrow-right-rotate: \\f01e;\n$fa-var-arrow-rotate-forward: \\f01e;\n$fa-var-redo: \\f01e;\n$fa-var-biohazard: \\f780;\n$fa-var-location-crosshairs: \\f601;\n$fa-var-location: \\f601;\n$fa-var-mars-double: \\f227;\n$fa-var-child-dress: \\e59c;\n$fa-var-users-between-lines: \\e591;\n$fa-var-lungs-virus: \\e067;\n$fa-var-face-grin-tears: \\f588;\n$fa-var-grin-tears: \\f588;\n$fa-var-phone: \\f095;\n$fa-var-calendar-xmark: \\f273;\n$fa-var-calendar-times: \\f273;\n$fa-var-child-reaching: \\e59d;\n$fa-var-head-side-virus: \\e064;\n$fa-var-user-gear: \\f4fe;\n$fa-var-user-cog: \\f4fe;\n$fa-var-arrow-up-1-9: \\f163;\n$fa-var-sort-numeric-up: \\f163;\n$fa-var-door-closed: \\f52a;\n$fa-var-shield-virus: \\e06c;\n$fa-var-dice-six: \\f526;\n$fa-var-mosquito-net: \\e52c;\n$fa-var-bridge-water: \\e4ce;\n$fa-var-person-booth: \\f756;\n$fa-var-text-width: \\f035;\n$fa-var-hat-wizard: \\f6e8;\n$fa-var-pen-fancy: \\f5ac;\n$fa-var-person-digging: \\f85e;\n$fa-var-digging: \\f85e;\n$fa-var-trash: \\f1f8;\n$fa-var-gauge-simple: \\f629;\n$fa-var-gauge-simple-med: \\f629;\n$fa-var-tachometer-average: \\f629;\n$fa-var-book-medical: \\f7e6;\n$fa-var-poo: \\f2fe;\n$fa-var-quote-right: \\f10e;\n$fa-var-quote-right-alt: \\f10e;\n$fa-var-shirt: \\f553;\n$fa-var-t-shirt: \\f553;\n$fa-var-tshirt: \\f553;\n$fa-var-cubes: \\f1b3;\n$fa-var-divide: \\f529;\n$fa-var-tenge-sign: \\f7d7;\n$fa-var-tenge: \\f7d7;\n$fa-var-headphones: \\f025;\n$fa-var-hands-holding: \\f4c2;\n$fa-var-hands-clapping: \\e1a8;\n$fa-var-republican: \\f75e;\n$fa-var-arrow-left: \\f060;\n$fa-var-person-circle-xmark: \\e543;\n$fa-var-ruler: \\f545;\n$fa-var-align-left: \\f036;\n$fa-var-dice-d6: \\f6d1;\n$fa-var-restroom: \\f7bd;\n$fa-var-j: \\4a;\n$fa-var-users-viewfinder: \\e595;\n$fa-var-file-video: \\f1c8;\n$fa-var-up-right-from-square: \\f35d;\n$fa-var-external-link-alt: \\f35d;\n$fa-var-table-cells: \\f00a;\n$fa-var-th: \\f00a;\n$fa-var-file-pdf: \\f1c1;\n$fa-var-book-bible: \\f647;\n$fa-var-bible: \\f647;\n$fa-var-o: \\4f;\n$fa-var-suitcase-medical: \\f0fa;\n$fa-var-medkit: \\f0fa;\n$fa-var-user-secret: \\f21b;\n$fa-var-otter: \\f700;\n$fa-var-person-dress: \\f182;\n$fa-var-female: \\f182;\n$fa-var-comment-dollar: \\f651;\n$fa-var-business-time: \\f64a;\n$fa-var-briefcase-clock: \\f64a;\n$fa-var-table-cells-large: \\f009;\n$fa-var-th-large: \\f009;\n$fa-var-book-tanakh: \\f827;\n$fa-var-tanakh: \\f827;\n$fa-var-phone-volume: \\f2a0;\n$fa-var-volume-control-phone: \\f2a0;\n$fa-var-hat-cowboy-side: \\f8c1;\n$fa-var-clipboard-user: \\f7f3;\n$fa-var-child: \\f1ae;\n$fa-var-lira-sign: \\f195;\n$fa-var-satellite: \\f7bf;\n$fa-var-plane-lock: \\e558;\n$fa-var-tag: \\f02b;\n$fa-var-comment: \\f075;\n$fa-var-cake-candles: \\f1fd;\n$fa-var-birthday-cake: \\f1fd;\n$fa-var-cake: \\f1fd;\n$fa-var-envelope: \\f0e0;\n$fa-var-angles-up: \\f102;\n$fa-var-angle-double-up: \\f102;\n$fa-var-paperclip: \\f0c6;\n$fa-var-arrow-right-to-city: \\e4b3;\n$fa-var-ribbon: \\f4d6;\n$fa-var-lungs: \\f604;\n$fa-var-arrow-up-9-1: \\f887;\n$fa-var-sort-numeric-up-alt: \\f887;\n$fa-var-litecoin-sign: \\e1d3;\n$fa-var-border-none: \\f850;\n$fa-var-circle-nodes: \\e4e2;\n$fa-var-parachute-box: \\f4cd;\n$fa-var-indent: \\f03c;\n$fa-var-truck-field-un: \\e58e;\n$fa-var-hourglass: \\f254;\n$fa-var-hourglass-empty: \\f254;\n$fa-var-mountain: \\f6fc;\n$fa-var-user-doctor: \\f0f0;\n$fa-var-user-md: \\f0f0;\n$fa-var-circle-info: \\f05a;\n$fa-var-info-circle: \\f05a;\n$fa-var-cloud-meatball: \\f73b;\n$fa-var-camera: \\f030;\n$fa-var-camera-alt: \\f030;\n$fa-var-square-virus: \\e578;\n$fa-var-meteor: \\f753;\n$fa-var-car-on: \\e4dd;\n$fa-var-sleigh: \\f7cc;\n$fa-var-arrow-down-1-9: \\f162;\n$fa-var-sort-numeric-asc: \\f162;\n$fa-var-sort-numeric-down: \\f162;\n$fa-var-hand-holding-droplet: \\f4c1;\n$fa-var-hand-holding-water: \\f4c1;\n$fa-var-water: \\f773;\n$fa-var-calendar-check: \\f274;\n$fa-var-braille: \\f2a1;\n$fa-var-prescription-bottle-medical: \\f486;\n$fa-var-prescription-bottle-alt: \\f486;\n$fa-var-landmark: \\f66f;\n$fa-var-truck: \\f0d1;\n$fa-var-crosshairs: \\f05b;\n$fa-var-person-cane: \\e53c;\n$fa-var-tent: \\e57d;\n$fa-var-vest-patches: \\e086;\n$fa-var-check-double: \\f560;\n$fa-var-arrow-down-a-z: \\f15d;\n$fa-var-sort-alpha-asc: \\f15d;\n$fa-var-sort-alpha-down: \\f15d;\n$fa-var-money-bill-wheat: \\e52a;\n$fa-var-cookie: \\f563;\n$fa-var-arrow-rotate-left: \\f0e2;\n$fa-var-arrow-left-rotate: \\f0e2;\n$fa-var-arrow-rotate-back: \\f0e2;\n$fa-var-arrow-rotate-backward: \\f0e2;\n$fa-var-undo: \\f0e2;\n$fa-var-hard-drive: \\f0a0;\n$fa-var-hdd: \\f0a0;\n$fa-var-face-grin-squint-tears: \\f586;\n$fa-var-grin-squint-tears: \\f586;\n$fa-var-dumbbell: \\f44b;\n$fa-var-rectangle-list: \\f022;\n$fa-var-list-alt: \\f022;\n$fa-var-tarp-droplet: \\e57c;\n$fa-var-house-medical-circle-check: \\e511;\n$fa-var-person-skiing-nordic: \\f7ca;\n$fa-var-skiing-nordic: \\f7ca;\n$fa-var-calendar-plus: \\f271;\n$fa-var-plane-arrival: \\f5af;\n$fa-var-circle-left: \\f359;\n$fa-var-arrow-alt-circle-left: \\f359;\n$fa-var-train-subway: \\f239;\n$fa-var-subway: \\f239;\n$fa-var-chart-gantt: \\e0e4;\n$fa-var-indian-rupee-sign: \\e1bc;\n$fa-var-indian-rupee: \\e1bc;\n$fa-var-inr: \\e1bc;\n$fa-var-crop-simple: \\f565;\n$fa-var-crop-alt: \\f565;\n$fa-var-money-bill-1: \\f3d1;\n$fa-var-money-bill-alt: \\f3d1;\n$fa-var-left-long: \\f30a;\n$fa-var-long-arrow-alt-left: \\f30a;\n$fa-var-dna: \\f471;\n$fa-var-virus-slash: \\e075;\n$fa-var-minus: \\f068;\n$fa-var-subtract: \\f068;\n$fa-var-chess: \\f439;\n$fa-var-arrow-left-long: \\f177;\n$fa-var-long-arrow-left: \\f177;\n$fa-var-plug-circle-check: \\e55c;\n$fa-var-street-view: \\f21d;\n$fa-var-franc-sign: \\e18f;\n$fa-var-volume-off: \\f026;\n$fa-var-hands-asl-interpreting: \\f2a3;\n$fa-var-american-sign-language-interpreting: \\f2a3;\n$fa-var-asl-interpreting: \\f2a3;\n$fa-var-hands-american-sign-language-interpreting: \\f2a3;\n$fa-var-gear: \\f013;\n$fa-var-cog: \\f013;\n$fa-var-droplet-slash: \\f5c7;\n$fa-var-tint-slash: \\f5c7;\n$fa-var-mosque: \\f678;\n$fa-var-mosquito: \\e52b;\n$fa-var-star-of-david: \\f69a;\n$fa-var-person-military-rifle: \\e54b;\n$fa-var-cart-shopping: \\f07a;\n$fa-var-shopping-cart: \\f07a;\n$fa-var-vials: \\f493;\n$fa-var-plug-circle-plus: \\e55f;\n$fa-var-place-of-worship: \\f67f;\n$fa-var-grip-vertical: \\f58e;\n$fa-var-arrow-turn-up: \\f148;\n$fa-var-level-up: \\f148;\n$fa-var-u: \\55;\n$fa-var-square-root-variable: \\f698;\n$fa-var-square-root-alt: \\f698;\n$fa-var-clock: \\f017;\n$fa-var-clock-four: \\f017;\n$fa-var-backward-step: \\f048;\n$fa-var-step-backward: \\f048;\n$fa-var-pallet: \\f482;\n$fa-var-faucet: \\e005;\n$fa-var-baseball-bat-ball: \\f432;\n$fa-var-s: \\53;\n$fa-var-timeline: \\e29c;\n$fa-var-keyboard: \\f11c;\n$fa-var-caret-down: \\f0d7;\n$fa-var-house-chimney-medical: \\f7f2;\n$fa-var-clinic-medical: \\f7f2;\n$fa-var-temperature-three-quarters: \\f2c8;\n$fa-var-temperature-3: \\f2c8;\n$fa-var-thermometer-3: \\f2c8;\n$fa-var-thermometer-three-quarters: \\f2c8;\n$fa-var-mobile-screen: \\f3cf;\n$fa-var-mobile-android-alt: \\f3cf;\n$fa-var-plane-up: \\e22d;\n$fa-var-piggy-bank: \\f4d3;\n$fa-var-battery-half: \\f242;\n$fa-var-battery-3: \\f242;\n$fa-var-mountain-city: \\e52e;\n$fa-var-coins: \\f51e;\n$fa-var-khanda: \\f66d;\n$fa-var-sliders: \\f1de;\n$fa-var-sliders-h: \\f1de;\n$fa-var-folder-tree: \\f802;\n$fa-var-network-wired: \\f6ff;\n$fa-var-map-pin: \\f276;\n$fa-var-hamsa: \\f665;\n$fa-var-cent-sign: \\e3f5;\n$fa-var-flask: \\f0c3;\n$fa-var-person-pregnant: \\e31e;\n$fa-var-wand-sparkles: \\f72b;\n$fa-var-ellipsis-vertical: \\f142;\n$fa-var-ellipsis-v: \\f142;\n$fa-var-ticket: \\f145;\n$fa-var-power-off: \\f011;\n$fa-var-right-long: \\f30b;\n$fa-var-long-arrow-alt-right: \\f30b;\n$fa-var-flag-usa: \\f74d;\n$fa-var-laptop-file: \\e51d;\n$fa-var-tty: \\f1e4;\n$fa-var-teletype: \\f1e4;\n$fa-var-diagram-next: \\e476;\n$fa-var-person-rifle: \\e54e;\n$fa-var-house-medical-circle-exclamation: \\e512;\n$fa-var-closed-captioning: \\f20a;\n$fa-var-person-hiking: \\f6ec;\n$fa-var-hiking: \\f6ec;\n$fa-var-venus-double: \\f226;\n$fa-var-images: \\f302;\n$fa-var-calculator: \\f1ec;\n$fa-var-people-pulling: \\e535;\n$fa-var-n: \\4e;\n$fa-var-cable-car: \\f7da;\n$fa-var-tram: \\f7da;\n$fa-var-cloud-rain: \\f73d;\n$fa-var-building-circle-xmark: \\e4d4;\n$fa-var-ship: \\f21a;\n$fa-var-arrows-down-to-line: \\e4b8;\n$fa-var-download: \\f019;\n$fa-var-face-grin: \\f580;\n$fa-var-grin: \\f580;\n$fa-var-delete-left: \\f55a;\n$fa-var-backspace: \\f55a;\n$fa-var-eye-dropper: \\f1fb;\n$fa-var-eye-dropper-empty: \\f1fb;\n$fa-var-eyedropper: \\f1fb;\n$fa-var-file-circle-check: \\e5a0;\n$fa-var-forward: \\f04e;\n$fa-var-mobile: \\f3ce;\n$fa-var-mobile-android: \\f3ce;\n$fa-var-mobile-phone: \\f3ce;\n$fa-var-face-meh: \\f11a;\n$fa-var-meh: \\f11a;\n$fa-var-align-center: \\f037;\n$fa-var-book-skull: \\f6b7;\n$fa-var-book-dead: \\f6b7;\n$fa-var-id-card: \\f2c2;\n$fa-var-drivers-license: \\f2c2;\n$fa-var-outdent: \\f03b;\n$fa-var-dedent: \\f03b;\n$fa-var-heart-circle-exclamation: \\e4fe;\n$fa-var-house: \\f015;\n$fa-var-home: \\f015;\n$fa-var-home-alt: \\f015;\n$fa-var-home-lg-alt: \\f015;\n$fa-var-calendar-week: \\f784;\n$fa-var-laptop-medical: \\f812;\n$fa-var-b: \\42;\n$fa-var-file-medical: \\f477;\n$fa-var-dice-one: \\f525;\n$fa-var-kiwi-bird: \\f535;\n$fa-var-arrow-right-arrow-left: \\f0ec;\n$fa-var-exchange: \\f0ec;\n$fa-var-rotate-right: \\f2f9;\n$fa-var-redo-alt: \\f2f9;\n$fa-var-rotate-forward: \\f2f9;\n$fa-var-utensils: \\f2e7;\n$fa-var-cutlery: \\f2e7;\n$fa-var-arrow-up-wide-short: \\f161;\n$fa-var-sort-amount-up: \\f161;\n$fa-var-mill-sign: \\e1ed;\n$fa-var-bowl-rice: \\e2eb;\n$fa-var-skull: \\f54c;\n$fa-var-tower-broadcast: \\f519;\n$fa-var-broadcast-tower: \\f519;\n$fa-var-truck-pickup: \\f63c;\n$fa-var-up-long: \\f30c;\n$fa-var-long-arrow-alt-up: \\f30c;\n$fa-var-stop: \\f04d;\n$fa-var-code-merge: \\f387;\n$fa-var-upload: \\f093;\n$fa-var-hurricane: \\f751;\n$fa-var-mound: \\e52d;\n$fa-var-toilet-portable: \\e583;\n$fa-var-compact-disc: \\f51f;\n$fa-var-file-arrow-down: \\f56d;\n$fa-var-file-download: \\f56d;\n$fa-var-caravan: \\f8ff;\n$fa-var-shield-cat: \\e572;\n$fa-var-bolt: \\f0e7;\n$fa-var-zap: \\f0e7;\n$fa-var-glass-water: \\e4f4;\n$fa-var-oil-well: \\e532;\n$fa-var-vault: \\e2c5;\n$fa-var-mars: \\f222;\n$fa-var-toilet: \\f7d8;\n$fa-var-plane-circle-xmark: \\e557;\n$fa-var-yen-sign: \\f157;\n$fa-var-cny: \\f157;\n$fa-var-jpy: \\f157;\n$fa-var-rmb: \\f157;\n$fa-var-yen: \\f157;\n$fa-var-ruble-sign: \\f158;\n$fa-var-rouble: \\f158;\n$fa-var-rub: \\f158;\n$fa-var-ruble: \\f158;\n$fa-var-sun: \\f185;\n$fa-var-guitar: \\f7a6;\n$fa-var-face-laugh-wink: \\f59c;\n$fa-var-laugh-wink: \\f59c;\n$fa-var-horse-head: \\f7ab;\n$fa-var-bore-hole: \\e4c3;\n$fa-var-industry: \\f275;\n$fa-var-circle-down: \\f358;\n$fa-var-arrow-alt-circle-down: \\f358;\n$fa-var-arrows-turn-to-dots: \\e4c1;\n$fa-var-florin-sign: \\e184;\n$fa-var-arrow-down-short-wide: \\f884;\n$fa-var-sort-amount-desc: \\f884;\n$fa-var-sort-amount-down-alt: \\f884;\n$fa-var-less-than: \\3c;\n$fa-var-angle-down: \\f107;\n$fa-var-car-tunnel: \\e4de;\n$fa-var-head-side-cough: \\e061;\n$fa-var-grip-lines: \\f7a4;\n$fa-var-thumbs-down: \\f165;\n$fa-var-user-lock: \\f502;\n$fa-var-arrow-right-long: \\f178;\n$fa-var-long-arrow-right: \\f178;\n$fa-var-anchor-circle-xmark: \\e4ac;\n$fa-var-ellipsis: \\f141;\n$fa-var-ellipsis-h: \\f141;\n$fa-var-chess-pawn: \\f443;\n$fa-var-kit-medical: \\f479;\n$fa-var-first-aid: \\f479;\n$fa-var-person-through-window: \\e5a9;\n$fa-var-toolbox: \\f552;\n$fa-var-hands-holding-circle: \\e4fb;\n$fa-var-bug: \\f188;\n$fa-var-credit-card: \\f09d;\n$fa-var-credit-card-alt: \\f09d;\n$fa-var-car: \\f1b9;\n$fa-var-automobile: \\f1b9;\n$fa-var-hand-holding-hand: \\e4f7;\n$fa-var-book-open-reader: \\f5da;\n$fa-var-book-reader: \\f5da;\n$fa-var-mountain-sun: \\e52f;\n$fa-var-arrows-left-right-to-line: \\e4ba;\n$fa-var-dice-d20: \\f6cf;\n$fa-var-truck-droplet: \\e58c;\n$fa-var-file-circle-xmark: \\e5a1;\n$fa-var-temperature-arrow-up: \\e040;\n$fa-var-temperature-up: \\e040;\n$fa-var-medal: \\f5a2;\n$fa-var-bed: \\f236;\n$fa-var-square-h: \\f0fd;\n$fa-var-h-square: \\f0fd;\n$fa-var-podcast: \\f2ce;\n$fa-var-temperature-full: \\f2c7;\n$fa-var-temperature-4: \\f2c7;\n$fa-var-thermometer-4: \\f2c7;\n$fa-var-thermometer-full: \\f2c7;\n$fa-var-bell: \\f0f3;\n$fa-var-superscript: \\f12b;\n$fa-var-plug-circle-xmark: \\e560;\n$fa-var-star-of-life: \\f621;\n$fa-var-phone-slash: \\f3dd;\n$fa-var-paint-roller: \\f5aa;\n$fa-var-handshake-angle: \\f4c4;\n$fa-var-hands-helping: \\f4c4;\n$fa-var-location-dot: \\f3c5;\n$fa-var-map-marker-alt: \\f3c5;\n$fa-var-file: \\f15b;\n$fa-var-greater-than: \\3e;\n$fa-var-person-swimming: \\f5c4;\n$fa-var-swimmer: \\f5c4;\n$fa-var-arrow-down: \\f063;\n$fa-var-droplet: \\f043;\n$fa-var-tint: \\f043;\n$fa-var-eraser: \\f12d;\n$fa-var-earth-americas: \\f57d;\n$fa-var-earth: \\f57d;\n$fa-var-earth-america: \\f57d;\n$fa-var-globe-americas: \\f57d;\n$fa-var-person-burst: \\e53b;\n$fa-var-dove: \\f4ba;\n$fa-var-battery-empty: \\f244;\n$fa-var-battery-0: \\f244;\n$fa-var-socks: \\f696;\n$fa-var-inbox: \\f01c;\n$fa-var-section: \\e447;\n$fa-var-gauge-high: \\f625;\n$fa-var-tachometer-alt: \\f625;\n$fa-var-tachometer-alt-fast: \\f625;\n$fa-var-envelope-open-text: \\f658;\n$fa-var-hospital: \\f0f8;\n$fa-var-hospital-alt: \\f0f8;\n$fa-var-hospital-wide: \\f0f8;\n$fa-var-wine-bottle: \\f72f;\n$fa-var-chess-rook: \\f447;\n$fa-var-bars-staggered: \\f550;\n$fa-var-reorder: \\f550;\n$fa-var-stream: \\f550;\n$fa-var-dharmachakra: \\f655;\n$fa-var-hotdog: \\f80f;\n$fa-var-person-walking-with-cane: \\f29d;\n$fa-var-blind: \\f29d;\n$fa-var-drum: \\f569;\n$fa-var-ice-cream: \\f810;\n$fa-var-heart-circle-bolt: \\e4fc;\n$fa-var-fax: \\f1ac;\n$fa-var-paragraph: \\f1dd;\n$fa-var-check-to-slot: \\f772;\n$fa-var-vote-yea: \\f772;\n$fa-var-star-half: \\f089;\n$fa-var-boxes-stacked: \\f468;\n$fa-var-boxes: \\f468;\n$fa-var-boxes-alt: \\f468;\n$fa-var-link: \\f0c1;\n$fa-var-chain: \\f0c1;\n$fa-var-ear-listen: \\f2a2;\n$fa-var-assistive-listening-systems: \\f2a2;\n$fa-var-tree-city: \\e587;\n$fa-var-play: \\f04b;\n$fa-var-font: \\f031;\n$fa-var-table-cells-row-lock: \\e67a;\n$fa-var-rupiah-sign: \\e23d;\n$fa-var-magnifying-glass: \\f002;\n$fa-var-search: \\f002;\n$fa-var-table-tennis-paddle-ball: \\f45d;\n$fa-var-ping-pong-paddle-ball: \\f45d;\n$fa-var-table-tennis: \\f45d;\n$fa-var-person-dots-from-line: \\f470;\n$fa-var-diagnoses: \\f470;\n$fa-var-trash-can-arrow-up: \\f82a;\n$fa-var-trash-restore-alt: \\f82a;\n$fa-var-naira-sign: \\e1f6;\n$fa-var-cart-arrow-down: \\f218;\n$fa-var-walkie-talkie: \\f8ef;\n$fa-var-file-pen: \\f31c;\n$fa-var-file-edit: \\f31c;\n$fa-var-receipt: \\f543;\n$fa-var-square-pen: \\f14b;\n$fa-var-pen-square: \\f14b;\n$fa-var-pencil-square: \\f14b;\n$fa-var-suitcase-rolling: \\f5c1;\n$fa-var-person-circle-exclamation: \\e53f;\n$fa-var-chevron-down: \\f078;\n$fa-var-battery-full: \\f240;\n$fa-var-battery: \\f240;\n$fa-var-battery-5: \\f240;\n$fa-var-skull-crossbones: \\f714;\n$fa-var-code-compare: \\e13a;\n$fa-var-list-ul: \\f0ca;\n$fa-var-list-dots: \\f0ca;\n$fa-var-school-lock: \\e56f;\n$fa-var-tower-cell: \\e585;\n$fa-var-down-long: \\f309;\n$fa-var-long-arrow-alt-down: \\f309;\n$fa-var-ranking-star: \\e561;\n$fa-var-chess-king: \\f43f;\n$fa-var-person-harassing: \\e549;\n$fa-var-brazilian-real-sign: \\e46c;\n$fa-var-landmark-dome: \\f752;\n$fa-var-landmark-alt: \\f752;\n$fa-var-arrow-up: \\f062;\n$fa-var-tv: \\f26c;\n$fa-var-television: \\f26c;\n$fa-var-tv-alt: \\f26c;\n$fa-var-shrimp: \\e448;\n$fa-var-list-check: \\f0ae;\n$fa-var-tasks: \\f0ae;\n$fa-var-jug-detergent: \\e519;\n$fa-var-circle-user: \\f2bd;\n$fa-var-user-circle: \\f2bd;\n$fa-var-user-shield: \\f505;\n$fa-var-wind: \\f72e;\n$fa-var-car-burst: \\f5e1;\n$fa-var-car-crash: \\f5e1;\n$fa-var-y: \\59;\n$fa-var-person-snowboarding: \\f7ce;\n$fa-var-snowboarding: \\f7ce;\n$fa-var-truck-fast: \\f48b;\n$fa-var-shipping-fast: \\f48b;\n$fa-var-fish: \\f578;\n$fa-var-user-graduate: \\f501;\n$fa-var-circle-half-stroke: \\f042;\n$fa-var-adjust: \\f042;\n$fa-var-clapperboard: \\e131;\n$fa-var-circle-radiation: \\f7ba;\n$fa-var-radiation-alt: \\f7ba;\n$fa-var-baseball: \\f433;\n$fa-var-baseball-ball: \\f433;\n$fa-var-jet-fighter-up: \\e518;\n$fa-var-diagram-project: \\f542;\n$fa-var-project-diagram: \\f542;\n$fa-var-copy: \\f0c5;\n$fa-var-volume-xmark: \\f6a9;\n$fa-var-volume-mute: \\f6a9;\n$fa-var-volume-times: \\f6a9;\n$fa-var-hand-sparkles: \\e05d;\n$fa-var-grip: \\f58d;\n$fa-var-grip-horizontal: \\f58d;\n$fa-var-share-from-square: \\f14d;\n$fa-var-share-square: \\f14d;\n$fa-var-child-combatant: \\e4e0;\n$fa-var-child-rifle: \\e4e0;\n$fa-var-gun: \\e19b;\n$fa-var-square-phone: \\f098;\n$fa-var-phone-square: \\f098;\n$fa-var-plus: \\2b;\n$fa-var-add: \\2b;\n$fa-var-expand: \\f065;\n$fa-var-computer: \\e4e5;\n$fa-var-xmark: \\f00d;\n$fa-var-close: \\f00d;\n$fa-var-multiply: \\f00d;\n$fa-var-remove: \\f00d;\n$fa-var-times: \\f00d;\n$fa-var-arrows-up-down-left-right: \\f047;\n$fa-var-arrows: \\f047;\n$fa-var-chalkboard-user: \\f51c;\n$fa-var-chalkboard-teacher: \\f51c;\n$fa-var-peso-sign: \\e222;\n$fa-var-building-shield: \\e4d8;\n$fa-var-baby: \\f77c;\n$fa-var-users-line: \\e592;\n$fa-var-quote-left: \\f10d;\n$fa-var-quote-left-alt: \\f10d;\n$fa-var-tractor: \\f722;\n$fa-var-trash-arrow-up: \\f829;\n$fa-var-trash-restore: \\f829;\n$fa-var-arrow-down-up-lock: \\e4b0;\n$fa-var-lines-leaning: \\e51e;\n$fa-var-ruler-combined: \\f546;\n$fa-var-copyright: \\f1f9;\n$fa-var-equals: \\3d;\n$fa-var-blender: \\f517;\n$fa-var-teeth: \\f62e;\n$fa-var-shekel-sign: \\f20b;\n$fa-var-ils: \\f20b;\n$fa-var-shekel: \\f20b;\n$fa-var-sheqel: \\f20b;\n$fa-var-sheqel-sign: \\f20b;\n$fa-var-map: \\f279;\n$fa-var-rocket: \\f135;\n$fa-var-photo-film: \\f87c;\n$fa-var-photo-video: \\f87c;\n$fa-var-folder-minus: \\f65d;\n$fa-var-store: \\f54e;\n$fa-var-arrow-trend-up: \\e098;\n$fa-var-plug-circle-minus: \\e55e;\n$fa-var-sign-hanging: \\f4d9;\n$fa-var-sign: \\f4d9;\n$fa-var-bezier-curve: \\f55b;\n$fa-var-bell-slash: \\f1f6;\n$fa-var-tablet: \\f3fb;\n$fa-var-tablet-android: \\f3fb;\n$fa-var-school-flag: \\e56e;\n$fa-var-fill: \\f575;\n$fa-var-angle-up: \\f106;\n$fa-var-drumstick-bite: \\f6d7;\n$fa-var-holly-berry: \\f7aa;\n$fa-var-chevron-left: \\f053;\n$fa-var-bacteria: \\e059;\n$fa-var-hand-lizard: \\f258;\n$fa-var-notdef: \\e1fe;\n$fa-var-disease: \\f7fa;\n$fa-var-briefcase-medical: \\f469;\n$fa-var-genderless: \\f22d;\n$fa-var-chevron-right: \\f054;\n$fa-var-retweet: \\f079;\n$fa-var-car-rear: \\f5de;\n$fa-var-car-alt: \\f5de;\n$fa-var-pump-soap: \\e06b;\n$fa-var-video-slash: \\f4e2;\n$fa-var-battery-quarter: \\f243;\n$fa-var-battery-2: \\f243;\n$fa-var-radio: \\f8d7;\n$fa-var-baby-carriage: \\f77d;\n$fa-var-carriage-baby: \\f77d;\n$fa-var-traffic-light: \\f637;\n$fa-var-thermometer: \\f491;\n$fa-var-vr-cardboard: \\f729;\n$fa-var-hand-middle-finger: \\f806;\n$fa-var-percent: \\25;\n$fa-var-percentage: \\25;\n$fa-var-truck-moving: \\f4df;\n$fa-var-glass-water-droplet: \\e4f5;\n$fa-var-display: \\e163;\n$fa-var-face-smile: \\f118;\n$fa-var-smile: \\f118;\n$fa-var-thumbtack: \\f08d;\n$fa-var-thumb-tack: \\f08d;\n$fa-var-trophy: \\f091;\n$fa-var-person-praying: \\f683;\n$fa-var-pray: \\f683;\n$fa-var-hammer: \\f6e3;\n$fa-var-hand-peace: \\f25b;\n$fa-var-rotate: \\f2f1;\n$fa-var-sync-alt: \\f2f1;\n$fa-var-spinner: \\f110;\n$fa-var-robot: \\f544;\n$fa-var-peace: \\f67c;\n$fa-var-gears: \\f085;\n$fa-var-cogs: \\f085;\n$fa-var-warehouse: \\f494;\n$fa-var-arrow-up-right-dots: \\e4b7;\n$fa-var-splotch: \\f5bc;\n$fa-var-face-grin-hearts: \\f584;\n$fa-var-grin-hearts: \\f584;\n$fa-var-dice-four: \\f524;\n$fa-var-sim-card: \\f7c4;\n$fa-var-transgender: \\f225;\n$fa-var-transgender-alt: \\f225;\n$fa-var-mercury: \\f223;\n$fa-var-arrow-turn-down: \\f149;\n$fa-var-level-down: \\f149;\n$fa-var-person-falling-burst: \\e547;\n$fa-var-award: \\f559;\n$fa-var-ticket-simple: \\f3ff;\n$fa-var-ticket-alt: \\f3ff;\n$fa-var-building: \\f1ad;\n$fa-var-angles-left: \\f100;\n$fa-var-angle-double-left: \\f100;\n$fa-var-qrcode: \\f029;\n$fa-var-clock-rotate-left: \\f1da;\n$fa-var-history: \\f1da;\n$fa-var-face-grin-beam-sweat: \\f583;\n$fa-var-grin-beam-sweat: \\f583;\n$fa-var-file-export: \\f56e;\n$fa-var-arrow-right-from-file: \\f56e;\n$fa-var-shield: \\f132;\n$fa-var-shield-blank: \\f132;\n$fa-var-arrow-up-short-wide: \\f885;\n$fa-var-sort-amount-up-alt: \\f885;\n$fa-var-house-medical: \\e3b2;\n$fa-var-golf-ball-tee: \\f450;\n$fa-var-golf-ball: \\f450;\n$fa-var-circle-chevron-left: \\f137;\n$fa-var-chevron-circle-left: \\f137;\n$fa-var-house-chimney-window: \\e00d;\n$fa-var-pen-nib: \\f5ad;\n$fa-var-tent-arrow-turn-left: \\e580;\n$fa-var-tents: \\e582;\n$fa-var-wand-magic: \\f0d0;\n$fa-var-magic: \\f0d0;\n$fa-var-dog: \\f6d3;\n$fa-var-carrot: \\f787;\n$fa-var-moon: \\f186;\n$fa-var-wine-glass-empty: \\f5ce;\n$fa-var-wine-glass-alt: \\f5ce;\n$fa-var-cheese: \\f7ef;\n$fa-var-yin-yang: \\f6ad;\n$fa-var-music: \\f001;\n$fa-var-code-commit: \\f386;\n$fa-var-temperature-low: \\f76b;\n$fa-var-person-biking: \\f84a;\n$fa-var-biking: \\f84a;\n$fa-var-broom: \\f51a;\n$fa-var-shield-heart: \\e574;\n$fa-var-gopuram: \\f664;\n$fa-var-earth-oceania: \\e47b;\n$fa-var-globe-oceania: \\e47b;\n$fa-var-square-xmark: \\f2d3;\n$fa-var-times-square: \\f2d3;\n$fa-var-xmark-square: \\f2d3;\n$fa-var-hashtag: \\23;\n$fa-var-up-right-and-down-left-from-center: \\f424;\n$fa-var-expand-alt: \\f424;\n$fa-var-oil-can: \\f613;\n$fa-var-t: \\54;\n$fa-var-hippo: \\f6ed;\n$fa-var-chart-column: \\e0e3;\n$fa-var-infinity: \\f534;\n$fa-var-vial-circle-check: \\e596;\n$fa-var-person-arrow-down-to-line: \\e538;\n$fa-var-voicemail: \\f897;\n$fa-var-fan: \\f863;\n$fa-var-person-walking-luggage: \\e554;\n$fa-var-up-down: \\f338;\n$fa-var-arrows-alt-v: \\f338;\n$fa-var-cloud-moon-rain: \\f73c;\n$fa-var-calendar: \\f133;\n$fa-var-trailer: \\e041;\n$fa-var-bahai: \\f666;\n$fa-var-haykal: \\f666;\n$fa-var-sd-card: \\f7c2;\n$fa-var-dragon: \\f6d5;\n$fa-var-shoe-prints: \\f54b;\n$fa-var-circle-plus: \\f055;\n$fa-var-plus-circle: \\f055;\n$fa-var-face-grin-tongue-wink: \\f58b;\n$fa-var-grin-tongue-wink: \\f58b;\n$fa-var-hand-holding: \\f4bd;\n$fa-var-plug-circle-exclamation: \\e55d;\n$fa-var-link-slash: \\f127;\n$fa-var-chain-broken: \\f127;\n$fa-var-chain-slash: \\f127;\n$fa-var-unlink: \\f127;\n$fa-var-clone: \\f24d;\n$fa-var-person-walking-arrow-loop-left: \\e551;\n$fa-var-arrow-up-z-a: \\f882;\n$fa-var-sort-alpha-up-alt: \\f882;\n$fa-var-fire-flame-curved: \\f7e4;\n$fa-var-fire-alt: \\f7e4;\n$fa-var-tornado: \\f76f;\n$fa-var-file-circle-plus: \\e494;\n$fa-var-book-quran: \\f687;\n$fa-var-quran: \\f687;\n$fa-var-anchor: \\f13d;\n$fa-var-border-all: \\f84c;\n$fa-var-face-angry: \\f556;\n$fa-var-angry: \\f556;\n$fa-var-cookie-bite: \\f564;\n$fa-var-arrow-trend-down: \\e097;\n$fa-var-rss: \\f09e;\n$fa-var-feed: \\f09e;\n$fa-var-draw-polygon: \\f5ee;\n$fa-var-scale-balanced: \\f24e;\n$fa-var-balance-scale: \\f24e;\n$fa-var-gauge-simple-high: \\f62a;\n$fa-var-tachometer: \\f62a;\n$fa-var-tachometer-fast: \\f62a;\n$fa-var-shower: \\f2cc;\n$fa-var-desktop: \\f390;\n$fa-var-desktop-alt: \\f390;\n$fa-var-m: \\4d;\n$fa-var-table-list: \\f00b;\n$fa-var-th-list: \\f00b;\n$fa-var-comment-sms: \\f7cd;\n$fa-var-sms: \\f7cd;\n$fa-var-book: \\f02d;\n$fa-var-user-plus: \\f234;\n$fa-var-check: \\f00c;\n$fa-var-battery-three-quarters: \\f241;\n$fa-var-battery-4: \\f241;\n$fa-var-house-circle-check: \\e509;\n$fa-var-angle-left: \\f104;\n$fa-var-diagram-successor: \\e47a;\n$fa-var-truck-arrow-right: \\e58b;\n$fa-var-arrows-split-up-and-left: \\e4bc;\n$fa-var-hand-fist: \\f6de;\n$fa-var-fist-raised: \\f6de;\n$fa-var-cloud-moon: \\f6c3;\n$fa-var-briefcase: \\f0b1;\n$fa-var-person-falling: \\e546;\n$fa-var-image-portrait: \\f3e0;\n$fa-var-portrait: \\f3e0;\n$fa-var-user-tag: \\f507;\n$fa-var-rug: \\e569;\n$fa-var-earth-europe: \\f7a2;\n$fa-var-globe-europe: \\f7a2;\n$fa-var-cart-flatbed-suitcase: \\f59d;\n$fa-var-luggage-cart: \\f59d;\n$fa-var-rectangle-xmark: \\f410;\n$fa-var-rectangle-times: \\f410;\n$fa-var-times-rectangle: \\f410;\n$fa-var-window-close: \\f410;\n$fa-var-baht-sign: \\e0ac;\n$fa-var-book-open: \\f518;\n$fa-var-book-journal-whills: \\f66a;\n$fa-var-journal-whills: \\f66a;\n$fa-var-handcuffs: \\e4f8;\n$fa-var-triangle-exclamation: \\f071;\n$fa-var-exclamation-triangle: \\f071;\n$fa-var-warning: \\f071;\n$fa-var-database: \\f1c0;\n$fa-var-share: \\f064;\n$fa-var-mail-forward: \\f064;\n$fa-var-bottle-droplet: \\e4c4;\n$fa-var-mask-face: \\e1d7;\n$fa-var-hill-rockslide: \\e508;\n$fa-var-right-left: \\f362;\n$fa-var-exchange-alt: \\f362;\n$fa-var-paper-plane: \\f1d8;\n$fa-var-road-circle-exclamation: \\e565;\n$fa-var-dungeon: \\f6d9;\n$fa-var-align-right: \\f038;\n$fa-var-money-bill-1-wave: \\f53b;\n$fa-var-money-bill-wave-alt: \\f53b;\n$fa-var-life-ring: \\f1cd;\n$fa-var-hands: \\f2a7;\n$fa-var-sign-language: \\f2a7;\n$fa-var-signing: \\f2a7;\n$fa-var-calendar-day: \\f783;\n$fa-var-water-ladder: \\f5c5;\n$fa-var-ladder-water: \\f5c5;\n$fa-var-swimming-pool: \\f5c5;\n$fa-var-arrows-up-down: \\f07d;\n$fa-var-arrows-v: \\f07d;\n$fa-var-face-grimace: \\f57f;\n$fa-var-grimace: \\f57f;\n$fa-var-wheelchair-move: \\e2ce;\n$fa-var-wheelchair-alt: \\e2ce;\n$fa-var-turn-down: \\f3be;\n$fa-var-level-down-alt: \\f3be;\n$fa-var-person-walking-arrow-right: \\e552;\n$fa-var-square-envelope: \\f199;\n$fa-var-envelope-square: \\f199;\n$fa-var-dice: \\f522;\n$fa-var-bowling-ball: \\f436;\n$fa-var-brain: \\f5dc;\n$fa-var-bandage: \\f462;\n$fa-var-band-aid: \\f462;\n$fa-var-calendar-minus: \\f272;\n$fa-var-circle-xmark: \\f057;\n$fa-var-times-circle: \\f057;\n$fa-var-xmark-circle: \\f057;\n$fa-var-gifts: \\f79c;\n$fa-var-hotel: \\f594;\n$fa-var-earth-asia: \\f57e;\n$fa-var-globe-asia: \\f57e;\n$fa-var-id-card-clip: \\f47f;\n$fa-var-id-card-alt: \\f47f;\n$fa-var-magnifying-glass-plus: \\f00e;\n$fa-var-search-plus: \\f00e;\n$fa-var-thumbs-up: \\f164;\n$fa-var-user-clock: \\f4fd;\n$fa-var-hand-dots: \\f461;\n$fa-var-allergies: \\f461;\n$fa-var-file-invoice: \\f570;\n$fa-var-window-minimize: \\f2d1;\n$fa-var-mug-saucer: \\f0f4;\n$fa-var-coffee: \\f0f4;\n$fa-var-brush: \\f55d;\n$fa-var-mask: \\f6fa;\n$fa-var-magnifying-glass-minus: \\f010;\n$fa-var-search-minus: \\f010;\n$fa-var-ruler-vertical: \\f548;\n$fa-var-user-large: \\f406;\n$fa-var-user-alt: \\f406;\n$fa-var-train-tram: \\e5b4;\n$fa-var-user-nurse: \\f82f;\n$fa-var-syringe: \\f48e;\n$fa-var-cloud-sun: \\f6c4;\n$fa-var-stopwatch-20: \\e06f;\n$fa-var-square-full: \\f45c;\n$fa-var-magnet: \\f076;\n$fa-var-jar: \\e516;\n$fa-var-note-sticky: \\f249;\n$fa-var-sticky-note: \\f249;\n$fa-var-bug-slash: \\e490;\n$fa-var-arrow-up-from-water-pump: \\e4b6;\n$fa-var-bone: \\f5d7;\n$fa-var-table-cells-row-unlock: \\e691;\n$fa-var-user-injured: \\f728;\n$fa-var-face-sad-tear: \\f5b4;\n$fa-var-sad-tear: \\f5b4;\n$fa-var-plane: \\f072;\n$fa-var-tent-arrows-down: \\e581;\n$fa-var-exclamation: \\21;\n$fa-var-arrows-spin: \\e4bb;\n$fa-var-print: \\f02f;\n$fa-var-turkish-lira-sign: \\e2bb;\n$fa-var-try: \\e2bb;\n$fa-var-turkish-lira: \\e2bb;\n$fa-var-dollar-sign: \\24;\n$fa-var-dollar: \\24;\n$fa-var-usd: \\24;\n$fa-var-x: \\58;\n$fa-var-magnifying-glass-dollar: \\f688;\n$fa-var-search-dollar: \\f688;\n$fa-var-users-gear: \\f509;\n$fa-var-users-cog: \\f509;\n$fa-var-person-military-pointing: \\e54a;\n$fa-var-building-columns: \\f19c;\n$fa-var-bank: \\f19c;\n$fa-var-institution: \\f19c;\n$fa-var-museum: \\f19c;\n$fa-var-university: \\f19c;\n$fa-var-umbrella: \\f0e9;\n$fa-var-trowel: \\e589;\n$fa-var-d: \\44;\n$fa-var-stapler: \\e5af;\n$fa-var-masks-theater: \\f630;\n$fa-var-theater-masks: \\f630;\n$fa-var-kip-sign: \\e1c4;\n$fa-var-hand-point-left: \\f0a5;\n$fa-var-handshake-simple: \\f4c6;\n$fa-var-handshake-alt: \\f4c6;\n$fa-var-jet-fighter: \\f0fb;\n$fa-var-fighter-jet: \\f0fb;\n$fa-var-square-share-nodes: \\f1e1;\n$fa-var-share-alt-square: \\f1e1;\n$fa-var-barcode: \\f02a;\n$fa-var-plus-minus: \\e43c;\n$fa-var-video: \\f03d;\n$fa-var-video-camera: \\f03d;\n$fa-var-graduation-cap: \\f19d;\n$fa-var-mortar-board: \\f19d;\n$fa-var-hand-holding-medical: \\e05c;\n$fa-var-person-circle-check: \\e53e;\n$fa-var-turn-up: \\f3bf;\n$fa-var-level-up-alt: \\f3bf;\n\n$fa-var-monero: \\f3d0;\n$fa-var-hooli: \\f427;\n$fa-var-yelp: \\f1e9;\n$fa-var-cc-visa: \\f1f0;\n$fa-var-lastfm: \\f202;\n$fa-var-shopware: \\f5b5;\n$fa-var-creative-commons-nc: \\f4e8;\n$fa-var-aws: \\f375;\n$fa-var-redhat: \\f7bc;\n$fa-var-yoast: \\f2b1;\n$fa-var-cloudflare: \\e07d;\n$fa-var-ups: \\f7e0;\n$fa-var-pixiv: \\e640;\n$fa-var-wpexplorer: \\f2de;\n$fa-var-dyalog: \\f399;\n$fa-var-bity: \\f37a;\n$fa-var-stackpath: \\f842;\n$fa-var-buysellads: \\f20d;\n$fa-var-first-order: \\f2b0;\n$fa-var-modx: \\f285;\n$fa-var-guilded: \\e07e;\n$fa-var-vnv: \\f40b;\n$fa-var-square-js: \\f3b9;\n$fa-var-js-square: \\f3b9;\n$fa-var-microsoft: \\f3ca;\n$fa-var-qq: \\f1d6;\n$fa-var-orcid: \\f8d2;\n$fa-var-java: \\f4e4;\n$fa-var-invision: \\f7b0;\n$fa-var-creative-commons-pd-alt: \\f4ed;\n$fa-var-centercode: \\f380;\n$fa-var-glide-g: \\f2a6;\n$fa-var-drupal: \\f1a9;\n$fa-var-jxl: \\e67b;\n$fa-var-dart-lang: \\e693;\n$fa-var-hire-a-helper: \\f3b0;\n$fa-var-creative-commons-by: \\f4e7;\n$fa-var-unity: \\e049;\n$fa-var-whmcs: \\f40d;\n$fa-var-rocketchat: \\f3e8;\n$fa-var-vk: \\f189;\n$fa-var-untappd: \\f405;\n$fa-var-mailchimp: \\f59e;\n$fa-var-css3-alt: \\f38b;\n$fa-var-square-reddit: \\f1a2;\n$fa-var-reddit-square: \\f1a2;\n$fa-var-vimeo-v: \\f27d;\n$fa-var-contao: \\f26d;\n$fa-var-square-font-awesome: \\e5ad;\n$fa-var-deskpro: \\f38f;\n$fa-var-brave: \\e63c;\n$fa-var-sistrix: \\f3ee;\n$fa-var-square-instagram: \\e055;\n$fa-var-instagram-square: \\e055;\n$fa-var-battle-net: \\f835;\n$fa-var-the-red-yeti: \\f69d;\n$fa-var-square-hacker-news: \\f3af;\n$fa-var-hacker-news-square: \\f3af;\n$fa-var-edge: \\f282;\n$fa-var-threads: \\e618;\n$fa-var-napster: \\f3d2;\n$fa-var-square-snapchat: \\f2ad;\n$fa-var-snapchat-square: \\f2ad;\n$fa-var-google-plus-g: \\f0d5;\n$fa-var-artstation: \\f77a;\n$fa-var-markdown: \\f60f;\n$fa-var-sourcetree: \\f7d3;\n$fa-var-google-plus: \\f2b3;\n$fa-var-diaspora: \\f791;\n$fa-var-foursquare: \\f180;\n$fa-var-stack-overflow: \\f16c;\n$fa-var-github-alt: \\f113;\n$fa-var-phoenix-squadron: \\f511;\n$fa-var-pagelines: \\f18c;\n$fa-var-algolia: \\f36c;\n$fa-var-red-river: \\f3e3;\n$fa-var-creative-commons-sa: \\f4ef;\n$fa-var-safari: \\f267;\n$fa-var-google: \\f1a0;\n$fa-var-square-font-awesome-stroke: \\f35c;\n$fa-var-font-awesome-alt: \\f35c;\n$fa-var-atlassian: \\f77b;\n$fa-var-linkedin-in: \\f0e1;\n$fa-var-digital-ocean: \\f391;\n$fa-var-nimblr: \\f5a8;\n$fa-var-chromecast: \\f838;\n$fa-var-evernote: \\f839;\n$fa-var-hacker-news: \\f1d4;\n$fa-var-creative-commons-sampling: \\f4f0;\n$fa-var-adversal: \\f36a;\n$fa-var-creative-commons: \\f25e;\n$fa-var-watchman-monitoring: \\e087;\n$fa-var-fonticons: \\f280;\n$fa-var-weixin: \\f1d7;\n$fa-var-shirtsinbulk: \\f214;\n$fa-var-codepen: \\f1cb;\n$fa-var-git-alt: \\f841;\n$fa-var-lyft: \\f3c3;\n$fa-var-rev: \\f5b2;\n$fa-var-windows: \\f17a;\n$fa-var-wizards-of-the-coast: \\f730;\n$fa-var-square-viadeo: \\f2aa;\n$fa-var-viadeo-square: \\f2aa;\n$fa-var-meetup: \\f2e0;\n$fa-var-centos: \\f789;\n$fa-var-adn: \\f170;\n$fa-var-cloudsmith: \\f384;\n$fa-var-opensuse: \\e62b;\n$fa-var-pied-piper-alt: \\f1a8;\n$fa-var-square-dribbble: \\f397;\n$fa-var-dribbble-square: \\f397;\n$fa-var-codiepie: \\f284;\n$fa-var-node: \\f419;\n$fa-var-mix: \\f3cb;\n$fa-var-steam: \\f1b6;\n$fa-var-cc-apple-pay: \\f416;\n$fa-var-scribd: \\f28a;\n$fa-var-debian: \\e60b;\n$fa-var-openid: \\f19b;\n$fa-var-instalod: \\e081;\n$fa-var-expeditedssl: \\f23e;\n$fa-var-sellcast: \\f2da;\n$fa-var-square-twitter: \\f081;\n$fa-var-twitter-square: \\f081;\n$fa-var-r-project: \\f4f7;\n$fa-var-delicious: \\f1a5;\n$fa-var-freebsd: \\f3a4;\n$fa-var-vuejs: \\f41f;\n$fa-var-accusoft: \\f369;\n$fa-var-ioxhost: \\f208;\n$fa-var-fonticons-fi: \\f3a2;\n$fa-var-app-store: \\f36f;\n$fa-var-cc-mastercard: \\f1f1;\n$fa-var-itunes-note: \\f3b5;\n$fa-var-golang: \\e40f;\n$fa-var-kickstarter: \\f3bb;\n$fa-var-square-kickstarter: \\f3bb;\n$fa-var-grav: \\f2d6;\n$fa-var-weibo: \\f18a;\n$fa-var-uncharted: \\e084;\n$fa-var-firstdraft: \\f3a1;\n$fa-var-square-youtube: \\f431;\n$fa-var-youtube-square: \\f431;\n$fa-var-wikipedia-w: \\f266;\n$fa-var-wpressr: \\f3e4;\n$fa-var-rendact: \\f3e4;\n$fa-var-angellist: \\f209;\n$fa-var-galactic-republic: \\f50c;\n$fa-var-nfc-directional: \\e530;\n$fa-var-skype: \\f17e;\n$fa-var-joget: \\f3b7;\n$fa-var-fedora: \\f798;\n$fa-var-stripe-s: \\f42a;\n$fa-var-meta: \\e49b;\n$fa-var-laravel: \\f3bd;\n$fa-var-hotjar: \\f3b1;\n$fa-var-bluetooth-b: \\f294;\n$fa-var-square-letterboxd: \\e62e;\n$fa-var-sticker-mule: \\f3f7;\n$fa-var-creative-commons-zero: \\f4f3;\n$fa-var-hips: \\f452;\n$fa-var-behance: \\f1b4;\n$fa-var-reddit: \\f1a1;\n$fa-var-discord: \\f392;\n$fa-var-chrome: \\f268;\n$fa-var-app-store-ios: \\f370;\n$fa-var-cc-discover: \\f1f2;\n$fa-var-wpbeginner: \\f297;\n$fa-var-confluence: \\f78d;\n$fa-var-shoelace: \\e60c;\n$fa-var-mdb: \\f8ca;\n$fa-var-dochub: \\f394;\n$fa-var-accessible-icon: \\f368;\n$fa-var-ebay: \\f4f4;\n$fa-var-amazon: \\f270;\n$fa-var-unsplash: \\e07c;\n$fa-var-yarn: \\f7e3;\n$fa-var-square-steam: \\f1b7;\n$fa-var-steam-square: \\f1b7;\n$fa-var-500px: \\f26e;\n$fa-var-square-vimeo: \\f194;\n$fa-var-vimeo-square: \\f194;\n$fa-var-asymmetrik: \\f372;\n$fa-var-font-awesome: \\f2b4;\n$fa-var-font-awesome-flag: \\f2b4;\n$fa-var-font-awesome-logo-full: \\f2b4;\n$fa-var-gratipay: \\f184;\n$fa-var-apple: \\f179;\n$fa-var-hive: \\e07f;\n$fa-var-gitkraken: \\f3a6;\n$fa-var-keybase: \\f4f5;\n$fa-var-apple-pay: \\f415;\n$fa-var-padlet: \\e4a0;\n$fa-var-amazon-pay: \\f42c;\n$fa-var-square-github: \\f092;\n$fa-var-github-square: \\f092;\n$fa-var-stumbleupon: \\f1a4;\n$fa-var-fedex: \\f797;\n$fa-var-phoenix-framework: \\f3dc;\n$fa-var-shopify: \\e057;\n$fa-var-neos: \\f612;\n$fa-var-square-threads: \\e619;\n$fa-var-hackerrank: \\f5f7;\n$fa-var-researchgate: \\f4f8;\n$fa-var-swift: \\f8e1;\n$fa-var-angular: \\f420;\n$fa-var-speakap: \\f3f3;\n$fa-var-angrycreative: \\f36e;\n$fa-var-y-combinator: \\f23b;\n$fa-var-empire: \\f1d1;\n$fa-var-envira: \\f299;\n$fa-var-google-scholar: \\e63b;\n$fa-var-square-gitlab: \\e5ae;\n$fa-var-gitlab-square: \\e5ae;\n$fa-var-studiovinari: \\f3f8;\n$fa-var-pied-piper: \\f2ae;\n$fa-var-wordpress: \\f19a;\n$fa-var-product-hunt: \\f288;\n$fa-var-firefox: \\f269;\n$fa-var-linode: \\f2b8;\n$fa-var-goodreads: \\f3a8;\n$fa-var-square-odnoklassniki: \\f264;\n$fa-var-odnoklassniki-square: \\f264;\n$fa-var-jsfiddle: \\f1cc;\n$fa-var-sith: \\f512;\n$fa-var-themeisle: \\f2b2;\n$fa-var-page4: \\f3d7;\n$fa-var-hashnode: \\e499;\n$fa-var-react: \\f41b;\n$fa-var-cc-paypal: \\f1f4;\n$fa-var-squarespace: \\f5be;\n$fa-var-cc-stripe: \\f1f5;\n$fa-var-creative-commons-share: \\f4f2;\n$fa-var-bitcoin: \\f379;\n$fa-var-keycdn: \\f3ba;\n$fa-var-opera: \\f26a;\n$fa-var-itch-io: \\f83a;\n$fa-var-umbraco: \\f8e8;\n$fa-var-galactic-senate: \\f50d;\n$fa-var-ubuntu: \\f7df;\n$fa-var-draft2digital: \\f396;\n$fa-var-stripe: \\f429;\n$fa-var-houzz: \\f27c;\n$fa-var-gg: \\f260;\n$fa-var-dhl: \\f790;\n$fa-var-square-pinterest: \\f0d3;\n$fa-var-pinterest-square: \\f0d3;\n$fa-var-xing: \\f168;\n$fa-var-blackberry: \\f37b;\n$fa-var-creative-commons-pd: \\f4ec;\n$fa-var-playstation: \\f3df;\n$fa-var-quinscape: \\f459;\n$fa-var-less: \\f41d;\n$fa-var-blogger-b: \\f37d;\n$fa-var-opencart: \\f23d;\n$fa-var-vine: \\f1ca;\n$fa-var-signal-messenger: \\e663;\n$fa-var-paypal: \\f1ed;\n$fa-var-gitlab: \\f296;\n$fa-var-typo3: \\f42b;\n$fa-var-reddit-alien: \\f281;\n$fa-var-yahoo: \\f19e;\n$fa-var-dailymotion: \\e052;\n$fa-var-affiliatetheme: \\f36b;\n$fa-var-pied-piper-pp: \\f1a7;\n$fa-var-bootstrap: \\f836;\n$fa-var-odnoklassniki: \\f263;\n$fa-var-nfc-symbol: \\e531;\n$fa-var-mintbit: \\e62f;\n$fa-var-ethereum: \\f42e;\n$fa-var-speaker-deck: \\f83c;\n$fa-var-creative-commons-nc-eu: \\f4e9;\n$fa-var-patreon: \\f3d9;\n$fa-var-avianex: \\f374;\n$fa-var-ello: \\f5f1;\n$fa-var-gofore: \\f3a7;\n$fa-var-bimobject: \\f378;\n$fa-var-brave-reverse: \\e63d;\n$fa-var-facebook-f: \\f39e;\n$fa-var-square-google-plus: \\f0d4;\n$fa-var-google-plus-square: \\f0d4;\n$fa-var-web-awesome: \\e682;\n$fa-var-mandalorian: \\f50f;\n$fa-var-first-order-alt: \\f50a;\n$fa-var-osi: \\f41a;\n$fa-var-google-wallet: \\f1ee;\n$fa-var-d-and-d-beyond: \\f6ca;\n$fa-var-periscope: \\f3da;\n$fa-var-fulcrum: \\f50b;\n$fa-var-cloudscale: \\f383;\n$fa-var-forumbee: \\f211;\n$fa-var-mizuni: \\f3cc;\n$fa-var-schlix: \\f3ea;\n$fa-var-square-xing: \\f169;\n$fa-var-xing-square: \\f169;\n$fa-var-bandcamp: \\f2d5;\n$fa-var-wpforms: \\f298;\n$fa-var-cloudversify: \\f385;\n$fa-var-usps: \\f7e1;\n$fa-var-megaport: \\f5a3;\n$fa-var-magento: \\f3c4;\n$fa-var-spotify: \\f1bc;\n$fa-var-optin-monster: \\f23c;\n$fa-var-fly: \\f417;\n$fa-var-aviato: \\f421;\n$fa-var-itunes: \\f3b4;\n$fa-var-cuttlefish: \\f38c;\n$fa-var-blogger: \\f37c;\n$fa-var-flickr: \\f16e;\n$fa-var-viber: \\f409;\n$fa-var-soundcloud: \\f1be;\n$fa-var-digg: \\f1a6;\n$fa-var-tencent-weibo: \\f1d5;\n$fa-var-letterboxd: \\e62d;\n$fa-var-symfony: \\f83d;\n$fa-var-maxcdn: \\f136;\n$fa-var-etsy: \\f2d7;\n$fa-var-facebook-messenger: \\f39f;\n$fa-var-audible: \\f373;\n$fa-var-think-peaks: \\f731;\n$fa-var-bilibili: \\e3d9;\n$fa-var-erlang: \\f39d;\n$fa-var-x-twitter: \\e61b;\n$fa-var-cotton-bureau: \\f89e;\n$fa-var-dashcube: \\f210;\n$fa-var-42-group: \\e080;\n$fa-var-innosoft: \\e080;\n$fa-var-stack-exchange: \\f18d;\n$fa-var-elementor: \\f430;\n$fa-var-square-pied-piper: \\e01e;\n$fa-var-pied-piper-square: \\e01e;\n$fa-var-creative-commons-nd: \\f4eb;\n$fa-var-palfed: \\f3d8;\n$fa-var-superpowers: \\f2dd;\n$fa-var-resolving: \\f3e7;\n$fa-var-xbox: \\f412;\n$fa-var-square-web-awesome-stroke: \\e684;\n$fa-var-searchengin: \\f3eb;\n$fa-var-tiktok: \\e07b;\n$fa-var-square-facebook: \\f082;\n$fa-var-facebook-square: \\f082;\n$fa-var-renren: \\f18b;\n$fa-var-linux: \\f17c;\n$fa-var-glide: \\f2a5;\n$fa-var-linkedin: \\f08c;\n$fa-var-hubspot: \\f3b2;\n$fa-var-deploydog: \\f38e;\n$fa-var-twitch: \\f1e8;\n$fa-var-flutter: \\e694;\n$fa-var-ravelry: \\f2d9;\n$fa-var-mixer: \\e056;\n$fa-var-square-lastfm: \\f203;\n$fa-var-lastfm-square: \\f203;\n$fa-var-vimeo: \\f40a;\n$fa-var-mendeley: \\f7b3;\n$fa-var-uniregistry: \\f404;\n$fa-var-figma: \\f799;\n$fa-var-creative-commons-remix: \\f4ee;\n$fa-var-cc-amazon-pay: \\f42d;\n$fa-var-dropbox: \\f16b;\n$fa-var-instagram: \\f16d;\n$fa-var-cmplid: \\e360;\n$fa-var-upwork: \\e641;\n$fa-var-facebook: \\f09a;\n$fa-var-gripfire: \\f3ac;\n$fa-var-jedi-order: \\f50e;\n$fa-var-uikit: \\f403;\n$fa-var-fort-awesome-alt: \\f3a3;\n$fa-var-phabricator: \\f3db;\n$fa-var-ussunnah: \\f407;\n$fa-var-earlybirds: \\f39a;\n$fa-var-trade-federation: \\f513;\n$fa-var-autoprefixer: \\f41c;\n$fa-var-whatsapp: \\f232;\n$fa-var-square-upwork: \\e67c;\n$fa-var-slideshare: \\f1e7;\n$fa-var-google-play: \\f3ab;\n$fa-var-viadeo: \\f2a9;\n$fa-var-line: \\f3c0;\n$fa-var-google-drive: \\f3aa;\n$fa-var-servicestack: \\f3ec;\n$fa-var-simplybuilt: \\f215;\n$fa-var-bitbucket: \\f171;\n$fa-var-imdb: \\f2d8;\n$fa-var-deezer: \\e077;\n$fa-var-raspberry-pi: \\f7bb;\n$fa-var-jira: \\f7b1;\n$fa-var-docker: \\f395;\n$fa-var-screenpal: \\e570;\n$fa-var-bluetooth: \\f293;\n$fa-var-gitter: \\f426;\n$fa-var-d-and-d: \\f38d;\n$fa-var-microblog: \\e01a;\n$fa-var-cc-diners-club: \\f24c;\n$fa-var-gg-circle: \\f261;\n$fa-var-pied-piper-hat: \\f4e5;\n$fa-var-kickstarter-k: \\f3bc;\n$fa-var-yandex: \\f413;\n$fa-var-readme: \\f4d5;\n$fa-var-html5: \\f13b;\n$fa-var-sellsy: \\f213;\n$fa-var-square-web-awesome: \\e683;\n$fa-var-sass: \\f41e;\n$fa-var-wirsindhandwerk: \\e2d0;\n$fa-var-wsh: \\e2d0;\n$fa-var-buromobelexperte: \\f37f;\n$fa-var-salesforce: \\f83b;\n$fa-var-octopus-deploy: \\e082;\n$fa-var-medapps: \\f3c6;\n$fa-var-ns8: \\f3d5;\n$fa-var-pinterest-p: \\f231;\n$fa-var-apper: \\f371;\n$fa-var-fort-awesome: \\f286;\n$fa-var-waze: \\f83f;\n$fa-var-bluesky: \\e671;\n$fa-var-cc-jcb: \\f24b;\n$fa-var-snapchat: \\f2ab;\n$fa-var-snapchat-ghost: \\f2ab;\n$fa-var-fantasy-flight-games: \\f6dc;\n$fa-var-rust: \\e07a;\n$fa-var-wix: \\f5cf;\n$fa-var-square-behance: \\f1b5;\n$fa-var-behance-square: \\f1b5;\n$fa-var-supple: \\f3f9;\n$fa-var-webflow: \\e65c;\n$fa-var-rebel: \\f1d0;\n$fa-var-css3: \\f13c;\n$fa-var-staylinked: \\f3f5;\n$fa-var-kaggle: \\f5fa;\n$fa-var-space-awesome: \\e5ac;\n$fa-var-deviantart: \\f1bd;\n$fa-var-cpanel: \\f388;\n$fa-var-goodreads-g: \\f3a9;\n$fa-var-square-git: \\f1d2;\n$fa-var-git-square: \\f1d2;\n$fa-var-square-tumblr: \\f174;\n$fa-var-tumblr-square: \\f174;\n$fa-var-trello: \\f181;\n$fa-var-creative-commons-nc-jp: \\f4ea;\n$fa-var-get-pocket: \\f265;\n$fa-var-perbyte: \\e083;\n$fa-var-grunt: \\f3ad;\n$fa-var-weebly: \\f5cc;\n$fa-var-connectdevelop: \\f20e;\n$fa-var-leanpub: \\f212;\n$fa-var-black-tie: \\f27e;\n$fa-var-themeco: \\f5c6;\n$fa-var-python: \\f3e2;\n$fa-var-android: \\f17b;\n$fa-var-bots: \\e340;\n$fa-var-free-code-camp: \\f2c5;\n$fa-var-hornbill: \\f592;\n$fa-var-js: \\f3b8;\n$fa-var-ideal: \\e013;\n$fa-var-git: \\f1d3;\n$fa-var-dev: \\f6cc;\n$fa-var-sketch: \\f7c6;\n$fa-var-yandex-international: \\f414;\n$fa-var-cc-amex: \\f1f3;\n$fa-var-uber: \\f402;\n$fa-var-github: \\f09b;\n$fa-var-php: \\f457;\n$fa-var-alipay: \\f642;\n$fa-var-youtube: \\f167;\n$fa-var-skyatlas: \\f216;\n$fa-var-firefox-browser: \\e007;\n$fa-var-replyd: \\f3e6;\n$fa-var-suse: \\f7d6;\n$fa-var-jenkins: \\f3b6;\n$fa-var-twitter: \\f099;\n$fa-var-rockrms: \\f3e9;\n$fa-var-pinterest: \\f0d2;\n$fa-var-buffer: \\f837;\n$fa-var-npm: \\f3d4;\n$fa-var-yammer: \\f840;\n$fa-var-btc: \\f15a;\n$fa-var-dribbble: \\f17d;\n$fa-var-stumbleupon-circle: \\f1a3;\n$fa-var-internet-explorer: \\f26b;\n$fa-var-stubber: \\e5c7;\n$fa-var-telegram: \\f2c6;\n$fa-var-telegram-plane: \\f2c6;\n$fa-var-old-republic: \\f510;\n$fa-var-odysee: \\e5c6;\n$fa-var-square-whatsapp: \\f40c;\n$fa-var-whatsapp-square: \\f40c;\n$fa-var-node-js: \\f3d3;\n$fa-var-edge-legacy: \\e078;\n$fa-var-slack: \\f198;\n$fa-var-slack-hash: \\f198;\n$fa-var-medrt: \\f3c8;\n$fa-var-usb: \\f287;\n$fa-var-tumblr: \\f173;\n$fa-var-vaadin: \\f408;\n$fa-var-quora: \\f2c4;\n$fa-var-square-x-twitter: \\e61a;\n$fa-var-reacteurope: \\f75d;\n$fa-var-medium: \\f23a;\n$fa-var-medium-m: \\f23a;\n$fa-var-amilia: \\f36d;\n$fa-var-mixcloud: \\f289;\n$fa-var-flipboard: \\f44d;\n$fa-var-viacoin: \\f237;\n$fa-var-critical-role: \\f6c9;\n$fa-var-sitrox: \\e44a;\n$fa-var-discourse: \\f393;\n$fa-var-joomla: \\f1aa;\n$fa-var-mastodon: \\f4f6;\n$fa-var-airbnb: \\f834;\n$fa-var-wolf-pack-battalion: \\f514;\n$fa-var-buy-n-large: \\f8a6;\n$fa-var-gulp: \\f3ae;\n$fa-var-creative-commons-sampling-plus: \\f4f1;\n$fa-var-strava: \\f428;\n$fa-var-ember: \\f423;\n$fa-var-canadian-maple-leaf: \\f785;\n$fa-var-teamspeak: \\f4f9;\n$fa-var-pushed: \\f3e1;\n$fa-var-wordpress-simple: \\f411;\n$fa-var-nutritionix: \\f3d6;\n$fa-var-wodu: \\e088;\n$fa-var-google-pay: \\e079;\n$fa-var-intercom: \\f7af;\n$fa-var-zhihu: \\f63f;\n$fa-var-korvue: \\f42f;\n$fa-var-pix: \\e43a;\n$fa-var-steam-symbol: \\f3f6;\n\n$fa-icons: (\n  '0': $fa-var-0,\n  '1': $fa-var-1,\n  '2': $fa-var-2,\n  '3': $fa-var-3,\n  '4': $fa-var-4,\n  '5': $fa-var-5,\n  '6': $fa-var-6,\n  '7': $fa-var-7,\n  '8': $fa-var-8,\n  '9': $fa-var-9,\n  'fill-drip': $fa-var-fill-drip,\n  'arrows-to-circle': $fa-var-arrows-to-circle,\n  'circle-chevron-right': $fa-var-circle-chevron-right,\n  'chevron-circle-right': $fa-var-chevron-circle-right,\n  'at': $fa-var-at,\n  'trash-can': $fa-var-trash-can,\n  'trash-alt': $fa-var-trash-alt,\n  'text-height': $fa-var-text-height,\n  'user-xmark': $fa-var-user-xmark,\n  'user-times': $fa-var-user-times,\n  'stethoscope': $fa-var-stethoscope,\n  'message': $fa-var-message,\n  'comment-alt': $fa-var-comment-alt,\n  'info': $fa-var-info,\n  'down-left-and-up-right-to-center': $fa-var-down-left-and-up-right-to-center,\n  'compress-alt': $fa-var-compress-alt,\n  'explosion': $fa-var-explosion,\n  'file-lines': $fa-var-file-lines,\n  'file-alt': $fa-var-file-alt,\n  'file-text': $fa-var-file-text,\n  'wave-square': $fa-var-wave-square,\n  'ring': $fa-var-ring,\n  'building-un': $fa-var-building-un,\n  'dice-three': $fa-var-dice-three,\n  'calendar-days': $fa-var-calendar-days,\n  'calendar-alt': $fa-var-calendar-alt,\n  'anchor-circle-check': $fa-var-anchor-circle-check,\n  'building-circle-arrow-right': $fa-var-building-circle-arrow-right,\n  'volleyball': $fa-var-volleyball,\n  'volleyball-ball': $fa-var-volleyball-ball,\n  'arrows-up-to-line': $fa-var-arrows-up-to-line,\n  'sort-down': $fa-var-sort-down,\n  'sort-desc': $fa-var-sort-desc,\n  'circle-minus': $fa-var-circle-minus,\n  'minus-circle': $fa-var-minus-circle,\n  'door-open': $fa-var-door-open,\n  'right-from-bracket': $fa-var-right-from-bracket,\n  'sign-out-alt': $fa-var-sign-out-alt,\n  'atom': $fa-var-atom,\n  'soap': $fa-var-soap,\n  'icons': $fa-var-icons,\n  'heart-music-camera-bolt': $fa-var-heart-music-camera-bolt,\n  'microphone-lines-slash': $fa-var-microphone-lines-slash,\n  'microphone-alt-slash': $fa-var-microphone-alt-slash,\n  'bridge-circle-check': $fa-var-bridge-circle-check,\n  'pump-medical': $fa-var-pump-medical,\n  'fingerprint': $fa-var-fingerprint,\n  'hand-point-right': $fa-var-hand-point-right,\n  'magnifying-glass-location': $fa-var-magnifying-glass-location,\n  'search-location': $fa-var-search-location,\n  'forward-step': $fa-var-forward-step,\n  'step-forward': $fa-var-step-forward,\n  'face-smile-beam': $fa-var-face-smile-beam,\n  'smile-beam': $fa-var-smile-beam,\n  'flag-checkered': $fa-var-flag-checkered,\n  'football': $fa-var-football,\n  'football-ball': $fa-var-football-ball,\n  'school-circle-exclamation': $fa-var-school-circle-exclamation,\n  'crop': $fa-var-crop,\n  'angles-down': $fa-var-angles-down,\n  'angle-double-down': $fa-var-angle-double-down,\n  'users-rectangle': $fa-var-users-rectangle,\n  'people-roof': $fa-var-people-roof,\n  'people-line': $fa-var-people-line,\n  'beer-mug-empty': $fa-var-beer-mug-empty,\n  'beer': $fa-var-beer,\n  'diagram-predecessor': $fa-var-diagram-predecessor,\n  'arrow-up-long': $fa-var-arrow-up-long,\n  'long-arrow-up': $fa-var-long-arrow-up,\n  'fire-flame-simple': $fa-var-fire-flame-simple,\n  'burn': $fa-var-burn,\n  'person': $fa-var-person,\n  'male': $fa-var-male,\n  'laptop': $fa-var-laptop,\n  'file-csv': $fa-var-file-csv,\n  'menorah': $fa-var-menorah,\n  'truck-plane': $fa-var-truck-plane,\n  'record-vinyl': $fa-var-record-vinyl,\n  'face-grin-stars': $fa-var-face-grin-stars,\n  'grin-stars': $fa-var-grin-stars,\n  'bong': $fa-var-bong,\n  'spaghetti-monster-flying': $fa-var-spaghetti-monster-flying,\n  'pastafarianism': $fa-var-pastafarianism,\n  'arrow-down-up-across-line': $fa-var-arrow-down-up-across-line,\n  'spoon': $fa-var-spoon,\n  'utensil-spoon': $fa-var-utensil-spoon,\n  'jar-wheat': $fa-var-jar-wheat,\n  'envelopes-bulk': $fa-var-envelopes-bulk,\n  'mail-bulk': $fa-var-mail-bulk,\n  'file-circle-exclamation': $fa-var-file-circle-exclamation,\n  'circle-h': $fa-var-circle-h,\n  'hospital-symbol': $fa-var-hospital-symbol,\n  'pager': $fa-var-pager,\n  'address-book': $fa-var-address-book,\n  'contact-book': $fa-var-contact-book,\n  'strikethrough': $fa-var-strikethrough,\n  'k': $fa-var-k,\n  'landmark-flag': $fa-var-landmark-flag,\n  'pencil': $fa-var-pencil,\n  'pencil-alt': $fa-var-pencil-alt,\n  'backward': $fa-var-backward,\n  'caret-right': $fa-var-caret-right,\n  'comments': $fa-var-comments,\n  'paste': $fa-var-paste,\n  'file-clipboard': $fa-var-file-clipboard,\n  'code-pull-request': $fa-var-code-pull-request,\n  'clipboard-list': $fa-var-clipboard-list,\n  'truck-ramp-box': $fa-var-truck-ramp-box,\n  'truck-loading': $fa-var-truck-loading,\n  'user-check': $fa-var-user-check,\n  'vial-virus': $fa-var-vial-virus,\n  'sheet-plastic': $fa-var-sheet-plastic,\n  'blog': $fa-var-blog,\n  'user-ninja': $fa-var-user-ninja,\n  'person-arrow-up-from-line': $fa-var-person-arrow-up-from-line,\n  'scroll-torah': $fa-var-scroll-torah,\n  'torah': $fa-var-torah,\n  'broom-ball': $fa-var-broom-ball,\n  'quidditch': $fa-var-quidditch,\n  'quidditch-broom-ball': $fa-var-quidditch-broom-ball,\n  'toggle-off': $fa-var-toggle-off,\n  'box-archive': $fa-var-box-archive,\n  'archive': $fa-var-archive,\n  'person-drowning': $fa-var-person-drowning,\n  'arrow-down-9-1': $fa-var-arrow-down-9-1,\n  'sort-numeric-desc': $fa-var-sort-numeric-desc,\n  'sort-numeric-down-alt': $fa-var-sort-numeric-down-alt,\n  'face-grin-tongue-squint': $fa-var-face-grin-tongue-squint,\n  'grin-tongue-squint': $fa-var-grin-tongue-squint,\n  'spray-can': $fa-var-spray-can,\n  'truck-monster': $fa-var-truck-monster,\n  'w': $fa-var-w,\n  'earth-africa': $fa-var-earth-africa,\n  'globe-africa': $fa-var-globe-africa,\n  'rainbow': $fa-var-rainbow,\n  'circle-notch': $fa-var-circle-notch,\n  'tablet-screen-button': $fa-var-tablet-screen-button,\n  'tablet-alt': $fa-var-tablet-alt,\n  'paw': $fa-var-paw,\n  'cloud': $fa-var-cloud,\n  'trowel-bricks': $fa-var-trowel-bricks,\n  'face-flushed': $fa-var-face-flushed,\n  'flushed': $fa-var-flushed,\n  'hospital-user': $fa-var-hospital-user,\n  'tent-arrow-left-right': $fa-var-tent-arrow-left-right,\n  'gavel': $fa-var-gavel,\n  'legal': $fa-var-legal,\n  'binoculars': $fa-var-binoculars,\n  'microphone-slash': $fa-var-microphone-slash,\n  'box-tissue': $fa-var-box-tissue,\n  'motorcycle': $fa-var-motorcycle,\n  'bell-concierge': $fa-var-bell-concierge,\n  'concierge-bell': $fa-var-concierge-bell,\n  'pen-ruler': $fa-var-pen-ruler,\n  'pencil-ruler': $fa-var-pencil-ruler,\n  'people-arrows': $fa-var-people-arrows,\n  'people-arrows-left-right': $fa-var-people-arrows-left-right,\n  'mars-and-venus-burst': $fa-var-mars-and-venus-burst,\n  'square-caret-right': $fa-var-square-caret-right,\n  'caret-square-right': $fa-var-caret-square-right,\n  'scissors': $fa-var-scissors,\n  'cut': $fa-var-cut,\n  'sun-plant-wilt': $fa-var-sun-plant-wilt,\n  'toilets-portable': $fa-var-toilets-portable,\n  'hockey-puck': $fa-var-hockey-puck,\n  'table': $fa-var-table,\n  'magnifying-glass-arrow-right': $fa-var-magnifying-glass-arrow-right,\n  'tachograph-digital': $fa-var-tachograph-digital,\n  'digital-tachograph': $fa-var-digital-tachograph,\n  'users-slash': $fa-var-users-slash,\n  'clover': $fa-var-clover,\n  'reply': $fa-var-reply,\n  'mail-reply': $fa-var-mail-reply,\n  'star-and-crescent': $fa-var-star-and-crescent,\n  'house-fire': $fa-var-house-fire,\n  'square-minus': $fa-var-square-minus,\n  'minus-square': $fa-var-minus-square,\n  'helicopter': $fa-var-helicopter,\n  'compass': $fa-var-compass,\n  'square-caret-down': $fa-var-square-caret-down,\n  'caret-square-down': $fa-var-caret-square-down,\n  'file-circle-question': $fa-var-file-circle-question,\n  'laptop-code': $fa-var-laptop-code,\n  'swatchbook': $fa-var-swatchbook,\n  'prescription-bottle': $fa-var-prescription-bottle,\n  'bars': $fa-var-bars,\n  'navicon': $fa-var-navicon,\n  'people-group': $fa-var-people-group,\n  'hourglass-end': $fa-var-hourglass-end,\n  'hourglass-3': $fa-var-hourglass-3,\n  'heart-crack': $fa-var-heart-crack,\n  'heart-broken': $fa-var-heart-broken,\n  'square-up-right': $fa-var-square-up-right,\n  'external-link-square-alt': $fa-var-external-link-square-alt,\n  'face-kiss-beam': $fa-var-face-kiss-beam,\n  'kiss-beam': $fa-var-kiss-beam,\n  'film': $fa-var-film,\n  'ruler-horizontal': $fa-var-ruler-horizontal,\n  'people-robbery': $fa-var-people-robbery,\n  'lightbulb': $fa-var-lightbulb,\n  'caret-left': $fa-var-caret-left,\n  'circle-exclamation': $fa-var-circle-exclamation,\n  'exclamation-circle': $fa-var-exclamation-circle,\n  'school-circle-xmark': $fa-var-school-circle-xmark,\n  'arrow-right-from-bracket': $fa-var-arrow-right-from-bracket,\n  'sign-out': $fa-var-sign-out,\n  'circle-chevron-down': $fa-var-circle-chevron-down,\n  'chevron-circle-down': $fa-var-chevron-circle-down,\n  'unlock-keyhole': $fa-var-unlock-keyhole,\n  'unlock-alt': $fa-var-unlock-alt,\n  'cloud-showers-heavy': $fa-var-cloud-showers-heavy,\n  'headphones-simple': $fa-var-headphones-simple,\n  'headphones-alt': $fa-var-headphones-alt,\n  'sitemap': $fa-var-sitemap,\n  'circle-dollar-to-slot': $fa-var-circle-dollar-to-slot,\n  'donate': $fa-var-donate,\n  'memory': $fa-var-memory,\n  'road-spikes': $fa-var-road-spikes,\n  'fire-burner': $fa-var-fire-burner,\n  'flag': $fa-var-flag,\n  'hanukiah': $fa-var-hanukiah,\n  'feather': $fa-var-feather,\n  'volume-low': $fa-var-volume-low,\n  'volume-down': $fa-var-volume-down,\n  'comment-slash': $fa-var-comment-slash,\n  'cloud-sun-rain': $fa-var-cloud-sun-rain,\n  'compress': $fa-var-compress,\n  'wheat-awn': $fa-var-wheat-awn,\n  'wheat-alt': $fa-var-wheat-alt,\n  'ankh': $fa-var-ankh,\n  'hands-holding-child': $fa-var-hands-holding-child,\n  'asterisk': $fa-var-asterisk,\n  'square-check': $fa-var-square-check,\n  'check-square': $fa-var-check-square,\n  'peseta-sign': $fa-var-peseta-sign,\n  'heading': $fa-var-heading,\n  'header': $fa-var-header,\n  'ghost': $fa-var-ghost,\n  'list': $fa-var-list,\n  'list-squares': $fa-var-list-squares,\n  'square-phone-flip': $fa-var-square-phone-flip,\n  'phone-square-alt': $fa-var-phone-square-alt,\n  'cart-plus': $fa-var-cart-plus,\n  'gamepad': $fa-var-gamepad,\n  'circle-dot': $fa-var-circle-dot,\n  'dot-circle': $fa-var-dot-circle,\n  'face-dizzy': $fa-var-face-dizzy,\n  'dizzy': $fa-var-dizzy,\n  'egg': $fa-var-egg,\n  'house-medical-circle-xmark': $fa-var-house-medical-circle-xmark,\n  'campground': $fa-var-campground,\n  'folder-plus': $fa-var-folder-plus,\n  'futbol': $fa-var-futbol,\n  'futbol-ball': $fa-var-futbol-ball,\n  'soccer-ball': $fa-var-soccer-ball,\n  'paintbrush': $fa-var-paintbrush,\n  'paint-brush': $fa-var-paint-brush,\n  'lock': $fa-var-lock,\n  'gas-pump': $fa-var-gas-pump,\n  'hot-tub-person': $fa-var-hot-tub-person,\n  'hot-tub': $fa-var-hot-tub,\n  'map-location': $fa-var-map-location,\n  'map-marked': $fa-var-map-marked,\n  'house-flood-water': $fa-var-house-flood-water,\n  'tree': $fa-var-tree,\n  'bridge-lock': $fa-var-bridge-lock,\n  'sack-dollar': $fa-var-sack-dollar,\n  'pen-to-square': $fa-var-pen-to-square,\n  'edit': $fa-var-edit,\n  'car-side': $fa-var-car-side,\n  'share-nodes': $fa-var-share-nodes,\n  'share-alt': $fa-var-share-alt,\n  'heart-circle-minus': $fa-var-heart-circle-minus,\n  'hourglass-half': $fa-var-hourglass-half,\n  'hourglass-2': $fa-var-hourglass-2,\n  'microscope': $fa-var-microscope,\n  'sink': $fa-var-sink,\n  'bag-shopping': $fa-var-bag-shopping,\n  'shopping-bag': $fa-var-shopping-bag,\n  'arrow-down-z-a': $fa-var-arrow-down-z-a,\n  'sort-alpha-desc': $fa-var-sort-alpha-desc,\n  'sort-alpha-down-alt': $fa-var-sort-alpha-down-alt,\n  'mitten': $fa-var-mitten,\n  'person-rays': $fa-var-person-rays,\n  'users': $fa-var-users,\n  'eye-slash': $fa-var-eye-slash,\n  'flask-vial': $fa-var-flask-vial,\n  'hand': $fa-var-hand,\n  'hand-paper': $fa-var-hand-paper,\n  'om': $fa-var-om,\n  'worm': $fa-var-worm,\n  'house-circle-xmark': $fa-var-house-circle-xmark,\n  'plug': $fa-var-plug,\n  'chevron-up': $fa-var-chevron-up,\n  'hand-spock': $fa-var-hand-spock,\n  'stopwatch': $fa-var-stopwatch,\n  'face-kiss': $fa-var-face-kiss,\n  'kiss': $fa-var-kiss,\n  'bridge-circle-xmark': $fa-var-bridge-circle-xmark,\n  'face-grin-tongue': $fa-var-face-grin-tongue,\n  'grin-tongue': $fa-var-grin-tongue,\n  'chess-bishop': $fa-var-chess-bishop,\n  'face-grin-wink': $fa-var-face-grin-wink,\n  'grin-wink': $fa-var-grin-wink,\n  'ear-deaf': $fa-var-ear-deaf,\n  'deaf': $fa-var-deaf,\n  'deafness': $fa-var-deafness,\n  'hard-of-hearing': $fa-var-hard-of-hearing,\n  'road-circle-check': $fa-var-road-circle-check,\n  'dice-five': $fa-var-dice-five,\n  'square-rss': $fa-var-square-rss,\n  'rss-square': $fa-var-rss-square,\n  'land-mine-on': $fa-var-land-mine-on,\n  'i-cursor': $fa-var-i-cursor,\n  'stamp': $fa-var-stamp,\n  'stairs': $fa-var-stairs,\n  'i': $fa-var-i,\n  'hryvnia-sign': $fa-var-hryvnia-sign,\n  'hryvnia': $fa-var-hryvnia,\n  'pills': $fa-var-pills,\n  'face-grin-wide': $fa-var-face-grin-wide,\n  'grin-alt': $fa-var-grin-alt,\n  'tooth': $fa-var-tooth,\n  'v': $fa-var-v,\n  'bangladeshi-taka-sign': $fa-var-bangladeshi-taka-sign,\n  'bicycle': $fa-var-bicycle,\n  'staff-snake': $fa-var-staff-snake,\n  'rod-asclepius': $fa-var-rod-asclepius,\n  'rod-snake': $fa-var-rod-snake,\n  'staff-aesculapius': $fa-var-staff-aesculapius,\n  'head-side-cough-slash': $fa-var-head-side-cough-slash,\n  'truck-medical': $fa-var-truck-medical,\n  'ambulance': $fa-var-ambulance,\n  'wheat-awn-circle-exclamation': $fa-var-wheat-awn-circle-exclamation,\n  'snowman': $fa-var-snowman,\n  'mortar-pestle': $fa-var-mortar-pestle,\n  'road-barrier': $fa-var-road-barrier,\n  'school': $fa-var-school,\n  'igloo': $fa-var-igloo,\n  'joint': $fa-var-joint,\n  'angle-right': $fa-var-angle-right,\n  'horse': $fa-var-horse,\n  'q': $fa-var-q,\n  'g': $fa-var-g,\n  'notes-medical': $fa-var-notes-medical,\n  'temperature-half': $fa-var-temperature-half,\n  'temperature-2': $fa-var-temperature-2,\n  'thermometer-2': $fa-var-thermometer-2,\n  'thermometer-half': $fa-var-thermometer-half,\n  'dong-sign': $fa-var-dong-sign,\n  'capsules': $fa-var-capsules,\n  'poo-storm': $fa-var-poo-storm,\n  'poo-bolt': $fa-var-poo-bolt,\n  'face-frown-open': $fa-var-face-frown-open,\n  'frown-open': $fa-var-frown-open,\n  'hand-point-up': $fa-var-hand-point-up,\n  'money-bill': $fa-var-money-bill,\n  'bookmark': $fa-var-bookmark,\n  'align-justify': $fa-var-align-justify,\n  'umbrella-beach': $fa-var-umbrella-beach,\n  'helmet-un': $fa-var-helmet-un,\n  'bullseye': $fa-var-bullseye,\n  'bacon': $fa-var-bacon,\n  'hand-point-down': $fa-var-hand-point-down,\n  'arrow-up-from-bracket': $fa-var-arrow-up-from-bracket,\n  'folder': $fa-var-folder,\n  'folder-blank': $fa-var-folder-blank,\n  'file-waveform': $fa-var-file-waveform,\n  'file-medical-alt': $fa-var-file-medical-alt,\n  'radiation': $fa-var-radiation,\n  'chart-simple': $fa-var-chart-simple,\n  'mars-stroke': $fa-var-mars-stroke,\n  'vial': $fa-var-vial,\n  'gauge': $fa-var-gauge,\n  'dashboard': $fa-var-dashboard,\n  'gauge-med': $fa-var-gauge-med,\n  'tachometer-alt-average': $fa-var-tachometer-alt-average,\n  'wand-magic-sparkles': $fa-var-wand-magic-sparkles,\n  'magic-wand-sparkles': $fa-var-magic-wand-sparkles,\n  'e': $fa-var-e,\n  'pen-clip': $fa-var-pen-clip,\n  'pen-alt': $fa-var-pen-alt,\n  'bridge-circle-exclamation': $fa-var-bridge-circle-exclamation,\n  'user': $fa-var-user,\n  'school-circle-check': $fa-var-school-circle-check,\n  'dumpster': $fa-var-dumpster,\n  'van-shuttle': $fa-var-van-shuttle,\n  'shuttle-van': $fa-var-shuttle-van,\n  'building-user': $fa-var-building-user,\n  'square-caret-left': $fa-var-square-caret-left,\n  'caret-square-left': $fa-var-caret-square-left,\n  'highlighter': $fa-var-highlighter,\n  'key': $fa-var-key,\n  'bullhorn': $fa-var-bullhorn,\n  'globe': $fa-var-globe,\n  'synagogue': $fa-var-synagogue,\n  'person-half-dress': $fa-var-person-half-dress,\n  'road-bridge': $fa-var-road-bridge,\n  'location-arrow': $fa-var-location-arrow,\n  'c': $fa-var-c,\n  'tablet-button': $fa-var-tablet-button,\n  'building-lock': $fa-var-building-lock,\n  'pizza-slice': $fa-var-pizza-slice,\n  'money-bill-wave': $fa-var-money-bill-wave,\n  'chart-area': $fa-var-chart-area,\n  'area-chart': $fa-var-area-chart,\n  'house-flag': $fa-var-house-flag,\n  'person-circle-minus': $fa-var-person-circle-minus,\n  'ban': $fa-var-ban,\n  'cancel': $fa-var-cancel,\n  'camera-rotate': $fa-var-camera-rotate,\n  'spray-can-sparkles': $fa-var-spray-can-sparkles,\n  'air-freshener': $fa-var-air-freshener,\n  'star': $fa-var-star,\n  'repeat': $fa-var-repeat,\n  'cross': $fa-var-cross,\n  'box': $fa-var-box,\n  'venus-mars': $fa-var-venus-mars,\n  'arrow-pointer': $fa-var-arrow-pointer,\n  'mouse-pointer': $fa-var-mouse-pointer,\n  'maximize': $fa-var-maximize,\n  'expand-arrows-alt': $fa-var-expand-arrows-alt,\n  'charging-station': $fa-var-charging-station,\n  'shapes': $fa-var-shapes,\n  'triangle-circle-square': $fa-var-triangle-circle-square,\n  'shuffle': $fa-var-shuffle,\n  'random': $fa-var-random,\n  'person-running': $fa-var-person-running,\n  'running': $fa-var-running,\n  'mobile-retro': $fa-var-mobile-retro,\n  'grip-lines-vertical': $fa-var-grip-lines-vertical,\n  'spider': $fa-var-spider,\n  'hands-bound': $fa-var-hands-bound,\n  'file-invoice-dollar': $fa-var-file-invoice-dollar,\n  'plane-circle-exclamation': $fa-var-plane-circle-exclamation,\n  'x-ray': $fa-var-x-ray,\n  'spell-check': $fa-var-spell-check,\n  'slash': $fa-var-slash,\n  'computer-mouse': $fa-var-computer-mouse,\n  'mouse': $fa-var-mouse,\n  'arrow-right-to-bracket': $fa-var-arrow-right-to-bracket,\n  'sign-in': $fa-var-sign-in,\n  'shop-slash': $fa-var-shop-slash,\n  'store-alt-slash': $fa-var-store-alt-slash,\n  'server': $fa-var-server,\n  'virus-covid-slash': $fa-var-virus-covid-slash,\n  'shop-lock': $fa-var-shop-lock,\n  'hourglass-start': $fa-var-hourglass-start,\n  'hourglass-1': $fa-var-hourglass-1,\n  'blender-phone': $fa-var-blender-phone,\n  'building-wheat': $fa-var-building-wheat,\n  'person-breastfeeding': $fa-var-person-breastfeeding,\n  'right-to-bracket': $fa-var-right-to-bracket,\n  'sign-in-alt': $fa-var-sign-in-alt,\n  'venus': $fa-var-venus,\n  'passport': $fa-var-passport,\n  'thumbtack-slash': $fa-var-thumbtack-slash,\n  'thumb-tack-slash': $fa-var-thumb-tack-slash,\n  'heart-pulse': $fa-var-heart-pulse,\n  'heartbeat': $fa-var-heartbeat,\n  'people-carry-box': $fa-var-people-carry-box,\n  'people-carry': $fa-var-people-carry,\n  'temperature-high': $fa-var-temperature-high,\n  'microchip': $fa-var-microchip,\n  'crown': $fa-var-crown,\n  'weight-hanging': $fa-var-weight-hanging,\n  'xmarks-lines': $fa-var-xmarks-lines,\n  'file-prescription': $fa-var-file-prescription,\n  'weight-scale': $fa-var-weight-scale,\n  'weight': $fa-var-weight,\n  'user-group': $fa-var-user-group,\n  'user-friends': $fa-var-user-friends,\n  'arrow-up-a-z': $fa-var-arrow-up-a-z,\n  'sort-alpha-up': $fa-var-sort-alpha-up,\n  'chess-knight': $fa-var-chess-knight,\n  'face-laugh-squint': $fa-var-face-laugh-squint,\n  'laugh-squint': $fa-var-laugh-squint,\n  'wheelchair': $fa-var-wheelchair,\n  'circle-arrow-up': $fa-var-circle-arrow-up,\n  'arrow-circle-up': $fa-var-arrow-circle-up,\n  'toggle-on': $fa-var-toggle-on,\n  'person-walking': $fa-var-person-walking,\n  'walking': $fa-var-walking,\n  'l': $fa-var-l,\n  'fire': $fa-var-fire,\n  'bed-pulse': $fa-var-bed-pulse,\n  'procedures': $fa-var-procedures,\n  'shuttle-space': $fa-var-shuttle-space,\n  'space-shuttle': $fa-var-space-shuttle,\n  'face-laugh': $fa-var-face-laugh,\n  'laugh': $fa-var-laugh,\n  'folder-open': $fa-var-folder-open,\n  'heart-circle-plus': $fa-var-heart-circle-plus,\n  'code-fork': $fa-var-code-fork,\n  'city': $fa-var-city,\n  'microphone-lines': $fa-var-microphone-lines,\n  'microphone-alt': $fa-var-microphone-alt,\n  'pepper-hot': $fa-var-pepper-hot,\n  'unlock': $fa-var-unlock,\n  'colon-sign': $fa-var-colon-sign,\n  'headset': $fa-var-headset,\n  'store-slash': $fa-var-store-slash,\n  'road-circle-xmark': $fa-var-road-circle-xmark,\n  'user-minus': $fa-var-user-minus,\n  'mars-stroke-up': $fa-var-mars-stroke-up,\n  'mars-stroke-v': $fa-var-mars-stroke-v,\n  'champagne-glasses': $fa-var-champagne-glasses,\n  'glass-cheers': $fa-var-glass-cheers,\n  'clipboard': $fa-var-clipboard,\n  'house-circle-exclamation': $fa-var-house-circle-exclamation,\n  'file-arrow-up': $fa-var-file-arrow-up,\n  'file-upload': $fa-var-file-upload,\n  'wifi': $fa-var-wifi,\n  'wifi-3': $fa-var-wifi-3,\n  'wifi-strong': $fa-var-wifi-strong,\n  'bath': $fa-var-bath,\n  'bathtub': $fa-var-bathtub,\n  'underline': $fa-var-underline,\n  'user-pen': $fa-var-user-pen,\n  'user-edit': $fa-var-user-edit,\n  'signature': $fa-var-signature,\n  'stroopwafel': $fa-var-stroopwafel,\n  'bold': $fa-var-bold,\n  'anchor-lock': $fa-var-anchor-lock,\n  'building-ngo': $fa-var-building-ngo,\n  'manat-sign': $fa-var-manat-sign,\n  'not-equal': $fa-var-not-equal,\n  'border-top-left': $fa-var-border-top-left,\n  'border-style': $fa-var-border-style,\n  'map-location-dot': $fa-var-map-location-dot,\n  'map-marked-alt': $fa-var-map-marked-alt,\n  'jedi': $fa-var-jedi,\n  'square-poll-vertical': $fa-var-square-poll-vertical,\n  'poll': $fa-var-poll,\n  'mug-hot': $fa-var-mug-hot,\n  'car-battery': $fa-var-car-battery,\n  'battery-car': $fa-var-battery-car,\n  'gift': $fa-var-gift,\n  'dice-two': $fa-var-dice-two,\n  'chess-queen': $fa-var-chess-queen,\n  'glasses': $fa-var-glasses,\n  'chess-board': $fa-var-chess-board,\n  'building-circle-check': $fa-var-building-circle-check,\n  'person-chalkboard': $fa-var-person-chalkboard,\n  'mars-stroke-right': $fa-var-mars-stroke-right,\n  'mars-stroke-h': $fa-var-mars-stroke-h,\n  'hand-back-fist': $fa-var-hand-back-fist,\n  'hand-rock': $fa-var-hand-rock,\n  'square-caret-up': $fa-var-square-caret-up,\n  'caret-square-up': $fa-var-caret-square-up,\n  'cloud-showers-water': $fa-var-cloud-showers-water,\n  'chart-bar': $fa-var-chart-bar,\n  'bar-chart': $fa-var-bar-chart,\n  'hands-bubbles': $fa-var-hands-bubbles,\n  'hands-wash': $fa-var-hands-wash,\n  'less-than-equal': $fa-var-less-than-equal,\n  'train': $fa-var-train,\n  'eye-low-vision': $fa-var-eye-low-vision,\n  'low-vision': $fa-var-low-vision,\n  'crow': $fa-var-crow,\n  'sailboat': $fa-var-sailboat,\n  'window-restore': $fa-var-window-restore,\n  'square-plus': $fa-var-square-plus,\n  'plus-square': $fa-var-plus-square,\n  'torii-gate': $fa-var-torii-gate,\n  'frog': $fa-var-frog,\n  'bucket': $fa-var-bucket,\n  'image': $fa-var-image,\n  'microphone': $fa-var-microphone,\n  'cow': $fa-var-cow,\n  'caret-up': $fa-var-caret-up,\n  'screwdriver': $fa-var-screwdriver,\n  'folder-closed': $fa-var-folder-closed,\n  'house-tsunami': $fa-var-house-tsunami,\n  'square-nfi': $fa-var-square-nfi,\n  'arrow-up-from-ground-water': $fa-var-arrow-up-from-ground-water,\n  'martini-glass': $fa-var-martini-glass,\n  'glass-martini-alt': $fa-var-glass-martini-alt,\n  'rotate-left': $fa-var-rotate-left,\n  'rotate-back': $fa-var-rotate-back,\n  'rotate-backward': $fa-var-rotate-backward,\n  'undo-alt': $fa-var-undo-alt,\n  'table-columns': $fa-var-table-columns,\n  'columns': $fa-var-columns,\n  'lemon': $fa-var-lemon,\n  'head-side-mask': $fa-var-head-side-mask,\n  'handshake': $fa-var-handshake,\n  'gem': $fa-var-gem,\n  'dolly': $fa-var-dolly,\n  'dolly-box': $fa-var-dolly-box,\n  'smoking': $fa-var-smoking,\n  'minimize': $fa-var-minimize,\n  'compress-arrows-alt': $fa-var-compress-arrows-alt,\n  'monument': $fa-var-monument,\n  'snowplow': $fa-var-snowplow,\n  'angles-right': $fa-var-angles-right,\n  'angle-double-right': $fa-var-angle-double-right,\n  'cannabis': $fa-var-cannabis,\n  'circle-play': $fa-var-circle-play,\n  'play-circle': $fa-var-play-circle,\n  'tablets': $fa-var-tablets,\n  'ethernet': $fa-var-ethernet,\n  'euro-sign': $fa-var-euro-sign,\n  'eur': $fa-var-eur,\n  'euro': $fa-var-euro,\n  'chair': $fa-var-chair,\n  'circle-check': $fa-var-circle-check,\n  'check-circle': $fa-var-check-circle,\n  'circle-stop': $fa-var-circle-stop,\n  'stop-circle': $fa-var-stop-circle,\n  'compass-drafting': $fa-var-compass-drafting,\n  'drafting-compass': $fa-var-drafting-compass,\n  'plate-wheat': $fa-var-plate-wheat,\n  'icicles': $fa-var-icicles,\n  'person-shelter': $fa-var-person-shelter,\n  'neuter': $fa-var-neuter,\n  'id-badge': $fa-var-id-badge,\n  'marker': $fa-var-marker,\n  'face-laugh-beam': $fa-var-face-laugh-beam,\n  'laugh-beam': $fa-var-laugh-beam,\n  'helicopter-symbol': $fa-var-helicopter-symbol,\n  'universal-access': $fa-var-universal-access,\n  'circle-chevron-up': $fa-var-circle-chevron-up,\n  'chevron-circle-up': $fa-var-chevron-circle-up,\n  'lari-sign': $fa-var-lari-sign,\n  'volcano': $fa-var-volcano,\n  'person-walking-dashed-line-arrow-right':\n    $fa-var-person-walking-dashed-line-arrow-right,\n  'sterling-sign': $fa-var-sterling-sign,\n  'gbp': $fa-var-gbp,\n  'pound-sign': $fa-var-pound-sign,\n  'viruses': $fa-var-viruses,\n  'square-person-confined': $fa-var-square-person-confined,\n  'user-tie': $fa-var-user-tie,\n  'arrow-down-long': $fa-var-arrow-down-long,\n  'long-arrow-down': $fa-var-long-arrow-down,\n  'tent-arrow-down-to-line': $fa-var-tent-arrow-down-to-line,\n  'certificate': $fa-var-certificate,\n  'reply-all': $fa-var-reply-all,\n  'mail-reply-all': $fa-var-mail-reply-all,\n  'suitcase': $fa-var-suitcase,\n  'person-skating': $fa-var-person-skating,\n  'skating': $fa-var-skating,\n  'filter-circle-dollar': $fa-var-filter-circle-dollar,\n  'funnel-dollar': $fa-var-funnel-dollar,\n  'camera-retro': $fa-var-camera-retro,\n  'circle-arrow-down': $fa-var-circle-arrow-down,\n  'arrow-circle-down': $fa-var-arrow-circle-down,\n  'file-import': $fa-var-file-import,\n  'arrow-right-to-file': $fa-var-arrow-right-to-file,\n  'square-arrow-up-right': $fa-var-square-arrow-up-right,\n  'external-link-square': $fa-var-external-link-square,\n  'box-open': $fa-var-box-open,\n  'scroll': $fa-var-scroll,\n  'spa': $fa-var-spa,\n  'location-pin-lock': $fa-var-location-pin-lock,\n  'pause': $fa-var-pause,\n  'hill-avalanche': $fa-var-hill-avalanche,\n  'temperature-empty': $fa-var-temperature-empty,\n  'temperature-0': $fa-var-temperature-0,\n  'thermometer-0': $fa-var-thermometer-0,\n  'thermometer-empty': $fa-var-thermometer-empty,\n  'bomb': $fa-var-bomb,\n  'registered': $fa-var-registered,\n  'address-card': $fa-var-address-card,\n  'contact-card': $fa-var-contact-card,\n  'vcard': $fa-var-vcard,\n  'scale-unbalanced-flip': $fa-var-scale-unbalanced-flip,\n  'balance-scale-right': $fa-var-balance-scale-right,\n  'subscript': $fa-var-subscript,\n  'diamond-turn-right': $fa-var-diamond-turn-right,\n  'directions': $fa-var-directions,\n  'burst': $fa-var-burst,\n  'house-laptop': $fa-var-house-laptop,\n  'laptop-house': $fa-var-laptop-house,\n  'face-tired': $fa-var-face-tired,\n  'tired': $fa-var-tired,\n  'money-bills': $fa-var-money-bills,\n  'smog': $fa-var-smog,\n  'crutch': $fa-var-crutch,\n  'cloud-arrow-up': $fa-var-cloud-arrow-up,\n  'cloud-upload': $fa-var-cloud-upload,\n  'cloud-upload-alt': $fa-var-cloud-upload-alt,\n  'palette': $fa-var-palette,\n  'arrows-turn-right': $fa-var-arrows-turn-right,\n  'vest': $fa-var-vest,\n  'ferry': $fa-var-ferry,\n  'arrows-down-to-people': $fa-var-arrows-down-to-people,\n  'seedling': $fa-var-seedling,\n  'sprout': $fa-var-sprout,\n  'left-right': $fa-var-left-right,\n  'arrows-alt-h': $fa-var-arrows-alt-h,\n  'boxes-packing': $fa-var-boxes-packing,\n  'circle-arrow-left': $fa-var-circle-arrow-left,\n  'arrow-circle-left': $fa-var-arrow-circle-left,\n  'group-arrows-rotate': $fa-var-group-arrows-rotate,\n  'bowl-food': $fa-var-bowl-food,\n  'candy-cane': $fa-var-candy-cane,\n  'arrow-down-wide-short': $fa-var-arrow-down-wide-short,\n  'sort-amount-asc': $fa-var-sort-amount-asc,\n  'sort-amount-down': $fa-var-sort-amount-down,\n  'cloud-bolt': $fa-var-cloud-bolt,\n  'thunderstorm': $fa-var-thunderstorm,\n  'text-slash': $fa-var-text-slash,\n  'remove-format': $fa-var-remove-format,\n  'face-smile-wink': $fa-var-face-smile-wink,\n  'smile-wink': $fa-var-smile-wink,\n  'file-word': $fa-var-file-word,\n  'file-powerpoint': $fa-var-file-powerpoint,\n  'arrows-left-right': $fa-var-arrows-left-right,\n  'arrows-h': $fa-var-arrows-h,\n  'house-lock': $fa-var-house-lock,\n  'cloud-arrow-down': $fa-var-cloud-arrow-down,\n  'cloud-download': $fa-var-cloud-download,\n  'cloud-download-alt': $fa-var-cloud-download-alt,\n  'children': $fa-var-children,\n  'chalkboard': $fa-var-chalkboard,\n  'blackboard': $fa-var-blackboard,\n  'user-large-slash': $fa-var-user-large-slash,\n  'user-alt-slash': $fa-var-user-alt-slash,\n  'envelope-open': $fa-var-envelope-open,\n  'handshake-simple-slash': $fa-var-handshake-simple-slash,\n  'handshake-alt-slash': $fa-var-handshake-alt-slash,\n  'mattress-pillow': $fa-var-mattress-pillow,\n  'guarani-sign': $fa-var-guarani-sign,\n  'arrows-rotate': $fa-var-arrows-rotate,\n  'refresh': $fa-var-refresh,\n  'sync': $fa-var-sync,\n  'fire-extinguisher': $fa-var-fire-extinguisher,\n  'cruzeiro-sign': $fa-var-cruzeiro-sign,\n  'greater-than-equal': $fa-var-greater-than-equal,\n  'shield-halved': $fa-var-shield-halved,\n  'shield-alt': $fa-var-shield-alt,\n  'book-atlas': $fa-var-book-atlas,\n  'atlas': $fa-var-atlas,\n  'virus': $fa-var-virus,\n  'envelope-circle-check': $fa-var-envelope-circle-check,\n  'layer-group': $fa-var-layer-group,\n  'arrows-to-dot': $fa-var-arrows-to-dot,\n  'archway': $fa-var-archway,\n  'heart-circle-check': $fa-var-heart-circle-check,\n  'house-chimney-crack': $fa-var-house-chimney-crack,\n  'house-damage': $fa-var-house-damage,\n  'file-zipper': $fa-var-file-zipper,\n  'file-archive': $fa-var-file-archive,\n  'square': $fa-var-square,\n  'martini-glass-empty': $fa-var-martini-glass-empty,\n  'glass-martini': $fa-var-glass-martini,\n  'couch': $fa-var-couch,\n  'cedi-sign': $fa-var-cedi-sign,\n  'italic': $fa-var-italic,\n  'table-cells-column-lock': $fa-var-table-cells-column-lock,\n  'church': $fa-var-church,\n  'comments-dollar': $fa-var-comments-dollar,\n  'democrat': $fa-var-democrat,\n  'z': $fa-var-z,\n  'person-skiing': $fa-var-person-skiing,\n  'skiing': $fa-var-skiing,\n  'road-lock': $fa-var-road-lock,\n  'a': $fa-var-a,\n  'temperature-arrow-down': $fa-var-temperature-arrow-down,\n  'temperature-down': $fa-var-temperature-down,\n  'feather-pointed': $fa-var-feather-pointed,\n  'feather-alt': $fa-var-feather-alt,\n  'p': $fa-var-p,\n  'snowflake': $fa-var-snowflake,\n  'newspaper': $fa-var-newspaper,\n  'rectangle-ad': $fa-var-rectangle-ad,\n  'ad': $fa-var-ad,\n  'circle-arrow-right': $fa-var-circle-arrow-right,\n  'arrow-circle-right': $fa-var-arrow-circle-right,\n  'filter-circle-xmark': $fa-var-filter-circle-xmark,\n  'locust': $fa-var-locust,\n  'sort': $fa-var-sort,\n  'unsorted': $fa-var-unsorted,\n  'list-ol': $fa-var-list-ol,\n  'list-1-2': $fa-var-list-1-2,\n  'list-numeric': $fa-var-list-numeric,\n  'person-dress-burst': $fa-var-person-dress-burst,\n  'money-check-dollar': $fa-var-money-check-dollar,\n  'money-check-alt': $fa-var-money-check-alt,\n  'vector-square': $fa-var-vector-square,\n  'bread-slice': $fa-var-bread-slice,\n  'language': $fa-var-language,\n  'face-kiss-wink-heart': $fa-var-face-kiss-wink-heart,\n  'kiss-wink-heart': $fa-var-kiss-wink-heart,\n  'filter': $fa-var-filter,\n  'question': $fa-var-question,\n  'file-signature': $fa-var-file-signature,\n  'up-down-left-right': $fa-var-up-down-left-right,\n  'arrows-alt': $fa-var-arrows-alt,\n  'house-chimney-user': $fa-var-house-chimney-user,\n  'hand-holding-heart': $fa-var-hand-holding-heart,\n  'puzzle-piece': $fa-var-puzzle-piece,\n  'money-check': $fa-var-money-check,\n  'star-half-stroke': $fa-var-star-half-stroke,\n  'star-half-alt': $fa-var-star-half-alt,\n  'code': $fa-var-code,\n  'whiskey-glass': $fa-var-whiskey-glass,\n  'glass-whiskey': $fa-var-glass-whiskey,\n  'building-circle-exclamation': $fa-var-building-circle-exclamation,\n  'magnifying-glass-chart': $fa-var-magnifying-glass-chart,\n  'arrow-up-right-from-square': $fa-var-arrow-up-right-from-square,\n  'external-link': $fa-var-external-link,\n  'cubes-stacked': $fa-var-cubes-stacked,\n  'won-sign': $fa-var-won-sign,\n  'krw': $fa-var-krw,\n  'won': $fa-var-won,\n  'virus-covid': $fa-var-virus-covid,\n  'austral-sign': $fa-var-austral-sign,\n  'f': $fa-var-f,\n  'leaf': $fa-var-leaf,\n  'road': $fa-var-road,\n  'taxi': $fa-var-taxi,\n  'cab': $fa-var-cab,\n  'person-circle-plus': $fa-var-person-circle-plus,\n  'chart-pie': $fa-var-chart-pie,\n  'pie-chart': $fa-var-pie-chart,\n  'bolt-lightning': $fa-var-bolt-lightning,\n  'sack-xmark': $fa-var-sack-xmark,\n  'file-excel': $fa-var-file-excel,\n  'file-contract': $fa-var-file-contract,\n  'fish-fins': $fa-var-fish-fins,\n  'building-flag': $fa-var-building-flag,\n  'face-grin-beam': $fa-var-face-grin-beam,\n  'grin-beam': $fa-var-grin-beam,\n  'object-ungroup': $fa-var-object-ungroup,\n  'poop': $fa-var-poop,\n  'location-pin': $fa-var-location-pin,\n  'map-marker': $fa-var-map-marker,\n  'kaaba': $fa-var-kaaba,\n  'toilet-paper': $fa-var-toilet-paper,\n  'helmet-safety': $fa-var-helmet-safety,\n  'hard-hat': $fa-var-hard-hat,\n  'hat-hard': $fa-var-hat-hard,\n  'eject': $fa-var-eject,\n  'circle-right': $fa-var-circle-right,\n  'arrow-alt-circle-right': $fa-var-arrow-alt-circle-right,\n  'plane-circle-check': $fa-var-plane-circle-check,\n  'face-rolling-eyes': $fa-var-face-rolling-eyes,\n  'meh-rolling-eyes': $fa-var-meh-rolling-eyes,\n  'object-group': $fa-var-object-group,\n  'chart-line': $fa-var-chart-line,\n  'line-chart': $fa-var-line-chart,\n  'mask-ventilator': $fa-var-mask-ventilator,\n  'arrow-right': $fa-var-arrow-right,\n  'signs-post': $fa-var-signs-post,\n  'map-signs': $fa-var-map-signs,\n  'cash-register': $fa-var-cash-register,\n  'person-circle-question': $fa-var-person-circle-question,\n  'h': $fa-var-h,\n  'tarp': $fa-var-tarp,\n  'screwdriver-wrench': $fa-var-screwdriver-wrench,\n  'tools': $fa-var-tools,\n  'arrows-to-eye': $fa-var-arrows-to-eye,\n  'plug-circle-bolt': $fa-var-plug-circle-bolt,\n  'heart': $fa-var-heart,\n  'mars-and-venus': $fa-var-mars-and-venus,\n  'house-user': $fa-var-house-user,\n  'home-user': $fa-var-home-user,\n  'dumpster-fire': $fa-var-dumpster-fire,\n  'house-crack': $fa-var-house-crack,\n  'martini-glass-citrus': $fa-var-martini-glass-citrus,\n  'cocktail': $fa-var-cocktail,\n  'face-surprise': $fa-var-face-surprise,\n  'surprise': $fa-var-surprise,\n  'bottle-water': $fa-var-bottle-water,\n  'circle-pause': $fa-var-circle-pause,\n  'pause-circle': $fa-var-pause-circle,\n  'toilet-paper-slash': $fa-var-toilet-paper-slash,\n  'apple-whole': $fa-var-apple-whole,\n  'apple-alt': $fa-var-apple-alt,\n  'kitchen-set': $fa-var-kitchen-set,\n  'r': $fa-var-r,\n  'temperature-quarter': $fa-var-temperature-quarter,\n  'temperature-1': $fa-var-temperature-1,\n  'thermometer-1': $fa-var-thermometer-1,\n  'thermometer-quarter': $fa-var-thermometer-quarter,\n  'cube': $fa-var-cube,\n  'bitcoin-sign': $fa-var-bitcoin-sign,\n  'shield-dog': $fa-var-shield-dog,\n  'solar-panel': $fa-var-solar-panel,\n  'lock-open': $fa-var-lock-open,\n  'elevator': $fa-var-elevator,\n  'money-bill-transfer': $fa-var-money-bill-transfer,\n  'money-bill-trend-up': $fa-var-money-bill-trend-up,\n  'house-flood-water-circle-arrow-right':\n    $fa-var-house-flood-water-circle-arrow-right,\n  'square-poll-horizontal': $fa-var-square-poll-horizontal,\n  'poll-h': $fa-var-poll-h,\n  'circle': $fa-var-circle,\n  'backward-fast': $fa-var-backward-fast,\n  'fast-backward': $fa-var-fast-backward,\n  'recycle': $fa-var-recycle,\n  'user-astronaut': $fa-var-user-astronaut,\n  'plane-slash': $fa-var-plane-slash,\n  'trademark': $fa-var-trademark,\n  'basketball': $fa-var-basketball,\n  'basketball-ball': $fa-var-basketball-ball,\n  'satellite-dish': $fa-var-satellite-dish,\n  'circle-up': $fa-var-circle-up,\n  'arrow-alt-circle-up': $fa-var-arrow-alt-circle-up,\n  'mobile-screen-button': $fa-var-mobile-screen-button,\n  'mobile-alt': $fa-var-mobile-alt,\n  'volume-high': $fa-var-volume-high,\n  'volume-up': $fa-var-volume-up,\n  'users-rays': $fa-var-users-rays,\n  'wallet': $fa-var-wallet,\n  'clipboard-check': $fa-var-clipboard-check,\n  'file-audio': $fa-var-file-audio,\n  'burger': $fa-var-burger,\n  'hamburger': $fa-var-hamburger,\n  'wrench': $fa-var-wrench,\n  'bugs': $fa-var-bugs,\n  'rupee-sign': $fa-var-rupee-sign,\n  'rupee': $fa-var-rupee,\n  'file-image': $fa-var-file-image,\n  'circle-question': $fa-var-circle-question,\n  'question-circle': $fa-var-question-circle,\n  'plane-departure': $fa-var-plane-departure,\n  'handshake-slash': $fa-var-handshake-slash,\n  'book-bookmark': $fa-var-book-bookmark,\n  'code-branch': $fa-var-code-branch,\n  'hat-cowboy': $fa-var-hat-cowboy,\n  'bridge': $fa-var-bridge,\n  'phone-flip': $fa-var-phone-flip,\n  'phone-alt': $fa-var-phone-alt,\n  'truck-front': $fa-var-truck-front,\n  'cat': $fa-var-cat,\n  'anchor-circle-exclamation': $fa-var-anchor-circle-exclamation,\n  'truck-field': $fa-var-truck-field,\n  'route': $fa-var-route,\n  'clipboard-question': $fa-var-clipboard-question,\n  'panorama': $fa-var-panorama,\n  'comment-medical': $fa-var-comment-medical,\n  'teeth-open': $fa-var-teeth-open,\n  'file-circle-minus': $fa-var-file-circle-minus,\n  'tags': $fa-var-tags,\n  'wine-glass': $fa-var-wine-glass,\n  'forward-fast': $fa-var-forward-fast,\n  'fast-forward': $fa-var-fast-forward,\n  'face-meh-blank': $fa-var-face-meh-blank,\n  'meh-blank': $fa-var-meh-blank,\n  'square-parking': $fa-var-square-parking,\n  'parking': $fa-var-parking,\n  'house-signal': $fa-var-house-signal,\n  'bars-progress': $fa-var-bars-progress,\n  'tasks-alt': $fa-var-tasks-alt,\n  'faucet-drip': $fa-var-faucet-drip,\n  'cart-flatbed': $fa-var-cart-flatbed,\n  'dolly-flatbed': $fa-var-dolly-flatbed,\n  'ban-smoking': $fa-var-ban-smoking,\n  'smoking-ban': $fa-var-smoking-ban,\n  'terminal': $fa-var-terminal,\n  'mobile-button': $fa-var-mobile-button,\n  'house-medical-flag': $fa-var-house-medical-flag,\n  'basket-shopping': $fa-var-basket-shopping,\n  'shopping-basket': $fa-var-shopping-basket,\n  'tape': $fa-var-tape,\n  'bus-simple': $fa-var-bus-simple,\n  'bus-alt': $fa-var-bus-alt,\n  'eye': $fa-var-eye,\n  'face-sad-cry': $fa-var-face-sad-cry,\n  'sad-cry': $fa-var-sad-cry,\n  'audio-description': $fa-var-audio-description,\n  'person-military-to-person': $fa-var-person-military-to-person,\n  'file-shield': $fa-var-file-shield,\n  'user-slash': $fa-var-user-slash,\n  'pen': $fa-var-pen,\n  'tower-observation': $fa-var-tower-observation,\n  'file-code': $fa-var-file-code,\n  'signal': $fa-var-signal,\n  'signal-5': $fa-var-signal-5,\n  'signal-perfect': $fa-var-signal-perfect,\n  'bus': $fa-var-bus,\n  'heart-circle-xmark': $fa-var-heart-circle-xmark,\n  'house-chimney': $fa-var-house-chimney,\n  'home-lg': $fa-var-home-lg,\n  'window-maximize': $fa-var-window-maximize,\n  'face-frown': $fa-var-face-frown,\n  'frown': $fa-var-frown,\n  'prescription': $fa-var-prescription,\n  'shop': $fa-var-shop,\n  'store-alt': $fa-var-store-alt,\n  'floppy-disk': $fa-var-floppy-disk,\n  'save': $fa-var-save,\n  'vihara': $fa-var-vihara,\n  'scale-unbalanced': $fa-var-scale-unbalanced,\n  'balance-scale-left': $fa-var-balance-scale-left,\n  'sort-up': $fa-var-sort-up,\n  'sort-asc': $fa-var-sort-asc,\n  'comment-dots': $fa-var-comment-dots,\n  'commenting': $fa-var-commenting,\n  'plant-wilt': $fa-var-plant-wilt,\n  'diamond': $fa-var-diamond,\n  'face-grin-squint': $fa-var-face-grin-squint,\n  'grin-squint': $fa-var-grin-squint,\n  'hand-holding-dollar': $fa-var-hand-holding-dollar,\n  'hand-holding-usd': $fa-var-hand-holding-usd,\n  'bacterium': $fa-var-bacterium,\n  'hand-pointer': $fa-var-hand-pointer,\n  'drum-steelpan': $fa-var-drum-steelpan,\n  'hand-scissors': $fa-var-hand-scissors,\n  'hands-praying': $fa-var-hands-praying,\n  'praying-hands': $fa-var-praying-hands,\n  'arrow-rotate-right': $fa-var-arrow-rotate-right,\n  'arrow-right-rotate': $fa-var-arrow-right-rotate,\n  'arrow-rotate-forward': $fa-var-arrow-rotate-forward,\n  'redo': $fa-var-redo,\n  'biohazard': $fa-var-biohazard,\n  'location-crosshairs': $fa-var-location-crosshairs,\n  'location': $fa-var-location,\n  'mars-double': $fa-var-mars-double,\n  'child-dress': $fa-var-child-dress,\n  'users-between-lines': $fa-var-users-between-lines,\n  'lungs-virus': $fa-var-lungs-virus,\n  'face-grin-tears': $fa-var-face-grin-tears,\n  'grin-tears': $fa-var-grin-tears,\n  'phone': $fa-var-phone,\n  'calendar-xmark': $fa-var-calendar-xmark,\n  'calendar-times': $fa-var-calendar-times,\n  'child-reaching': $fa-var-child-reaching,\n  'head-side-virus': $fa-var-head-side-virus,\n  'user-gear': $fa-var-user-gear,\n  'user-cog': $fa-var-user-cog,\n  'arrow-up-1-9': $fa-var-arrow-up-1-9,\n  'sort-numeric-up': $fa-var-sort-numeric-up,\n  'door-closed': $fa-var-door-closed,\n  'shield-virus': $fa-var-shield-virus,\n  'dice-six': $fa-var-dice-six,\n  'mosquito-net': $fa-var-mosquito-net,\n  'bridge-water': $fa-var-bridge-water,\n  'person-booth': $fa-var-person-booth,\n  'text-width': $fa-var-text-width,\n  'hat-wizard': $fa-var-hat-wizard,\n  'pen-fancy': $fa-var-pen-fancy,\n  'person-digging': $fa-var-person-digging,\n  'digging': $fa-var-digging,\n  'trash': $fa-var-trash,\n  'gauge-simple': $fa-var-gauge-simple,\n  'gauge-simple-med': $fa-var-gauge-simple-med,\n  'tachometer-average': $fa-var-tachometer-average,\n  'book-medical': $fa-var-book-medical,\n  'poo': $fa-var-poo,\n  'quote-right': $fa-var-quote-right,\n  'quote-right-alt': $fa-var-quote-right-alt,\n  'shirt': $fa-var-shirt,\n  't-shirt': $fa-var-t-shirt,\n  'tshirt': $fa-var-tshirt,\n  'cubes': $fa-var-cubes,\n  'divide': $fa-var-divide,\n  'tenge-sign': $fa-var-tenge-sign,\n  'tenge': $fa-var-tenge,\n  'headphones': $fa-var-headphones,\n  'hands-holding': $fa-var-hands-holding,\n  'hands-clapping': $fa-var-hands-clapping,\n  'republican': $fa-var-republican,\n  'arrow-left': $fa-var-arrow-left,\n  'person-circle-xmark': $fa-var-person-circle-xmark,\n  'ruler': $fa-var-ruler,\n  'align-left': $fa-var-align-left,\n  'dice-d6': $fa-var-dice-d6,\n  'restroom': $fa-var-restroom,\n  'j': $fa-var-j,\n  'users-viewfinder': $fa-var-users-viewfinder,\n  'file-video': $fa-var-file-video,\n  'up-right-from-square': $fa-var-up-right-from-square,\n  'external-link-alt': $fa-var-external-link-alt,\n  'table-cells': $fa-var-table-cells,\n  'th': $fa-var-th,\n  'file-pdf': $fa-var-file-pdf,\n  'book-bible': $fa-var-book-bible,\n  'bible': $fa-var-bible,\n  'o': $fa-var-o,\n  'suitcase-medical': $fa-var-suitcase-medical,\n  'medkit': $fa-var-medkit,\n  'user-secret': $fa-var-user-secret,\n  'otter': $fa-var-otter,\n  'person-dress': $fa-var-person-dress,\n  'female': $fa-var-female,\n  'comment-dollar': $fa-var-comment-dollar,\n  'business-time': $fa-var-business-time,\n  'briefcase-clock': $fa-var-briefcase-clock,\n  'table-cells-large': $fa-var-table-cells-large,\n  'th-large': $fa-var-th-large,\n  'book-tanakh': $fa-var-book-tanakh,\n  'tanakh': $fa-var-tanakh,\n  'phone-volume': $fa-var-phone-volume,\n  'volume-control-phone': $fa-var-volume-control-phone,\n  'hat-cowboy-side': $fa-var-hat-cowboy-side,\n  'clipboard-user': $fa-var-clipboard-user,\n  'child': $fa-var-child,\n  'lira-sign': $fa-var-lira-sign,\n  'satellite': $fa-var-satellite,\n  'plane-lock': $fa-var-plane-lock,\n  'tag': $fa-var-tag,\n  'comment': $fa-var-comment,\n  'cake-candles': $fa-var-cake-candles,\n  'birthday-cake': $fa-var-birthday-cake,\n  'cake': $fa-var-cake,\n  'envelope': $fa-var-envelope,\n  'angles-up': $fa-var-angles-up,\n  'angle-double-up': $fa-var-angle-double-up,\n  'paperclip': $fa-var-paperclip,\n  'arrow-right-to-city': $fa-var-arrow-right-to-city,\n  'ribbon': $fa-var-ribbon,\n  'lungs': $fa-var-lungs,\n  'arrow-up-9-1': $fa-var-arrow-up-9-1,\n  'sort-numeric-up-alt': $fa-var-sort-numeric-up-alt,\n  'litecoin-sign': $fa-var-litecoin-sign,\n  'border-none': $fa-var-border-none,\n  'circle-nodes': $fa-var-circle-nodes,\n  'parachute-box': $fa-var-parachute-box,\n  'indent': $fa-var-indent,\n  'truck-field-un': $fa-var-truck-field-un,\n  'hourglass': $fa-var-hourglass,\n  'hourglass-empty': $fa-var-hourglass-empty,\n  'mountain': $fa-var-mountain,\n  'user-doctor': $fa-var-user-doctor,\n  'user-md': $fa-var-user-md,\n  'circle-info': $fa-var-circle-info,\n  'info-circle': $fa-var-info-circle,\n  'cloud-meatball': $fa-var-cloud-meatball,\n  'camera': $fa-var-camera,\n  'camera-alt': $fa-var-camera-alt,\n  'square-virus': $fa-var-square-virus,\n  'meteor': $fa-var-meteor,\n  'car-on': $fa-var-car-on,\n  'sleigh': $fa-var-sleigh,\n  'arrow-down-1-9': $fa-var-arrow-down-1-9,\n  'sort-numeric-asc': $fa-var-sort-numeric-asc,\n  'sort-numeric-down': $fa-var-sort-numeric-down,\n  'hand-holding-droplet': $fa-var-hand-holding-droplet,\n  'hand-holding-water': $fa-var-hand-holding-water,\n  'water': $fa-var-water,\n  'calendar-check': $fa-var-calendar-check,\n  'braille': $fa-var-braille,\n  'prescription-bottle-medical': $fa-var-prescription-bottle-medical,\n  'prescription-bottle-alt': $fa-var-prescription-bottle-alt,\n  'landmark': $fa-var-landmark,\n  'truck': $fa-var-truck,\n  'crosshairs': $fa-var-crosshairs,\n  'person-cane': $fa-var-person-cane,\n  'tent': $fa-var-tent,\n  'vest-patches': $fa-var-vest-patches,\n  'check-double': $fa-var-check-double,\n  'arrow-down-a-z': $fa-var-arrow-down-a-z,\n  'sort-alpha-asc': $fa-var-sort-alpha-asc,\n  'sort-alpha-down': $fa-var-sort-alpha-down,\n  'money-bill-wheat': $fa-var-money-bill-wheat,\n  'cookie': $fa-var-cookie,\n  'arrow-rotate-left': $fa-var-arrow-rotate-left,\n  'arrow-left-rotate': $fa-var-arrow-left-rotate,\n  'arrow-rotate-back': $fa-var-arrow-rotate-back,\n  'arrow-rotate-backward': $fa-var-arrow-rotate-backward,\n  'undo': $fa-var-undo,\n  'hard-drive': $fa-var-hard-drive,\n  'hdd': $fa-var-hdd,\n  'face-grin-squint-tears': $fa-var-face-grin-squint-tears,\n  'grin-squint-tears': $fa-var-grin-squint-tears,\n  'dumbbell': $fa-var-dumbbell,\n  'rectangle-list': $fa-var-rectangle-list,\n  'list-alt': $fa-var-list-alt,\n  'tarp-droplet': $fa-var-tarp-droplet,\n  'house-medical-circle-check': $fa-var-house-medical-circle-check,\n  'person-skiing-nordic': $fa-var-person-skiing-nordic,\n  'skiing-nordic': $fa-var-skiing-nordic,\n  'calendar-plus': $fa-var-calendar-plus,\n  'plane-arrival': $fa-var-plane-arrival,\n  'circle-left': $fa-var-circle-left,\n  'arrow-alt-circle-left': $fa-var-arrow-alt-circle-left,\n  'train-subway': $fa-var-train-subway,\n  'subway': $fa-var-subway,\n  'chart-gantt': $fa-var-chart-gantt,\n  'indian-rupee-sign': $fa-var-indian-rupee-sign,\n  'indian-rupee': $fa-var-indian-rupee,\n  'inr': $fa-var-inr,\n  'crop-simple': $fa-var-crop-simple,\n  'crop-alt': $fa-var-crop-alt,\n  'money-bill-1': $fa-var-money-bill-1,\n  'money-bill-alt': $fa-var-money-bill-alt,\n  'left-long': $fa-var-left-long,\n  'long-arrow-alt-left': $fa-var-long-arrow-alt-left,\n  'dna': $fa-var-dna,\n  'virus-slash': $fa-var-virus-slash,\n  'minus': $fa-var-minus,\n  'subtract': $fa-var-subtract,\n  'chess': $fa-var-chess,\n  'arrow-left-long': $fa-var-arrow-left-long,\n  'long-arrow-left': $fa-var-long-arrow-left,\n  'plug-circle-check': $fa-var-plug-circle-check,\n  'street-view': $fa-var-street-view,\n  'franc-sign': $fa-var-franc-sign,\n  'volume-off': $fa-var-volume-off,\n  'hands-asl-interpreting': $fa-var-hands-asl-interpreting,\n  'american-sign-language-interpreting':\n    $fa-var-american-sign-language-interpreting,\n  'asl-interpreting': $fa-var-asl-interpreting,\n  'hands-american-sign-language-interpreting':\n    $fa-var-hands-american-sign-language-interpreting,\n  'gear': $fa-var-gear,\n  'cog': $fa-var-cog,\n  'droplet-slash': $fa-var-droplet-slash,\n  'tint-slash': $fa-var-tint-slash,\n  'mosque': $fa-var-mosque,\n  'mosquito': $fa-var-mosquito,\n  'star-of-david': $fa-var-star-of-david,\n  'person-military-rifle': $fa-var-person-military-rifle,\n  'cart-shopping': $fa-var-cart-shopping,\n  'shopping-cart': $fa-var-shopping-cart,\n  'vials': $fa-var-vials,\n  'plug-circle-plus': $fa-var-plug-circle-plus,\n  'place-of-worship': $fa-var-place-of-worship,\n  'grip-vertical': $fa-var-grip-vertical,\n  'arrow-turn-up': $fa-var-arrow-turn-up,\n  'level-up': $fa-var-level-up,\n  'u': $fa-var-u,\n  'square-root-variable': $fa-var-square-root-variable,\n  'square-root-alt': $fa-var-square-root-alt,\n  'clock': $fa-var-clock,\n  'clock-four': $fa-var-clock-four,\n  'backward-step': $fa-var-backward-step,\n  'step-backward': $fa-var-step-backward,\n  'pallet': $fa-var-pallet,\n  'faucet': $fa-var-faucet,\n  'baseball-bat-ball': $fa-var-baseball-bat-ball,\n  's': $fa-var-s,\n  'timeline': $fa-var-timeline,\n  'keyboard': $fa-var-keyboard,\n  'caret-down': $fa-var-caret-down,\n  'house-chimney-medical': $fa-var-house-chimney-medical,\n  'clinic-medical': $fa-var-clinic-medical,\n  'temperature-three-quarters': $fa-var-temperature-three-quarters,\n  'temperature-3': $fa-var-temperature-3,\n  'thermometer-3': $fa-var-thermometer-3,\n  'thermometer-three-quarters': $fa-var-thermometer-three-quarters,\n  'mobile-screen': $fa-var-mobile-screen,\n  'mobile-android-alt': $fa-var-mobile-android-alt,\n  'plane-up': $fa-var-plane-up,\n  'piggy-bank': $fa-var-piggy-bank,\n  'battery-half': $fa-var-battery-half,\n  'battery-3': $fa-var-battery-3,\n  'mountain-city': $fa-var-mountain-city,\n  'coins': $fa-var-coins,\n  'khanda': $fa-var-khanda,\n  'sliders': $fa-var-sliders,\n  'sliders-h': $fa-var-sliders-h,\n  'folder-tree': $fa-var-folder-tree,\n  'network-wired': $fa-var-network-wired,\n  'map-pin': $fa-var-map-pin,\n  'hamsa': $fa-var-hamsa,\n  'cent-sign': $fa-var-cent-sign,\n  'flask': $fa-var-flask,\n  'person-pregnant': $fa-var-person-pregnant,\n  'wand-sparkles': $fa-var-wand-sparkles,\n  'ellipsis-vertical': $fa-var-ellipsis-vertical,\n  'ellipsis-v': $fa-var-ellipsis-v,\n  'ticket': $fa-var-ticket,\n  'power-off': $fa-var-power-off,\n  'right-long': $fa-var-right-long,\n  'long-arrow-alt-right': $fa-var-long-arrow-alt-right,\n  'flag-usa': $fa-var-flag-usa,\n  'laptop-file': $fa-var-laptop-file,\n  'tty': $fa-var-tty,\n  'teletype': $fa-var-teletype,\n  'diagram-next': $fa-var-diagram-next,\n  'person-rifle': $fa-var-person-rifle,\n  'house-medical-circle-exclamation': $fa-var-house-medical-circle-exclamation,\n  'closed-captioning': $fa-var-closed-captioning,\n  'person-hiking': $fa-var-person-hiking,\n  'hiking': $fa-var-hiking,\n  'venus-double': $fa-var-venus-double,\n  'images': $fa-var-images,\n  'calculator': $fa-var-calculator,\n  'people-pulling': $fa-var-people-pulling,\n  'n': $fa-var-n,\n  'cable-car': $fa-var-cable-car,\n  'tram': $fa-var-tram,\n  'cloud-rain': $fa-var-cloud-rain,\n  'building-circle-xmark': $fa-var-building-circle-xmark,\n  'ship': $fa-var-ship,\n  'arrows-down-to-line': $fa-var-arrows-down-to-line,\n  'download': $fa-var-download,\n  'face-grin': $fa-var-face-grin,\n  'grin': $fa-var-grin,\n  'delete-left': $fa-var-delete-left,\n  'backspace': $fa-var-backspace,\n  'eye-dropper': $fa-var-eye-dropper,\n  'eye-dropper-empty': $fa-var-eye-dropper-empty,\n  'eyedropper': $fa-var-eyedropper,\n  'file-circle-check': $fa-var-file-circle-check,\n  'forward': $fa-var-forward,\n  'mobile': $fa-var-mobile,\n  'mobile-android': $fa-var-mobile-android,\n  'mobile-phone': $fa-var-mobile-phone,\n  'face-meh': $fa-var-face-meh,\n  'meh': $fa-var-meh,\n  'align-center': $fa-var-align-center,\n  'book-skull': $fa-var-book-skull,\n  'book-dead': $fa-var-book-dead,\n  'id-card': $fa-var-id-card,\n  'drivers-license': $fa-var-drivers-license,\n  'outdent': $fa-var-outdent,\n  'dedent': $fa-var-dedent,\n  'heart-circle-exclamation': $fa-var-heart-circle-exclamation,\n  'house': $fa-var-house,\n  'home': $fa-var-home,\n  'home-alt': $fa-var-home-alt,\n  'home-lg-alt': $fa-var-home-lg-alt,\n  'calendar-week': $fa-var-calendar-week,\n  'laptop-medical': $fa-var-laptop-medical,\n  'b': $fa-var-b,\n  'file-medical': $fa-var-file-medical,\n  'dice-one': $fa-var-dice-one,\n  'kiwi-bird': $fa-var-kiwi-bird,\n  'arrow-right-arrow-left': $fa-var-arrow-right-arrow-left,\n  'exchange': $fa-var-exchange,\n  'rotate-right': $fa-var-rotate-right,\n  'redo-alt': $fa-var-redo-alt,\n  'rotate-forward': $fa-var-rotate-forward,\n  'utensils': $fa-var-utensils,\n  'cutlery': $fa-var-cutlery,\n  'arrow-up-wide-short': $fa-var-arrow-up-wide-short,\n  'sort-amount-up': $fa-var-sort-amount-up,\n  'mill-sign': $fa-var-mill-sign,\n  'bowl-rice': $fa-var-bowl-rice,\n  'skull': $fa-var-skull,\n  'tower-broadcast': $fa-var-tower-broadcast,\n  'broadcast-tower': $fa-var-broadcast-tower,\n  'truck-pickup': $fa-var-truck-pickup,\n  'up-long': $fa-var-up-long,\n  'long-arrow-alt-up': $fa-var-long-arrow-alt-up,\n  'stop': $fa-var-stop,\n  'code-merge': $fa-var-code-merge,\n  'upload': $fa-var-upload,\n  'hurricane': $fa-var-hurricane,\n  'mound': $fa-var-mound,\n  'toilet-portable': $fa-var-toilet-portable,\n  'compact-disc': $fa-var-compact-disc,\n  'file-arrow-down': $fa-var-file-arrow-down,\n  'file-download': $fa-var-file-download,\n  'caravan': $fa-var-caravan,\n  'shield-cat': $fa-var-shield-cat,\n  'bolt': $fa-var-bolt,\n  'zap': $fa-var-zap,\n  'glass-water': $fa-var-glass-water,\n  'oil-well': $fa-var-oil-well,\n  'vault': $fa-var-vault,\n  'mars': $fa-var-mars,\n  'toilet': $fa-var-toilet,\n  'plane-circle-xmark': $fa-var-plane-circle-xmark,\n  'yen-sign': $fa-var-yen-sign,\n  'cny': $fa-var-cny,\n  'jpy': $fa-var-jpy,\n  'rmb': $fa-var-rmb,\n  'yen': $fa-var-yen,\n  'ruble-sign': $fa-var-ruble-sign,\n  'rouble': $fa-var-rouble,\n  'rub': $fa-var-rub,\n  'ruble': $fa-var-ruble,\n  'sun': $fa-var-sun,\n  'guitar': $fa-var-guitar,\n  'face-laugh-wink': $fa-var-face-laugh-wink,\n  'laugh-wink': $fa-var-laugh-wink,\n  'horse-head': $fa-var-horse-head,\n  'bore-hole': $fa-var-bore-hole,\n  'industry': $fa-var-industry,\n  'circle-down': $fa-var-circle-down,\n  'arrow-alt-circle-down': $fa-var-arrow-alt-circle-down,\n  'arrows-turn-to-dots': $fa-var-arrows-turn-to-dots,\n  'florin-sign': $fa-var-florin-sign,\n  'arrow-down-short-wide': $fa-var-arrow-down-short-wide,\n  'sort-amount-desc': $fa-var-sort-amount-desc,\n  'sort-amount-down-alt': $fa-var-sort-amount-down-alt,\n  'less-than': $fa-var-less-than,\n  'angle-down': $fa-var-angle-down,\n  'car-tunnel': $fa-var-car-tunnel,\n  'head-side-cough': $fa-var-head-side-cough,\n  'grip-lines': $fa-var-grip-lines,\n  'thumbs-down': $fa-var-thumbs-down,\n  'user-lock': $fa-var-user-lock,\n  'arrow-right-long': $fa-var-arrow-right-long,\n  'long-arrow-right': $fa-var-long-arrow-right,\n  'anchor-circle-xmark': $fa-var-anchor-circle-xmark,\n  'ellipsis': $fa-var-ellipsis,\n  'ellipsis-h': $fa-var-ellipsis-h,\n  'chess-pawn': $fa-var-chess-pawn,\n  'kit-medical': $fa-var-kit-medical,\n  'first-aid': $fa-var-first-aid,\n  'person-through-window': $fa-var-person-through-window,\n  'toolbox': $fa-var-toolbox,\n  'hands-holding-circle': $fa-var-hands-holding-circle,\n  'bug': $fa-var-bug,\n  'credit-card': $fa-var-credit-card,\n  'credit-card-alt': $fa-var-credit-card-alt,\n  'car': $fa-var-car,\n  'automobile': $fa-var-automobile,\n  'hand-holding-hand': $fa-var-hand-holding-hand,\n  'book-open-reader': $fa-var-book-open-reader,\n  'book-reader': $fa-var-book-reader,\n  'mountain-sun': $fa-var-mountain-sun,\n  'arrows-left-right-to-line': $fa-var-arrows-left-right-to-line,\n  'dice-d20': $fa-var-dice-d20,\n  'truck-droplet': $fa-var-truck-droplet,\n  'file-circle-xmark': $fa-var-file-circle-xmark,\n  'temperature-arrow-up': $fa-var-temperature-arrow-up,\n  'temperature-up': $fa-var-temperature-up,\n  'medal': $fa-var-medal,\n  'bed': $fa-var-bed,\n  'square-h': $fa-var-square-h,\n  'h-square': $fa-var-h-square,\n  'podcast': $fa-var-podcast,\n  'temperature-full': $fa-var-temperature-full,\n  'temperature-4': $fa-var-temperature-4,\n  'thermometer-4': $fa-var-thermometer-4,\n  'thermometer-full': $fa-var-thermometer-full,\n  'bell': $fa-var-bell,\n  'superscript': $fa-var-superscript,\n  'plug-circle-xmark': $fa-var-plug-circle-xmark,\n  'star-of-life': $fa-var-star-of-life,\n  'phone-slash': $fa-var-phone-slash,\n  'paint-roller': $fa-var-paint-roller,\n  'handshake-angle': $fa-var-handshake-angle,\n  'hands-helping': $fa-var-hands-helping,\n  'location-dot': $fa-var-location-dot,\n  'map-marker-alt': $fa-var-map-marker-alt,\n  'file': $fa-var-file,\n  'greater-than': $fa-var-greater-than,\n  'person-swimming': $fa-var-person-swimming,\n  'swimmer': $fa-var-swimmer,\n  'arrow-down': $fa-var-arrow-down,\n  'droplet': $fa-var-droplet,\n  'tint': $fa-var-tint,\n  'eraser': $fa-var-eraser,\n  'earth-americas': $fa-var-earth-americas,\n  'earth': $fa-var-earth,\n  'earth-america': $fa-var-earth-america,\n  'globe-americas': $fa-var-globe-americas,\n  'person-burst': $fa-var-person-burst,\n  'dove': $fa-var-dove,\n  'battery-empty': $fa-var-battery-empty,\n  'battery-0': $fa-var-battery-0,\n  'socks': $fa-var-socks,\n  'inbox': $fa-var-inbox,\n  'section': $fa-var-section,\n  'gauge-high': $fa-var-gauge-high,\n  'tachometer-alt': $fa-var-tachometer-alt,\n  'tachometer-alt-fast': $fa-var-tachometer-alt-fast,\n  'envelope-open-text': $fa-var-envelope-open-text,\n  'hospital': $fa-var-hospital,\n  'hospital-alt': $fa-var-hospital-alt,\n  'hospital-wide': $fa-var-hospital-wide,\n  'wine-bottle': $fa-var-wine-bottle,\n  'chess-rook': $fa-var-chess-rook,\n  'bars-staggered': $fa-var-bars-staggered,\n  'reorder': $fa-var-reorder,\n  'stream': $fa-var-stream,\n  'dharmachakra': $fa-var-dharmachakra,\n  'hotdog': $fa-var-hotdog,\n  'person-walking-with-cane': $fa-var-person-walking-with-cane,\n  'blind': $fa-var-blind,\n  'drum': $fa-var-drum,\n  'ice-cream': $fa-var-ice-cream,\n  'heart-circle-bolt': $fa-var-heart-circle-bolt,\n  'fax': $fa-var-fax,\n  'paragraph': $fa-var-paragraph,\n  'check-to-slot': $fa-var-check-to-slot,\n  'vote-yea': $fa-var-vote-yea,\n  'star-half': $fa-var-star-half,\n  'boxes-stacked': $fa-var-boxes-stacked,\n  'boxes': $fa-var-boxes,\n  'boxes-alt': $fa-var-boxes-alt,\n  'link': $fa-var-link,\n  'chain': $fa-var-chain,\n  'ear-listen': $fa-var-ear-listen,\n  'assistive-listening-systems': $fa-var-assistive-listening-systems,\n  'tree-city': $fa-var-tree-city,\n  'play': $fa-var-play,\n  'font': $fa-var-font,\n  'table-cells-row-lock': $fa-var-table-cells-row-lock,\n  'rupiah-sign': $fa-var-rupiah-sign,\n  'magnifying-glass': $fa-var-magnifying-glass,\n  'search': $fa-var-search,\n  'table-tennis-paddle-ball': $fa-var-table-tennis-paddle-ball,\n  'ping-pong-paddle-ball': $fa-var-ping-pong-paddle-ball,\n  'table-tennis': $fa-var-table-tennis,\n  'person-dots-from-line': $fa-var-person-dots-from-line,\n  'diagnoses': $fa-var-diagnoses,\n  'trash-can-arrow-up': $fa-var-trash-can-arrow-up,\n  'trash-restore-alt': $fa-var-trash-restore-alt,\n  'naira-sign': $fa-var-naira-sign,\n  'cart-arrow-down': $fa-var-cart-arrow-down,\n  'walkie-talkie': $fa-var-walkie-talkie,\n  'file-pen': $fa-var-file-pen,\n  'file-edit': $fa-var-file-edit,\n  'receipt': $fa-var-receipt,\n  'square-pen': $fa-var-square-pen,\n  'pen-square': $fa-var-pen-square,\n  'pencil-square': $fa-var-pencil-square,\n  'suitcase-rolling': $fa-var-suitcase-rolling,\n  'person-circle-exclamation': $fa-var-person-circle-exclamation,\n  'chevron-down': $fa-var-chevron-down,\n  'battery-full': $fa-var-battery-full,\n  'battery': $fa-var-battery,\n  'battery-5': $fa-var-battery-5,\n  'skull-crossbones': $fa-var-skull-crossbones,\n  'code-compare': $fa-var-code-compare,\n  'list-ul': $fa-var-list-ul,\n  'list-dots': $fa-var-list-dots,\n  'school-lock': $fa-var-school-lock,\n  'tower-cell': $fa-var-tower-cell,\n  'down-long': $fa-var-down-long,\n  'long-arrow-alt-down': $fa-var-long-arrow-alt-down,\n  'ranking-star': $fa-var-ranking-star,\n  'chess-king': $fa-var-chess-king,\n  'person-harassing': $fa-var-person-harassing,\n  'brazilian-real-sign': $fa-var-brazilian-real-sign,\n  'landmark-dome': $fa-var-landmark-dome,\n  'landmark-alt': $fa-var-landmark-alt,\n  'arrow-up': $fa-var-arrow-up,\n  'tv': $fa-var-tv,\n  'television': $fa-var-television,\n  'tv-alt': $fa-var-tv-alt,\n  'shrimp': $fa-var-shrimp,\n  'list-check': $fa-var-list-check,\n  'tasks': $fa-var-tasks,\n  'jug-detergent': $fa-var-jug-detergent,\n  'circle-user': $fa-var-circle-user,\n  'user-circle': $fa-var-user-circle,\n  'user-shield': $fa-var-user-shield,\n  'wind': $fa-var-wind,\n  'car-burst': $fa-var-car-burst,\n  'car-crash': $fa-var-car-crash,\n  'y': $fa-var-y,\n  'person-snowboarding': $fa-var-person-snowboarding,\n  'snowboarding': $fa-var-snowboarding,\n  'truck-fast': $fa-var-truck-fast,\n  'shipping-fast': $fa-var-shipping-fast,\n  'fish': $fa-var-fish,\n  'user-graduate': $fa-var-user-graduate,\n  'circle-half-stroke': $fa-var-circle-half-stroke,\n  'adjust': $fa-var-adjust,\n  'clapperboard': $fa-var-clapperboard,\n  'circle-radiation': $fa-var-circle-radiation,\n  'radiation-alt': $fa-var-radiation-alt,\n  'baseball': $fa-var-baseball,\n  'baseball-ball': $fa-var-baseball-ball,\n  'jet-fighter-up': $fa-var-jet-fighter-up,\n  'diagram-project': $fa-var-diagram-project,\n  'project-diagram': $fa-var-project-diagram,\n  'copy': $fa-var-copy,\n  'volume-xmark': $fa-var-volume-xmark,\n  'volume-mute': $fa-var-volume-mute,\n  'volume-times': $fa-var-volume-times,\n  'hand-sparkles': $fa-var-hand-sparkles,\n  'grip': $fa-var-grip,\n  'grip-horizontal': $fa-var-grip-horizontal,\n  'share-from-square': $fa-var-share-from-square,\n  'share-square': $fa-var-share-square,\n  'child-combatant': $fa-var-child-combatant,\n  'child-rifle': $fa-var-child-rifle,\n  'gun': $fa-var-gun,\n  'square-phone': $fa-var-square-phone,\n  'phone-square': $fa-var-phone-square,\n  'plus': $fa-var-plus,\n  'add': $fa-var-add,\n  'expand': $fa-var-expand,\n  'computer': $fa-var-computer,\n  'xmark': $fa-var-xmark,\n  'close': $fa-var-close,\n  'multiply': $fa-var-multiply,\n  'remove': $fa-var-remove,\n  'times': $fa-var-times,\n  'arrows-up-down-left-right': $fa-var-arrows-up-down-left-right,\n  'arrows': $fa-var-arrows,\n  'chalkboard-user': $fa-var-chalkboard-user,\n  'chalkboard-teacher': $fa-var-chalkboard-teacher,\n  'peso-sign': $fa-var-peso-sign,\n  'building-shield': $fa-var-building-shield,\n  'baby': $fa-var-baby,\n  'users-line': $fa-var-users-line,\n  'quote-left': $fa-var-quote-left,\n  'quote-left-alt': $fa-var-quote-left-alt,\n  'tractor': $fa-var-tractor,\n  'trash-arrow-up': $fa-var-trash-arrow-up,\n  'trash-restore': $fa-var-trash-restore,\n  'arrow-down-up-lock': $fa-var-arrow-down-up-lock,\n  'lines-leaning': $fa-var-lines-leaning,\n  'ruler-combined': $fa-var-ruler-combined,\n  'copyright': $fa-var-copyright,\n  'equals': $fa-var-equals,\n  'blender': $fa-var-blender,\n  'teeth': $fa-var-teeth,\n  'shekel-sign': $fa-var-shekel-sign,\n  'ils': $fa-var-ils,\n  'shekel': $fa-var-shekel,\n  'sheqel': $fa-var-sheqel,\n  'sheqel-sign': $fa-var-sheqel-sign,\n  'map': $fa-var-map,\n  'rocket': $fa-var-rocket,\n  'photo-film': $fa-var-photo-film,\n  'photo-video': $fa-var-photo-video,\n  'folder-minus': $fa-var-folder-minus,\n  'store': $fa-var-store,\n  'arrow-trend-up': $fa-var-arrow-trend-up,\n  'plug-circle-minus': $fa-var-plug-circle-minus,\n  'sign-hanging': $fa-var-sign-hanging,\n  'sign': $fa-var-sign,\n  'bezier-curve': $fa-var-bezier-curve,\n  'bell-slash': $fa-var-bell-slash,\n  'tablet': $fa-var-tablet,\n  'tablet-android': $fa-var-tablet-android,\n  'school-flag': $fa-var-school-flag,\n  'fill': $fa-var-fill,\n  'angle-up': $fa-var-angle-up,\n  'drumstick-bite': $fa-var-drumstick-bite,\n  'holly-berry': $fa-var-holly-berry,\n  'chevron-left': $fa-var-chevron-left,\n  'bacteria': $fa-var-bacteria,\n  'hand-lizard': $fa-var-hand-lizard,\n  'notdef': $fa-var-notdef,\n  'disease': $fa-var-disease,\n  'briefcase-medical': $fa-var-briefcase-medical,\n  'genderless': $fa-var-genderless,\n  'chevron-right': $fa-var-chevron-right,\n  'retweet': $fa-var-retweet,\n  'car-rear': $fa-var-car-rear,\n  'car-alt': $fa-var-car-alt,\n  'pump-soap': $fa-var-pump-soap,\n  'video-slash': $fa-var-video-slash,\n  'battery-quarter': $fa-var-battery-quarter,\n  'battery-2': $fa-var-battery-2,\n  'radio': $fa-var-radio,\n  'baby-carriage': $fa-var-baby-carriage,\n  'carriage-baby': $fa-var-carriage-baby,\n  'traffic-light': $fa-var-traffic-light,\n  'thermometer': $fa-var-thermometer,\n  'vr-cardboard': $fa-var-vr-cardboard,\n  'hand-middle-finger': $fa-var-hand-middle-finger,\n  'percent': $fa-var-percent,\n  'percentage': $fa-var-percentage,\n  'truck-moving': $fa-var-truck-moving,\n  'glass-water-droplet': $fa-var-glass-water-droplet,\n  'display': $fa-var-display,\n  'face-smile': $fa-var-face-smile,\n  'smile': $fa-var-smile,\n  'thumbtack': $fa-var-thumbtack,\n  'thumb-tack': $fa-var-thumb-tack,\n  'trophy': $fa-var-trophy,\n  'person-praying': $fa-var-person-praying,\n  'pray': $fa-var-pray,\n  'hammer': $fa-var-hammer,\n  'hand-peace': $fa-var-hand-peace,\n  'rotate': $fa-var-rotate,\n  'sync-alt': $fa-var-sync-alt,\n  'spinner': $fa-var-spinner,\n  'robot': $fa-var-robot,\n  'peace': $fa-var-peace,\n  'gears': $fa-var-gears,\n  'cogs': $fa-var-cogs,\n  'warehouse': $fa-var-warehouse,\n  'arrow-up-right-dots': $fa-var-arrow-up-right-dots,\n  'splotch': $fa-var-splotch,\n  'face-grin-hearts': $fa-var-face-grin-hearts,\n  'grin-hearts': $fa-var-grin-hearts,\n  'dice-four': $fa-var-dice-four,\n  'sim-card': $fa-var-sim-card,\n  'transgender': $fa-var-transgender,\n  'transgender-alt': $fa-var-transgender-alt,\n  'mercury': $fa-var-mercury,\n  'arrow-turn-down': $fa-var-arrow-turn-down,\n  'level-down': $fa-var-level-down,\n  'person-falling-burst': $fa-var-person-falling-burst,\n  'award': $fa-var-award,\n  'ticket-simple': $fa-var-ticket-simple,\n  'ticket-alt': $fa-var-ticket-alt,\n  'building': $fa-var-building,\n  'angles-left': $fa-var-angles-left,\n  'angle-double-left': $fa-var-angle-double-left,\n  'qrcode': $fa-var-qrcode,\n  'clock-rotate-left': $fa-var-clock-rotate-left,\n  'history': $fa-var-history,\n  'face-grin-beam-sweat': $fa-var-face-grin-beam-sweat,\n  'grin-beam-sweat': $fa-var-grin-beam-sweat,\n  'file-export': $fa-var-file-export,\n  'arrow-right-from-file': $fa-var-arrow-right-from-file,\n  'shield': $fa-var-shield,\n  'shield-blank': $fa-var-shield-blank,\n  'arrow-up-short-wide': $fa-var-arrow-up-short-wide,\n  'sort-amount-up-alt': $fa-var-sort-amount-up-alt,\n  'house-medical': $fa-var-house-medical,\n  'golf-ball-tee': $fa-var-golf-ball-tee,\n  'golf-ball': $fa-var-golf-ball,\n  'circle-chevron-left': $fa-var-circle-chevron-left,\n  'chevron-circle-left': $fa-var-chevron-circle-left,\n  'house-chimney-window': $fa-var-house-chimney-window,\n  'pen-nib': $fa-var-pen-nib,\n  'tent-arrow-turn-left': $fa-var-tent-arrow-turn-left,\n  'tents': $fa-var-tents,\n  'wand-magic': $fa-var-wand-magic,\n  'magic': $fa-var-magic,\n  'dog': $fa-var-dog,\n  'carrot': $fa-var-carrot,\n  'moon': $fa-var-moon,\n  'wine-glass-empty': $fa-var-wine-glass-empty,\n  'wine-glass-alt': $fa-var-wine-glass-alt,\n  'cheese': $fa-var-cheese,\n  'yin-yang': $fa-var-yin-yang,\n  'music': $fa-var-music,\n  'code-commit': $fa-var-code-commit,\n  'temperature-low': $fa-var-temperature-low,\n  'person-biking': $fa-var-person-biking,\n  'biking': $fa-var-biking,\n  'broom': $fa-var-broom,\n  'shield-heart': $fa-var-shield-heart,\n  'gopuram': $fa-var-gopuram,\n  'earth-oceania': $fa-var-earth-oceania,\n  'globe-oceania': $fa-var-globe-oceania,\n  'square-xmark': $fa-var-square-xmark,\n  'times-square': $fa-var-times-square,\n  'xmark-square': $fa-var-xmark-square,\n  'hashtag': $fa-var-hashtag,\n  'up-right-and-down-left-from-center':\n    $fa-var-up-right-and-down-left-from-center,\n  'expand-alt': $fa-var-expand-alt,\n  'oil-can': $fa-var-oil-can,\n  't': $fa-var-t,\n  'hippo': $fa-var-hippo,\n  'chart-column': $fa-var-chart-column,\n  'infinity': $fa-var-infinity,\n  'vial-circle-check': $fa-var-vial-circle-check,\n  'person-arrow-down-to-line': $fa-var-person-arrow-down-to-line,\n  'voicemail': $fa-var-voicemail,\n  'fan': $fa-var-fan,\n  'person-walking-luggage': $fa-var-person-walking-luggage,\n  'up-down': $fa-var-up-down,\n  'arrows-alt-v': $fa-var-arrows-alt-v,\n  'cloud-moon-rain': $fa-var-cloud-moon-rain,\n  'calendar': $fa-var-calendar,\n  'trailer': $fa-var-trailer,\n  'bahai': $fa-var-bahai,\n  'haykal': $fa-var-haykal,\n  'sd-card': $fa-var-sd-card,\n  'dragon': $fa-var-dragon,\n  'shoe-prints': $fa-var-shoe-prints,\n  'circle-plus': $fa-var-circle-plus,\n  'plus-circle': $fa-var-plus-circle,\n  'face-grin-tongue-wink': $fa-var-face-grin-tongue-wink,\n  'grin-tongue-wink': $fa-var-grin-tongue-wink,\n  'hand-holding': $fa-var-hand-holding,\n  'plug-circle-exclamation': $fa-var-plug-circle-exclamation,\n  'link-slash': $fa-var-link-slash,\n  'chain-broken': $fa-var-chain-broken,\n  'chain-slash': $fa-var-chain-slash,\n  'unlink': $fa-var-unlink,\n  'clone': $fa-var-clone,\n  'person-walking-arrow-loop-left': $fa-var-person-walking-arrow-loop-left,\n  'arrow-up-z-a': $fa-var-arrow-up-z-a,\n  'sort-alpha-up-alt': $fa-var-sort-alpha-up-alt,\n  'fire-flame-curved': $fa-var-fire-flame-curved,\n  'fire-alt': $fa-var-fire-alt,\n  'tornado': $fa-var-tornado,\n  'file-circle-plus': $fa-var-file-circle-plus,\n  'book-quran': $fa-var-book-quran,\n  'quran': $fa-var-quran,\n  'anchor': $fa-var-anchor,\n  'border-all': $fa-var-border-all,\n  'face-angry': $fa-var-face-angry,\n  'angry': $fa-var-angry,\n  'cookie-bite': $fa-var-cookie-bite,\n  'arrow-trend-down': $fa-var-arrow-trend-down,\n  'rss': $fa-var-rss,\n  'feed': $fa-var-feed,\n  'draw-polygon': $fa-var-draw-polygon,\n  'scale-balanced': $fa-var-scale-balanced,\n  'balance-scale': $fa-var-balance-scale,\n  'gauge-simple-high': $fa-var-gauge-simple-high,\n  'tachometer': $fa-var-tachometer,\n  'tachometer-fast': $fa-var-tachometer-fast,\n  'shower': $fa-var-shower,\n  'desktop': $fa-var-desktop,\n  'desktop-alt': $fa-var-desktop-alt,\n  'm': $fa-var-m,\n  'table-list': $fa-var-table-list,\n  'th-list': $fa-var-th-list,\n  'comment-sms': $fa-var-comment-sms,\n  'sms': $fa-var-sms,\n  'book': $fa-var-book,\n  'user-plus': $fa-var-user-plus,\n  'check': $fa-var-check,\n  'battery-three-quarters': $fa-var-battery-three-quarters,\n  'battery-4': $fa-var-battery-4,\n  'house-circle-check': $fa-var-house-circle-check,\n  'angle-left': $fa-var-angle-left,\n  'diagram-successor': $fa-var-diagram-successor,\n  'truck-arrow-right': $fa-var-truck-arrow-right,\n  'arrows-split-up-and-left': $fa-var-arrows-split-up-and-left,\n  'hand-fist': $fa-var-hand-fist,\n  'fist-raised': $fa-var-fist-raised,\n  'cloud-moon': $fa-var-cloud-moon,\n  'briefcase': $fa-var-briefcase,\n  'person-falling': $fa-var-person-falling,\n  'image-portrait': $fa-var-image-portrait,\n  'portrait': $fa-var-portrait,\n  'user-tag': $fa-var-user-tag,\n  'rug': $fa-var-rug,\n  'earth-europe': $fa-var-earth-europe,\n  'globe-europe': $fa-var-globe-europe,\n  'cart-flatbed-suitcase': $fa-var-cart-flatbed-suitcase,\n  'luggage-cart': $fa-var-luggage-cart,\n  'rectangle-xmark': $fa-var-rectangle-xmark,\n  'rectangle-times': $fa-var-rectangle-times,\n  'times-rectangle': $fa-var-times-rectangle,\n  'window-close': $fa-var-window-close,\n  'baht-sign': $fa-var-baht-sign,\n  'book-open': $fa-var-book-open,\n  'book-journal-whills': $fa-var-book-journal-whills,\n  'journal-whills': $fa-var-journal-whills,\n  'handcuffs': $fa-var-handcuffs,\n  'triangle-exclamation': $fa-var-triangle-exclamation,\n  'exclamation-triangle': $fa-var-exclamation-triangle,\n  'warning': $fa-var-warning,\n  'database': $fa-var-database,\n  'share': $fa-var-share,\n  'mail-forward': $fa-var-mail-forward,\n  'bottle-droplet': $fa-var-bottle-droplet,\n  'mask-face': $fa-var-mask-face,\n  'hill-rockslide': $fa-var-hill-rockslide,\n  'right-left': $fa-var-right-left,\n  'exchange-alt': $fa-var-exchange-alt,\n  'paper-plane': $fa-var-paper-plane,\n  'road-circle-exclamation': $fa-var-road-circle-exclamation,\n  'dungeon': $fa-var-dungeon,\n  'align-right': $fa-var-align-right,\n  'money-bill-1-wave': $fa-var-money-bill-1-wave,\n  'money-bill-wave-alt': $fa-var-money-bill-wave-alt,\n  'life-ring': $fa-var-life-ring,\n  'hands': $fa-var-hands,\n  'sign-language': $fa-var-sign-language,\n  'signing': $fa-var-signing,\n  'calendar-day': $fa-var-calendar-day,\n  'water-ladder': $fa-var-water-ladder,\n  'ladder-water': $fa-var-ladder-water,\n  'swimming-pool': $fa-var-swimming-pool,\n  'arrows-up-down': $fa-var-arrows-up-down,\n  'arrows-v': $fa-var-arrows-v,\n  'face-grimace': $fa-var-face-grimace,\n  'grimace': $fa-var-grimace,\n  'wheelchair-move': $fa-var-wheelchair-move,\n  'wheelchair-alt': $fa-var-wheelchair-alt,\n  'turn-down': $fa-var-turn-down,\n  'level-down-alt': $fa-var-level-down-alt,\n  'person-walking-arrow-right': $fa-var-person-walking-arrow-right,\n  'square-envelope': $fa-var-square-envelope,\n  'envelope-square': $fa-var-envelope-square,\n  'dice': $fa-var-dice,\n  'bowling-ball': $fa-var-bowling-ball,\n  'brain': $fa-var-brain,\n  'bandage': $fa-var-bandage,\n  'band-aid': $fa-var-band-aid,\n  'calendar-minus': $fa-var-calendar-minus,\n  'circle-xmark': $fa-var-circle-xmark,\n  'times-circle': $fa-var-times-circle,\n  'xmark-circle': $fa-var-xmark-circle,\n  'gifts': $fa-var-gifts,\n  'hotel': $fa-var-hotel,\n  'earth-asia': $fa-var-earth-asia,\n  'globe-asia': $fa-var-globe-asia,\n  'id-card-clip': $fa-var-id-card-clip,\n  'id-card-alt': $fa-var-id-card-alt,\n  'magnifying-glass-plus': $fa-var-magnifying-glass-plus,\n  'search-plus': $fa-var-search-plus,\n  'thumbs-up': $fa-var-thumbs-up,\n  'user-clock': $fa-var-user-clock,\n  'hand-dots': $fa-var-hand-dots,\n  'allergies': $fa-var-allergies,\n  'file-invoice': $fa-var-file-invoice,\n  'window-minimize': $fa-var-window-minimize,\n  'mug-saucer': $fa-var-mug-saucer,\n  'coffee': $fa-var-coffee,\n  'brush': $fa-var-brush,\n  'mask': $fa-var-mask,\n  'magnifying-glass-minus': $fa-var-magnifying-glass-minus,\n  'search-minus': $fa-var-search-minus,\n  'ruler-vertical': $fa-var-ruler-vertical,\n  'user-large': $fa-var-user-large,\n  'user-alt': $fa-var-user-alt,\n  'train-tram': $fa-var-train-tram,\n  'user-nurse': $fa-var-user-nurse,\n  'syringe': $fa-var-syringe,\n  'cloud-sun': $fa-var-cloud-sun,\n  'stopwatch-20': $fa-var-stopwatch-20,\n  'square-full': $fa-var-square-full,\n  'magnet': $fa-var-magnet,\n  'jar': $fa-var-jar,\n  'note-sticky': $fa-var-note-sticky,\n  'sticky-note': $fa-var-sticky-note,\n  'bug-slash': $fa-var-bug-slash,\n  'arrow-up-from-water-pump': $fa-var-arrow-up-from-water-pump,\n  'bone': $fa-var-bone,\n  'table-cells-row-unlock': $fa-var-table-cells-row-unlock,\n  'user-injured': $fa-var-user-injured,\n  'face-sad-tear': $fa-var-face-sad-tear,\n  'sad-tear': $fa-var-sad-tear,\n  'plane': $fa-var-plane,\n  'tent-arrows-down': $fa-var-tent-arrows-down,\n  'exclamation': $fa-var-exclamation,\n  'arrows-spin': $fa-var-arrows-spin,\n  'print': $fa-var-print,\n  'turkish-lira-sign': $fa-var-turkish-lira-sign,\n  'try': $fa-var-try,\n  'turkish-lira': $fa-var-turkish-lira,\n  'dollar-sign': $fa-var-dollar-sign,\n  'dollar': $fa-var-dollar,\n  'usd': $fa-var-usd,\n  'x': $fa-var-x,\n  'magnifying-glass-dollar': $fa-var-magnifying-glass-dollar,\n  'search-dollar': $fa-var-search-dollar,\n  'users-gear': $fa-var-users-gear,\n  'users-cog': $fa-var-users-cog,\n  'person-military-pointing': $fa-var-person-military-pointing,\n  'building-columns': $fa-var-building-columns,\n  'bank': $fa-var-bank,\n  'institution': $fa-var-institution,\n  'museum': $fa-var-museum,\n  'university': $fa-var-university,\n  'umbrella': $fa-var-umbrella,\n  'trowel': $fa-var-trowel,\n  'd': $fa-var-d,\n  'stapler': $fa-var-stapler,\n  'masks-theater': $fa-var-masks-theater,\n  'theater-masks': $fa-var-theater-masks,\n  'kip-sign': $fa-var-kip-sign,\n  'hand-point-left': $fa-var-hand-point-left,\n  'handshake-simple': $fa-var-handshake-simple,\n  'handshake-alt': $fa-var-handshake-alt,\n  'jet-fighter': $fa-var-jet-fighter,\n  'fighter-jet': $fa-var-fighter-jet,\n  'square-share-nodes': $fa-var-square-share-nodes,\n  'share-alt-square': $fa-var-share-alt-square,\n  'barcode': $fa-var-barcode,\n  'plus-minus': $fa-var-plus-minus,\n  'video': $fa-var-video,\n  'video-camera': $fa-var-video-camera,\n  'graduation-cap': $fa-var-graduation-cap,\n  'mortar-board': $fa-var-mortar-board,\n  'hand-holding-medical': $fa-var-hand-holding-medical,\n  'person-circle-check': $fa-var-person-circle-check,\n  'turn-up': $fa-var-turn-up,\n  'level-up-alt': $fa-var-level-up-alt,\n);\n\n$fa-brand-icons: (\n  'monero': $fa-var-monero,\n  'hooli': $fa-var-hooli,\n  'yelp': $fa-var-yelp,\n  'cc-visa': $fa-var-cc-visa,\n  'lastfm': $fa-var-lastfm,\n  'shopware': $fa-var-shopware,\n  'creative-commons-nc': $fa-var-creative-commons-nc,\n  'aws': $fa-var-aws,\n  'redhat': $fa-var-redhat,\n  'yoast': $fa-var-yoast,\n  'cloudflare': $fa-var-cloudflare,\n  'ups': $fa-var-ups,\n  'pixiv': $fa-var-pixiv,\n  'wpexplorer': $fa-var-wpexplorer,\n  'dyalog': $fa-var-dyalog,\n  'bity': $fa-var-bity,\n  'stackpath': $fa-var-stackpath,\n  'buysellads': $fa-var-buysellads,\n  'first-order': $fa-var-first-order,\n  'modx': $fa-var-modx,\n  'guilded': $fa-var-guilded,\n  'vnv': $fa-var-vnv,\n  'square-js': $fa-var-square-js,\n  'js-square': $fa-var-js-square,\n  'microsoft': $fa-var-microsoft,\n  'qq': $fa-var-qq,\n  'orcid': $fa-var-orcid,\n  'java': $fa-var-java,\n  'invision': $fa-var-invision,\n  'creative-commons-pd-alt': $fa-var-creative-commons-pd-alt,\n  'centercode': $fa-var-centercode,\n  'glide-g': $fa-var-glide-g,\n  'drupal': $fa-var-drupal,\n  'jxl': $fa-var-jxl,\n  'dart-lang': $fa-var-dart-lang,\n  'hire-a-helper': $fa-var-hire-a-helper,\n  'creative-commons-by': $fa-var-creative-commons-by,\n  'unity': $fa-var-unity,\n  'whmcs': $fa-var-whmcs,\n  'rocketchat': $fa-var-rocketchat,\n  'vk': $fa-var-vk,\n  'untappd': $fa-var-untappd,\n  'mailchimp': $fa-var-mailchimp,\n  'css3-alt': $fa-var-css3-alt,\n  'square-reddit': $fa-var-square-reddit,\n  'reddit-square': $fa-var-reddit-square,\n  'vimeo-v': $fa-var-vimeo-v,\n  'contao': $fa-var-contao,\n  'square-font-awesome': $fa-var-square-font-awesome,\n  'deskpro': $fa-var-deskpro,\n  'brave': $fa-var-brave,\n  'sistrix': $fa-var-sistrix,\n  'square-instagram': $fa-var-square-instagram,\n  'instagram-square': $fa-var-instagram-square,\n  'battle-net': $fa-var-battle-net,\n  'the-red-yeti': $fa-var-the-red-yeti,\n  'square-hacker-news': $fa-var-square-hacker-news,\n  'hacker-news-square': $fa-var-hacker-news-square,\n  'edge': $fa-var-edge,\n  'threads': $fa-var-threads,\n  'napster': $fa-var-napster,\n  'square-snapchat': $fa-var-square-snapchat,\n  'snapchat-square': $fa-var-snapchat-square,\n  'google-plus-g': $fa-var-google-plus-g,\n  'artstation': $fa-var-artstation,\n  'markdown': $fa-var-markdown,\n  'sourcetree': $fa-var-sourcetree,\n  'google-plus': $fa-var-google-plus,\n  'diaspora': $fa-var-diaspora,\n  'foursquare': $fa-var-foursquare,\n  'stack-overflow': $fa-var-stack-overflow,\n  'github-alt': $fa-var-github-alt,\n  'phoenix-squadron': $fa-var-phoenix-squadron,\n  'pagelines': $fa-var-pagelines,\n  'algolia': $fa-var-algolia,\n  'red-river': $fa-var-red-river,\n  'creative-commons-sa': $fa-var-creative-commons-sa,\n  'safari': $fa-var-safari,\n  'google': $fa-var-google,\n  'square-font-awesome-stroke': $fa-var-square-font-awesome-stroke,\n  'font-awesome-alt': $fa-var-font-awesome-alt,\n  'atlassian': $fa-var-atlassian,\n  'linkedin-in': $fa-var-linkedin-in,\n  'digital-ocean': $fa-var-digital-ocean,\n  'nimblr': $fa-var-nimblr,\n  'chromecast': $fa-var-chromecast,\n  'evernote': $fa-var-evernote,\n  'hacker-news': $fa-var-hacker-news,\n  'creative-commons-sampling': $fa-var-creative-commons-sampling,\n  'adversal': $fa-var-adversal,\n  'creative-commons': $fa-var-creative-commons,\n  'watchman-monitoring': $fa-var-watchman-monitoring,\n  'fonticons': $fa-var-fonticons,\n  'weixin': $fa-var-weixin,\n  'shirtsinbulk': $fa-var-shirtsinbulk,\n  'codepen': $fa-var-codepen,\n  'git-alt': $fa-var-git-alt,\n  'lyft': $fa-var-lyft,\n  'rev': $fa-var-rev,\n  'windows': $fa-var-windows,\n  'wizards-of-the-coast': $fa-var-wizards-of-the-coast,\n  'square-viadeo': $fa-var-square-viadeo,\n  'viadeo-square': $fa-var-viadeo-square,\n  'meetup': $fa-var-meetup,\n  'centos': $fa-var-centos,\n  'adn': $fa-var-adn,\n  'cloudsmith': $fa-var-cloudsmith,\n  'opensuse': $fa-var-opensuse,\n  'pied-piper-alt': $fa-var-pied-piper-alt,\n  'square-dribbble': $fa-var-square-dribbble,\n  'dribbble-square': $fa-var-dribbble-square,\n  'codiepie': $fa-var-codiepie,\n  'node': $fa-var-node,\n  'mix': $fa-var-mix,\n  'steam': $fa-var-steam,\n  'cc-apple-pay': $fa-var-cc-apple-pay,\n  'scribd': $fa-var-scribd,\n  'debian': $fa-var-debian,\n  'openid': $fa-var-openid,\n  'instalod': $fa-var-instalod,\n  'expeditedssl': $fa-var-expeditedssl,\n  'sellcast': $fa-var-sellcast,\n  'square-twitter': $fa-var-square-twitter,\n  'twitter-square': $fa-var-twitter-square,\n  'r-project': $fa-var-r-project,\n  'delicious': $fa-var-delicious,\n  'freebsd': $fa-var-freebsd,\n  'vuejs': $fa-var-vuejs,\n  'accusoft': $fa-var-accusoft,\n  'ioxhost': $fa-var-ioxhost,\n  'fonticons-fi': $fa-var-fonticons-fi,\n  'app-store': $fa-var-app-store,\n  'cc-mastercard': $fa-var-cc-mastercard,\n  'itunes-note': $fa-var-itunes-note,\n  'golang': $fa-var-golang,\n  'kickstarter': $fa-var-kickstarter,\n  'square-kickstarter': $fa-var-square-kickstarter,\n  'grav': $fa-var-grav,\n  'weibo': $fa-var-weibo,\n  'uncharted': $fa-var-uncharted,\n  'firstdraft': $fa-var-firstdraft,\n  'square-youtube': $fa-var-square-youtube,\n  'youtube-square': $fa-var-youtube-square,\n  'wikipedia-w': $fa-var-wikipedia-w,\n  'wpressr': $fa-var-wpressr,\n  'rendact': $fa-var-rendact,\n  'angellist': $fa-var-angellist,\n  'galactic-republic': $fa-var-galactic-republic,\n  'nfc-directional': $fa-var-nfc-directional,\n  'skype': $fa-var-skype,\n  'joget': $fa-var-joget,\n  'fedora': $fa-var-fedora,\n  'stripe-s': $fa-var-stripe-s,\n  'meta': $fa-var-meta,\n  'laravel': $fa-var-laravel,\n  'hotjar': $fa-var-hotjar,\n  'bluetooth-b': $fa-var-bluetooth-b,\n  'square-letterboxd': $fa-var-square-letterboxd,\n  'sticker-mule': $fa-var-sticker-mule,\n  'creative-commons-zero': $fa-var-creative-commons-zero,\n  'hips': $fa-var-hips,\n  'behance': $fa-var-behance,\n  'reddit': $fa-var-reddit,\n  'discord': $fa-var-discord,\n  'chrome': $fa-var-chrome,\n  'app-store-ios': $fa-var-app-store-ios,\n  'cc-discover': $fa-var-cc-discover,\n  'wpbeginner': $fa-var-wpbeginner,\n  'confluence': $fa-var-confluence,\n  'shoelace': $fa-var-shoelace,\n  'mdb': $fa-var-mdb,\n  'dochub': $fa-var-dochub,\n  'accessible-icon': $fa-var-accessible-icon,\n  'ebay': $fa-var-ebay,\n  'amazon': $fa-var-amazon,\n  'unsplash': $fa-var-unsplash,\n  'yarn': $fa-var-yarn,\n  'square-steam': $fa-var-square-steam,\n  'steam-square': $fa-var-steam-square,\n  '500px': $fa-var-500px,\n  'square-vimeo': $fa-var-square-vimeo,\n  'vimeo-square': $fa-var-vimeo-square,\n  'asymmetrik': $fa-var-asymmetrik,\n  'font-awesome': $fa-var-font-awesome,\n  'font-awesome-flag': $fa-var-font-awesome-flag,\n  'font-awesome-logo-full': $fa-var-font-awesome-logo-full,\n  'gratipay': $fa-var-gratipay,\n  'apple': $fa-var-apple,\n  'hive': $fa-var-hive,\n  'gitkraken': $fa-var-gitkraken,\n  'keybase': $fa-var-keybase,\n  'apple-pay': $fa-var-apple-pay,\n  'padlet': $fa-var-padlet,\n  'amazon-pay': $fa-var-amazon-pay,\n  'square-github': $fa-var-square-github,\n  'github-square': $fa-var-github-square,\n  'stumbleupon': $fa-var-stumbleupon,\n  'fedex': $fa-var-fedex,\n  'phoenix-framework': $fa-var-phoenix-framework,\n  'shopify': $fa-var-shopify,\n  'neos': $fa-var-neos,\n  'square-threads': $fa-var-square-threads,\n  'hackerrank': $fa-var-hackerrank,\n  'researchgate': $fa-var-researchgate,\n  'swift': $fa-var-swift,\n  'angular': $fa-var-angular,\n  'speakap': $fa-var-speakap,\n  'angrycreative': $fa-var-angrycreative,\n  'y-combinator': $fa-var-y-combinator,\n  'empire': $fa-var-empire,\n  'envira': $fa-var-envira,\n  'google-scholar': $fa-var-google-scholar,\n  'square-gitlab': $fa-var-square-gitlab,\n  'gitlab-square': $fa-var-gitlab-square,\n  'studiovinari': $fa-var-studiovinari,\n  'pied-piper': $fa-var-pied-piper,\n  'wordpress': $fa-var-wordpress,\n  'product-hunt': $fa-var-product-hunt,\n  'firefox': $fa-var-firefox,\n  'linode': $fa-var-linode,\n  'goodreads': $fa-var-goodreads,\n  'square-odnoklassniki': $fa-var-square-odnoklassniki,\n  'odnoklassniki-square': $fa-var-odnoklassniki-square,\n  'jsfiddle': $fa-var-jsfiddle,\n  'sith': $fa-var-sith,\n  'themeisle': $fa-var-themeisle,\n  'page4': $fa-var-page4,\n  'hashnode': $fa-var-hashnode,\n  'react': $fa-var-react,\n  'cc-paypal': $fa-var-cc-paypal,\n  'squarespace': $fa-var-squarespace,\n  'cc-stripe': $fa-var-cc-stripe,\n  'creative-commons-share': $fa-var-creative-commons-share,\n  'bitcoin': $fa-var-bitcoin,\n  'keycdn': $fa-var-keycdn,\n  'opera': $fa-var-opera,\n  'itch-io': $fa-var-itch-io,\n  'umbraco': $fa-var-umbraco,\n  'galactic-senate': $fa-var-galactic-senate,\n  'ubuntu': $fa-var-ubuntu,\n  'draft2digital': $fa-var-draft2digital,\n  'stripe': $fa-var-stripe,\n  'houzz': $fa-var-houzz,\n  'gg': $fa-var-gg,\n  'dhl': $fa-var-dhl,\n  'square-pinterest': $fa-var-square-pinterest,\n  'pinterest-square': $fa-var-pinterest-square,\n  'xing': $fa-var-xing,\n  'blackberry': $fa-var-blackberry,\n  'creative-commons-pd': $fa-var-creative-commons-pd,\n  'playstation': $fa-var-playstation,\n  'quinscape': $fa-var-quinscape,\n  'less': $fa-var-less,\n  'blogger-b': $fa-var-blogger-b,\n  'opencart': $fa-var-opencart,\n  'vine': $fa-var-vine,\n  'signal-messenger': $fa-var-signal-messenger,\n  'paypal': $fa-var-paypal,\n  'gitlab': $fa-var-gitlab,\n  'typo3': $fa-var-typo3,\n  'reddit-alien': $fa-var-reddit-alien,\n  'yahoo': $fa-var-yahoo,\n  'dailymotion': $fa-var-dailymotion,\n  'affiliatetheme': $fa-var-affiliatetheme,\n  'pied-piper-pp': $fa-var-pied-piper-pp,\n  'bootstrap': $fa-var-bootstrap,\n  'odnoklassniki': $fa-var-odnoklassniki,\n  'nfc-symbol': $fa-var-nfc-symbol,\n  'mintbit': $fa-var-mintbit,\n  'ethereum': $fa-var-ethereum,\n  'speaker-deck': $fa-var-speaker-deck,\n  'creative-commons-nc-eu': $fa-var-creative-commons-nc-eu,\n  'patreon': $fa-var-patreon,\n  'avianex': $fa-var-avianex,\n  'ello': $fa-var-ello,\n  'gofore': $fa-var-gofore,\n  'bimobject': $fa-var-bimobject,\n  'brave-reverse': $fa-var-brave-reverse,\n  'facebook-f': $fa-var-facebook-f,\n  'square-google-plus': $fa-var-square-google-plus,\n  'google-plus-square': $fa-var-google-plus-square,\n  'web-awesome': $fa-var-web-awesome,\n  'mandalorian': $fa-var-mandalorian,\n  'first-order-alt': $fa-var-first-order-alt,\n  'osi': $fa-var-osi,\n  'google-wallet': $fa-var-google-wallet,\n  'd-and-d-beyond': $fa-var-d-and-d-beyond,\n  'periscope': $fa-var-periscope,\n  'fulcrum': $fa-var-fulcrum,\n  'cloudscale': $fa-var-cloudscale,\n  'forumbee': $fa-var-forumbee,\n  'mizuni': $fa-var-mizuni,\n  'schlix': $fa-var-schlix,\n  'square-xing': $fa-var-square-xing,\n  'xing-square': $fa-var-xing-square,\n  'bandcamp': $fa-var-bandcamp,\n  'wpforms': $fa-var-wpforms,\n  'cloudversify': $fa-var-cloudversify,\n  'usps': $fa-var-usps,\n  'megaport': $fa-var-megaport,\n  'magento': $fa-var-magento,\n  'spotify': $fa-var-spotify,\n  'optin-monster': $fa-var-optin-monster,\n  'fly': $fa-var-fly,\n  'aviato': $fa-var-aviato,\n  'itunes': $fa-var-itunes,\n  'cuttlefish': $fa-var-cuttlefish,\n  'blogger': $fa-var-blogger,\n  'flickr': $fa-var-flickr,\n  'viber': $fa-var-viber,\n  'soundcloud': $fa-var-soundcloud,\n  'digg': $fa-var-digg,\n  'tencent-weibo': $fa-var-tencent-weibo,\n  'letterboxd': $fa-var-letterboxd,\n  'symfony': $fa-var-symfony,\n  'maxcdn': $fa-var-maxcdn,\n  'etsy': $fa-var-etsy,\n  'facebook-messenger': $fa-var-facebook-messenger,\n  'audible': $fa-var-audible,\n  'think-peaks': $fa-var-think-peaks,\n  'bilibili': $fa-var-bilibili,\n  'erlang': $fa-var-erlang,\n  'x-twitter': $fa-var-x-twitter,\n  'cotton-bureau': $fa-var-cotton-bureau,\n  'dashcube': $fa-var-dashcube,\n  '42-group': $fa-var-42-group,\n  'innosoft': $fa-var-innosoft,\n  'stack-exchange': $fa-var-stack-exchange,\n  'elementor': $fa-var-elementor,\n  'square-pied-piper': $fa-var-square-pied-piper,\n  'pied-piper-square': $fa-var-pied-piper-square,\n  'creative-commons-nd': $fa-var-creative-commons-nd,\n  'palfed': $fa-var-palfed,\n  'superpowers': $fa-var-superpowers,\n  'resolving': $fa-var-resolving,\n  'xbox': $fa-var-xbox,\n  'square-web-awesome-stroke': $fa-var-square-web-awesome-stroke,\n  'searchengin': $fa-var-searchengin,\n  'tiktok': $fa-var-tiktok,\n  'square-facebook': $fa-var-square-facebook,\n  'facebook-square': $fa-var-facebook-square,\n  'renren': $fa-var-renren,\n  'linux': $fa-var-linux,\n  'glide': $fa-var-glide,\n  'linkedin': $fa-var-linkedin,\n  'hubspot': $fa-var-hubspot,\n  'deploydog': $fa-var-deploydog,\n  'twitch': $fa-var-twitch,\n  'flutter': $fa-var-flutter,\n  'ravelry': $fa-var-ravelry,\n  'mixer': $fa-var-mixer,\n  'square-lastfm': $fa-var-square-lastfm,\n  'lastfm-square': $fa-var-lastfm-square,\n  'vimeo': $fa-var-vimeo,\n  'mendeley': $fa-var-mendeley,\n  'uniregistry': $fa-var-uniregistry,\n  'figma': $fa-var-figma,\n  'creative-commons-remix': $fa-var-creative-commons-remix,\n  'cc-amazon-pay': $fa-var-cc-amazon-pay,\n  'dropbox': $fa-var-dropbox,\n  'instagram': $fa-var-instagram,\n  'cmplid': $fa-var-cmplid,\n  'upwork': $fa-var-upwork,\n  'facebook': $fa-var-facebook,\n  'gripfire': $fa-var-gripfire,\n  'jedi-order': $fa-var-jedi-order,\n  'uikit': $fa-var-uikit,\n  'fort-awesome-alt': $fa-var-fort-awesome-alt,\n  'phabricator': $fa-var-phabricator,\n  'ussunnah': $fa-var-ussunnah,\n  'earlybirds': $fa-var-earlybirds,\n  'trade-federation': $fa-var-trade-federation,\n  'autoprefixer': $fa-var-autoprefixer,\n  'whatsapp': $fa-var-whatsapp,\n  'square-upwork': $fa-var-square-upwork,\n  'slideshare': $fa-var-slideshare,\n  'google-play': $fa-var-google-play,\n  'viadeo': $fa-var-viadeo,\n  'line': $fa-var-line,\n  'google-drive': $fa-var-google-drive,\n  'servicestack': $fa-var-servicestack,\n  'simplybuilt': $fa-var-simplybuilt,\n  'bitbucket': $fa-var-bitbucket,\n  'imdb': $fa-var-imdb,\n  'deezer': $fa-var-deezer,\n  'raspberry-pi': $fa-var-raspberry-pi,\n  'jira': $fa-var-jira,\n  'docker': $fa-var-docker,\n  'screenpal': $fa-var-screenpal,\n  'bluetooth': $fa-var-bluetooth,\n  'gitter': $fa-var-gitter,\n  'd-and-d': $fa-var-d-and-d,\n  'microblog': $fa-var-microblog,\n  'cc-diners-club': $fa-var-cc-diners-club,\n  'gg-circle': $fa-var-gg-circle,\n  'pied-piper-hat': $fa-var-pied-piper-hat,\n  'kickstarter-k': $fa-var-kickstarter-k,\n  'yandex': $fa-var-yandex,\n  'readme': $fa-var-readme,\n  'html5': $fa-var-html5,\n  'sellsy': $fa-var-sellsy,\n  'square-web-awesome': $fa-var-square-web-awesome,\n  'sass': $fa-var-sass,\n  'wirsindhandwerk': $fa-var-wirsindhandwerk,\n  'wsh': $fa-var-wsh,\n  'buromobelexperte': $fa-var-buromobelexperte,\n  'salesforce': $fa-var-salesforce,\n  'octopus-deploy': $fa-var-octopus-deploy,\n  'medapps': $fa-var-medapps,\n  'ns8': $fa-var-ns8,\n  'pinterest-p': $fa-var-pinterest-p,\n  'apper': $fa-var-apper,\n  'fort-awesome': $fa-var-fort-awesome,\n  'waze': $fa-var-waze,\n  'bluesky': $fa-var-bluesky,\n  'cc-jcb': $fa-var-cc-jcb,\n  'snapchat': $fa-var-snapchat,\n  'snapchat-ghost': $fa-var-snapchat-ghost,\n  'fantasy-flight-games': $fa-var-fantasy-flight-games,\n  'rust': $fa-var-rust,\n  'wix': $fa-var-wix,\n  'square-behance': $fa-var-square-behance,\n  'behance-square': $fa-var-behance-square,\n  'supple': $fa-var-supple,\n  'webflow': $fa-var-webflow,\n  'rebel': $fa-var-rebel,\n  'css3': $fa-var-css3,\n  'staylinked': $fa-var-staylinked,\n  'kaggle': $fa-var-kaggle,\n  'space-awesome': $fa-var-space-awesome,\n  'deviantart': $fa-var-deviantart,\n  'cpanel': $fa-var-cpanel,\n  'goodreads-g': $fa-var-goodreads-g,\n  'square-git': $fa-var-square-git,\n  'git-square': $fa-var-git-square,\n  'square-tumblr': $fa-var-square-tumblr,\n  'tumblr-square': $fa-var-tumblr-square,\n  'trello': $fa-var-trello,\n  'creative-commons-nc-jp': $fa-var-creative-commons-nc-jp,\n  'get-pocket': $fa-var-get-pocket,\n  'perbyte': $fa-var-perbyte,\n  'grunt': $fa-var-grunt,\n  'weebly': $fa-var-weebly,\n  'connectdevelop': $fa-var-connectdevelop,\n  'leanpub': $fa-var-leanpub,\n  'black-tie': $fa-var-black-tie,\n  'themeco': $fa-var-themeco,\n  'python': $fa-var-python,\n  'android': $fa-var-android,\n  'bots': $fa-var-bots,\n  'free-code-camp': $fa-var-free-code-camp,\n  'hornbill': $fa-var-hornbill,\n  'js': $fa-var-js,\n  'ideal': $fa-var-ideal,\n  'git': $fa-var-git,\n  'dev': $fa-var-dev,\n  'sketch': $fa-var-sketch,\n  'yandex-international': $fa-var-yandex-international,\n  'cc-amex': $fa-var-cc-amex,\n  'uber': $fa-var-uber,\n  'github': $fa-var-github,\n  'php': $fa-var-php,\n  'alipay': $fa-var-alipay,\n  'youtube': $fa-var-youtube,\n  'skyatlas': $fa-var-skyatlas,\n  'firefox-browser': $fa-var-firefox-browser,\n  'replyd': $fa-var-replyd,\n  'suse': $fa-var-suse,\n  'jenkins': $fa-var-jenkins,\n  'twitter': $fa-var-twitter,\n  'rockrms': $fa-var-rockrms,\n  'pinterest': $fa-var-pinterest,\n  'buffer': $fa-var-buffer,\n  'npm': $fa-var-npm,\n  'yammer': $fa-var-yammer,\n  'btc': $fa-var-btc,\n  'dribbble': $fa-var-dribbble,\n  'stumbleupon-circle': $fa-var-stumbleupon-circle,\n  'internet-explorer': $fa-var-internet-explorer,\n  'stubber': $fa-var-stubber,\n  'telegram': $fa-var-telegram,\n  'telegram-plane': $fa-var-telegram-plane,\n  'old-republic': $fa-var-old-republic,\n  'odysee': $fa-var-odysee,\n  'square-whatsapp': $fa-var-square-whatsapp,\n  'whatsapp-square': $fa-var-whatsapp-square,\n  'node-js': $fa-var-node-js,\n  'edge-legacy': $fa-var-edge-legacy,\n  'slack': $fa-var-slack,\n  'slack-hash': $fa-var-slack-hash,\n  'medrt': $fa-var-medrt,\n  'usb': $fa-var-usb,\n  'tumblr': $fa-var-tumblr,\n  'vaadin': $fa-var-vaadin,\n  'quora': $fa-var-quora,\n  'square-x-twitter': $fa-var-square-x-twitter,\n  'reacteurope': $fa-var-reacteurope,\n  'medium': $fa-var-medium,\n  'medium-m': $fa-var-medium-m,\n  'amilia': $fa-var-amilia,\n  'mixcloud': $fa-var-mixcloud,\n  'flipboard': $fa-var-flipboard,\n  'viacoin': $fa-var-viacoin,\n  'critical-role': $fa-var-critical-role,\n  'sitrox': $fa-var-sitrox,\n  'discourse': $fa-var-discourse,\n  'joomla': $fa-var-joomla,\n  'mastodon': $fa-var-mastodon,\n  'airbnb': $fa-var-airbnb,\n  'wolf-pack-battalion': $fa-var-wolf-pack-battalion,\n  'buy-n-large': $fa-var-buy-n-large,\n  'gulp': $fa-var-gulp,\n  'creative-commons-sampling-plus': $fa-var-creative-commons-sampling-plus,\n  'strava': $fa-var-strava,\n  'ember': $fa-var-ember,\n  'canadian-maple-leaf': $fa-var-canadian-maple-leaf,\n  'teamspeak': $fa-var-teamspeak,\n  'pushed': $fa-var-pushed,\n  'wordpress-simple': $fa-var-wordpress-simple,\n  'nutritionix': $fa-var-nutritionix,\n  'wodu': $fa-var-wodu,\n  'google-pay': $fa-var-google-pay,\n  'intercom': $fa-var-intercom,\n  'zhihu': $fa-var-zhihu,\n  'korvue': $fa-var-korvue,\n  'pix': $fa-var-pix,\n  'steam-symbol': $fa-var-steam-symbol,\n);\n","// icons in a list\n// -------------------------\n\n.#{$fa-css-prefix}-ul {\n  list-style-type: none;\n  margin-left: var(--#{$fa-css-prefix}-li-margin, #{$fa-li-margin});\n  padding-left: 0;\n\n  > li { position: relative; }\n}\n\n.#{$fa-css-prefix}-li {\n  left: calc(-1 * var(--#{$fa-css-prefix}-li-width, #{$fa-li-width}));\n  position: absolute;\n  text-align: center;\n  width: var(--#{$fa-css-prefix}-li-width, #{$fa-li-width});\n  line-height: inherit;\n}\n","// bordered + pulled icons\n// -------------------------\n\n.#{$fa-css-prefix}-border {\n  border-color: var(--#{$fa-css-prefix}-border-color, #{$fa-border-color});\n  border-radius: var(--#{$fa-css-prefix}-border-radius, #{$fa-border-radius});\n  border-style: var(--#{$fa-css-prefix}-border-style, #{$fa-border-style});\n  border-width: var(--#{$fa-css-prefix}-border-width, #{$fa-border-width});\n  padding: var(--#{$fa-css-prefix}-border-padding, #{$fa-border-padding});\n}\n\n.#{$fa-css-prefix}-pull-left {\n  float: left;\n  margin-right: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n\n.#{$fa-css-prefix}-pull-right {\n  float: right;\n  margin-left: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n","// animating icons\n// --------------------------\n\n.#{$fa-css-prefix}-beat {\n  animation-name: #{$fa-css-prefix}-beat;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-bounce {\n  animation-name: #{$fa-css-prefix}-bounce;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(0.280, 0.840, 0.420, 1));\n}\n\n.#{$fa-css-prefix}-fade {\n  animation-name: #{$fa-css-prefix}-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-beat-fade {\n  animation-name: #{$fa-css-prefix}-beat-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-flip {\n  animation-name: #{$fa-css-prefix}-flip;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-shake {\n  animation-name: #{$fa-css-prefix}-shake;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 2s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin-reverse {\n  --#{$fa-css-prefix}-animation-direction: reverse;\n}\n\n.#{$fa-css-prefix}-pulse,\n.#{$fa-css-prefix}-spin-pulse {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, steps(8));\n}\n\n// if agent or operating system prefers reduced motion, disable animations\n// see: https://www.smashingmagazine.com/2020/09/design-reduced-motion-sensitivities/\n// see: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion\n@media (prefers-reduced-motion: reduce) {\n  .#{$fa-css-prefix}-beat,\n  .#{$fa-css-prefix}-bounce,\n  .#{$fa-css-prefix}-fade,\n  .#{$fa-css-prefix}-beat-fade,\n  .#{$fa-css-prefix}-flip,\n  .#{$fa-css-prefix}-pulse,\n  .#{$fa-css-prefix}-shake,\n  .#{$fa-css-prefix}-spin,\n  .#{$fa-css-prefix}-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n\n@keyframes #{$fa-css-prefix}-beat {\n  0%, 90% { transform: scale(1); }\n  45% { transform: scale(var(--#{$fa-css-prefix}-beat-scale, 1.25)); }\n}\n\n@keyframes #{$fa-css-prefix}-bounce {\n  0%   { transform: scale(1,1) translateY(0); }\n  10%  { transform: scale(var(--#{$fa-css-prefix}-bounce-start-scale-x, 1.1),var(--#{$fa-css-prefix}-bounce-start-scale-y, 0.9)) translateY(0); }\n  30%  { transform: scale(var(--#{$fa-css-prefix}-bounce-jump-scale-x, 0.9),var(--#{$fa-css-prefix}-bounce-jump-scale-y, 1.1)) translateY(var(--#{$fa-css-prefix}-bounce-height, -0.5em)); }\n  50%  { transform: scale(var(--#{$fa-css-prefix}-bounce-land-scale-x, 1.05),var(--#{$fa-css-prefix}-bounce-land-scale-y, 0.95)) translateY(0); }\n  57%  { transform: scale(1,1) translateY(var(--#{$fa-css-prefix}-bounce-rebound, -0.125em)); }\n  64%  { transform: scale(1,1) translateY(0); }\n  100% { transform: scale(1,1) translateY(0); }\n}\n\n@keyframes #{$fa-css-prefix}-fade {\n  50% { opacity: var(--#{$fa-css-prefix}-fade-opacity, 0.4); }\n}\n\n@keyframes #{$fa-css-prefix}-beat-fade {\n  0%, 100% {\n    opacity: var(--#{$fa-css-prefix}-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--#{$fa-css-prefix}-beat-fade-scale, 1.125));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-flip {\n  50% {\n    transform: rotate3d(var(--#{$fa-css-prefix}-flip-x, 0), var(--#{$fa-css-prefix}-flip-y, 1), var(--#{$fa-css-prefix}-flip-z, 0), var(--#{$fa-css-prefix}-flip-angle, -180deg));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-shake {\n  0% { transform: rotate(-15deg); }\n  4% { transform: rotate(15deg); }\n  8%, 24% { transform: rotate(-18deg); }\n  12%, 28% { transform: rotate(18deg); }\n  16% { transform: rotate(-22deg); }\n  20% { transform: rotate(22deg); }\n  32% { transform: rotate(-12deg); }\n  36% { transform: rotate(12deg); }\n  40%, 100% { transform: rotate(0deg); }\n}\n\n@keyframes #{$fa-css-prefix}-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n","// rotating + flipping icons\n// -------------------------\n\n.#{$fa-css-prefix}-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.#{$fa-css-prefix}-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.#{$fa-css-prefix}-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.#{$fa-css-prefix}-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.#{$fa-css-prefix}-flip-both,\n.#{$fa-css-prefix}-flip-horizontal.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.#{$fa-css-prefix}-rotate-by {\n  transform: rotate(var(--#{$fa-css-prefix}-rotate-angle, 0));\n}\n","// stacking icons\n// -------------------------\n\n.#{$fa-css-prefix}-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: $fa-stack-vertical-align;\n  width: $fa-stack-width;\n}\n\n.#{$fa-css-prefix}-stack-1x,\n.#{$fa-css-prefix}-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: var(--#{$fa-css-prefix}-stack-z-index, #{$fa-stack-z-index});\n}\n\n.#{$fa-css-prefix}-stack-1x {\n  line-height: inherit;\n}\n\n.#{$fa-css-prefix}-stack-2x {\n  font-size: 2em;\n}\n\n.#{$fa-css-prefix}-inverse {\n  color: var(--#{$fa-css-prefix}-inverse, #{$fa-inverse});\n}\n","// specific icon class definition\n// -------------------------\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n\n@each $name, $icon in $fa-icons {\n  .#{$fa-css-prefix}-#{$name}::before { content: unquote(\"\\\"#{ $icon }\\\"\"); }\n}\n\n","// screen-reader utilities\n// -------------------------\n\n// only display content to screen readers\n.sr-only,\n.#{$fa-css-prefix}-sr-only {\n  @include fa-sr-only;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n.sr-only-focusable,\n.#{$fa-css-prefix}-sr-only-focusable {\n  @include fa-sr-only-focusable;\n}\n","/*!\n * Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n@import 'functions';\n@import 'variables';\n\n:root, :host {\n  --#{$fa-css-prefix}-style-family-classic: '#{ $fa-style-family }';\n  --#{$fa-css-prefix}-font-solid: normal 900 1em/1 '#{ $fa-style-family }';\n}\n\n\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-solid-900.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-solid-900.ttf') format('truetype');\n}\n\n.fas,\n.#{$fa-css-prefix}-solid {\n  font-weight: 900;\n}\n","/*!\n * Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n@import 'functions';\n@import 'variables';\n\n:root, :host {\n  --#{$fa-css-prefix}-style-family-classic: '#{ $fa-style-family }';\n  --#{$fa-css-prefix}-font-regular: normal 400 1em/1 '#{ $fa-style-family }';\n}\n\n\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-regular-400.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-regular-400.ttf') format('truetype');\n}\n\n.far,\n.#{$fa-css-prefix}-regular {\n  font-weight: 400;\n}\n","@import 'variables';\n@import 'functions';\n\n@mixin icon-button {\n  cursor: pointer;\n  color: $primary-color;\n}\n\n@mixin prefix($name) {\n  .#{prefix($name)} {\n    @content;\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-controls') {\n  &-show,\n  &-hover {\n    z-index: inherit;\n    &.#{$prefix}-player-controls-container-bottom {\n      @include prefix('player-controls-bottom') {\n        &::before {\n          content: '';\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          width: 100%;\n          background: linear-gradient(\n            to top,\n            rgba(0, 0, 0, 0.7) 0%,\n            rgba(0, 0, 0, 0.5) 30%,\n            rgba(0, 0, 0, 0.3) 50%,\n            rgba(0, 0, 0, 0.1) 75%,\n            rgba(0, 0, 0, 0) 100%\n          );\n          height: 0;\n          opacity: 0;\n          z-index: 0;\n          transition:\n            opacity 0.2s ease,\n            height 0.1s ease;\n        }\n      }\n    }\n    &.#{$prefix}-player-controls-container-top {\n      @include prefix('player-controls-top') {\n        &::before {\n          content: '';\n          pointer-events: none;\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          width: 100%;\n          background: linear-gradient(\n            to bottom,\n            rgba(0, 0, 0, 0.7) 0%,\n            rgba(0, 0, 0, 0.5) 30%,\n            rgba(0, 0, 0, 0.3) 50%,\n            rgba(0, 0, 0, 0.1) 75%,\n            rgba(0, 0, 0, 0) 100%\n          );\n          height: 0;\n          opacity: 0;\n          z-index: 0;\n          transition: opacity 0.2s ease;\n        }\n      }\n    }\n    &.#{$prefix}-player-controls-container-bottom-top {\n      @include prefix('player-controls-bottom') {\n        &::before {\n          content: '';\n          pointer-events: none;\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          width: 100%;\n          background: linear-gradient(\n            to top,\n            rgba(0, 0, 0, 0.7) 0%,\n            rgba(0, 0, 0, 0.5) 30%,\n            rgba(0, 0, 0, 0.3) 50%,\n            rgba(0, 0, 0, 0.1) 75%,\n            rgba(0, 0, 0, 0) 100%\n          );\n          height: 0;\n          opacity: 0;\n          z-index: 0;\n          transition:\n            opacity 0.2s ease,\n            height 0.1s ease;\n        }\n      }\n      @include prefix('player-controls-top') {\n        &::before {\n          content: '';\n          pointer-events: none;\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          width: 100%;\n          background: linear-gradient(\n            to bottom,\n            rgba(0, 0, 0, 0.7) 0%,\n            rgba(0, 0, 0, 0.5) 30%,\n            rgba(0, 0, 0, 0.3) 50%,\n            rgba(0, 0, 0, 0.1) 75%,\n            rgba(0, 0, 0, 0) 100%\n          );\n          height: 0;\n          opacity: 0;\n          z-index: 0;\n          transition: opacity 0.2s ease;\n        }\n      }\n    }\n    &.#{$prefix}-player-controls-container-full {\n      &::before {\n        content: '';\n        pointer-events: none;\n        position: absolute;\n        transition: opacity 200ms ease-in-out;\n        background: linear-gradient(\n          180deg,\n          rgba(13, 13, 13, 0.6) 0,\n          rgba(13, 13, 13, 0.2) 20%,\n          rgba(13, 13, 13, 0.2) 80%,\n          rgba(13, 13, 13, 0.6) 100%\n        );\n        left: 0;\n        bottom: 0;\n        right: 0;\n        top: 0;\n        opacity: 0;\n      }\n    }\n  }\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  pointer-events: none;\n  &-middle,\n  &-bottom,\n  &-top {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    opacity: 0;\n    transition: opacity 0.3s ease $control-hide-time;\n    color: $control-color;\n    width: 100%;\n    &-left,\n    &-center,\n    &-right {\n      display: flex;\n      align-items: center;\n      pointer-events: auto;\n    }\n    &-center {\n      flex-grow: 1;\n    }\n  }\n  &-top {\n    bottom: initial;\n    top: 0;\n  }\n  &-middle {\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    top: 50%;\n    position: absolute;\n    transform: translateY(-50%);\n    width: fit-content;\n    height: fit-content;\n    flex-direction: row;\n    pointer-events: auto;\n    margin: 0 auto;\n  }\n  &-top-sticky,\n  &-bottom-sticky {\n    opacity: 1;\n  }\n}\n.#{$prefix}-player-controls-show,\n.#{$prefix}-player:hover .#{$prefix}-player-controls {\n  &.#{$prefix}-player-controls-container-full {\n    &::before {\n      opacity: 1;\n    }\n  }\n  &.#{$prefix}-player-controls-container-bottom {\n    @include prefix('player-controls-bottom') {\n      &::before {\n        height: 200%;\n        min-height: 50px;\n        opacity: 1;\n      }\n    }\n  }\n  &.#{$prefix}-player-controls-container-top {\n    @include prefix('player-controls-top') {\n      &::before {\n        height: 200%;\n        min-height: 50px;\n        opacity: 1;\n      }\n    }\n  }\n  &.#{$prefix}-player-controls-container-bottom-top {\n    @include prefix('player-controls-bottom') {\n      &::before {\n        height: 200%;\n        min-height: 50px;\n        opacity: 1;\n      }\n    }\n    @include prefix('player-controls-top') {\n      &::before {\n        height: 200%;\n        min-height: 50px;\n        opacity: 1;\n      }\n    }\n  }\n}\n.#{$prefix}-player-controls-hide {\n  height: 0px;\n}\n.#{$prefix}-player-controls-show,\n.#{$prefix}-player:hover .#{$prefix}-player-controls {\n  @include prefix('player-controls-zone') {\n    opacity: 1;\n  }\n}\n\n@include prefix('player-control') {\n  background: none;\n  border: none;\n  color: $control-color;\n  font-size: 20px;\n  padding: 0 5px;\n  display: flex;\n  transition: color 0.3s ease;\n  position: relative;\n  /*button {\n    &:hover {\n      filter: brightness(0.8);\n    }\n  }*/\n}\n@include prefix('player-controls-middle') {\n  @include prefix('player-control') {\n    font-size: 55px;\n    padding: 5px 25px;\n  }\n}\n.#{$prefix}-player-size-xs,\n.#{$prefix}-player-size-xxs {\n  @include prefix('player-controls-middle') {\n    @include prefix('player-control') {\n      font-size: 30px;\n      padding: 5px;\n    }\n  }\n}\n\n@include prefix('player-control-button') {\n  &:focus-visible {\n    border: 1px solid $primary-color;\n  }\n  &:focus {\n    outline: none;\n  }\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: inherit;\n  text-align: inherit;\n  outline: none;\n  cursor: pointer;\n  width: 30px;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  opacity: 0.9;\n  &:hover {\n    opacity: 1;\n  }\n  @include prefix('player-control-button-back') {\n    display: none;\n  }\n  @include prefix('player-control-button-title') {\n    display: none;\n  }\n  &-show-text {\n    width: fit-content;\n    @include prefix('player-control-button-title') {\n      display: block;\n      width: fit-content;\n      @include prefix('player-control-icon') {\n        display: none;\n      }\n    }\n  }\n  @include prefix('player-control-button-icon') {\n    display: flex;\n    justify-content: center;\n  }\n  &-fullscreen {\n    @include prefix('player-control-button-icon') {\n      transition: transform 250ms cubic-bezier(0.4, 0, 1, 1);\n      transform-origin: center;\n    }\n    &:hover {\n      @include prefix('player-control-button-icon') {\n        animation: iconPulse 400ms;\n      }\n    }\n  }\n}\n@include prefix('player-control-live-dvr-indicator') {\n  cursor: pointer;\n}\n","$prefix: 'blastream';\n\n$primary-color: var(--player-color-primary, #ffffff);\n$secondary-color: #000000;\n$action-color: var(--player-color-primary, #0075ff);\n\n$progressbar-color: var(--player-color-progress-bar, #{$action-color});\n$control-color: var(--player-color-control-icon, #{$primary-color});\n$title-color: var(--player-color-title, #{$primary-color});\n$text-color: var(--player-color-text, #{$primary-color});\n$tooltip-background-color: var(\n  --player-color-tooltip-background,\n  #{$secondary-color}\n);\n$cta-background-color: var(--player-color-cta-background, #{$action-color});\n$tooltip-text-color: var(\n  --player-color-tooltip-background-text,\n  #{$primary-color}\n);\n$cta-text-color: var(--player-color-cta-background-text, #{$text-color});\n$control-hide-time: var(--player-control-hide-time, 0s);\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-control-button') {\n  &-sub-menu {\n    z-index: 14;\n    @include prefix('player-control-button-icon') {\n      transition: transform 150ms cubic-bezier(0.4, 0, 1, 1);\n      transform-origin: center;\n    }\n  }\n}\n\n@include prefix('player-control-sub-menu') {\n  @include prefix('player-control') {\n    font-size: 12px;\n    position: initial;\n    &:hover {\n      background: rgba(255, 255, 255, 0.08);\n    }\n    @include prefix('tooltip-container') {\n      width: 100%;\n    }\n    @include prefix('player-control-button') {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: -webkit-fill-available;\n      width: -moz-available;\n      height: 20px;\n      line-height: 20px;\n      @include prefix('player-control-button-title') {\n        margin-left: 10px;\n        display: initial;\n        text-align: right;\n        padding: 4px 0;\n        flex-grow: 1;\n        display: flex;\n        align-items: baseline;\n        justify-content: space-between;\n        @include prefix('player-control-icon') {\n          padding-left: 12px;\n        }\n      }\n    }\n    @include prefix('player-control-menu') {\n      background: transparent;\n      position: absolute;\n      bottom: 0;\n      padding: 0px;\n      transform: translate(100%, 0);\n      transition: none;\n      /*transition:\n        transform 250ms ease-in-out,\n        height 250ms ease-in-out;\n      */\n      &-open {\n        transform: translate(0, 0);\n        height: initial;\n        padding: 6px;\n        width: 100%;\n        text-align: left;\n        position: relative;\n      }\n      &-back {\n        display: initial;\n      }\n      @include prefix('player-control-button-title') {\n        font-size: 12px;\n      }\n    }\n  }\n}\n@include prefix('player-control-menu-list-sub-menu') {\n  @include prefix('player-control-menu-item-submenu') {\n    &:hover {\n      background: none;\n    }\n  }\n  &-open {\n    @include prefix('player-control-button') {\n      display: none !important;\n    }\n    @include prefix('player-control') {\n      @include prefix('tooltip-container') {\n        width: initial;\n      }\n      &.#{$prefix}-player-control-menu-open {\n        padding: 0;\n        &:hover {\n          background: none;\n        }\n      }\n    }\n  }\n}\n@include prefix('player-control-menu') {\n  position: absolute;\n  background: rgba(43, 42, 42, 0.589);\n  border-radius: 6px;\n  font-size: 12px;\n  bottom: 100%;\n  right: 0;\n  opacity: 0;\n  width: max-content;\n  white-space: nowrap;\n  height: fit-content;\n  transition:\n    opacity 250ms ease-in-out,\n    transform 250ms ease-in-out 100ms,\n    height 250ms ease-in-out;\n  transform: translateY(200%);\n  overflow: hidden;\n  padding: 6px;\n  color: $text-color;\n  z-index: 3;\n\n  &-title {\n    font-weight: bold;\n    margin-bottom: 6px;\n    text-align: left;\n  }\n  &-back {\n    display: none;\n  }\n  &-item {\n    border-top: 1px solid rgba(255, 255, 255, 0.288);\n    padding: 2px;\n    text-align: right;\n    cursor: pointer;\n    .tooltip {\n      display: none;\n    }\n    &:first-child {\n      border: none;\n    }\n    &:hover {\n      background: rgba(255, 255, 255, 0.08);\n    }\n    &-selected {\n      background: rgba(255, 255, 255, 0.2);\n      font-weight: bold;\n    }\n  }\n}\n@include prefix('player-control-menu-open') {\n  outline: none;\n\n  @include prefix('player-control-menu') {\n    outline: none;\n    opacity: 1;\n    transform: translateY(0);\n    max-height: calc(var(--player-height) - 80px);\n    overflow: hidden;\n    overflow-y: auto;\n    &.#{$prefix}-player-control-sub-menu-menu {\n      overflow: hidden;\n    }\n    &::-webkit-scrollbar {\n      width: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background-color: $secondary-color;\n      border-radius: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: #272727;\n      border-radius: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      border: 2px solid $secondary-color;\n    }\n  }\n  @include prefix('tooltip') {\n    display: none;\n  }\n\n  @include prefix('player-control-menu-list-sub-menu-open') {\n    @include prefix('player-control-menu-open') {\n      @include prefix('player-control-menu') {\n        outline: none;\n        opacity: 1;\n        transform: translateY(0);\n        position: relative;\n        transition:\n          transform 250ms ease-in-out,\n          height 250ms ease-in-out;\n        padding: 0 6px;\n      }\n    }\n  }\n}\n\n@include prefix('player-controls-top') {\n  @include prefix('player-control-menu') {\n    transform: translateY(100%);\n    bottom: 0;\n  }\n}\n\n.#{$prefix}-player-controls-bottom-left,\n.#{$prefix}-player-controls-top-left {\n  @include prefix('player-control-menu') {\n    left: 0;\n    right: initial;\n  }\n}\n.#{$prefix}-player-controls-bottom-left,\n.#{$prefix}-player-controls-top-left {\n  @include prefix('player-control-sub-menu') {\n    @include prefix('player-control') {\n      @include prefix('player-control-menu') {\n        transform: translate(-100%, 0);\n      }\n    }\n    @include prefix('player-control-menu-open') {\n      @include prefix('player-control-menu') {\n        transform: translate(0, 0);\n      }\n    }\n  }\n}\n@include prefix('player-device-mobile') {\n  @include prefix('player-control-menu') {\n    position: fixed;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    background: none;\n    margin: 0;\n    padding: 0;\n    pointer-events: none;\n    border-radius: 0;\n    z-index: 51;\n    max-height: 100%;\n    &::before {\n      position: absolute;\n      content: '';\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: -1;\n      background: #2828288f;\n      opacity: 0;\n      transition: opacity 300ms ease 300ms;\n    }\n    &-inner {\n      font-size: 16px;\n      background: #000000;\n      margin: 6px;\n      text-align: center;\n      padding: 6px;\n      border-radius: 12px;\n      pointer-events: auto;\n      max-height: calc(80vh - 24px);\n      overflow-y: auto;\n    }\n    &-item {\n      padding: 6px 12px;\n      text-align: left;\n    }\n    &-list-sub-menu {\n      @include prefix('player-control-menu-item-submenu') {\n        padding: 0;\n        background: none;\n\n        @include prefix('player-control-menu-open') {\n          padding: 0px;\n        }\n        @include prefix('player-control-menu') {\n          &::before {\n            display: none;\n          }\n          &-inner {\n            padding: 0px;\n            margin: 0;\n          }\n        }\n      }\n      @include prefix('player-control') {\n        &:hover {\n          background: none;\n        }\n      }\n      @include prefix('player-control-button') {\n        height: 33px;\n        line-height: 33px;\n        padding-left: 6px;\n      }\n    }\n  }\n  @include prefix('player-control-menu-open') {\n    @include prefix('player-control-menu') {\n      &::before {\n        opacity: 1;\n      }\n    }\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-control-volume') {\n  display: flex;\n  align-items: center;\n  &-container {\n    position: relative;\n    display: inline-block;\n  }\n  &-thumb {\n    position: absolute;\n    top: 50%;\n    left: calc(var(--value) * 1%);\n    width: 16px;\n    height: 16px;\n    transform: translate(-50%, -50%);\n    background-color: $progressbar-color;\n    border-radius: 50%;\n    z-index: 3;\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n    transition:\n      opacity 0.3s ease,\n      width 0.3s ease,\n      height 0.3s ease;\n  }\n\n  &-slider {\n    padding: 0px;\n    margin: 0px;\n    position: relative;\n    height: 8px;\n    width: 0px;\n    opacity: 0;\n    border-radius: 4px;\n    cursor: pointer;\n    background-color: #ddd;\n    background: linear-gradient(\n      to right,\n      $action-color calc(var(--value) * 1%),\n      #ddd calc(var(--value) * 1%)\n    );\n    -webkit-transition:\n      margin 0.2s cubic-bezier(0.4, 0, 1, 1),\n      width 0.2s cubic-bezier(0.4, 0, 1, 1);\n    transition:\n      margin 0.2s cubic-bezier(0.4, 0, 1, 1),\n      width 0.2s cubic-bezier(0.4, 0, 1, 1);\n  }\n  .#{$prefix}-player-control-volume-slider-portrait {\n    &.#{$prefix}-player-control-volume-slider-container {\n      position: absolute;\n      left: 50%;\n      margin-top: 0px;\n      transform: translateX(-50%);\n      width: 100%;\n      display: flex;\n      justify-content: center;\n    }\n    .#{$prefix}-player-control-volume-slider {\n      width: 8px;\n      height: 0px;\n      opacity: 0;\n      background: linear-gradient(\n        to top,\n        $action-color calc(var(--value) * 1%),\n        #ddd calc(var(--value) * 1%)\n      );\n      -webkit-transition:\n        margin 0.2s cubic-bezier(0.4, 0, 1, 1),\n        height 0.2s cubic-bezier(0.4, 0, 1, 1);\n      transition:\n        margin 0.2s cubic-bezier(0.4, 0, 1, 1),\n        height 0.2s cubic-bezier(0.4, 0, 1, 1);\n\n      .#{$prefix}-player-control-volume-thumb {\n        position: absolute;\n        left: 50%;\n        transform: translate(-50%, 50%);\n        bottom: calc(var(--value) * 1%);\n        top: initial;\n      }\n    }\n  }\n  &:hover {\n    .#{$prefix}-player-control-volume-slider {\n      margin-right: 10px;\n      opacity: 1;\n      width: 60px;\n    }\n    .#{$prefix}-player-control-volume-slider-portrait {\n      bottom: 100%;\n      .#{$prefix}-player-control-volume-slider {\n        margin-right: 0px;\n        margin-top: -15px;\n        opacity: 1;\n        width: 8px;\n        height: 60px;\n      }\n    }\n  }\n  &-muted {\n    color: $action-color;\n    &:hover {\n      color: $action-color;\n    }\n    @include prefix('player-control-volume-range') {\n      background: #ddd;\n    }\n  }\n}\n.#{$prefix}-player-controls-bottom-right,\n.#{$prefix}-player-controls-top-right {\n  @include prefix('player-control-volume') {\n    flex-direction: row-reverse;\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-control-quality') {\n  display: flex;\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-progressbar') {\n  position: relative;\n  display: inline-block;\n  width: calc(100% - 20px);\n  margin: 5px 10px;\n  user-select: none;\n  outline: none;\n  pointer-events: auto;\n  z-index: 2;\n  cursor: pointer;\n\n  &-container {\n    position: relative;\n    width: 100%;\n    height: 5px;\n    background-color: #959595e3;\n    border-radius: 4px;\n    user-select: none;\n    outline: none;\n\n    &:focus {\n      box-shadow: 0 0 3px 2px rgba(21, 156, 228, 0.4);\n    }\n  }\n  &-loaded {\n    position: absolute;\n    height: 100%;\n    height: 5px;\n    top: 0;\n    left: 0;\n    background-color: #ddd;\n    border-radius: 4px;\n    z-index: 1;\n    transition: width 150ms;\n  }\n  &-progress {\n    position: relative;\n    height: 100%;\n    background-color: $progressbar-color;\n    border-radius: 4px;\n    z-index: 3;\n    transition: width 150ms;\n  }\n\n  &-thumb {\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    transform: translate(100%, -50%);\n    width: 16px;\n    height: 16px;\n    background-color: $progressbar-color;\n    border-radius: 50%;\n    z-index: 3;\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n    transition:\n      opacity 0.3s ease,\n      width 0.3s ease,\n      height 0.3s ease;\n    opacity: 0;\n  }\n  &-hover-bar {\n    position: absolute;\n    height: 100%;\n    height: 5px;\n    top: 0;\n    left: 0;\n    background-color: #afafaf;\n    border-radius: 4px;\n    z-index: 2;\n    transition:\n      opacity 0.3s ease,\n      width 0.3s ease,\n      height 0.3s ease;\n  }\n  &:hover &-thumb,\n  &:active &-thumb {\n    opacity: 1;\n  }\n\n  &:not(:hover) &-thumb {\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n\n  &-hover-time {\n    position: absolute;\n    bottom: 12px;\n    font-size: 12px;\n    transform: translateX(-50%);\n    padding: 0;\n    pointer-events: none;\n    background: rgba(43, 42, 42, 0.589);\n    padding: 2px 4px;\n    border-radius: 4px;\n    color: $primary-color;\n    border: 1px solid #ffffff75;\n  }\n\n  &-before-bottom-controls {\n    position: absolute;\n    left: 0;\n    top: -10px;\n  }\n  &-after-bottom-controls {\n    padding: 10px 0;\n    flex-basis: 100%;\n    @include prefix('player-progressbar-hover-time') {\n      bottom: 17px;\n    }\n  }\n  &-bottom {\n    position: absolute;\n    left: 0;\n    bottom: 0px;\n    padding: 5px 0 0;\n    margin: 0;\n    width: 100%;\n    @include prefix('player-progressbar-progress') {\n      border-radius: 0;\n    }\n\n    @include prefix('player-progressbar-loaded') {\n      border-radius: 0;\n    }\n\n    @include prefix('player-container') {\n      border-radius: 0;\n    }\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-control-time-info') {\n  font-size: 17px;\n  display: flex;\n  cursor: initial;\n  align-items: center;\n  line-height: 17px;\n  /*&:hover {\n    color: $secondary-color;\n  }*/\n  &-sep {\n    font-size: 15px;\n    padding: 0 2px;\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-control-pip') {\n  @include prefix('player-control-button-icon') {\n    transform: scaleY(-1);\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-control-big-button') {\n  left: 50%;\n  top: 50%;\n  position: absolute;\n  transform: translateX(-50%) translateY(-50%);\n  height: 20vh;\n  width: 20vh;\n  color: $control-color;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 20;\n  text-align: center;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n    background: $control-color;\n    opacity: 0.2;\n  }\n  .tooltip-container,\n  button {\n    width: 100%;\n    height: 100%;\n  }\n  .tooltip {\n    display: none;\n  }\n  @include prefix('player-control-button') {\n    font-size: 35px;\n    text-shadow: 2px 0px 3px rgba(0, 0, 0, 0.7);\n    line-height: initial;\n    @include prefix('player-control-button-title') {\n      display: block;\n      font-size: 18px;\n      text-shadow: 2px 0px 3px rgba(0, 0, 0, 0.7);\n\n      @include prefix('player-control-icon') {\n        display: none;\n      }\n    }\n  }\n  &-topRight,\n  &-topLeft {\n    left: 20px;\n    top: 20px;\n    transform: none;\n    flex-direction: row;\n    width: auto;\n    height: auto;\n    border-radius: 6px;\n    border: 1px solid #ffffff73;\n    padding: 10px;\n    @include prefix('player-control-button') {\n      display: flex;\n      align-items: center;\n      font-size: 20px;\n      @include prefix('player-control-button-title') {\n        padding-left: 15px;\n      }\n    }\n  }\n  &-topRight {\n    left: initial;\n    right: 20px;\n  }\n  &-mute {\n    @include prefix('player-control-button-title') {\n      transition: width 1s ease;\n      overflow: hidden;\n    }\n    transition: opacity 0.3s ease $control-hide-time;\n  }\n  &-mute-shrinked {\n    @include prefix('player-control-button-title') {\n      width: 0px;\n      line-height: 0px;\n      padding-left: 0px !important;\n    }\n  }\n  &-mute-hided {\n    opacity: 0;\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-notification-loading') {\n  left: 50%;\n  top: 50%;\n  position: absolute;\n  transform: translateX(-50%) translateY(-50%);\n  height: 10vh;\n  width: 10vh;\n  color: $primary-color;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 17;\n  text-align: center;\n  font-size: 20px;\n  font-size: 3vw;\n  text-shadow: 2px 0px 3px rgba(0, 0, 0, 0.7);\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-notification-error') {\n  left: 50%;\n  top: 50%;\n  position: absolute;\n  transform: translateX(-50%) translateY(-50%);\n  max-width: 80vw;\n  max-height: 80vw;\n  color: $tooltip-text-color;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  z-index: 17;\n  text-align: center;\n  font-size: 3vw;\n  text-shadow: 2px 0px 3px rgba(0, 0, 0, 0.7);\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n    border-radius: 12px;\n    background: $tooltip-background-color;\n    opacity: 0.9;\n  }\n  &-message {\n    padding: 20px;\n    font-size: 16px;\n  }\n}\n.player-on-error {\n  @include prefix('player-control-big-button') {\n    display: none;\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-notification-action') {\n  left: 50%;\n  top: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  width: 80px;\n  height: 80px;\n  color: $control-color;\n  display: flex;\n  font-size: 35px;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  z-index: 10;\n  text-align: center;\n  animation: notificationAction 800ms ease-in-out 1 forwards;\n  pointer-events: none;\n  transform-origin: center;\n  -webkit-font-smoothing: antialiased;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n    border-radius: 50%;\n    background: $tooltip-background-color;\n    opacity: 0.3;\n  }\n}\n","@include prefix('tooltip-container') {\n  position: relative;\n  display: flex;\n  outline: none;\n}\n@include prefix('tooltip') {\n  position: absolute;\n  background-color: #000000b3;\n  color: #e3e3e3;\n  text-align: center;\n  padding: 5px;\n  border-radius: 4px;\n  z-index: 1;\n  white-space: nowrap;\n  margin: 5px 0;\n  font-size: 12px;\n  font-weight: 400;\n  opacity: 0;\n  transition: opacity 150ms ease;\n  pointer-events: none;\n  outline: none;\n  left: 50%;\n  &-center {\n    left: 50%;\n    transform: translateY(0px) translateX(-50%);\n  }\n\n  &-left {\n    left: inherit;\n    right: 0em;\n    transform: translateY(0px) translateX(0%);\n  }\n\n  &-right {\n    left: 0em;\n    transform: translateY(0px) translateX(0%);\n  }\n  &-top {\n    bottom: 100%;\n  }\n  &-bottom {\n    top: 100%;\n    bottom: initial;\n  }\n  &-fadeIn {\n    opacity: 1;\n  }\n\n  &-fadeOut {\n    opacity: 0;\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-control-cta') {\n  a {\n    color: $cta-text-color;\n    background: $cta-background-color;\n    text-decoration: none;\n    padding: 5px;\n    border-radius: 6px;\n    transition: filter 0.3s ease;\n\n    &:hover {\n      color: $cta-text-color;\n      filter: brightness(0.9);\n    }\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-control-title') {\n  color: $title-color;\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-control-logo') {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 200px;\n  padding: 10px;\n  pointer-events: none;  \n  img {\n    width: 100%;\n    /*max-width: 200px;\n    min-width: 70px;*/\n    height: auto;\n    display: block;\n    margin: 0 auto;\n  }\n}\n","@import '../utils/mixins';\n@import '../utils/variables';\n\n@include prefix('player-poster') {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 16;\n  top: 0;\n  left: 0;\n  background-color: transparent;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
